String::dasherize = ->
	@.replace /_/g, "-"

String::undasherize = ->
	@.replace /-/g, "_"

String::removeStart = (start) ->
	@.slice start.length

String::removeEnd = (end) ->
	@.slice 0, @.indexOf(end)

# Convert alfaBetaGamma to alfa_beta_gamma
String::camelToSnake = (sep = '_') ->
	@.split(/(?=[A-Z])/).join(sep).toLowerCase()

# Convert alfa_beta_gamma to alfaBetaGamma
# Also works with "-" as separator.
String::snakeToCamel = ->
	@.toLowerCase().replace /([_-][a-z])/g, (group) ->
		group.toUpperCase().replace('_', '').replace('-', '')

# Convert alfa_beta_gamma to AlfaBetaGamma
# Also works with "-" as separator.
String::snakeToPascal = ->
	str = @.snakeToCamel()
	str.slice(0, 1).toUpperCase() + str.slice 1

String::htmlEntities = ->
	@.replace /[\u00A0-\u9999<>\&]/g, (i) => '&#'+i.charCodeAt(0)+';'

String::firstPart = (end) ->
	ellipsis = if end < @.length then '…' else ''
	(@.substring 0, end)+ellipsis

String::stripHTML = ->
	container = document.createElement 'div'
	container.innerHTML = @
	container.textContent || container.innerText

Array::last = -> @[@length - 1]

#console.assert 'helloThereBuddy'.camelToSnake(), 'hello_there_buddy'
#console.assert 'hello_there_buddy'.snakeToCamel(), 'helloThereBuddy'
#console.assert 'hello_there_buddy'.snakeToPascal(), 'HelloThereBuddy'

class pgweb.Main
	
	constructor: ->
		
	instance = null
	
	pageX = null
	pageY = null
	
	tooltipTimeout = null
	
	detachableListHeaderPrefix: null
	
	@inst: ->
		if not instance?
			instance = new @
		instance

	@init: ->
		# This mitigates that when the browser window is resized, the trends chart can only grow, not shrink.
		$(window).bind "resize", ->
			width = $(document).width() - 40
			$(".trends-chart-container").css("width", width);
			$(".trend-tool-container").css("width", width);
			$(".analysis-container").css("width", width);
			$(".linechart-container").css("width", width);
			$(".heatmapchart-container").css("width", width);
			$(".heatmap-vertical-chart-container").css("width", width);

		$(document).on 'pagecreate', '[data-role=page]', (event) ->
			$(-> pgweb.Main.inst().initAfterPageLoad())

		$(document).on 'pageshow', (event) ->
			pageId = $($('[data-role=page]')[0]).prop('id')
			action = $.url().param().action
			if pgweb.Main.inst().getTermsLaterCookie() or $('#terms-box').length == 0 or pageId == 'loginPage' or action == 'showTerms'
				$('[data-role=page]').css 'margin-top', 0
			else
				$('[data-role=page]').css 'margin-top', 80
				$('#terms-box').show()
			#if $.url().param().openPanel
				#$("#menuPanel").panel 'option', 'animate', false
				#$('#menuPanel').panel 'open'
				#$("#menuPanel").panel 'option', 'animate', true

			if $('#message-bubble-text').html()
				if $('#message-bubble-text').html().trim()
					$('#message-warning-button').show()

		$('body').on 'click', '.function-link', ->
			closestCollapsible = $(@).closest '.network-collapsible'
			if closestCollapsible.length == 1
				networkId = lastNum closestCollapsible.prop 'id'
			else
				networkId = $.url().param().networkId
			functionId = lastNum @.id
			f = functions['network'+networkId]['function'+functionId]
			pgweb.Main.onFunctionLinkClick f.showHow, f.url, f.width, f.height
	
		$(document).on 'mousemove', (e) ->
			pageX = e.pageX
			pageY = e.pageY
		
		# Sorting of tables by clicking on column titles.
		$(document).on 'click', '.col-sortable', (event) ->
			defaultColumnName = 'system_name'
			columnName = ($(event.target).parent().attr('id').split '-')[1]
			url = new URL window.location.href
			lastSortBy = url.searchParams.get 'sortBy'

			reverse = parseInt ((url.searchParams.get 'reverse') ? 0)

			# Determine if sort order is:
			# 1) ascending for the selected column
			# 2) descending for the selected column
			# 3) ascending for the default column
			# And handle the sort direction arrow.
			
			# When switching column, remove the symbol from the last one.
			if lastSortBy != columnName
				$('#col-'+lastSortBy+' a i').remove()
			icon = $('#col-'+columnName+' a i').eq(0)
			if icon.length == 0 # There is no icon. Switch to ascending.
				if reverse
					$('#col-'+columnName+' a').append '<i class="fa fa-arrow-up"></i>'
				else
					$('#col-'+columnName+' a').append '<i class="fa fa-arrow-down"></i>'
			else
				if icon.hasClass 'fa-arrow-down' # Ascending, switch to descending
					$('#col-'+columnName+' a i').removeClass 'fa-arrow-down'
					$('#col-'+columnName+' a i').addClass 'fa-arrow-up'
				else if icon.hasClass 'fa-arrow-up' # Descending, switch to default
					$('#col-'+columnName+' a i').remove()
					url.searchParams.delete 'sortBy'
					url.searchParams.delete 'reverse'
					columnName = defaultColumnName
			
			findRowValue = (row, columnName) ->
				row.find('[class*="-td-'+columnName+'"] .table-value').text().trim()
			
			# Sort the rows.
			
			table = $(event.target).closest 'table'
			trs = table.find('tbody tr').toArray()
			trsSorted = trs.sort (aRow, bRow) ->
				aValue = findRowValue $(aRow), columnName
				bValue = findRowValue $(bRow), columnName
				aValueTryNumber = parseFloat(commaToDot aValue)
				if isNaN aValueTryNumber
					aValue = aValue.toLowerCase()
					bValue = bValue.toLowerCase()
				else
					aValue = aValueTryNumber
					bValueTryNumber = parseFloat(commaToDot bValue)
					bValue = bValueTryNumber
				if aValue < bValue
					-1
				else if aValue > bValue
					1
				else 0
			
			if columnName != defaultColumnName
				# Update the url parameter 'sortBy'.
				
				url.searchParams.set 'sortBy', columnName
			
				# Find out if all values in this column are equal. This is needed because if all are equal,
				# order should not be reversed (even if reverse=1).
				
				allEqual = true
				firstVal = findRowValue $(trsSorted[0]), columnName
				for i in [0..(trsSorted.length-1)]
					val = findRowValue $(trsSorted[i]), columnName
					if val != firstVal
						allEqual = false
						break

				# Handle reverse sorting.
				
				if lastSortBy == columnName
					reverse = if reverse then 0 else 1
				if reverse and not allEqual
					trsSorted.reverse()

				# Update the url parameter 'reverse'.

				if reverse
					url.searchParams.set 'reverse', 1
				else
					url.searchParams.delete 'reverse'
			
			# Replace all the rows.
			
			$(table).find('tbody').html trsSorted
			
			# Replace the url
			window.history.replaceState null, null, url
			
			# Inhibit the clicked link.
			false

		# Header sticky to the top when scrolling down.
		scrollState = 1
		# Here, addEventListener must be used because the Capture Event flag is needed.
		document.addEventListener 'scroll', (e) =>
			tableId = @detachableListHeaderPrefix+'-table'
			if $('#'+tableId).length == 0 then return
			theadId = @detachableListHeaderPrefix+'-list-thead'
			limit = $('#'+tableId).offset().top
			if scrollState == 0
				if window.scrollY >= limit
					scrollState = 1
					# Make a copy of the header and change the id of the copy.
					$('#'+theadId).clone().attr('id', theadId+'-duplicate').appendTo '#'+tableId
					# Detech the  normal header.
					$('#'+@detachableListHeaderPrefix+'-list-thead').addClass 'list-header-detached'
					# Remove IDs of the duplicate.
					trdups = $('#'+theadId+'-duplicate tr')
					for tr in trdups
						$(tr).attr 'id', null
					# Copy widths.
					ths = $('#'+theadId+' th')
					thdups = $('#'+theadId+'-duplicate th')
					for i in [0..ths.length-1]
						$(ths[i]).width $(thdups[i]).width()
			if scrollState == 1
				if window.scrollY < limit
					scrollState = 0
					$('#'+theadId).removeClass 'list-header-detached'
					$('#'+theadId+'-duplicate').remove()
		, true # Capture event

		$(document).on 'pageshow', '[data-role="page"]', (event) ->

			# Selector for area changed.
			$('body').on 'change', '#selected_area_id', (e) ->
				areaId = $(e.target).val()
				networkId = $.url().param().networkId
				moduleTypeId = $.url().param().moduleTypeId
				idHash = pgwebGetCookie 'idHash'
				pgwebSetCookie 'area_network'+networkId+'_'+idHash, areaId
				if $.url().param().moduleId
					# We are on a module level page. Switch to the module list page.
					location.href = "?action=showModules&networkId=#{networkId}&moduleTypeId=#{moduleTypeId}"
				else
					# We are on a network level page. Just reload.
					location.href = $.url().attr 'source'

		$('body').on 'click', '#message-warning-button', ->
			pgweb.ErrorDialog.inst().show t.MainPage_Messages, $('#message-bubble-text').html()

	@onFunctionLinkClick: (showHow, url, width, height) ->
		ret = true
		if showHow == 3 # Open as popup
			ret = false
			$('.function-popup-iframe').remove()
			popupId = '#function-popup'
			$(popupId).append('<iframe class="function-popup-iframe"></iframe>');
			$(popupId).popup 'open'
			$(popupId+' iframe').attr 'src', url
			$(popupId).css 'width', width
			$(popupId).css 'height', height
		ret
	
	initAfterPageLoad: ->
		currentAutoUpdateIsOn = @getAutoUpdateCookie()
		@setAutoUpdateButtonOn currentAutoUpdateIsOn

		$('body').off 'change', '#auto-update-onoff'
		$('body').on 'change', '#auto-update-onoff', (event) =>
			@setAutoUpdateCookie $('#auto-update-onoff').val() == "on"

		$('#terms-accept-button').off 'click'
		$('#terms-accept-button').on 'click', (event) =>
			@onAcceptTerms()
		
		$('#terms-later-button').off
		$('#terms-later-button').on 'click', (event) =>
			@onAcceptTermsLater()

	@showTooltip: (html) ->
		clearTimeout tooltipTimeout
		$('#general-tooltip').css 'top', pageY+20
		$('#general-tooltip').css 'left', pageX-10
		$('#general-tooltip').html html
		$('#general-tooltip').show()
		tooltipTimeout = window.setTimeout ->
			$('#general-tooltip').hide()
		, 10000

	@removeTooltip: (selector) ->
		clearTimeout tooltipTimeout
		$('#general-tooltip').hide()

	onAcceptTerms: ->
		$.getJSON 'ajax/user/acceptTerms.php', (data, textStatus, jqXHR) ->
			if data.result != 'OK'
				alert 'Unable to register acceptence of terms!'
			else
				$('#terms-box').hide ->
					$('[data-role=page]').css 'margin-top', 0
					$('#terms-box').remove()
					$('#terms-accept-button').hide()
	
	onAcceptTermsLater: ->
		@setTermsLaterCookie true
		$('#terms-box').hide ->
			$('[data-role=page]').css 'margin-top', 0
	
	autoUpdateButtonIsOn: ->
		@getAutoUpdateCookie()

	setAutoUpdateButtonOn: (bool) ->
		@setAutoUpdateCookie bool
		if bool
			$('.auto-update-onoff').val 'on'
		else
			$('.auto-update-onoff').val 'off'
		$('.auto-update-onoff').slider('refresh');

	getTermsLaterCookie: ->
		idHash = pgwebGetCookie 'idHash'
		if !idHash then return false
		Number(pgwebGetCookie 'terms_later_'+idHash) == 1

	setTermsLaterCookie: (bool) ->
		idHash = pgwebGetCookie 'idHash'
		if !idHash then return
		pgwebSetCookie 'terms_later_'+idHash, Number(bool), 3 # Days

	getAutoUpdateCookie: ->
		idHash = pgwebGetCookie 'idHash'
		if !idHash then return false
		Number(pgwebGetCookie 'autoupdate_'+idHash) == 1
	
	setAutoUpdateCookie: (bool) ->
		idHash = pgwebGetCookie 'idHash'
		if !idHash then return
		pgwebSetCookie 'autoupdate_'+idHash, Number(bool)

	# Copy to the clipboard using the deprecated method.
	copyToClipboardOld: (text) ->
		if typeof document.execCommand == 'undefined'
			alert 'No support for clipboard in this browser!'
		else
			$("body").append $('<textarea id="tmp-clipboard">')
			# focus() has to be done *after* select(), strange.
			$('#tmp-clipboard').text(text).select().focus()
			res = document.execCommand "copy"
			$('#tmp-clipboard').remove()
			if res
				console.log 'Success.'
			else
				alert 'Copy to clipboard failed.'
		
	# Copy to the clipboard using the new method.
	copyToClipboard: (text) ->
		navigator.permissions.query({name: "clipboard-write"}).then (result) =>
			if result.state in ["granted", "prompt"]
				promise = navigator.clipboard.writeText text 
				promise.then (-> ), (=> @copyToClipboardOld text)
			else
				console.log 'Copy to clipboard failed using modern method, trying the old one.'
				@copyToClipboardOld text
	
	openInStrippedWindow: (url, windowName) ->
		window.open url, windowName, 'toolbar=no, menubar=no, scrollbars=no, resizable=yes, location=no, directories=no, status=no'

	@openBaiduMap: (lat, lng) ->
		[lat, lng] = CoordinateConvert.wgs84ToBd09 [lat, lng]
		url  = 'http://api.map.baidu.com/marker?location='+lat+','+lng+'&output=html'
		window.open url, 'pgweb_map'
		
	@openGoogleMap: (lat, lng) ->
		url  = 'https://www.google.com/maps/place/'+lat+'+'+lng+'/@'+lat+','+lng+',15z'
		window.open url, 'pgweb_map'

	@emailValid: (mail) ->
		/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test mail

	@isStrongPassword: (password) ->
		regExp = new RegExp /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
		regExp.test password

	# Converts iso time ('YYYY-MM-DDTHH:MM:SS') into unix time (milliseconds since 1970).
	# Unix time is used in Highcharts.
	@isoToUnixMilliTz: (iso, timezoneOffset) ->
		dt = Globalize.parseDate iso
		dtJSTime = dateTimeToJSTime dt # Unix time * 1000
		dtJSTimeTzCorrected = dtJSTime + timezoneOffset*60000
		dtJSTimeTzCorrected

	# Converts unix time (milliseconds since 1970) into iso time ('YYYY-MM-DDTHH:MM:SS').
	@unixMilliToIso: (unixMilli) ->
		d = new Date unixMilli
		d.toISOString().substring 0, 19

	@unixMilliToIsoTz: (unixMilli) ->
		dBrowser = new Date unixMilli
		dLocal = new Date (dBrowser.getTime() + dBrowser.getTimezoneOffset()*60000)
		dStr = Globalize.format dLocal, 'F'
		dStr

	# Converts a database time (yyyy-mm-dd hh:mm:ss) in UTC to a localized time string.
	@dbTimeUTCToGlobalizedFormat: (dbTime) ->
		time = new Date dbTime
		localTime = new Date(time.getTime() - time.getTimezoneOffset()*60000)
		(Globalize.format localTime, 'd') + ' ' + (Globalize.format localTime, 'T')

	# Returns distance [m] between two points in a map.
	# Points are given as [lat, lng].
	@distance: (point1, point2) ->
		latlng1 = L.latLng point1[0], point1[1]
		latlng2 = L.latLng point2[0], point2[1]
		latlng1.distanceTo latlng2

	# For example "AN1" --> "an1_color".
	@tagMeaningToColorMemberName: (tagMeaning) ->
		tagMeaning.toLowerCase()+'_color'

	# Check that the order of the alarm limits are correct.
	# The limit values can be NaN!
	@checkRightAlarmLimitOrder: (lolo, lo, hi, hihi) ->
		arr = [lolo, lo, hi, hihi].map (x, i) -> {index: i, limit: x}
		arr = arr.filter (a) ->	not isNaN a.limit # Remove all NaN values.
		arrUnsorted = Array.from arr # Clone.
		arrSorted = arr.toSorted (a, b) -> if a.limit < b.limit then -1 else if a.limit > b.limit then 1 else 0 # Sort.
		zipped = @zip arrUnsorted, arrSorted # Zip the two arrays.
		zipped.reduce ((acc, currVal) -> acc and currVal[0].index == currVal[1].index), true # All indexes identical?

	# Zip function, makes array of pairs from two arrays.
	@zip: (a1, a2) -> a1.map((x, i) -> [x, a2[i]])

	# Remove first letter 'f' if it exists.
	@removeFormatF: (format) ->
		if format.slice(0, 1) == 'f' then format.slice(1) else format

	# Given an array, return the most common value. Returns an object the value as a string!
	# Null values will also be returned as string 'null'.
	@mostCommonElement: (arr) ->
		dict = arr.reduce ((obj, val) -> Object.assign obj, {[val]: if !obj[val]? then 1 else obj[val]+1}), {}
		sortedPairs = Object.entries(dict).sort (a, b) -> if a[1] < b[1] then 1 else if a[1] > b[1] then -1 else 0
		{mostCommon: sortedPairs[0][0], sortedPairs: sortedPairs}

	@xor: (a, b) ->
		(a or b) and not (a and b)

	@getUpdateInterval: ->
		if pgweb.Login.inst().usernameFromCookie() == 'elias.waldhe@pipeguard.se' then 10000 else 60000

	@onPageShow: (cls, f) ->
		$(document).on 'pageshow', cls, f

	@onEvent: (eventName, selector, f) ->
		$('body').off eventName, selector
		$('body').on eventName, selector, f

pgweb.Main.init()
$(-> pgweb.Main.inst())

#console.assert (pgweb.Main.mostCommonElement [3, null, null, 6, 5, 8, 5]) == '5'
#console.assert (pgweb.Main.mostCommonElement [3, 8, 8, null, null, 6, 5, 8, 5]) == '8'
#console.assert (pgweb.Main.mostCommonElement [3, 8, 8, null, null, null, null, 6, 5, 8, 5]) == 'null'

#console.log pgweb.Main.inst().checkAlarm '', 500, 200, 50, 20
#module = {
#	activation: true
#	an1: 44
#	an1_active: true
#	hihi_limit_an1: null
#	hi_limit_an1: null
#	lo_limit_an1: null
#	lolo_limit_an1: null
#	an2: 123
#	an2_active: true
#	hihi_limit_an2: 500
#	hi_limit_an2: 200
#	lo_limit_an2: 50
#	lolo_limit_an2: 20
#}
#console.log pgweb.Main.inst().anAlarm 1, null, module
#console.log pgweb.Main.inst().anColor 2, module
#console.log pgweb.Main.emailValid 'asdf@asdf..se'
class pgweb.Map

	id: null
	modules: null
	maximized = false
	fullscreen = false
	map = null
	
	grayMarkerLayer = null
	greenMarkerLayer = null
	yellowMarkerLayer = null
	redMarkerLayer = null
	yellowredMarkerLayer = null

	layerDatas = []
	lastHighlightedLayer = null
	lastHighlightedLayerColor = null
	markers = []
	_afterCreateMarkersCallBack = -> {}

	@LAYER_TYPE_GEOJSON = 1
	@LAYER_TYPE_SHAPEFILE = 2

	init: (config) ->
		# Ensure there is no map.
		@ensureNoMap()

		# Create the map object.
		map = @createMap()

		if !config or not config.hideFullScreenButton
			# Add the map fullscreen toggle button.
			map.addControl @createFullscreenButton()

		if !config or not config.hideMapHeightButton
			# Add the map height toggle button.
			map.addControl @createMaximizeButton()

		# Display markers for all the modules.
		@clearMarkers()
		@update true

		map.on 'resize', =>
			@fitToBounds()

		map.on 'zoomend', (obj) =>
			@onZoomEnd()

		maximized = @getMaximizedCookie()
		if ($.url().attr 'anchor') == 'fullscreen'
			$('.map-fullscreen-button').trigger 'click'
		else
			if maximized
				maximized = not maximized
				$('.map-maximize-button').trigger 'click'

	onZoomEnd: ->
		#console.log "zoom="+map.getZoom()
		if not layerDatas? then return
		for layerData in layerDatas
			if map.getZoom() >= layerData.visible_zoom_level_min and map.getZoom() <= layerData.visible_zoom_level_max
				if not layerData.visible
					if layerData.geojson
						showGeoJSON layerData.geojson, true
					if layerData.shapefile
						showGeoJSON layerData.shapefile, true
					layerData.visible = true
				weight = Math.min map.getZoom()/5 - 1, 3
				if layerData.geojson
					layerData.geojson.setStyle weight: weight
			else
				if layerData.visible
					if layerData.geojson
						showGeoJSON layerData.geojson, false
					if layerData.shapefile
						showGeoJSON layerData.shapefile, false
					layerData.visible = false
	
	isInitialized: ->
		return not $('#'+@id).is ':empty' 

	ensureNoMap: ->
		if map
			map.remove()
			map = undefined

	getMap: ->
		map

	clearMarkers: ->
		if grayMarkerLayer? then  grayMarkerLayer.clearLayers()
		grayMarkerLayer = undefined

		if greenMarkerLayer? then greenMarkerLayer.clearLayers()
		greenMarkerLayer = undefined
		
		if yellowMarkerLayer? then yellowMarkerLayer.clearLayers()
		yellowMarkerLayer = undefined
		
		if redMarkerLayer? then redMarkerLayer.clearLayers()
		redMarkerLayer = undefined
		
		if yellowredMarkerLayer? then yellowredMarkerLayer.clearLayers()
		yellowredMarkerLayer = undefined
		
		markers = []

	getMaximizedCookie: ->
		idHash = pgwebGetCookie 'idHash'
		Number(pgwebGetCookie (@id.replace /-/g, '')+'_maximized_'+idHash) == 1
	
	setMaximizedCookie: (bool) ->
		idHash = pgwebGetCookie 'idHash'
		pgwebSetCookie (@id.replace /-/g, '')+'_maximized_'+idHash, Number(bool)
	
	fitToBounds: (latMargin, lngMargin) ->
		# Get the points of the modules to be viewed (for map bounds calculation).
		pointsForBoundsCalcAll = (@correctCoords([module.gis_latitude, module.gis_longitude]) for module in @modules)
		pointsForBoundsCalc = pointsForBoundsCalcAll.filter (c) -> 
			((typeof c[0]) in ['number', 'string']) and ((typeof c[1]) in ['number', 'string']) and 
			c[0] != '' and c[1] != ''

		# If there are no modules to be viewed on the map, do nothing more.
		if pointsForBoundsCalc.length == 0
			return
		
		# Fit bounds to the points.
		bounds = new L.LatLngBounds pointsForBoundsCalc

		if latMargin
			bounds._northEast.lat += latMargin;
			bounds._southWest.lat -= latMargin;
		if lngMargin
			bounds._northEast.lng += lngMargin;
			bounds._southWest.lng -= lngMargin;
		@fitBounds bounds
	
	# If coords [lat, lng] are invalid, set them to north pole.
	correctCoords: (coords) ->
		if coords[0] < -90 or coords[0] > 90 or coords[1] < -180 or coords[1] > 180
			coords = ["90", "0"]
		coords

	fitBounds: (bounds) ->
		map.fitBounds bounds, {maxZoom: 15}
	
	refresh: ->
		map.invalidateSize()
		
	# Create the map object.
	createMap: ->
		normalm = L.tileLayer.baiduLayer 'Normal.Map'
		#satellitem = L.tileLayer.baiduLayer 'Satellite.Map'
		normal = L.layerGroup [normalm]
		
		measureControl = $.url().param().networkId == "1"
		if USE_BAIDU_MAPS
			crs = L.CRS.Baidu # As defined in js/leaflet.baidu.
		else
			crs = L.CRS.EPSG3857 # Default CRS for Leaflet.
		map = L.map(@id, 
			crs: crs
			zoomAnimationThreshold: 17
			zoomSnap: .25
			zoomDelta: .25
			wheelPxPerZoomLevel: 300
			wheelDebounceTime: 20
			measureControl: measureControl
			attributionControl: false
		)
		attribution = ""
		config =
			attribution: attribution
			maxZoom: 21
			maxNativeZoom: 19
		
		if USE_BAIDU_MAPS
			map.addLayer(normal)
		else
			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', config).addTo(map)

		@addLayers map
		
		map

	addLayers: (map) =>
		if $.url().param().networkId?
			networkId = $.url().param().networkId
		else
			networkId = $('#network-id').val()
		if networkId != '' and networkId != undefined
			@getLayerDataByAjax networkId

	getLayerDataByAjax: (networkId) =>
		$.ajax
			url: "/pgweb/ajax/network/getLayerData.php"
			dataType: 'json'
			type: 'GET'
			data:
				networkId: networkId
			success: (data) => 
				switch data.result
					when "OK"
						layerDatas = data.mapLayers
						for layerData in layerDatas
							if layerData.type == pgweb.Map.LAYER_TYPE_GEOJSON
								@getGeoJSONByAjax layerData
							else if layerData.type == pgweb.Map.LAYER_TYPE_SHAPEFILE
								getShapefileByAjax layerData
							else alert 'invalid layer type'+layerData.type
						map.on 'click', ->
							if lastHighlightedLayer
								lastHighlightedLayer.setStyle color: lastHighlightedLayerColor
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get module data.', data.result);
			error: ajaxFailure
	
	getShapefileByAjax = (layerData) ->
		url = 'shapefiles/'+layerData.filename
		options =
			onEachFeature: (feature, featureLayer) ->
				if layerData.clickable
					if feature.properties
						featureLayer.bindPopup Object.keys(feature.properties).map((k) ->
							k + ": " + feature.properties[k]
						).join("<br />"), 
							maxHeight: 200
			importUrl: 'js/shapefile-js/dist/shp.js',
			style: (featureData) ->
				color: layerData.color, fill: true, fillColor: layerData.color, weight: 5, opacity: 1
		shpfile = new L.Shapefile url, options
		shpfile.addTo map
		shpfile.once "data:loaded", =>
			layerData.visible = false
			layerData.shapefile = shpfile
			showGeoJSON shpfile, false
			@onZoomEnd()

	getGeoJSONByAjax: (layerData) =>
		url = 'shapefiles/'+layerData.filename+'.json'
		$.getJSON url, (data, textStatus, jqXHR) =>
			calledFile = url.substring 11, url.indexOf '.json'
			geojsonFeature = data
			geojson = addGeoJSONTolayer geojsonFeature, layerData
			layerData.visible = false
			showGeoJSON geojson, false
			@onZoomEnd()
	
	addGeoJSONTolayer = (geojsonFeature, layerData) ->
		geojson = L.geoJson geojsonFeature, 
			style:
				color: layerData.color
				opacity: 1
			onEachFeature: (feature, featureLayer) ->
				featureGroup = L.featureGroup([featureLayer])
				featureGroup.on 'click', (e) ->
					onFeatureClick feature, featureGroup, layerData
				featureGroup.addTo map
		layerData.geojson = geojson
		geojson
	
	showGeoJSON = (geojson, show) ->
		geojson.setStyle
			opacity: if show then 1.0 else 0.0

	onFeatureClick = (feature, featureGroup, layerData) ->
		if lastHighlightedLayer
			lastHighlightedLayer.setStyle color: lastHighlightedLayerColor
		if feature.properties.AREA
			str=''
			if feature.properties.AREA
				str += 'Area: '+feature.properties.AREA+'<br/>'
			if feature.properties.MAXTEMP
				str += 'Maxtemp: '+feature.properties.MAXTEMP
			#for key, val of feature.properties
			#	str += key+': '+val+'<br/>'
			featureGroup.bindPopup str
		if layerData.clickable
			featureGroup.setStyle color: '#ee44ff'
			lastHighlightedLayer = featureGroup
			lastHighlightedLayerColor = layerData.color
	
	# Create the markers with popups.
	createMarkers: (showLayers = {gray: true, green: true, yellow: true, red: true}) ->
		icons = @createIcons()

		@checkAddLayerGroups()

		for module in @modules
			if module.gis_active
				coords = @correctCoords [module.gis_latitude, module.gis_longitude]
				if USE_BAIDU_MAPS
					coords = CoordinateConvert.wgs84ToBd09(coords)
				switch module.module_type_name 
					when 'smbasicPG' then icon = @getSMBasicPGIcon module
					else
						iconName = pgweb.PVStatus.toColor(module.pv_status)+'Icon'
						icon = icons[iconName]
				
				marker = L.marker(coords, 
					icon: icon
					title: module.module_name
				).bindPopup @getPopupHtml module
				markers.push marker
				module.marker = marker
				@addMarkerToLayerGroupByPVStatus marker, (parseInt module.pv_status), showLayers
		
		_afterCreateMarkersCallBack()
	
	createIcons: ->
		MapNeedle = L.Icon.extend
			options:
				shadowUrl: 'images/mapneedle_shadow.png'
				iconSize: [20, 32],
				shadowSize: [21, 25],
				iconAnchor: [10, 32],
				shadowAnchor: [5, 25],
				popupAnchor: [0, -32]

		grayIcon: new MapNeedle
			iconUrl: 'images/mapneedle_gray.png'
		greenIcon: new MapNeedle
			iconUrl: 'images/mapneedle_green.png'
		yellowIcon: new MapNeedle
			iconUrl: 'images/mapneedle_yellow.png'
		yellowredIcon: new MapNeedle
			iconUrl: 'images/mapneedle_yellowred.png'
		redIcon: new MapNeedle
			iconUrl: 'images/mapneedle_red.png'

	addMarkerToLayerGroupByPVStatus: (marker, pvStatus, showLayers) ->
		switch pvStatus
			when pgweb.PVStatus.SWITCHED_OFF
				if showLayers.gray
					grayMarkerLayer.addLayer marker
			when pgweb.PVStatus.NO_ALARMS
				if showLayers.green
					greenMarkerLayer.addLayer marker
			when pgweb.PVStatus.OPERATION_ALARM
				if showLayers.yellow
					yellowMarkerLayer.addLayer marker
			when pgweb.PVStatus.SYSTEM_ALARM
				if showLayers.red
					redMarkerLayer.addLayer marker
			when pgweb.PVStatus.OPERATION_SYSTEM_ALARM
				if showLayers.red or showLayers.yellow
					yellowredMarkerLayer.addLayer marker
			else console.log 'Unknown pv_status: '+module.pv_status

	checkAddLayerGroups: ->
		# If the marker layer exists, remove all markers from it, else create the marker layer and add it to the map.
		if grayMarkerLayer? then      grayMarkerLayer.clearLayers()      else grayMarkerLayer      = L.layerGroup().addTo map
		if greenMarkerLayer? then     greenMarkerLayer.clearLayers()     else greenMarkerLayer     = L.layerGroup().addTo map
		if yellowMarkerLayer? then    yellowMarkerLayer.clearLayers()    else yellowMarkerLayer    = L.layerGroup().addTo map
		if redMarkerLayer? then       redMarkerLayer.clearLayers()       else redMarkerLayer       = L.layerGroup().addTo map
		if yellowredMarkerLayer? then yellowredMarkerLayer.clearLayers() else yellowredMarkerLayer = L.layerGroup().addTo map

	setAfterCreateMarkersCallback: (callback) ->
		_afterCreateMarkersCallBack = callback

	toggleLayers: (isGreen, isYellow, isRed, isGray) ->
		if not map or not greenMarkerLayer then return # Just check any layer.
		@toggleLayer isGreen,           greenMarkerLayer
		@toggleLayer isGray,            grayMarkerLayer
		@toggleLayer isYellow or isRed, yellowredMarkerLayer
		@toggleLayer isYellow,          yellowMarkerLayer
		@toggleLayer isRed,             redMarkerLayer

	toggleLayer: (show, layer) ->
		if show
			if not map.hasLayer layer
				map.addLayer layer
		else
			if map.hasLayer layer
				map.removeLayer layer

	toggleMarker: (module, show, map) ->
		layerGroup = @colorToLayerGroup module.pv_status_color
		if layerGroup # It could be undefined because there are no markers in the map so the layergroups are undefined.
			if module.marker # It could be undefined because a module may have gis_active off or missing coords.
				if show
					if not layerGroup.hasLayer module.marker
						layerGroup.addLayer module.marker
						if module.module_type_name == 'gw102'
							SonitusSectionCircles.addCirclesByModuleId map, module.id
				else
					if layerGroup.hasLayer module.marker
						layerGroup.removeLayer module.marker
						if module.module_type_name == 'gw102'
							SonitusSectionCircles.removeCirclesByModuleId module.id

	colorToLayerGroup: (color) ->
		switch color
			when 'green' then greenMarkerLayer
			when 'gray' then grayMarkerLayer
			when 'yellow' then yellowMarkerLayer
			when 'red' then redMarkerLayer
			when 'yellowred' then yellowredMarkerLayer
			else alert 'Unhandled color: '+module.pv_status_color

	# Return html för the popup that appears when clicking on the icon.
	getPopupHtml: (module) ->
		[lat, lng] = if module.projection in ['', 'wgs84', undefined]
			[module.gis_latitude, module.gis_longitude]
		else
			ll2xy module.projection, module.gis_latitude, module.gis_longitude
		moduleTypeId = $.url().param().moduleTypeId
		url = "?action=showModule&networkId=#{module.network_id}&moduleTypeId="+moduleTypeId+"&moduleId=#{module.id}"
		""" <!-- " -->
			<h3><a href="#{url}">#{module.system_name}</a></h3>
			<table>
			<tr><td>#{t.ModuleList_ModuleName}:</td><td>#{module.module_name}</td></tr>
			<tr><td>#{t.ModuleList_TechnicalName}:</td><td>#{escapeStringForHTML(module.technical_name)}</td></tr>
			<tr><td>#{t.ModuleList_Address}:</td><td>#{module.address}</td></tr>
			</table>
		""" # "

	# Return the icon for a SM-basicPG module.
	getSMBasicPGIcon: (module) ->
		# Colors of AN1 and AN2
		#color1 = pgweb.Main.inst().anColor 1, module
		#color2 = pgweb.Main.inst().anColor 2, module
		color1 = module.an1_color
		color2 = module.an2_color
		# Color of halo
		haloColor = @getHaloColor color1, color2
		# Array of blurs and spreads for the halo. Used for css 'box-shadow'. [blur, spread]
		blursAndSpreads = [[10, 3], [12, 4], [14, 6], [16, 8], [20, 10], [24, 12], [28, 14], [32, 16], 
			[36, 18], [40, 20], [44, 22], [48, 24], [53, 26], [57, 28], [60, 30]]
		# Compute which index in the array to use.
		blurAndSpreadIndex = @getTotalBlurAndSpreadIndex color1, color2, module.an1, module.an2, 
			(Number module.hihi_limit_an1), (Number module.hi_limit_an1), 
			(Number module.hihi_limit_an2), (Number module.hi_limit_an2), 
			blursAndSpreads.length
		# This is the blur and spread pair to use.
		blurAndSpread = blursAndSpreads[blurAndSpreadIndex]
		blur = blurAndSpread[0]
		spread = blurAndSpread[1]
		icon = new L.DivIcon
			className: 'smbasicpg-icon'
			html: """ <!-- " -->
				<div class="smbasicpg-icon-container" style="box-shadow: 0px 0px #{blur}px #{spread}px #{haloColor};">
					<div class="ui-grid-a" id="smbasicpg-icon-#{module.id}">
						<div class="ui-block-a smbasicpg-mic1-container smbasicpg-mic-#{color1}">
							<span id="smbasicpg-mic1-value">#{if module.an1 != '' then Math.round(module.an1) else '-'}</span>
						</div>
						<div class="ui-block-b smbasicpg-mic2-container smbasicpg-mic-#{color2}">
							<span id="smbasicpg-mic2-value">#{if module.an2 != '' then Math.round(module.an2) else '-'}</span>
						</div>
					</div>
				</div>""" # "
			iconAnchor: [28, 10]

	# Give higher priority to hihi alarms, i.e. red halo.
	getHaloColor: (color1, color2) ->
		switch
			when color1 == 'red'    or color2 == 'red'    then 'red'
			when color1 == 'orange' or color2 == 'orange' then 'orange'
			else 'gray'
	
	# Get the total size of the halo, with regard to halo color. Red is higher priority than orange.
	getTotalBlurAndSpreadIndex: (color1, color2, an1, an2, hihi_an1, hi_an1, hihi_an2, hi_an2, n) ->
		if color1 == 'red'
			if color2 == 'red'
				blurAndSpreadIndex1 = @getBlurAndSpreadIndex an1, hihi_an1, n
				blurAndSpreadIndex2 = @getBlurAndSpreadIndex an2, hihi_an2, n
				blurAndSpreadIndex = Math.max blurAndSpreadIndex1, blurAndSpreadIndex2
			else
				blurAndSpreadIndex = @getBlurAndSpreadIndex an1, hihi_an1, n
		else
			if color2 == 'red'
				blurAndSpreadIndex = @getBlurAndSpreadIndex an2, hihi_an2, n
			else
				if color1 == 'orange'
					if color2 == 'orange'
						blurAndSpreadIndex1 = @getBlurAndSpreadIndex an1, hi_an1, n
						blurAndSpreadIndex2 = @getBlurAndSpreadIndex an2, hi_an2, n
						blurAndSpreadIndex = Math.max blurAndSpreadIndex1, blurAndSpreadIndex2
					else
						blurAndSpreadIndex = @getBlurAndSpreadIndex an1, hi_an1, n
				else
					if color2 == 'orange'
						blurAndSpreadIndex = @getBlurAndSpreadIndex an2, hi_an2, n
					else
						blurAndSpreadIndex = 0
		blurAndSpreadIndex
	
	# If e.g. an1 is above the limit but below the center of the limit and 100, then the higher the value the larger 
	# the halo, i.e. greater blurSpreadIndex.
	# If an1 is greater than the center of the limit and 100, then show the largest halo.
	# If an1 is below the limit then the halo is the smallest.
	getBlurAndSpreadIndex: (value, limit, n) ->
		if value > limit
			switch
				when value < (limit+100)/2 then Math.floor n*(value - limit)/((limit+100)/2 - limit)
				else n - 1
		else 0
		
	# Create the map resize toggle button.
	createMaximizeButton: ->
		MaximizeButton = L.Control.extend(
			options:
				position: 'topright'
			onAdd: (map) =>
				button = L.DomUtil.create('button', 'map-maximize-button')
				$(button).html '<i class="fa fa-arrows-v fa-lg"></i>'
				$('body').off 'click', '.map-maximize-button'
				$('body').on 'click', '.map-maximize-button', (event, ui) =>
					maximized = not maximized
					if maximized
						@setMaximizedButtonPressed()
						height = 500
					else
						@setMaximizedButtonReleased()
						height = 200
					@setMaximizedCookie maximized
					$('#'+@id).animate
						height: "#{height}px"
						100
						@refresh

				return button
		)
		new MaximizeButton()

	setMaximizedButtonPressed: ->
		$('.map-maximize-button').css
			'background-color': '#ddf'
		
	setMaximizedButtonReleased: ->
		$('.map-maximize-button').css
			'background-color': '#fff'
	
	# Create the map fullscreen button.
	createFullscreenButton: ->
		fullscreenButton = L.Control.extend(
			options:
				position: 'topright'
			onAdd: (map) =>
				button = L.DomUtil.create('button', 'map-fullscreen-button')
				$(button).html '<i class="fa fa-expand fa-lg"></i>'
				$('body').off 'click', '.map-fullscreen-button'
				$('body').on 'click', '.map-fullscreen-button', (event, ui) =>
					fullscreen = not fullscreen
					if fullscreen
						$('#'+@id).css
							position: 'fixed'
							width: '100%'
							height: $(window).height()
							top: 0
							left: 0
							'z-index': 1000
						$('.map-maximize-button').hide()
						$(button).html '<i class="fa fa-compress fa-lg"></i>'

						$.mobile.navigate $.url().attr('path') + '?' + $.url().attr('query') + '#fullscreen'
					else
						if maximized
							height = 500.toString()
							@setMaximizedButtonPressed()
						else
							height = 200.toString()
							@setMaximizedButtonReleased()
						$('#'+@id).css
							position: 'relative'
							width: 'auto'
							height: height+'px'
							top: 0
							left: 0
							'z-index': 0
						$('.map-maximize-button').show()
						$(button).html('<i class="fa fa-expand fa-lg"></i>')

						$.mobile.navigate $.url().attr('path') + '?' + $.url().attr 'query'
					@refresh()

				return button
		)
		return new fullscreenButton()

	getModuleById: (id) ->
		@modules.find (module) ->
			module.id == id

	show: ->
		$('#'+@id).show() # 400, 'slow', =>
		@init()
		idHash = pgwebGetCookie 'idHash'
		pgwebSetCookie 'show'+(@id.replace /-/g, '')+'_'+idHash, 1

	hide: ->
		$('#'+@id).hide() # 'fast', =>
		@refresh()
		idHash = pgwebGetCookie 'idHash'
		pgwebSetCookie 'show'+(@id.replace /-/g, '')+'_'+idHash, 0

	showCookie: ->
		idHash = pgwebGetCookie 'idHash'
		(pgwebGetCookie 'show'+(@id.replace /-/g, '')+'_'+idHash) == "1"

	getModulesWithCoords: ->
		tmpModules = []
		for module in @modules
			if module.gis_latitude.toString().length > 0 and module.gis_longitude.toString().length > 0 and module.gis_active
				tmpModules.push module
		tmpModules

	addPixelsToCoords: (coords, xPixels, yPixels) ->
		pixelPoint = @getMap().latLngToLayerPoint coords
		pixelPoint.x += xPixels
		pixelPoint.y += yPixels
		@getMap().layerPointToLatLng pixelPoint
class pgweb.HelpDialog

	@register: (dialogId, buttonId) ->
		$('body').off 'click', '#'+buttonId
		$('body').on 'click', '#'+buttonId, ->
			$('#'+dialogId).fadeToggle 'fast'

		$('body').off 'click', '.help-box button'
		$('body').on 'click', '.help-box button', ->
			$(this).closest('.help-box').fadeToggle 'fast'
class pgweb.ExergiOverviewBackgroundGauge
	value: null
	containerId: null
	
	constructor: (config) ->
		containerIdSuffix = config.containerIdSuffix
		unit = config.unit ? ''
		min = config.min ? 0
		max = config.max ? 100
		initValue = config.initValue ? 0
		stops = config.stops ? [
			[0.1, '#00ff00'], # green
			[0.5, '#ffff00'], # yellow
			[0.9, '#ff0000']  # red
		]
		size = config.size ? 1.0
		decimals = config.decimals ? 1
		size*=1.2
		@containerId = 'exergi-overview-chart-'+containerIdSuffix

		# These are the full size measurements.
		containerWidth = 190
		containerHeight = 218
		displayWidth  = 48 # %
		displayHeight = 46 # %
		displayTop    = (100 - displayHeight)/2 # %
		displayLeft   = (100 - displayWidth)/2+3  # %
		fontSize = 40
		
		# Dynamically set COMMON (independent of absolute size) styles, if not already set.
		if $('#eoc-background-gauge-styles').length == 0
			$('<style id="eoc-background-gauge-styles">')
				.prop "type", "text/css"
				.html "\
					.exergi-overview-solid-chart {
						background-image: url(images/background-gauge.jpeg);\
						background-size: cover;\
					}
					.eoc-display {\
						position: relative;\
						width: #{displayWidth}%;\
						height: #{displayHeight}%;\
						top: #{displayTop}%;\
						left: #{displayLeft}%;\
						/*border-style: solid;\
						border-width: 1px;\
						border-color: #888;*/\
						color: #00ff00;\
						font-weight: bold;\
						text-align: center;\
					}
					.eoc-value {\
						display: block;\
						position: relative;\
						top: 20%;\
					}\
					.eoc-unit {\
						display: block;\
						position: relative;\
						top: 10%;\
					}\
					"
				.appendTo "head"
		
		sel = '#'+@containerId 
		$(sel).width containerWidth*size
		$(sel).height containerHeight*size
		contents = '<div class="eoc-value"></div><div class="eoc-unit">'+unit+'</div>'
		$(sel).append '<div class="eoc-display">'+contents+'</div>'
		#rnd = Math.random()*5
		#if rnd < 3
		color = '#00ff00'
		#else if rnd < 4
			#color = '#ffff00'
		#else color = '#ff0000'
		$(sel+' .eoc-display').css 'color', color
		$(sel+' .eoc-value').css 'font-size', fontSize*size
		$(sel+' .eoc-unit').css 'font-size', fontSize*size*0.5
		
	updateValue: (newValue) ->
		oldValue = @value
		@value = newValue
		valueFormatted = ''
		if typeof @value == 'number'
			valueFormatted = newValue.toFixed 1
		$('#'+@containerId+' .eoc-value').html valueFormatted
class pgweb.TagCategoryListMap extends pgweb.Map
	
	instance = null
	intervalId = null
	
	tags: null
	layerGroups = {}
	tagCategorySymbolCode = null

	markers = []

	#mapNeedleColorSelectionButtonPressed = false

	@inst: ->
		# Run only on tag category list page.
		if $.url().param().action != 'showTagCategory'
			return
		if not instance?
			instance = new @
		instance
	
	init: ->
		super()

		## Add the button for needle color selection.
		#selectionButton = @createNeedleColorSelectionButton()
		#@getMap().addControl selectionButton

	# Display markers for all the tags.
	update: (fitBounds) ->
		if $.url().param().action != 'showTagCategory' then return
		#if not pgweb.Main.inst().autoUpdateButtonIsOn() then return
		@ajaxUpdate fitBounds, $.url().param().networkId, $.url().param().tagCategoryIds

	clearMarkers: ->
		for tagMeaning, layerGroup of layerGroups
			layerGroup.clearLayers()
		layerGroups = {}
		markers = []

	ajaxUpdate: (fitBounds, networkId, tagCategoryIds) ->
		@tags = []
		$.ajax
			url: "/pgweb/ajax/tag/tagCategoryMap.php"
			dataType: 'json'
			type: 'GET'
			data:
				networkId: networkId
				tagCategoryIds: tagCategoryIds
			success: (data) =>
				@tags = data.tags
				switch data.result
					when "OK"
						@afterAjaxUpdate fitBounds
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get tag category data.', data.result);
			error: ajaxFailure

	beforeAjaxUpdate: ->
		for tag in @tags
			[tag.tagStatusColor, tag.dropletColor, tag.haloColor, tag.haloClass] = @calcColors tag

	afterAjaxUpdate: (fitBounds) ->
		@beforeAjaxUpdate()

		# For bounds check.
		tmpTags = @getTagsWithCoords()

		# Get the points of the modules to be viewed (for map bounds calculation).
		pointsForBoundsCalc = (@correctCoords [tag.module.gis_latitude, tag.module.gis_longitude] for tag in tmpTags)

		# If there are no modules to be viewed on the map, do nothing more.
		if pointsForBoundsCalc.length == 0
			@clearMarkers()
			return

		# Fit bounds perfectly to the points.
		if fitBounds
			bounds = new L.LatLngBounds pointsForBoundsCalc
			bounds._northEast.lat += (bounds._northEast.lat - bounds._southWest.lat)*0.17
			@fitBounds bounds

		@createMarkers()
	
	getTagsWithCoords: ->
		tmpTags = []
		for tag in @tags
			if tag.module.gis_latitude.toString().length > 0 and tag.module.gis_longitude.toString().length > 0 and tag.module.gis_active
				tmpTags.push tag
		tmpTags
	
	createMarkers: ->
		awesomeName = $('#tag-category-awesome-name').val()
		map = @getMap()

		@clearMarkers()
		
		for tag in @tags
			coords = @correctCoords [tag.module.gis_latitude, tag.module.gis_longitude]
			if coords[0] and coords[1]
				zIndexOffset = if tag.dropletColor == 'red' then 50000
				else if tag.dropletColor == 'orange' then 40000
				else if tag.dropletColor == 'yellow' then 30000
				else 20000
				if awesomeName.endsWith '.png'
					themeType = parseInt $('#theme-type').val()
					color = 'black';
					fname = awesomeName.replace('.png', '-'+color+'.png')
					size = 10
					html = '<img src="images/'+fname+'" style="width: '+size+'px; position: relative; top: 3px"/>'
				else
					html = '<i class="fa fa-'+awesomeName+' map-needle-symbol"></i>'
				icon = L.divIcon
					html: html
					className: 'map-needle map-needle-'+tag.dropletColor+' '+tag.haloClass
					iconSize: [24, 38]
					iconAnchor: [12, 38]
					popupAnchor: [0, -38]
				marker = L.marker(coords, 
					icon: icon
					title: tag.module.module_name
					zIndexOffset: zIndexOffset
				).bindPopup @getPopupHtml tag
				marker.tagId = tag.tag_id
				marker.tag = tag
				marker.on 'popupopen', (e) =>
					@onPopupOpen e
				marker.on 'popupclose', (e) =>
					@onPopupClose e
				markers.push marker
				if layerGroups[tag.tag_category_name] == undefined
					layerGroups[tag.tag_category_name] = L.layerGroup()
					if @layerVisibilityByName tag.tag_category_name
						layerGroups[tag.tag_category_name].addTo map

				showGreen  = $('#needle-button-green').is ':checked'
				showOrange = $('#needle-button-orange').is ':checked'
				showRed    = $('#needle-button-red').is ':checked'
				showYellow = $('#needle-button-yellow').is ':checked'

				if not (
					(not showGreen and tag.dropletColor == 'green') or
					(not showOrange and tag.dropletColor == 'orange') or
					(not showRed and tag.dropletColor == 'red') or
					(not showYellow and tag.dropletColor == 'yellow')
				)
					layerGroups[tag.tag_category_name].addLayer marker

	# # Create the needle color selection button.
	# createNeedleColorSelectionButton: ->
	# 	selectionButton = L.Control.extend(
	# 		options:
	# 			position: 'topright'
	# 		onAdd: (map) =>
	# 			button = L.DomUtil.create('button', 'map-needle-color-selection-button')
	# 			$(button).html('<i class="fa fa-bars fa-lg"></i>')
	# 			$(button).append @needleColorSelectionBoxHtml()

	# 			$('body').on 'change', '#map-needle-color-selection-div input', (event) =>
	# 				@needleColorSelectionCheckboxClick $(event.currentTarget)

	# 			$('body').on 'click', '.map-needle-color-selection-button', (event, ui) =>
	# 				@needleColorButtonClick()
		
	# 			$('body').on 'click', '#map-needle-color-selection-div', (event) =>
	# 				event.stopImmediatePropagation()
				
	# 			return button
	# 	)
	# 	return new selectionButton()

	# needleColorSelectionBoxHtml: ->
	# 	h  = '<div id="map-needle-color-selection-div">'

	# 	h += '<label><input type="checkbox" id="map-needle-color-selection-ok" checked/> '
	# 	h += '<div class="map-needle-color-selection selection-ok"/>'
	# 	h += t.MapLayerControlChoiceOK+'</label>'

	# 	h += '<label><input type="checkbox" id="map-needle-color-selection-hi" checked/> '
	# 	h += '<div class="map-needle-color-selection selection-hi"/>'
	# 	h += t.MapLayerControlChoiceAlarmHi+'</label>'

	# 	h += '<label><input type="checkbox" id="map-needle-color-selection-hihi" checked/> '
	# 	h += '<div class="map-needle-color-selection selection-hihi"/>'
	# 	h += t.MapLayerControlChoiceAlarmHiHi+'</label>'
		
	# 	h += '<label><input type="checkbox" id="map-needle-color-selection-timer" checked/> '
	# 	h += '<div class="map-needle-color-selection selection-timer"/>'
	# 	h += t.MapLayerControlChoiceTimerAlarm+'</label>'
		
	# 	h += '</div>'

	# needleColorSelectionCheckboxClick: (checkbox) ->
	# 	color = switch checkbox.attr 'id'
	# 		when 'map-needle-color-selection-ok' then 'green'
	# 		when 'map-needle-color-selection-hihi' then 'red'
	# 		when 'map-needle-color-selection-hi' then 'orange'
	# 		when 'map-needle-color-selection-timer' then 'yellow'
	# 	checked = checkbox.prop 'checked'
	# 	if not checked
	# 		for tagCategoryName, layerGroup of layerGroups
	# 			layerGroup.eachLayer (marker) =>
	# 				if marker.tag.dropletColor == color
	# 					marker.remove()
	# 					@showRow false, marker.tagId
	# 	else
	# 		foundMarkers = markers.filter (marker) ->
	# 			marker.tag.dropletColor == color
	# 		for marker in foundMarkers
	# 			layerGroups[marker.tag.tag_category_name].addLayer marker
	# 			@showRow true, marker.tagId

	# needleColorButtonClick: ->
	# 	mapNeedleColorSelectionButtonPressed = not mapNeedleColorSelectionButtonPressed
	# 	if mapNeedleColorSelectionButtonPressed 
	# 		$('.map-needle-color-selection-button').css
	# 			'background-color': '#ddf'
	# 	else
	# 		$('.map-needle-color-selection-button').css
	# 			'background-color': '#fff'
	# 	$('#map-needle-color-selection-div').fadeToggle mapNeedleColorSelectionButtonPressed

	getMarkers: ->
		markers

	onPopupOpen: (e) ->
		# Inherit this method.

	onPopupClose: (e) ->
		# Inherit this method.

	calcColors: (tag) ->
		colorMemberName = pgweb.Main.tagMeaningToColorMemberName tag.tag_meaning
		tagStatusColor = tag.module[colorMemberName]
		dropletColor = tagStatusColor
		if tagStatusColor == 'yellow'
			dropletColor = 'orange'
		if tagStatusColor == 'gray'
			dropletColor = 'yellow'
		haloColor = 'gray'
		haloClass = ''
		if tag.module.timer_color != 'green'
			dropletColor = 'yellow'
			haloColor = tagStatusColor
		if dropletColor == 'yellow'
			haloClass = 'map-needle-halo-'+haloColor
		[tagStatusColor, dropletColor, haloColor, haloClass]

	layerVisibilityByName: (name) ->
		true

	getPopupHtml: (tag) ->
		module = tag.module
		[lat, lng] = [module.gis_latitude, module.gis_longitude]
		if module.projection not in ['', 'wgs84', undefined]
			[lat, lng] = ll2xy module.projection, module.gis_latitude, module.gis_longitude
		moduleTypeId = module.module_type_id
		url = "?action=showModule&networkId=#{module.network_id}&moduleTypeId="+moduleTypeId+"&moduleId=#{module.id}"
		objdesc = tag.object_description
		if objdesc then objdesc = "<p>#{objdesc}</p>"
		"""
			<h3><a href="#{url}">#{module.system_name}</a>, #{tag.tag_meaning}, #{tag.tag_category_name}</h3>
			#{objdesc}
			<table>
			<tr><td>#{t.ModuleList_ModuleName}:</td><td>#{module.module_name}</td></tr>
			<tr><td>#{t.ModuleList_TechnicalName}:</td><td>#{escapeStringForHTML(module.technical_name)}</td></tr>
			<tr><td>#{t.ModuleList_Address}:</td><td>#{module.address}</td></tr>
			</table>
		"""
	
	fitToBounds: ->
		# Get the points of the modules to be viewed (for map bounds calculation).
		tmpTags = @getTagsWithCoords()
		pointsForBoundsCalc = (@correctCoords([tag.module.gis_latitude, tag.module.gis_longitude]) for tag in tmpTags)

		# If there are no modules to be viewed on the map, do nothing more.
		if pointsForBoundsCalc.length == 0
			return
		
		# Fit bounds to the points.
		bounds = new L.LatLngBounds(pointsForBoundsCalc)
		bounds._northEast.lat += (bounds._northEast.lat - bounds._southWest.lat)*0.17
		@fitBounds bounds

	getLayerGroupByName: (name) ->
		layerGroups[name]

	toggleMapNeedles: (color, checked) ->
		if checked
			foundMarkers = markers.filter (marker) ->
				marker.tag.dropletColor == color
			for marker in foundMarkers
				layerGroups[marker.tag.tag_category_name].addLayer marker
		else
			for tagCategoryName, layerGroup of layerGroups
				layerGroup.eachLayer (marker) =>
					if marker.tag.dropletColor == color
						marker.remove()

#$(document).on 'pageshow', '.tagCategoryListPage', (event) ->
#	console.log 'pageshow'
#	if $('#tag-category-list-map').length > 0
#		console.log '>0'
#		map = pgweb.TagCategoryListMap.inst()
#		if map
#			console.log 'map'
#			map.id = 'tag-category-list-map'
#			if !map.isInitialized()
#				map.init()
class pgweb.PulsPGOverview

	instance = null
	nIntervals = 10
	possibleNIntervals = [10, 15, 20, 30, 40, 50]
	possibleNIntervalsIndex= 0
	nLimit = 15
	start = null
	stop = null
	delta = null
	rawArr = null
	period = null
	
	barColors = [
		'black', 'green', 
		'yellow', 'yellow', 'yellow', 'yellow', 
		'orange', 'orange', 'orange', 'orange', 
		'orangered', 'orangered', 'orangered', 
		'red', 'red', 'red'
	]
	
	
	instance = null
	
	@inst: ->
		if not instance?
			instance = new @
		instance
	
	constructor: ->
		$('body').on 'change', '.pulspg-overview-page-range-buttons .range-free', =>
			$('#zoom-free-popup').popup('open');
			$('#free-range-zoom-error-message').text('');
			getStartAndStopTimes()
				
		$('body').on 'change', '.pulspg-overview-page-range-buttons .range-one-year', =>
			reload()
			
		$('body').on 'change', '.pulspg-overview-page-range-buttons .range-six-months', =>
			reload()
			
		$('body').on 'change', '.pulspg-overview-page-range-buttons .range-three-months', =>
			reload()
			
		$('body').on 'change', '.pulspg-overview-page-range-buttons .range-one-month', =>
			reload()
			
		$('body').on 'change', '.pulspg-overview-page-range-buttons .range-one-week', =>
			reload()

		$('body').on 'click', '.showPulsPGOverviewPage #free-zoom-ok', =>
			startTime = new Date $('[name=free-from]').val()
			stopTime = new Date $('[name=free-to]').val()
			if "Invalid Date" in [startTime.toString(), stopTime.toString()]
				$('#free-range-zoom-error-message').text t.InvalidDate
			else
				reload()
				$('#zoom-free-popup').popup 'close'
				
		$('body').on 'click', '.showPulsPGOverviewPage #free-zoom-cancel', =>
			$('#zoom-free-popup').popup 'close'
		
		# Bug in 1.4.5: $('[name=decrease-n-intervals]').button('disable')
		$('[name=decrease-n-intervals]').addClass('ui-disabled')
		
		$('body').on 'click', '[name=decrease-n-intervals]', =>
			possibleNIntervalsIndex--
			if possibleNIntervalsIndex == 0
				#$('[name=decrease-n-intervals]').button('disable')
				$('[name=decrease-n-intervals]').addClass('ui-disabled')
			else
				#$('[name=increase-n-intervals]').button('enable')
				$('[name=increase-n-intervals]').removeClass('ui-disabled')
			if possibleNIntervalsIndex < 0
				possibleNIntervalsIndex = 0
			else
				nIntervals = possibleNIntervals[possibleNIntervalsIndex]
				refreshIndicatorStacks()
		
		$('body').on 'click', '[name=increase-n-intervals]', =>
			possibleNIntervalsIndex++
			if possibleNIntervalsIndex == possibleNIntervals.length-1
				#$('[name=increase-n-intervals]').button('disable')
				$('[name=increase-n-intervals]').addClass('ui-disabled')
			else
				#$('[name=decrease-n-intervals]').button('enable')
				$('[name=decrease-n-intervals]').removeClass('ui-disabled')
			if possibleNIntervalsIndex >= possibleNIntervals.length
				possibleNIntervalsIndex = possibleNIntervals.length-1
			else
				nIntervals = possibleNIntervals[possibleNIntervalsIndex]
				refreshIndicatorStacks()

		$('body').on 'change', '[name=what-channelwire]', (event) =>
			what = $(event.target).val()
			url = '?action=showPulsPGOverview'
			url += '&networkId='+$.url().param().networkId
			url += '&moduleTypeId='+$.url().param().moduleTypeId
			url += '&moduleId='+$.url().param().moduleId
			channel = what.substr 8, 1
			url += '&channel='+channel
			wire = what.substr 10, 1
			url += '&wire='+wire
			$.mobile.changePage url, reload: true

	init: ->
		if $.mobile.activePage
			if not $.mobile.activePage.hasClass("showPulsPGOverviewPage")
				return
		start = 0
		stop = $('[name=wire_length]').val()
		idHash = pgwebGetCookie 'idHash'
		period = pgwebGetCookie 'trends_period_'+idHash
		if !period
			period = 'oneWeek'
		$('[name=range]').val([period]).checkboxradio 'refresh'
		reload()
	
	reload = ->
		[startTime, stopTime] = getStartAndStopTimes()
		ajaxLoad (Math.round nIntervals), startTime, stopTime
	
	getStartAndStopTimes = ->
		periods =
			free: 0
			oneYear: 365
			sixMonths: 180
			threeMonths: 90
			oneMonth: 30
			oneWeek: 7
		period = $('input[name=range]:checked').val()
		idHash = pgwebGetCookie 'idHash'
		pgwebSetCookie 'trends_period_'+idHash, period
		days = periods[period]
		if days == 0
			startTime = new Date $('[name=free-from]').val()+" 00:00:00.000"
			stopTime = new Date $('[name=free-to]').val()+" 23:59:59.999"
			if startTime.toString() == 'Invalid Date'
				now = new Date()
				dateStr = now.toISOString().substr 0, 10
				startTime = new Date dateStr+" 00:00:00.000"
				$('[name=free-from]').val dateStr
			if stopTime.toString() == 'Invalid Date'
				now = new Date()
				dateStr = now.toISOString().substr 0, 10
				stopTime = new Date dateStr+" 23:59:59.999"
				$('[name=free-to]').val dateStr
		else
			startTime = getMinXFromDays days, 0
			stopTime = getMaxXFromDays days, 0
		[startTime, stopTime]
	
	ajaxLoad = (nIntervals, startTime, stopTime) ->
		waitStart()
		$('#pulspg-overview-graph').fadeTo 'fast', 0, ->
			$.ajax
				url: "/pgweb/ajax/pulspg/pulsPGOverview.php"
				dataType: 'json'
				type: 'POST'
				data:
					moduleId: parseInt $.url().param().moduleId
					channel: parseInt $.url().param().channel
					wire: parseInt $.url().param().wire
					start: start
					stop: stop
					nIntervals: nIntervals
					startTime: dateTimeToDBFormat localDateToUTC startTime
					stopTime: dateTimeToDBFormat localDateToUTC stopTime
				success: (data) =>
					switch data.result
						when "OK"
							rawArr = data.rawArr
							refreshIndicatorStacks()
							loadTable()
							$('#pulspg-overview-graph').fadeTo 'fast', 1
						when 'NOT_LOGGED_IN'
							handleInactivity()
						else
							pgweb.ErrorDialog.inst().show('Failed', 'Failed to get pulsPG overview data.', data.result+' '+data.debug);
				error: ajaxFailure
				complete: -> waitStop()

	loadTable = () ->
		$('#pulspg-overview-list').html ''
		html  = '<table data-role="table" data-mode="columntoggle" data-column-btn-text="'+t.ModuleList_ColumnsToView+'" class="ui-responsive"><thead>'
		html += '<tr>'
		html += '<th data-priority="1">'+t.PulsPGQPG_Time+'</th><th data-priority="1">'+t.PulsPGQPG_Type+'</th>'
		html += '<th data-priority="2">'+t.PulsPGQPG_Distance+' [m]</th><th data-priority="3">'+t.PulsPGQPG_Divergence+' [%]</th>'
		html += '<th data-priority="4">'+t.PulsPGQPG_Status+'</th></tr></thead>'
		html += '<tbody>'
		for item in rawArr
			indicationOrDamage =
				if item.indication and item.damage then t.PulsPGQPG_DamageAndIndication
				else if item.indication then t.PulsPGQPG_Indication 
				else if item.damage then t.PulsPGQPG_Damage
			html += '<tr>'
			html += '<td>'+item.time+'</td>'
			html += '<td>'+indicationOrDamage+'</td>'
			html += '<td>'+item.eldf+'</td>'
			html += '<td>'+item.diverg+'</td>'
			html += '<td>'+item.statuscode+'</td>'
			html += '</tr>'
		html += '</tbody>'
		html += '</table>';
		$('#pulspg-overview-list').html html
		$('#pulspg-overview-list table').table()
		fixColumnToggleBug();

	refreshIndicatorStacks = () ->
		delta = (stop - start)/nIntervals
		stacksArr = computeIndicatorStacks rawArr, start, stop, nIntervals
		drawIndicatorStacks stacksArr

	computeIndicatorStacks = (arr, start, stop, nIntervals) ->

		retArr = []
		
		pos = start
		while pos < stop-0.001

			nIndications = 0
			nDamages = 0
			for item in arr
				if item.eldf >= pos and item.eldf < pos + delta
					if item.indication?
						if item.indication != 0
							nIndications++
					if item.damage?
						if item.damage != 0
							nDamages++
			retArr.push
				pos: pos
				nIndications: nIndications
				nDamages: nDamages

			pos += delta

		retArr

	drawIndicatorStacks = (nIndicationsArr) ->
		html = '<table id="pulspg-overview-table"><tr>'
		$.each nIndicationsArr, (index, item) ->
			
			widthPercentage = 100/nIndicationsArr.length
			nBars = nToNBars item.nIndications
			html += '<td width="'+widthPercentage+'%">'
			
			html += '<div class="pulspg-overview-exceed-arrow-container">'
			if item.nIndications >= nLimit
				html += '<i class="fa fa-chevron-up"></i> '+item.nIndications
			html += '</div>'
			
			html += drawIndicatorStack nBars, item.nDamages > 0
			
			html += '<div class="pulspg-overview-stack-title-container">'
			html += '<div class="pulspg-overview-stack-title">'+Math.round(item.pos)+'-'+Math.round(item.pos+delta)
			html += '</div>'
			html += '</div>'
			html += '</td>'
			
		html += '</tr></table>'
		$('#pulspg-overview-graph').html html
	
	drawIndicatorStack = (nBars, damage) ->
		html = ''
		damageClass = if damage then 'pulspg-overview-damage-redborder' else ''
		html += '<div class="'+damageClass+'">'
		if nBars < nLimit
			for i in [nLimit..nBars+1]
				cl = 'pulspg-overview-ind-black'
				html += '<div class="pulspg-overview-ind '+cl+'"></div>'
		if nBars > 0
			for i in [nBars..1]
				cl = 'pulspg-overview-ind-' + barColors[i]
				html += '<div class="pulspg-overview-ind '+cl+'"></div>'
		html += '</div>'
		html
	
	nToNBars = (n) ->
		if n < nLimit
			n+1
		else
			nLimit
	
	@inst: ->
		if not instance?
			instance = new @
		instance

$(document).on 'pageshow', '.showPulsPGOverviewPage', (event) ->
	pgweb.PulsPGOverview.inst().init()
class pgweb.SystemOverviewMap

	instance = null
	maximized = false
	fullscreen = false
	map = null
	markerLayer = null
	networks = null
	
	@inst: ->
		# Run only on system overview page.
		if $.url().param().action != 'showSystemOverview'
			return
		if not instance?
			instance = new @
		instance

	init: ->
		# Create the map object.
		map = @createMap()

		# Add the map fullscreen toggle button.
		map.addControl(@createFullscreenButton())

		# Add the map height toggle button.
		map.addControl(@createMaximizeButton())

		# Display markers for all the networks

		markerClusterGroup = L.markerClusterGroup
			spiderfyOnMaxZoom: true
			showCoverageOnHover: true
			zoomToBoundsOnClick: true
			singleMarkerMode: true
			removeOutsideVisibleBounds: true
			animate: true
			maxClusterRadius: 57
			iconCreateFunction: @iconCreateFunction
		
		# Array 'markers' is global, defined in javascript by php
		markerClusterGroup.addLayers markers
		
		map.addLayer markerClusterGroup


		fitToBounds()
		map.on 'resize', ->
			fitToBounds()

		maximized = @getMaximizedCookie()
		if ($.url().attr 'anchor') == 'fullscreen'
			$('.map-fullscreen-button').trigger 'click'
		else
			if maximized
				maximized = not maximized
				$('.map-maximize-button').trigger 'click'
				
	
	isInitialized: ->
		return not $('#system-overview-map').is ':empty' 
	
	iconCreateFunction: (cluster) ->
		childMarkers = cluster.getAllChildMarkers()
		sum = 0
		for childMarker in childMarkers
			sum += childMarker.nModules
		if childMarkers.length == 1 # Leaf node
			height = 40
			return L.divIcon
				html: '<div class="cluster-icon-text">'+sum+'</div>'
				className: 'cluster-icon cluster-icon-leaf'
				iconSize: L.point 40, height
		else # Not a leaf node
			height = 65
			return L.divIcon
				html: '<div class="cluster-icon-text cluster-icon-text-noleaf"><span class="cluster-icon-childnodes">'+childMarkers.length+'</span><br/>'+sum+'</div>'
				className: 'cluster-icon'
				iconSize: L.point 40, height

	getMaximizedCookie: ->
		idHash = pgwebGetCookie 'idHash'
		Number(pgwebGetCookie 'systemoverviewmap_maximized_'+idHash) == 1
	
	setMaximizedCookie: (bool) ->
		idHash = pgwebGetCookie 'idHash'
		pgwebSetCookie 'systemoverviewmap_maximized_'+idHash, Number(bool)
	
	fitToBounds = ->
		# Get the points of the networks to be viewed (for map bounds calculation).
		pointsForBoundsCalc = ([marker._latlng.lat, marker._latlng.lng] for marker in markers)

		# If there are no networks to be viewed on the map, do nothing more.
		if pointsForBoundsCalc.length == 0
			#if (markerLayer?)
			#	markerLayer.clearLayers()
			return
		
		# Fit bounds to the points.
		bounds = new L.LatLngBounds(pointsForBoundsCalc)
		#bounds._northEast.lat += 1;
		#bounds._southWest.lat -= 1;
		map.fitBounds bounds
	
	refresh: ->
		map.invalidateSize()
		
	# Create the map object.
	createMap: ->
		normalm = L.tileLayer.baiduLayer 'Normal.Map'
		#satellitem = L.tileLayer.baiduLayer 'Satellite.Map'
		normal = L.layerGroup [normalm]

		if USE_BAIDU_MAPS
			crs = L.CRS.Baidu # As defined in js/leaflet.baidu.
		else
			crs = L.CRS.EPSG3857 # Default CRS for Leaflet.

		map = L.map('system-overview-map',
			crs: crs
			zoomAnimationThreshold: 17
			attributionControl: false
		)
		attribution = """
			Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>
		"""
		config =
			attribution: attribution
			maxZoom: 21
			maxNativeZoom: 19

		if USE_BAIDU_MAPS
			map.addLayer normal
		else
			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', config).addTo map
		
		return map
	
	clearMarkers: ->
		if (markerLayer?)
			markerLayer.clearLayers()
	
	# Create the map resize toggle button.
	createMaximizeButton: ->
		MaximizeButton = L.Control.extend(
			options:
				position: 'topright'
			onAdd: (map) =>
				button = L.DomUtil.create('button', 'map-maximize-button')
				$(button).html('<i class="fa fa-arrows-v fa-lg"></i>')
				$('body').off 'click', '.map-maximize-button'
				$('body').on 'click', '.map-maximize-button', (event, ui) =>
					maximized = not maximized
					if maximized
						@setMaximizedButtonPressed()
						height = 500
					else
						@setMaximizedButtonReleased()
						height = 200
					@setMaximizedCookie maximized
					$('#system-overview-map').animate
						height: "#{height}px"
						100
						@refresh

				return button
		)
		return new MaximizeButton()

	setMaximizedButtonPressed: ->
		$('.map-maximize-button').css
			'background-color': '#ddf'
		
	setMaximizedButtonReleased: ->
		$('.map-maximize-button').css
			'background-color': '#fff'
	
	# Create the map fullscreen button.
	createFullscreenButton: ->
		FullscreenButton = L.Control.extend(
			options:
				position: 'topright'
			onAdd: (map) =>
				button = L.DomUtil.create('button', 'map-fullscreen-button')
				$(button).html('<i class="fa fa-expand fa-lg"></i>')
				$('body').off 'click', '.map-fullscreen-button'
				$('body').on 'click', '.map-fullscreen-button', (event, ui) =>
					fullscreen = not fullscreen
					if fullscreen
						$('#system-overview-map').css
							position: 'fixed'
							width: '100%'
							height: $(window).height()
							top: 0
							left: 0
							'z-index': 1000
						$('.map-maximize-button').hide()
						$(button).html('<i class="fa fa-compress fa-lg"></i>')

						$.mobile.navigate $.url().attr('path')+'?'+$.url().attr('query')+'#fullscreen'
					else
						if maximized
							height = 500.toString()
							@setMaximizedButtonPressed()
						else
							height = 200.toString()
							@setMaximizedButtonReleased()
						$('#system-overview-map').css
							position: 'relative'
							width: 'auto'
							height: height+'px'
							top: 0
							left: 0
							'z-index': 0
						$('.map-maximize-button').show()
						$(button).html('<i class="fa fa-expand fa-lg"></i>')

						$.mobile.navigate $.url().attr('path')+'?'+$.url().attr('query')
					@refresh()

				return button
		)
		return new FullscreenButton()

$(->
	systemOverviewMap = pgweb.SystemOverviewMap.inst()
	if systemOverviewMap
		if !systemOverviewMap.isInitialized()
			systemOverviewMap.init()
)
class pgweb.SystemOverviewPage

	constructor: ->
		$('body').on 'pageshow', '.systemOverviewPage', =>
			pgweb.SystemOverviewMap.inst().init()
		
	instance = null
	
	@inst: ->
		if not instance?
			instance = new @
		instance

$(-> pgweb.SystemOverviewPage.inst())
class pgweb.AdvenOverviewMap

	instance = null
	maximized = false
	fullscreen = false
	map = null
	markerLayer = null
	allLayers = []
	layers = []
	modules: null
	lastHighlightedLayer = null
	lastHighlightedLayerColor = null
	networkId = null

	@inst: ->
		# Run only on Adven overview page.
		if $.url().param().action != 'showSollefteaTryck' and $.url().param().action != 'showTimraTryck'
			return
		if not instance?
			instance = new @
		instance

	init: ->
		action = $.url().param().action
		if action == 'showTimraTryck' then networkId = 109
		else if action == 'showSollefteaTryck' then networkId = 114
		else
			alert 'Unknown network'
			return

		# Map will always update, so hide the control for auto-updating.
		$('#auto-update-container').hide()
		
		initGeoJSON networkId

		# Create the map object.
		map = @createMap networkId

		# Add the map fullscreen toggle button.
		map.addControl @createFullscreenButton()

		# Add the map height toggle button.
		map.addControl @createMaximizeButton()

		# Add the return zoom button.
		map.addControl @createReturnZoomButton()

		map.on 'resize', =>
			@fitToBounds()

		map.on 'zoomend', (obj) ->
			onZoomEnd()

		maximized = @getMaximizedCookie()
		if ($.url().attr 'anchor') == 'fullscreen'
			$('.map-fullscreen-button').trigger 'click'
		else
			if maximized
				maximized = not maximized
				$('.map-maximize-button').trigger 'click'
		
		@ajaxLoadModules networkId
		
		setInterval =>
			@updatePopups()
		, pgweb.Main.getUpdateInterval()

		setTimeout =>
			@updatePopups()
		, 2000
		
		$(document).on 'keyup', (event) ->
			if event.key == 'F11'
				if fullscreen
					location.reload()
		
		@ajaxGetTemperature networkId
		setInterval =>
			@ajaxGetTemperature networkId
		, 600000
		
	onZoomEnd = ->
		#console.log "zoom="+map.getZoom()
		if not layers? then return
		for layer in layers
			if map.getZoom() < layer.visibleZoomLevel
				#console.log 'unzoomat för att ta bort lager'
				if layer.visible
					#console.log 'tar bort lager '+layer.file
					if layer.geojson
						map.removeLayer layer.geojson
					layer.visible = false
			else
				#console.log 'inzoomat för att lägga till lager'
				if not layer.visible
					#console.log 'lägger till lager '+layer.file
					if layer.geojson
						map.addLayer layer.geojson
					layer.visible = true
				weight = Math.min map.getZoom()/5 - 1, 2
				if layer.geojson
					layer.geojson.setStyle weight: weight

	initGeoJSON = (networkId) ->
		# Data for the GeoJSON layers

		allLayers = []

		if networkId == 109
			allLayers[networkId] = [
					index: 0
					file: 'Timra_pipes_20190304'
					color: '#000000'
					visibleZoomLevel: 1
					clickable: false
			]
		else if networkId == 114
			allLayers[networkId] = [ 
					index: 0
					file: 'solleftea_centrumlinje_20190408'
					color: '#000000'
					visibleZoomLevel: 1
					clickable: false
			]
		else alert 'Unknown network'

	isInitialized: ->
		return not $('#adven-overview-map').is ':empty' 
	
	getMaximizedCookie: ->
		idHash = pgwebGetCookie 'idHash'
		Number(pgwebGetCookie 'advenoverviewmap_maximized_'+idHash) == 1
	
	setMaximizedCookie: (bool) ->
		idHash = pgwebGetCookie 'idHash'
		pgwebSetCookie 'advenoverviewmap_maximized_'+idHash, Number(bool)
	
	fitToBounds: ->
		# Get the points of the modules to be viewed (for map bounds calculation).
		#pointsForBoundsCalc = ([module.gis_latitude, module.gis_longitude] for module in @modules)
		if networkId == 114 # Sollefteå
			pointsForBoundsCalc = [[ 63.152, 17.245], [63.192, 17.315]]
		else if networkId == 109 # Timrå
			pointsForBoundsCalc = [[ 62.477, 17.32], [62.517, 17.36]]
		else alert 'Unknown network id!'

		# Fit bounds to the points.
		bounds = new L.LatLngBounds(pointsForBoundsCalc)
		map.fitBounds bounds
	
	refresh: ->
		map.invalidateSize()
		
	# Create the map object.
	createMap: (networkId) ->
		map = L.map 'adven-overview-map',
			zoomAnimationThreshold: 17
			attributionControl: false
		attribution = ""
		config =
			attribution: attribution
			maxZoom: 21
			maxNativeZoom: 19
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', config).addTo map
		
		addGeoJSONLayers map, networkId

		map

	addGeoJSONLayers = (map, networkId) ->
		layers = allLayers[networkId]
		if layers
			for layer in layers
				getGeoJSONByAjax layer
			map.on 'click', ->
				if lastHighlightedLayer
					lastHighlightedLayer.setStyle color: lastHighlightedLayerColor
	
	getGeoJSONByAjax = (layer) ->
		$.getJSON 'shapefiles/'+layer.file+'.json', (data, textStatus, jqXHR) ->
			calledFile = this.url.substring 11, this.url.indexOf '.json'
			layerData = findLayer layers, calledFile
			geojsonFeature = data
			geojson = L.geoJson geojsonFeature, 
				style:
					color: layerData.color
					opacity: 1
				onEachFeature: (feature, featureLayer) ->
					featureGroup = L.featureGroup([featureLayer])
					featureGroup.on 'click', (e) ->
						#onFeatureClick feature, featureGroup, layerData
					featureGroup.addTo map
			layerData.visible = true
			layers[layerData.index].geojson = geojson
			onZoomEnd()
	
	# Find the layer which has a specific file.
	findLayer = (layers, file) ->
		for layer in layers
			if layer.file == file
				return layer

	# Create the markers with popups.
	createMarkers: (networkId) ->
		# Classes needed for the map needles
		MapNeedle = L.Icon.extend
			options:
				shadowUrl: 'images/mapneedle_shadow.png'
				iconSize: [20, 32],
				shadowSize: [21, 25],
				iconAnchor: [10, 32],
				shadowAnchor: [5, 25],
				popupAnchor: [0, -32]
		icons =
			grayIcon: new MapNeedle
				iconUrl: 'images/mapneedle_gray.png'
			greenIcon: new MapNeedle
				iconUrl: 'images/mapneedle_green.png'
			yellowIcon: new MapNeedle
				iconUrl: 'images/mapneedle_yellow.png'
			yellowredIcon: new MapNeedle
				iconUrl: 'images/mapneedle_yellowred.png'
			redIcon: new MapNeedle
				iconUrl: 'images/mapneedle_red.png'

		# If the marker layer exists, remove all markers from it, else create the marker layer
		# and add it to the map.
		if (markerLayer?)
			markerLayer.clearLayers()
		else
			markerLayer = L.layerGroup()
		markerLayer.addTo map

		if networkId == 114 # Sollefteå
			arr = [
				  # 001 Hundskolan, Djursjukhus
					module_name: 'eonSOL_MT102_1817001'
					popup_position: [63.150, 17.375]
					in_map: true
				, # 002 Linjevägen 31
					module_name: 'eonSOL_MT102_1817002'
					popup_position: [63.188, 17.302]
					in_map: true
				, # 003 Prästbordets skola
					module_name: 'eonSOL_MT102_1817003'
					popup_position: [63.150, 17.24]
					in_map: true
				, # 004 Brandstation
					module_name: 'eonSOL_MT102_1817004'
					popup_position: [63.165, 17.18]
					in_map: true
				, # 005 Nipan 43
					module_name: 'eonSOL_MT102_1817005'
					popup_position: [63.188, 17.242]
					in_map: true
				, # 006 Zeunerts
					module_name: 'SOL_MT102_2149001'
					popup_position: [63.1685, 17.36]
					in_map: true
				, # 007 Bollsta SCA Kontor
					module_name: 'eonSOL_MT102_1851001'
					popup_position: [63.188, 17.375]
					in_map: false
				, # 008 Faxängen (Naturbruk)
					module_name: 'SOL_MT102_2010001'
					popup_position: [63.188, 17.18]
					in_map: false
			]
		else if networkId == 109 # Timrå
			arr = [
				  # 001 Örnen
					module_name: 'eonTIMRA_MT102_1817001'
					popup_position: [62.500, 17.28]
					in_map: true
				, # 002 Böle förskola
					module_name: 'eonTIMRA_MT102_1817002'
					popup_position: [62.485, 17.40]
					in_map: true
				, # 003 Gymmet
					module_name: 'eonTIMRA_MT102_1817003'
					popup_position: [62.483, 17.28]
					in_map: true
				, # 004 test
					module_name: 'eonTIMRA_MT102_1817004'
					popup_position: [62.510, 17.325]
					in_map: true
				, # 005 Sörberge Timråbo
					module_name: 'eonTIMRA_MT102_1817005'
					popup_position: [62.505 , 17.41]
					in_map: true
			]
		else alert 'Unknown network id!'

		setTimeout =>
			for module in @modules
				
				obj = (a for a in arr when a.module_name == module.module_name)[0]
				if !obj then continue

				coords = [module.gis_latitude, module.gis_longitude]
				url = "?action=showModule&networkId=#{module.network_id}&moduleTypeId=0&moduleId=#{module.id}"
				html = ''
				#if not obj.in_map
				html += "<a href=\""+url+"\" target=\"_blank\"><h3>#{module.technical_name}</h3>"
				html += "<div id=\"overview-bars#{module.id}\" class=\"overview-bars overview-timeralarm\"></div></a>"
				
				iconName = pgweb.PVStatus.toColor(module.pv_status)+'Icon'
				marker = L.marker coords, 
					icon: icons[iconName]
					title: module.module_name
				markerLayer.addLayer(marker)
				
				className = 'overview-popup'
				#if not obj.in_map
				className += ' overview-popup-not-in-map'
				popup = L.popup
					autoPan: false
					closeButton: false
					closeOnClick: false
					autoClose: false
					offset: [0, 64]
					className: className
				.setLatLng(obj.popup_position).setContent html
				map.addLayer popup
				
				# If the module's coordinates are in the map view, draw a line between it
				# and the popup.
				if obj.in_map
					xy = [obj.popup_position[0]+0.0016, obj.popup_position[1]]
					latlngs = [coords, xy]
					line = L.polyline latlngs,
						color: '#f00'
						opacity: 1
						weight: 3
					map.addLayer line
		, 500
	
	clearMarkers: ->
		if (markerLayer?)
			markerLayer.clearLayers()
	
	# Create the map resize toggle button.
	createMaximizeButton: ->
		MaximizeButton = L.Control.extend
			options:
				position: 'topright'
			onAdd: (map) =>
				button = L.DomUtil.create('button', 'map-maximize-button')
				$(button).html('<i class="fa fa-arrows-v fa-lg"></i>')
				$('body').off 'click', '.map-maximize-button'
				$('body').on 'click', '.map-maximize-button', (event, ui) =>
					maximized = not maximized
					@setMaximized maximized
				return button
		return new MaximizeButton()

	setMaximized: (val) ->
		maximized = val
		if maximized
			@setMaximizedButtonPressed()
			height = 500
		else
			@setMaximizedButtonReleased()
			height = 200
		@setMaximizedCookie maximized
		$('#adven-overview-map').animate
			height: "#{height}px"
			100
			@refresh

	# Create the return zoom button.
	createReturnZoomButton: ->
		MaximizeButton = L.Control.extend
			options:
				position: 'topright'
			onAdd: (map) =>
				button = L.DomUtil.create('button', 'map-return-zoom-button')
				$(button).html('<i class="fa fa-square-o fa-lg" style="margin-top: 2px"></i>')
				$('body').off 'click', '.map-return-zoom-button'
				$('body').on 'click', '.map-return-zoom-button', (event, ui) =>
					@fitToBounds()
				return button
		return new MaximizeButton()

	setMaximizedButtonPressed: ->
		$('.map-maximize-button').css
			'background-color': '#ddf'
		
	setMaximizedButtonReleased: ->
		$('.map-maximize-button').css
			'background-color': '#fff'
	
	# Create the map fullscreen button.
	createFullscreenButton: ->
		FullscreenButton = L.Control.extend
			options:
				position: 'topright'
			onAdd: (map) =>
				button = L.DomUtil.create('button', 'map-fullscreen-button')
				$(button).html('<i class="fa fa-expand fa-lg"></i>')
				$('body').off 'click', '.map-fullscreen-button'
				$('body').on 'click', '.map-fullscreen-button', (event, ui) =>
					fullscreen = not fullscreen
					if fullscreen
						$('#overview-logo').show()
						$('#adven-overview-map').css
							position: 'fixed'
							width: '100%'
							height: $(window).height()
							top: 0
							left: 0
							'z-index': 1000
						$('.map-maximize-button').hide()
						$(button).html('<i class="fa fa-sign-out fa-lg" style="margin-top: 1px; margin-left: 2px;"></i>')

						url = $.url().attr('path')+'?'+$.url().attr('query')+'#fullscreen'
						$.mobile.navigate url
					else
						$('#overview-logo').hide()
						if maximized
							height = 500.toString()
							@setMaximizedButtonPressed()
						else
							height = 200.toString()
							@setMaximizedButtonReleased()
						$('#adven-overview-map').css
							position: 'relative'
							width: 'auto'
							height: height+'px'
							top: 0
							left: 0
							'z-index': 0
						$('.map-maximize-button').show()
						$(button).html('<i class="fa fa-expand fa-lg"></i>')

						$.mobile.navigate $.url().attr('path')+'?'+$.url().attr('query')
						
						@setMaximized true
						setTimeout =>
							@fitToBounds()
						, 3000
					@refresh()

				return button
		return new FullscreenButton()

	ajaxLoadModules: (networkId) ->
		$.ajax
			url: "/pgweb/ajax/adven/advenOverviewMap.php"
			dataType: 'json'
			type: 'GET'
			data:
				networkId: networkId
				authCode: $.url().param('authCode')
			success: (data) => 
				switch data.result
					when "OK"
						@modules = data.modules
						@displayModules networkId
						@fitToBounds()
						@updatePopups()
					when 'NOT_AUTHENTICATED'
						# Do nothing.
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get Adven overview map data.', data.result+' '+data.debug);
			error: ajaxFailure

	ajaxUpdatePopup: (moduleId) ->
		$.ajax
			url: "/pgweb/ajax/adven/advenOverviewBars.php"
			dataType: 'json'
			type: 'GET'
			data:
				moduleId: moduleId
				authCode: $.url().param('authCode')
			success: (data) => 
				switch data.result
					when "OK"
						$("#overview-bars"+moduleId).html data.html
					when 'NOT_AUTHENTICATED'
						# Do nothing.
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get Övik overview value data.', data.result+' '+data.debug);
			error: (jqXHR, str, ex) ->
				if jqXHR.readyState == 0 and jqXHR.statusText == 'error' and jqXHR.status == 0 and jqXHR.responseText == ''
					# Empty error, do nothing.
					# console.log 'Empty error!'
				else
					ajaxFailure jqXHR, str, ex

	ajaxGetTemperature: (networkId) ->
		#console.log 'Temperature'
		#$('#overview-temperature').html "-28 °C"
		#return
		waitStart()
		$.ajax
			url: $.url().attr('base')+'/pgweb/ajax/adven/advenOverviewWeather.php?networkId='+networkId
			dataType: 'json'
			type: 'GET'
			success: (data) => 
				$('#overview-temperature').html Math.round(data.main.temp)+' C°'
			error: (jqXHR, str, ex) =>
				ajaxFailure jqXHR, str, ex
				$('#overview-temperature').html ''
			complete: -> waitStop()

	displayModules: (networkId) ->
		@createMarkers networkId

	updatePopups: ->
		for module in @modules
			@ajaxUpdatePopup module.id

$ -> 
	advenOverviewMap = pgweb.AdvenOverviewMap.inst()
	if advenOverviewMap
		if !advenOverviewMap.isInitialized()
			advenOverviewMap.init()
class pgweb.AnalysisGW102
	N_CURVES = 15
	MARGIN_LEFT = 80
	MARGIN_RIGHT = 100
	HEATMAP_VERTICAL_N_PERIODS = 144 # 12 hours * 12 periods when 5 minute periods is selected
	
	_themeType = null
	_timezone = { 'identifier': '', 'offset': 0}
	_currentData = null

	_lineChart = null
	#_heatmapChart = null
	_heatmapVerticalChart = null
	_heatmapVerticalStartTime = null
	_heatmapVerticalEndTime = null
	
	_colorAxisStops = [
		[0.00, '#0000aa']
		[0.08, '#0000ff']
		[0.14, '#0044ff']
		[0.23, '#0088ff']
		[0.30, '#00eeff']
		[0.37, '#00ffff']
		[0.44, '#00ff77']
		[0.50, '#00ff00']
		[0.57, '#77ff00']
		[0.64, '#ffff00']
		[0.74, '#ffee00']
		[0.81, '#ff8800']
		[0.88, '#ff6600']
		[0.93, '#ff2200']
		[1.00, '#ff0000']
	]

	_periods =
		free: 0
		sixMonths: 180
		threeMonths: 90
		oneMonth: 30
		oneWeek: 7

	_crosshairConfig =
		width: 1
		color: 'gray'
		dashStyle: 'dash'
		zIndex: 10

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	constructor: ->
		
	init: ->
		_themeType = parseInt $('#theme-type').val()

		$('body').off 'change', '.analysis-tool-range-buttons .range-free'
		$('body').on 'change', '.analysis-tool-range-buttons .range-free', (event) ->
			$('#zoom-free-popup').popup 'open'
			$('#free-range-zoom-error-message').text ''
		
		$('body').off 'change', '.analysis-tool-range-buttons .range-six-months'
		$('body').on 'change', '.analysis-tool-range-buttons .range-six-months', (event) ->
			loadLineChart(false)
		
		$('body').off 'change', '.analysis-tool-range-buttons .range-three-months'
		$('body').on 'change', '.analysis-tool-range-buttons .range-three-months', (event) ->
			loadLineChart(false)
		
		$('body').off 'change', '.analysis-tool-range-buttons .range-one-month'
		$('body').on 'change', '.analysis-tool-range-buttons .range-one-month', (event) ->
			loadLineChart(false)
		
		$('body').off 'change', '.analysis-tool-range-buttons .range-one-week'
		$('body').on 'change', '.analysis-tool-range-buttons .range-one-week', (event) ->
			loadLineChart(false)
		
		$('body').off 'click', '.showGW102AnalysisPage #free-zoom-ok'
		$('body').on 'click', '.showGW102AnalysisPage #free-zoom-ok', (event) ->
			min = new Date $('[name=free-from]').val()
			max = new Date $('[name=free-to]').val()
			if min == "Invalid Date" or max == "Invalid Date"
				$('#free-range-zoom-error-message').text t.InvalidDate
			else
				loadLineChart(false)
				$('#zoom-free-popup').popup 'close'
		
		$('body').off 'click', '.showGW102AnalysisPage #free-zoom-cancel'
		$('body').on 'click', '.showGW102AnalysisPage #free-zoom-cancel', (event) ->
			$('#zoom-free-popup').popup 'close'

		$('body').off 'change', '#show-every-point'
		$('body').on 'change', '#show-every-point', (event) ->
			loadLineChart(false)

		$('body').off 'pageshow', '.showGW102AnalysisPage'
		$('body').on 'pageshow', '.showGW102AnalysisPage', (event) ->
			loadLineAndHeatmapCharts()

		$('body').off 'change', '[name=what-curve]'
		$('body').on 'change', '[name=what-curve]', (event) ->
			loadLineAndHeatmapCharts()

		$('#time-resolution-container').hide()

		$('#time-resolution').on 'change', ->
			loadHeatmapVerticalChart()

		$('body').off 'click', '#x-zoom-reset-button'
		$('body').on 'click', '#x-zoom-reset-button', (event) ->
			period = $('[name=range]:checked').val()
			days = _periods[period]
			if days == 0
				minmax = pgweb.TrendsPage.getMinMax days
				min = minmax[0]
				max = minmax[1]
				from = dateTimeToJSTime min
				to = dateTimeToJSTime max
				_lineChart.xAxis[0].setExtremes from, to
			else
				setXAxisInterval days
			pgweb.TrendsPage.showZoomXResetButton false

		pgweb.TrendsPage.showZoomXResetButton false
	
	setXAxisInterval = (days) ->
		minXLocal = getMinXFromDays days, _timezone.offset
		maxXLocal = getMaxXFromDays days, _timezone.offset
		minXLocal = dateTimeToJSTime minXLocal
		maxXLocal = dateTimeToJSTime maxXLocal
		_lineChart.xAxis[0].setExtremes minXLocal, maxXLocal

	onLineChartClick = (e) ->
		_heatmapVerticalEndTime = e.xAxis[0].value
		loadHeatmapVerticalChart()

	#@setHeatmapChart: (chart) ->
	#	_heatmapChart = chart

	#@getHeatmapChart: ->
	#	_heatmapChart

	setHeatmapVerticalChart = (chart) ->
		_heatmapVerticalChart = chart

	getHeatmapVerticalChart = ->
		_heatmapVerticalChart

	loadLineAndHeatmapCharts = ->
		loadLineChart(true)
		#loadHeatmapChart()

	loadLineChart = (clearHeatmapVertical) ->
		showEveryPoint = $('#show-every-point').prop 'checked'

		period = $('[name=range]:checked').val()
		if (!period)
			period = 'oneWeek'
		days = _periods[period]

		min = null
		max = null
		if days == 0 # Free selection of start and end time.
			# Order of start date and end date does not matter.
			date1 = $('[name=free-from]').val()
			date2 = $('[name=free-to]').val()
			if date2 < date1
				dateTmp = date1
				date1 = date2
				date2 = dateTmp
			min = new Date date1+" 00:00:00.000"
			max = new Date date2+" 23:59:59.999"
			if min == 'Invalid Date'
				now = new Date()
				dateStr = now.toISOString().substr 0, 10
				min = new Date dateStr+" 00:00:00.000"
				$('[name=free-from]').val dateStr
			if max == 'Invalid Date'
				now = new Date()
				dateStr = now.toISOString().substr 0, 10
				max = new Date dateStr+" 23:59:59.999"
				$('[name=free-to]').val dateStr
			min = new Date(min.getTime() - min.getTimezoneOffset()*60000)
			max = new Date(max.getTime() - max.getTimezoneOffset()*60000)
		else
			min = getMinXFromDays days, _timezone.offset
			max = getMaxXFromDays days, _timezone.offset
		msg = ''
		if not showEveryPoint
			if days == 0
				timeDiff = (max.getTime() - min.getTime())/1000; # Convert ms into s.
				periodMinutes = Math.floor(timeDiff/1000)/60; # Period length in minutes.
				periodHours = 0
				if periodMinutes >= 60
					periodHours = Math.floor periodMinutes/60
					periodMinutes = Math.floor periodMinutes % 60
				msg = periodHours+" h "+periodMinutes.toFixed(1)+" min"
			else if days > 0 and days <= 7 # Up to 1 week
				msg = "10 min" # 10 minutes resolution = max 1008 values
			else if days > 7 and days <= 31 # Up to 1 month
				msg = "1 h" # 1 hour resolution = max 744 values
			else if days > 31 && days <= 93 # Up to 3 months
				msg = "3 h" # 3 hours resolution = max 744 values
			else if days > 93 && days <= 186 # Up to 6 months
				msg = "6 h" # 6 hours resolution = max 744 values
			else # More than 6 months
				msg = "24 h" # 24 hours resolution
			msg = t.TrendsPage_MaxOneValuePer + ' ' + msg
		$('#show-every-point-message').html msg

		pgweb.TrendsPage.showZoomXResetButton false

		howMuchData = days
		seriesColors = [
			'#941D2A', '#A8212C', '#B9242C', '#CD282D', '#E12A2E', '#FC3030', '#FE612E', '#FD872C', '#FCBC2A', '#FBDA29', '#FBFB28', '#FCFF5A', '#FDFF99', '#FEFFC6', '#FFFFEC'
		]

		yAxisStandardConfig = pgweb.CurveChart.inst().yAxisFloatConfig '#999', false, .001, 1
		yAxisExtraConfig =
			labels:
				formatter: AnalysisGW102.lineChartYLabelFormatter
			min: -80
			max: 0
			tickPositions: pgweb.SonitusCalculator.calcYTickPositions()
		yAxisConfig = Object.assign yAxisStandardConfig, yAxisExtraConfig

		zoom = ''
		if $('.showGW102AnalysisPage .allow-zoom-button').is(':checked')
			zoom = 'xy'
		zoom = 'x'
		moduleName = $('#module-name').val()
		title = moduleName+', '+$('[name=what-curve]').val().toUpperCase()
		renderTo = $(".ui-page-active .linechart-container").get()[0]
		_lineChart = pgweb.CurveChart.inst().create min, max, zoom, title, yAxisConfig, 0, seriesColors, renderTo, lineChartToolTipFormatter, true
		
		_lineChart.update
			chart:
				marginLeft: MARGIN_LEFT
				marginRight: MARGIN_RIGHT
			legend:
				enabled: true
				layout: 'vertical'
				verticalAlign: 'top'
				align: 'right'
				reversed: true
			exporting:
				enabled: false
			plotOptions:
				series:
					point:
						events:
							mouseOut: onLineChartMouseOut
			xAxis:
				crosshair: _crosshairConfig
				minTickInterval: 3600*1000
			yAxis:
				crosshair: _crosshairConfig
			series: lineChartSeriesConfigs seriesColors
			, false

		Highcharts.addEvent _lineChart, 'click', onLineChartClick

		moduleId = $.url().param().moduleId
		which = $('[name=what-curve]').val()
		if days == 0
			loadLineChartDataFromAjax which, 0, min, max, moduleId, showEveryPoint
		else
			loadLineChartDataFromAjax which, days, undefined, undefined, moduleId, showEveryPoint
		
		if clearHeatmapVertical
			if _heatmapVerticalChart?
				_heatmapVerticalChart.destroy()
				_heatmapVerticalChart = null
				$('#time-resolution-container').hide()
		else
			if _heatmapVerticalStartTime? and _heatmapVerticalEndTime?
				setPlotBand()

	setPlotBand = ->
		_lineChart.xAxis[0].removePlotBand 'theplotband'
		_lineChart.xAxis[0].addPlotBand
			from: _heatmapVerticalStartTime
			to: _heatmapVerticalEndTime
			color: 'rgba(255, 255, 255, .15)'
			id: 'theplotband'

	lineChartSeriesConfigs = (seriesColors) ->
		arr = []
		moduleId = $('#module-id').val()
		for i in [0..14]
			arr[i] =
				name: "#{(i+1)*125} Hz"
				color: seriesColors[i]
				type: 'line'
				yAxis: 0
				animation: false
				data: []
				dashStyle: 'Solid'
				lineWidth: 2
				marker: { enabled: false }
				index: i
				step: ''
		arr

	#loadHeatmapChart = ->
		#colorAxisMin = -80
		#colorAxisMax = 0
		#title = 'Heatmap'
		#data = []
		#renderTo = $(".ui-page-active .heatmap-container").get()[0]
		#pgweb.AnalysisGW102.createHeatmapChart renderTo, title, colorAxisMin, colorAxisMax
		#fromTime = _lineChart.xAxis[0].min
		#toTime = _lineChart.xAxis[0].max
		#fromTimeIso = fromTime.toISOString().substr 0, 19
		#toTimeIso = toTime.toISOString().substr 0, 19
		#fromTimeUnix = pgweb.Main.isoToUnixMilliTz fromTimeIso, _timezone.offset
		#toTimeUnix = pgweb.Main.isoToUnixMilliTz toTimeIso, _timezone.offset
		#_heatmapChart.xAxis[0].setExtremes fromTimeUnix, toTimeUnix

	onLineChartMouseOut = ->
		$('.value-column div').text ''
		$('.value-column').css 'background-color', 'transparent'
		#_heatmapChart.xAxis[0].removePlotLine 'crosshair-plotline'
		if _heatmapVerticalChart
			_heatmapVerticalChart.yAxis[0].removePlotLine 'crosshair-plotline'

	#onHeatmapChartMouseOut = ->
		#$('.value-column').text ''
		#$('.value-column').css 'background-color', 'transparent'
		#_lineChart.xAxis[0].removePlotLine 'crosshair-plotline'

	onHeatmapVerticalChartMouseOut = ->
		$('.value-column div').text ''
		$('.value-column').css 'background-color', 'transparent'
		_lineChart.xAxis[0].removePlotLine 'crosshair-plotline'

	loadLineChartDataFromAjax = (which, days, from, to, moduleId, showEveryPoint) ->
		mic = lastNum which
		waitStart()
		if days == 0
			fromISO = from.toISOString()
			toISO = to.toISOString()
		$.ajax
			url: "/pgweb/ajax/sonitus/analysisGW102LineChart.php"
			dataType: 'json'
			data:
				mic: mic
				days: days
				from: fromISO
				to: toISO
				moduleId: moduleId
				showEveryPoint: showEveryPoint
			success: (data) ->
				if data.result == "OK"
					_currentData = data
					for i in [0..(N_CURVES-1)]
						_lineChart.series[i].setData []
					for curveIndex in [0..(N_CURVES-1)]
						dataSeriesObj = data.dataSerieses[curveIndex]
						if dataSeriesObj.length > 0
							for i in [0..(dataSeriesObj.length-1)]
								item = dataSeriesObj[i]
								dt = Globalize.parseDate item.t.replace ' ', 'T'
								dtJSTime = dateTimeToJSTime(dt) # Unix time * 1000
								_timezone = data.timezone
								dtJSTimeTzCorrected = dtJSTime + _timezone.offset*60000
								xy = [dtJSTimeTzCorrected, pgweb.SonitusCalculator.linToExpY item.v]
								_lineChart.series[curveIndex].addPoint xy, false
								
								# Heatmap chart.
								#xyz = AnalysisGW102.makeXYZ item, _timezone.offset, curveIndex+1
								#AnalysisGW102.getHeatmapChart().series[0].addPoint xyz, false
					if days == 0
						from = dateTimeToJSTime from
						to = dateTimeToJSTime to
						_lineChart.xAxis[0].setExtremes from, to, false
						#_heatmapChart.xAxis[0].setExtremes from, to, false
					else
						setLineChartXAxisInterval days

					_lineChart.redraw()
					#_heatmapChart.redraw()

				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Failed to load chart data: "+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()
	
	# Convert a 3D data item returned from ajax into an object acceptable for Highcharts heatmap.
	#@makeXYZ: (item, timezoneOffset, i) ->
	#	time = item.t.replace ' ', 'T'
	#	dtJSTimeTzCorrected = pgweb.Main.isoToUnixMilliTz time, timezoneOffset
	#	[dtJSTimeTzCorrected, i, item.v]
	
	@lineChartYLabelFormatter: (obj) ->
		v = pgweb.SonitusCalculator.expToLinY obj.value
		for p in pgweb.SonitusCalculator.yTickPositions
			if v <= 0.98*p and v >= 1.02*p
				return p

	setLineChartXAxisInterval = (days) ->
		minXLocal = getMinXFromDays days, _timezone.offset
		maxXLocal = getMaxXFromDays days, _timezone.offset
		minXLocal = dateTimeToJSTime minXLocal
		maxXLocal = dateTimeToJSTime maxXLocal
		_lineChart.xAxis[0].setExtremes minXLocal, maxXLocal, false
		#_heatmapChart.xAxis[0].setExtremes minXLocal, maxXLocal, false

	chartTitle = (which) ->
		if not _currentData? then return
		menuItem = getSelectedMenuItem()
		_currentData.moduleName + ', ' + menuItem.text()

	lineChartToolTipFormatter = (e) ->
		html = ''
		dBrowser = new Date @x
		dLocal = new Date dBrowser.getTime() + dBrowser.getTimezoneOffset() * 60000
		dStr = Globalize.format dLocal, 'F'
		html += dStr+'<br/>'

		$('.value-column').css 'background-color', 'transparent'
		for point in @points
			value = pgweb.SonitusCalculator.expToLinY point.y
			freqIndex = point.series.index+1
			setTableColor freqIndex, value

		#addCrossHairPlotLine _heatmapChart.xAxis[0], @x
		if _heatmapVerticalChart
			addCrossHairPlotLine _heatmapVerticalChart.yAxis[0], @x

		html

	#heatmapChartToolTipFormatter = ->
		#dBrowser = new Date @point.x
		#dLocal = new Date (dBrowser.getTime() + dBrowser.getTimezoneOffset()*60000)
		#dStr = Globalize.format dLocal, 'F'
		#html = '<div style="width: 10px">'+dStr+'<br>Frequency: '+@point.y*125+' Hz<br>Value: '+@point.value+' dB</div>'
		
		## There is no ready-made array of values at the selected time like for the line chart, so we need
		## to put it together.
		#items = (item for item in @.series.data when item.x == @.point.x)
		#for item in items
			#value = item.value
			#freqIndex = item.y
			#setTableColor freqIndex, value

		#addCrossHairPlotLine _lineChart.xAxis[0], @point.x

		#html

	heatmapVerticalChartToolTipFormatter = ->
		dBrowser = new Date @point.y
		dLocal = new Date (dBrowser.getTime() + dBrowser.getTimezoneOffset()*60000)
		dStr = Globalize.format dLocal, 'F'
		html = '<div style="width: 10px">'+dStr+'<br>Frequency: '+@point.x*125+' Hz<br>Value: '+@point.value+' dB</div>'
		
		# There is no ready-made array of values at the selected time like for the line chart, so we need
		# to put it together.
		items = (item for item in @.series.data when item.y == @.point.y)
		for item in items
			value = item.value
			freqIndex = item.x
			setTableColor freqIndex, value

		addCrossHairPlotLine _lineChart.xAxis[0], @point.y

		html

	setTableColor = (freqIndex, value) ->
		$("#val#{freqIndex}").text(value.toFixed 1)
		valueColorIndex = 14 - Math.floor(-Math.max(Math.min(value, 0), -80)/5.333) # 80/(number of colors) = 5.333
		if valueColorIndex < 0
			console.log 'ERROR: valueColorIndex = '+valueColorIndex
			valueColorIndex = 0
		textColor = if valueColorIndex < 4 then '#fff' else '#000'
		valueColor = _colorAxisStops[valueColorIndex][1]
		$("#val#{freqIndex}").parent().css 'background-color', valueColor
		$("#val#{freqIndex}").parent().css 'color', textColor
	
	#@createHeatmapChart: (renderTo, title, colorAxisMin, colorAxisMax) ->
		#data = []
		#chart = new Highcharts.Chart
			#chart:
				#type: 'heatmap'
				#renderTo: renderTo
				#animation: false
				#marginLeft: MARGIN_LEFT
				#marginRight: MARGIN_RIGHT
			#exporting:
				#enabled: false
			#title:
				#text: title
			#xAxis:
				#type: 'datetime',
				#title:
					#text: 'Time'
				#startOnTick: false
				#endOnTick: false
				#dateTimeLabelFormats: 
					#second: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.T)
					#minute: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.t)
					#hour: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.t)
					#day: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.M)
					#week: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.M)
					#month: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.Y)
					#year: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.Y)
				#crosshair: _crosshairConfig
				#gridLineWidth: 0
				#gridLineColor: 'rgba(255, 255, 255, .1)'
				#lineColor: '#999'
				#tickColor: '#999'
				##tickPixelInterval: 400
				#tickInterval: undefined
				#minTickInterval: 3600*1000
				#labels: 
					#style: 
						#color: if _themeType == 1 then '#555' else '#999'
						#font: 'bold 14px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif'
			#yAxis:
				#title:
					#text: 'Hz'
				#min: 1
				#max: N_CURVES
				#tickPositions: [1..N_CURVES]
				#labels:
					#formatter: AnalysisGW102.heatmapYLabelFormatter
				#crosshair: _crosshairConfig
			#colorAxis:
				#stops: _colorAxisStops
				#min: colorAxisMin
				#max: colorAxisMax
				#startOnTick: false
				#endOnTick: false
				#labels:
					#format: '{value}dB'
					#style: 
						#color: if _themeType == 1 then '#555' else '#999'
				#reversed: false
				#horizontal: true
				#gridLineWidth: 0
			#credits:
				#enabled: false
			#legend:
				#layout: 'vertical'
				#verticalAlign: 'top'
				#align: 'right'
			#tooltip:
				#formatter: heatmapChartToolTipFormatter
				#shared: true
			#plotOptions:
				#series:
					#crisp: false
					#point:
						#events:
							#mouseOut: onHeatmapChartMouseOut
			#series: [
				#nullColor: '#EFEFEF',
				#colsize: 5*60*1000, # 5 minutes
				#rowsize: 1
				#data: data
			#]
		#@setHeatmapChart chart
		#chart.redraw()
		#chart

	#@heatmapYLabelFormatter: (obj) ->
		#obj.value*125

	addCrossHairPlotLine = (axis, value) ->
		plotLineObj =
			color: 'gray'
			dashStyle: 'dash'
			width: 1
			value: value
			id: 'crosshair-plotline'
			zIndex: 10
		axis.removePlotLine 'crosshair-plotline'
		axis.addPlotLine plotLineObj

	loadHeatmapVerticalChart = ->
		moduleId = $('#module-id').val()
		moduleName = $('#module-name').val()
		which = $('[name=what-curve]').val()
		mic = lastNum which
		colorAxisMin = parseFloat $('#color-axis-min').val()
		colorAxisMax = parseFloat $('#color-axis-max').val()
		title = moduleName+', MIC'+mic+', vertical heatmap'
		nthMinute = $('#time-resolution').val()
		_heatmapVerticalStartTime = _heatmapVerticalEndTime - HEATMAP_VERTICAL_N_PERIODS*nthMinute*60*1000
		getHeatmapVerticalDataByAjax moduleId, moduleName, mic, _heatmapVerticalStartTime, _heatmapVerticalEndTime, title, colorAxisMin, colorAxisMax, nthMinute
		_heatmapVerticalChart.yAxis[0].setExtremes _heatmapVerticalStartTime, _heatmapVerticalEndTime
		setPlotBand()

	createHeatmapVerticalChart = (title, data, fromTimeUnixMilli, toTimeUnixMilli, colorAxisMin, colorAxisMax, nthMinute) ->
		chart = Highcharts.chart 'heatmap-vertical-chart-container',
			chart:
				type: 'heatmap'
				animation: false
			exporting:
				enabled: false
			title:
				text: title
			xAxis:
				title:
					text: 'Hz'
				min: 1
				max: N_CURVES
				tickPositions: [1..N_CURVES]
				labels:
					formatter: (obj) ->
						obj.value*125
				crosshair: _crosshairConfig
			yAxis:
				type: 'datetime',
				title:
					text: 'Time'
				reversed: false
				startOnTick: false
				endOnTick: false
				crosshair: _crosshairConfig
			colorAxis:
				stops: _colorAxisStops
				min: colorAxisMin
				max: colorAxisMax
				startOnTick: false
				endOnTick: false
				labels:
					format: '{value}dB'
					style:
						color: if _themeType == 1 then '#555' else '#999'
						font: 'bold 14px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif'
				reversed: false
				horizontal: true
				gridLineWidth: 0
			credits:
				enabled: false
			legend:
				layout: 'vertical'
				verticalAlign: 'top'
				align: 'right'
			tooltip:
				formatter: heatmapVerticalChartToolTipFormatter
			plotOptions:
				series:
					crisp: false
					point:
						events:
							mouseOut: onHeatmapVerticalChartMouseOut
				heatmap:
					colsize: 1
					rowsize: 5*60*1000, # 5 minutes
			series: [
				data: data
			]
		setHeatmapVerticalChart chart
		timeDiff = toTimeUnixMilli - fromTimeUnixMilli
		spacing = 10 + 15 + 70 # default spacingTop + spacingBottom + xAxis height
		height = 800 #Math.floor (timeDiff/75000 + spacing)
		chart.yAxis[0].setExtremes fromTimeUnixMilli, toTimeUnixMilli
		chart.setSize undefined, height, false
		chart.update(
			plotOptions:
				heatmap:
					rowsize: nthMinute*60*1000
		, false, false, false)
		chart.redraw()
		return chart
		
	getHeatmapVerticalDataByAjax = (moduleId, moduleName, mic, fromTimeUnixMilli, toTimeUnixMilli, title, colorAxisMin, colorAxisMax, nthMinute) ->
		waitStart()
		fromTimeIso = pgweb.Main.unixMilliToIso fromTimeUnixMilli
		toTimeIso = pgweb.Main.unixMilliToIso toTimeUnixMilli
		createHeatmapVerticalChart title, [], fromTimeUnixMilli, toTimeUnixMilli, colorAxisMin, colorAxisMax, nthMinute
		$.ajax
			url: "/pgweb/ajax/sonitus/getSonitusHeatmapVerticalData.php"
			dataType: 'json'
			type: 'GET'
			data:
				moduleId: moduleId
				mic: mic
				fromTime: fromTimeIso
				toTime: toTimeIso
				nthMinute: nthMinute
			success: (data) =>
				if data.result == "OK"
					seriesData = []
					for key, series of data.seriesArr
						i = lastNum key
						for point in series
							dt = Globalize.parseDate point.t.replace ' ', 'T'
							dtJSTime = dateTimeToJSTime(dt) # Unix time * 1000
							dtJSTimeTzCorrected = dtJSTime + _timezone.offset*60000
							xyz = [i, dtJSTimeTzCorrected, point.v]
							seriesData.push xyz
					_heatmapVerticalChart.series[0].setData seriesData
					$('#time-resolution-container').show()
				else
					console.log 'error '+data.debug
					console.log data
			error: ajaxFailure
			complete: ->
				waitStop()

	# Min or max for the color axis changed.
	@onColorAxisMinMaxChanged: ->
		newMin = parseFloat $('#color-axis-min').val()
		newMax = parseFloat $('#color-axis-max').val()
		if _heatmapVerticalChart
			_heatmapVerticalChart.colorAxis[0].setExtremes newMin, newMax

$(document).on 'pagecreate', '.showGW102AnalysisPage', (event) ->
	pgweb.AnalysisGW102.inst().init()
class pgweb.AnalysisQPG
	loopHi: null
	loopLo: null

	acMax: 10000
	acLo: null
	acLoLo: null
	acQpg5: null
	acMin: 0

	voltMax: 1000
	voltHiHi: null
	voltHi: null
	voltMin: 0

	moduleActive: null
	active: null

	wire1Color = '#8888ff'
	wire2Color = '#ffaadd'
	loopResColor = '#ffff99'

	loopResPos = 7.1
	
	constructor: (initDivId) ->
		@self = @
		@divId = initDivId
		@analysisChartObj = null

	getDivId: () ->
		return @divId
	
	init: ->
		@loadChart()
		
		# Turn on detection of click on a series and remove all points.
		if @analysisChartObj.series?
			for ser in Highcharts.addEvent @analysisChartObj.series
				Highcharts.addEvent ser, 'click', (e) ->
					console.log e.point.series
				ser.setData []
		
		ch = lastNum @divId
		
		$('.qpg-checkbox-wire1').css 'background-color', wire1Color
		$('.qpg-checkbox-wire2').css 'background-color', wire2Color
		
		$('body').on 'change', '.checkbox-ch'+ch, (event) =>
			id = $(event.target).prop 'id'
			wire = lastNum id
			ch = lastNum id.split('-')[1]
			checked = $(event.target).prop 'checked'
			if checked
				@analysisChartObj.series[wire-1].show()
			else
				@analysisChartObj.series[wire-1].hide()

	@start: ->
		for ch in [1..$('#n-channels').val()]
			if $('#qpg-chart-ch'+ch).length > 0
				pgweb.AnalysisQPG.startChannel ch

	@startChannel: (ch) ->
		console.log 'starting channel '+ch
		a = new pgweb.AnalysisQPG 'qpg-chart-ch'+ch
		a.init()
		
		fromDate = nowMinusDays 7
		from = dateTimeToDBFormat fromDate

		toDate = nowMinusDays 0
		to = dateTimeToDBFormat toDate

		a.loadFromAjax true, $.url().param().moduleId, ch, from, to
		a.loadFromAjax false, $.url().param().moduleId, ch, from, to

	isActive: ->
		@moduleActive and @active

	chartToolTipFormatter: ->
		html  = '<div style="color: #000">'
		arr = @key.split(',')
		if arr.length == 2
			lrTime = arr[0]
			lrValue = parseFloat arr[1]
			timeStr = lrTime
			html += '<b>' + @series.name+'</b><br/>'
			html += t.ModulePage_Value+': ' + Globalize.format lrValue, 'n'+1
		else
			acTime = arr[0]
			gvTime = arr[1]
			acValue = parseFloat arr[2]
			gvValue = parseFloat arr[3]
			if acTime == gvTime
				timeStr = acTime
			else
				timeStr = acTime+' (AC), '+gvTime+' (V)'
			html += '<b>' + @series.name+'</b><br/>'
			html += t.ModulePage_ACResistance+': ' + Globalize.format acValue, 'n'+1
			html += '<br/>'
			html += t.ModulePage_GalvanicVoltage+': ' + Globalize.format gvValue, 'n'+0
		html += '<br/>'
		html += t.ModulePage_Time+': '+timeStr
		html += '</div>'
		return html

	yTickPositions      = [0, 1, 5,     20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]
	yTickPositionsPanel = [0, 1,    10,     50,      200, 500, 1000, 2000, 5000, 10000]

	xTickPositions = [0, 1, 5, 10, 20, 50, 100, 200, 500, 1000]
	
	calcYTickPositions: ->
		positions = if isPanel() then yTickPositionsPanel else yTickPositions
		(pgweb.AnalysisQPG.expToLinY p for p in positions)

	calcXTickPositions: ->
		(pgweb.AnalysisQPG.expToLinX p for p in xTickPositions)
	
	yLabelFormatter: ->
		v = pgweb.AnalysisQPG.linToExpY @value
		for p in yTickPositions
			if v >= 0.95*p and v <= p
				return if p >= 1000 then p.toString().slice(0, -3)+'M' else p+'k'

	xLabelFormatter: ->
		v = pgweb.AnalysisQPG.linToExpX @value
		for p in xTickPositions
			if v >= 0.95*p and v <= p
				return p

	loadChart: ->
		themeType = parseInt $('#theme-type').val()
		if isPanel()
			xTitle = null
			yTitle = null
			yTitleLoopRes = null
			exporting = false
			marginBottom = 27
			marginTop = 34
		else
			xTitle =
				text: t.ModulePage_GalvanicVoltage
				style:
					'font-size': '14px'
					color: if themeType == 1 then '#333' else '#dddddd'
			yTitle =
				text: t.ModulePage_ACResistance
				style:
					'font-size': '14px'
					color: if themeType == 1 then '#333' else '#dddddd'
			yTitleLoopRes =
				text: t.ModulePage_LoopResistance
				style:
					'font-size': '14px'
					color: if themeType == 1 then '#333' else '#dddddd'
				margin: -15
			exporting = true
			marginBottom = 57
			marginTop = 54

		markerMouseOver =
			enabled: false
			symbol: 'circle'
			radius: 3
		
		config =
			chart:
				type:'scatter'
				borderRadius: 5
				animation: false
				marginRight: 40
				marginBottom: marginBottom
				marginTop: marginTop
				backgroundColor: if themeType == 1 then '#d8d8d8' else '#444'
			exporting:
				enabled: exporting
			title: null
			plotOptions:
				scatter:
					lineWidth:4
					marker:
						enabled: false
			legend:
				align: 'left'
				verticalAlign: 'top'
				x: 0
				y: -10
				itemStyle:
					color: if themeType == 1 then '#333' else '#dddddd'
			series: [{
				name: t.ModulePage_Wire1
				marker: markerMouseOver
				data: []
				color: wire1Color
				zIndex: 2
			}, {
				name: t.ModulePage_Wire2
				marker: markerMouseOver
				data: []
				color: wire2Color
				zIndex: 1
			}, {
				name: t.ModulePage_LoopResistance
				marker: markerMouseOver
				data: []
				color: loopResColor
				yAxis: 1
			}]
			yAxis: [
				# AC resistance y axis (to the left).
				min: pgweb.AnalysisQPG.expToLinY @acMin
				max: pgweb.AnalysisQPG.expToLinY @acMax
				endOnTick: false
				title: yTitle
				gridLineWidth: 0
				tickLength: 3
				tickWidth: 1
				tickPositions: @calcYTickPositions()
				tickColor: if themeType == 1 then '#333' else '#dddddd'
				plotLines: []
				lineWidth: 0
				labels:
					style:
						'font-size': '14px'
						color: if themeType == 1 then '#333' else '#dddddd'
					formatter: @yLabelFormatter
					x: -8
			,
				# Loop resistance y axis (to the right).
				min: 0
				max: 100
				opposite: true
				title: yTitleLoopRes
				gridLineWidth: 0
				tickLength: 3
				tickWidth: 1
				tickPositions: [0, 100]
				tickColor: if themeType == 1 then '#333' else '#dddddd'
				tickColor: '#dddddd'
				lineColor: '#777777'
				lineWidth: 2
				labels:
					style:
						'font-size': '14px'
						color: if themeType == 1 then '#333' else '#dddddd'
					x: 10
			]
			xAxis:
				min: pgweb.AnalysisQPG.expToLinX @voltMin
				max: 1 + pgweb.AnalysisQPG.expToLinX @voltMax
				endOnTick: false
				title: xTitle
				gridLineWidth: 0
				tickLength: 3
				tickWidth: 1
				tickPositions: @calcXTickPositions()
				tickColor: if themeType == 1 then '#333' else '#dddddd'
				plotLines: []
				lineWidth: 0
				labels:
					style:
						'font-size': '14px'
						color: if themeType == 1 then '#333' else '#dddddd'
					formatter: @xLabelFormatter
			credits:
				text: 'Pipeguard'
				enabled: false
			tooltip:
				formatter: @chartToolTipFormatter
		
		@analysisChartObj = Highcharts.chart @divId, config

	loadFromAjax: (onlyLast, moduleId, channelNumber, from, to) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/analysis/getAnalysisQPGData.php"
			dataType: 'json'
			method: 'GET'
			data:
				onlyLast: if onlyLast then 1 else 0
				moduleId: moduleId
				channelNumber: channelNumber
				from: from
				to: to
			success: (data) =>
				if data.result == "OK"
					@loopLo = data.loopResLo
					@loopHi = data.loopResHi
					@acLo = data.acResLo
					@acLoLo = data.acResLoLo
					@acQpg5 = data.acResQpg5
					@voltHi = data.galvVoltHi
					@voltHiHi = data.galvVoltHiHi
					@moduleActive = data.moduleActive
					@active = data.active
					for wire in [1..2]
						@loadOneWire wire, data
					@loadLoopRes data.wireArr, data.loopResHi, data.loopResLo, data.wireLastElemTime
					if onlyLast
						@drawQpgRects @analysisChartObj
						@drawAcGalvLines()
						@drawLoopLines()

				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Failed to get analysis qpg chart data: "+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()

	drawLoopLines: =>
		@drawLoopLine @loopHi
		@drawLoopLine @loopLo

	drawLoopLine: (limit) ->
		if limit == null  then return

		chart = @analysisChartObj
		r = chart.renderer

		lineAttributes =
			stroke: '#cc7733'
			'stroke-width': 2

		x1 = (chart.xAxis[0].toPixels loopResPos) + 3
		y1 = chart.yAxis[1].toPixels limit
		x2 = (chart.xAxis[0].toPixels loopResPos) + 8
		y2 = chart.yAxis[1].toPixels limit

		r.path(['M', x1, y1, 'L', x2, y2, 'z']).attr(lineAttributes).add()

	drawAcGalvLines: =>
		@drawHorizontalLine @acLo
		@drawHorizontalLine @acLoLo
		@drawVerticalLine @voltHi
		@drawVerticalLine @voltHiHi

	drawHorizontalLine: (val) ->
		@drawLine =>
			chart = @analysisChartObj
			x1 = chart.plotLeft
			y1 = chart.yAxis[0].toPixels pgweb.AnalysisQPG.expToLinY val
			x2 = chart.xAxis[0].toPixels pgweb.AnalysisQPG.expToLinX @voltMax
			y2 = y1
			[x1, y1, x2, y2]

	drawVerticalLine: (val) ->
		@drawLine =>
			chart = @analysisChartObj
			x1 = chart.xAxis[0].toPixels pgweb.AnalysisQPG.expToLinX val
			y1 = chart.plotTop
			x2 = x1
			y2 = chart.plotTop + chart.plotHeight
			[x1, y1, x2, y2]

	drawLine: (fn) ->
		r = @analysisChartObj.renderer

		lineAttributes =
			stroke: '#555555'
			'stroke-width': 2

		[x1, y1, x2, y2] = fn()

		r.path(['M', x1, y1, 'L', x2, y2, 'z']).attr(lineAttributes).add()

	loadLoopRes: (dataSeries, loopResHi, loopResLo, wireLastElemTime) ->
		markerLast =
			enabled: true
			symbol: 'circle'
			radius: 7
		
		chartSeries = @analysisChartObj.series[2]

		for key, items of dataSeries
			for item in items
				if item.type == 'LR'
					point =
						x: loopResPos
						y: item.v
						name: item.t+','+item.v
					if item.t == wireLastElemTime
						point.marker = markerLast
					chartSeries.addPoint point

	loadOneWire: (wire, data) ->
		markerLast =
			enabled: true
			symbol: 'circle'
			radius: 7
		
		chartSeries = @analysisChartObj.series[wire - 1]
		dataSeries = data['wire'+wire.toString()+'Arr']

		ac = null
		gv = null
		for key, items of dataSeries
			acExists = false
			gvExists = false
			for item in items
				if item.type == 'AC'
					acExists = true
				if item.type == 'GV'
					gvExists = true
			if acExists and gvExists
				ac = null
				gv = null
			for item in items
				if item.type == 'AC'
					ac = item
				if item.type == 'GV'
					gv = item
				if ac? and gv?
					point =
						x: pgweb.AnalysisQPG.expToLinX Math.max(gv.v, @voltMin)
						y: pgweb.AnalysisQPG.expToLinY Math.max(ac.v, @acMin)
						name: ac.t+','+gv.t+','+ac.v+','+gv.v # The name field will be renamed to 'key' in the tooltip formatter!
					if item.t == data['wire'+wire.toString()+'LastElemTime']
						point.marker = markerLast
					chartSeries.addPoint point
	
	plotY: (val) ->
		return
			color: '#666666'
			width: 2
			value: pgweb.AnalysisQPG.expToLinY val
	
	plotX: (val) ->
		return
			color: '#666666'
			width: 2
			value: pgweb.AnalysisQPG.expToLinX val
	
	drawOneQpgRect: (n, acmin, acmax, voltmin, voltmax, color, chart) ->
		xAxis = chart.xAxis[0]
		yAxis = chart.yAxis[0]
		yminp = yAxis.toPixels pgweb.AnalysisQPG.expToLinY acmax
		ymaxp = yAxis.toPixels pgweb.AnalysisQPG.expToLinY acmin
		xminp = xAxis.toPixels pgweb.AnalysisQPG.expToLinX voltmin
		xmaxp = xAxis.toPixels pgweb.AnalysisQPG.expToLinX voltmax
		widthp = xmaxp - xminp
		heightp = ymaxp - yminp
		chart.renderer.rect(xminp, yminp, widthp, heightp, 0).attr({fill: color}).add()

		xMiddle = (xmaxp + xminp)/2 - 3
		yMiddle = (ymaxp + yminp)/2 - 2
		text = 'QPG'+n
		width = 38
		attributes =
			width: width
			'text-align': 'center'
			'font-size': if isPanel() then '14px' else '16px'
			zIndex: 5
		extraXOffset = 0 #if isPanel() then 20 else 0 # Strange extra offset needed!
		chart.renderer.label('<xb>'+text+'</xb>', xMiddle - width/2 - extraXOffset, yMiddle - 10, useHtml=true).attr(attributes).add()

	drawQpgRects: (chart) =>
		if @isActive()
			col0 = '#77cc77'
			col1 = '#dddd66'
			col2 = '#ddbb66'
			col3 = '#dd8855'
			col4 = '#dd6644'
			col5 = '#cc4444'
		else
			col0 = '#aaaaaa'
			col1 = '#cccccc'
			col2 = '#bbbbbb'
			col3 = '#aaaaaa'
			col4 = '#999999'
			col5 = '#888888'

		@drawOneQpgRect 0, @acLo,     @acMax,    @voltMin,  @voltHi,   col0, chart # QPG0
		
		@drawOneQpgRect 1, @acLoLo,   @acLo,     @voltMin,  @voltHi,   col1, chart # QPG1 bottom left
		@drawOneQpgRect 1, @acLo,     @acMax,    @voltHi,   @voltHiHi, col1, chart # QPG1 top right
		
		@drawOneQpgRect 2, @acQpg5,   @acLoLo,   @voltMin,  @voltHi,   col2, chart # QPG2 bottom left
		@drawOneQpgRect 2, @acLoLo,   @acLo,     @voltHi,   @voltHiHi, col2, chart # QPG2 middle
		@drawOneQpgRect 2, @acLo,     @acMax,    @voltHiHi, @voltMax,  col2, chart # QPG2 top right

		@drawOneQpgRect 3, @acQpg5,   @acLoLo,   @voltHi,   @voltHiHi, col3, chart # QPG3 bottom left
		@drawOneQpgRect 3, @acLoLo,   @acLo,     @voltHiHi, @voltMax,  col3, chart # QPG3 top right

		@drawOneQpgRect 4, @acQpg5,   @acLoLo,   @voltHiHi, @voltMax,  col4, chart # QPG4

		@drawOneQpgRect 5, @acMin,    @acQpg5,   @voltMin,  @voltHi,   col5, chart # QPG5 left
		@drawOneQpgRect 5, @acMin,    @acQpg5,   @voltHi,   @voltHiHi, col5, chart # QPG5 middle
		@drawOneQpgRect 5, @acMin,    @acQpg5,   @voltHiHi, @voltMax,  col5, chart # QPG5 right
		
		@drawYLabel 'LoLo', @acLoLo, chart
		@drawYLabel 'Lo', @acLo, chart
		@drawYLabel 'L', @acQpg5, chart
		
		@drawXLabel 'Hi', @voltHi, chart
		@drawXLabel 'HiHi', @voltHiHi, chart
		

	drawYLabel: (text, acRes, chart) ->
		xPixelPos = chart.xAxis[0].toPixels(pgweb.AnalysisQPG.expToLinX @voltMax) + 1
		yPixelPos = chart.yAxis[0].toPixels(pgweb.AnalysisQPG.expToLinY acRes) - 13
		attributes =
			zIndex: 8
			width: 32
			'text-align': 'left'
		label = chart.renderer.label('<b>'+text+'</b>', xPixelPos, yPixelPos, useHtml=true)
		themeType = parseInt $('#theme-type').val()
		label.attr(attributes).css({color: if themeType == 1 then '#333' else '#ddd'}).add()

	drawXLabel: (text, volt, chart) ->
		yPixelPos = chart.yAxis[0].toPixels(pgweb.AnalysisQPG.expToLinY @acMax) - 19
		xPixelPos = chart.xAxis[0].toPixels(pgweb.AnalysisQPG.expToLinX volt) - 20
		attributes =
			zIndex: 8
			width: 32
			'text-align': 'center'
		label = chart.renderer.label('<b>'+text+'</b>', xPixelPos, yPixelPos, useHtml=true)
		themeType = parseInt $('#theme-type').val()
		label.attr(attributes).css({color: if themeType == 1 then '#333' else '#ddd'}).add()

	# Compute linear to exponential for the Y axis.
	@linToExpY: (x) ->
		Math.pow(x, 5) + x

	# Compute linear to exponential for the X axis.
	@linToExpX: (x) ->
		Math.pow(x, 3.8) + x
	
	# Table for linear interpolation in @expToLinY().
	@expTableY: null

	# Table for linear interpolation in @expToLinX().
	@expTableX: null

	# Compute exponential to linear for the Y axis.
	@expToLinY: (y) ->
		# Optimize by only computing the table once.
		if @exTableY?
			yArr = @exTableY
		else
			yArr = []
			for x in [0..6.6] by 0.2
				yArr.push {x: x, y: @linToExpY x}
			@exTableY = yArr
		# Find correct row in the table.
		foundKey = 0
		for item, key in yArr
			if y < item.y
				foundKey = key
				break
		if foundKey > 0
			upperItem = yArr[foundKey]
			lowerItem = yArr[foundKey-1]
			# Linear interpolation between the two points.
			k = (upperItem.x - lowerItem.x)/(upperItem.y - lowerItem.y)
			x = k*(y - lowerItem.y) + lowerItem.x
		else
			0

	# Compute exponential to linear for the X axis.
	@expToLinX: (y) ->
		# Optimize by only computing the table once.
		if @exTableX?
			yArr = @exTableX
		else
			yArr = []
			for x in [0..6.6] by 0.2
				yArr.push {x: x, y: @linToExpX x}
			@exTableX = yArr
		# Find correct row in the table.
		foundKey = 0
		for item, key in yArr
			if y < item.y
				foundKey = key
				break
		if foundKey > 0
			upperItem = yArr[foundKey]
			lowerItem = yArr[foundKey-1]
			# Linear interpolation between the two points.
			k = (upperItem.x - lowerItem.x)/(upperItem.y - lowerItem.y)
			x = k*(y - lowerItem.y) + lowerItem.x
		else
			0

	# Returns true if the chart is drawn in a panel on the module page instead of the analysis page.
	isPanel = ->
		$('[data-role="page"]').hasClass 'showModulePage'

for pageClassName in ['.showMicroPGAnalysisPage', '.showMiniPGAnalysisPage']
	$(document).on 'pageshow', pageClassName, (event) ->
		pgweb.AnalysisQPG.start()
class pgweb.AnalysisSMBasicPG
	instance = null
	analysisChartObj = null
	timezone = { 'identifier': '', 'offset': 0}
	dataArr = []
	selectedCurveType = 'line'
	unselectedCurveType = 'line'
	selectedCurveDashStyle = 'Solid'
	unselectedCurveDashStyle = 'ShortDot'
	selectedCurveLineWidth = 4
	unselectedCurveLineWidth = 2
	selectedCurveIndex = null
	moduleIdTags = null
	currentData = null
	seriesColors = null
	upperYZoom = 0
	lowerYZoom = 0
	currentWhich = null

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	constructor: ->
		# Create the Highcharts object.
		min = -100
		max = 100
		zoom =  ''
		title = 'title'
		seriesColors = pgweb.CurveChart.inst().standardSeriesColors
		yAxisConfig = pgweb.CurveChart.inst().yAxisFloatConfig(seriesColors[0], false, .001, 1)
		title = "title"
		
	destructor: ->
		instance = null
		analysisChartObj = null

	init: ->
		$('.mic-filter').hide()

		$('body').off 'change', '.mic-filter-active'
		$('body').on 'change', '.mic-filter-active', (e) =>
			selectedItem = getSelectedMenuItem()
			which = selectedItem.val()
			micNumber = lastNum which
			if filterIsOn()
				$('.mic-filter').show()
				analysisChartObj.series[5].show()
				micMean = $('#mic'+micNumber+'-filter').val()
				computeAverage micMean
				analysisChartObj.redraw()
				$('#min-labfilter').css('visibility', 'visible')
				$('#average-labfilter').css('visibility', 'visible')
				$('#max-labfilter').css('visibility', 'visible')
			else
				analysisChartObj.series[5].hide()
				$('.mic-filter').hide()
				$('#min-labfilter').css('visibility', 'hidden')
				$('#average-labfilter').css('visibility', 'hidden')
				$('#max-labfilter').css('visibility', 'hidden')

		$('body').off 'change', '.mic-filter'
		$('body').on 'change', '.mic-filter', (e) =>
			selectedItem = getSelectedMenuItem()
			which = selectedItem.val()
			micNumber = lastNum which
			if filterIsOn()
				micMean = $('#mic'+micNumber+'-filter').val()
				computeAverage micMean
				analysisChartObj.redraw()

		$('body').on 'change', '[name=what-curve]', (e) =>
			selectedItem = getSelectedMenuItem()
			which = selectedItem.val()
			currentWhich = which
			loadChart()
			showHideControls which

		$('body').off 'click', '.user-save-analysis-config-button'
		$('body').on 'click', '.user-save-analysis-config-button', (e) ->
			selectedItem = getSelectedMenuItem()
			which = selectedItem.val()
			micNumber = lastNum which
			moduleId = $.url().param().moduleId
			baseLevel = $('#mic-base-level').val()
			hiAlarm = $('#mic-hi-level').val()
			hihiAlarm = $('#mic-hihi-level').val()
			filter = $('#mic-filter').val()
			inData =
				moduleId: moduleId
				micNum: micNumber
				baseLevel: baseLevel
				hiAlarm: hiAlarm
				hihiAlarm: hihiAlarm
				filter: filter
			$.ajax
				url: "/pgweb/ajax/smbasicpg/saveAnalysisConfig.php"
				dataType: 'json'
				method: 'POST'
				data: inData
				success: (data) ->
					if data.result == "OK"
						onSaveConfig inData, data
					else if data.result == 'NOT_LOGGED_IN'
						handleInactivity()
					else
						alert "Failed to save analysis config: "+data.debug
				error: ajaxFailure
				complete: ->
					waitStop()

		$('body').on 'change', '#mic-base-level', (e) ->
			val = parseFloat $(this).val()
			hihi = parseInt calculateHiHiLimit val
			oldHiHi = parseInt $('#mic-hihi-level').val()
			$('#mic-hihi-level').val hihi
			if oldHiHi != hihi
				$('#mic-hihi-level').addClass 'level-highlight'
			#checkHiLevel()

		$('body').on 'change', '#mic-hihi-level', (e) ->
			#$('#mic-hihi-level').removeClass 'level-highlight'
			#checkHiLevel()

		$('body').on 'change', '#mic-hi-level', (e) ->
			#$('#mic-hi-level').removeClass 'level-highlight'
			#checkHiHiLevel()

		checkHiLevel = ->
			hihi = parseInt $('#mic-hihi-level').val()
			hi = parseInt $('#mic-hi-level').val()
			if hihi <= hi
				hi = hihi - 1
				$('#mic-hi-level').val hi
				$('#mic-hi-level').addClass 'level-highlight'
			else
				if hi < currentData.seriesArr[0].hiLimit
					hi = hihi - 1
					$('#mic-hi-level').val hi
			if hi >= currentData.seriesArr[0].hiLimit
				$('#mic-hi-level').removeClass 'level-highlight'
		
		checkHiHiLevel = ->
			hihi = parseInt $('#mic-hihi-level').val()
			hi = parseInt $('#mic-hi-level').val()
			if hi >= hihi
				hihi = hi + 1
				$('#mic-hihi-level').val hihi
				$('#mic-hihi-level').addClass 'level-highlight'
		
		$('body').off 'change', '.mic-curve-button'
		$('body').on 'change', '.mic-curve-button', (e) ->
			checkbox = $(e.target)
			checked = checkbox.prop('checked')
			selectedItem = getSelectedMenuItem()
			which = selectedItem.val()
			num = lastNum which
			id = checkbox.prop('id')
			if checkbox.hasClass 'mic-raw-curve-button'
				index = 0
				if checked
					analysisChartObj.series[index].show()
				else
					analysisChartObj.series[index].hide()
			else if checkbox.hasClass 'mic-curve-filter-button'
				index = 1
				if checked
					analysisChartObj.series[index].show()
				else
					analysisChartObj.series[index].hide()
			else if checkbox.hasClass 'mic-base-curve-button'
				index = 2
				if checked
					addBaseLevelPlotLine currentData.seriesArr[num-1].baseLevel
				else
					removeBaseLevelPlotLine()
			else if checkbox.hasClass 'mic-hi-curve-button'
				index = 3
				if checked
					addHiLimitPlotLine currentData.seriesArr[num-1].hiLimit
				else
					removeHiLimitPlotLine()
			else if checkbox.hasClass 'mic-hihi-curve-button'
				index = 4
				if checked
					addHiHiLimitPlotLine currentData.seriesArr[num-1].hihiLimit
				else
					removeHiHiLimitPlotLine()

		$('body').off 'change', '.analysis-tool-range-buttons .range-free'
		$('body').on 'change', '.analysis-tool-range-buttons .range-free', (event) ->
			$('#zoom-free-popup').popup 'open'
			$('#free-range-zoom-error-message').text ''
		
		$('body').off 'change', '.analysis-tool-range-buttons .range-six-months'
		$('body').on 'change', '.analysis-tool-range-buttons .range-six-months', (event) ->
			loadChart()
		
		$('body').off 'change', '.analysis-tool-range-buttons .range-three-months'
		$('body').on 'change', '.analysis-tool-range-buttons .range-three-months', (event) ->
			loadChart()
		
		$('body').off 'change', '.analysis-tool-range-buttons .range-one-month'
		$('body').on 'change', '.analysis-tool-range-buttons .range-one-month', (event) ->
			loadChart()
		
		$('body').off 'change', '.analysis-tool-range-buttons .range-one-week'
		$('body').on 'change', '.analysis-tool-range-buttons .range-one-week', (event) ->
			loadChart()
		
		$('body').off 'click', '.showSMBasicPGAnalysisPage #free-zoom-ok'
		$('body').on 'click', '.showSMBasicPGAnalysisPage #free-zoom-ok', (event) ->
			min = new Date $('[name=free-from]').val()
			max = new Date $('[name=free-to]').val()
			if min == "Invalid Date" or max == "Invalid Date"
				$('#free-range-zoom-error-message').text t.InvalidDate
			else
				loadChart()
				$('#zoom-free-popup').popup 'close'
		
		$('body').off 'click', '.showSMBasicPGAnalysisPage #free-zoom-cancel'
		$('body').on 'click', '.showSMBasicPGAnalysisPage #free-zoom-cancel', (event) ->
			$('#zoom-free-popup').popup 'close'

		$('body').off 'change', '#show-every-point'
		$('body').on 'change', '#show-every-point', (event) ->
			loadChart()

		$('#y-zoom-upper-decrease-button').addClass 'ui-disabled'
		$('#y-zoom-lower-decrease-button').addClass 'ui-disabled'
		$('body').off 'click', '#y-zoom-upper-increase-button'
		$('body').on 'click', '#y-zoom-upper-increase-button', (event) ->
			if upperYZoom == -3 then return
			#$('#y-zoom-upper-decrease-button').prop 'disabled', null
			upperYZoom -= 1
			setYExtremes()
			analysisChartObj.redraw()
			if (upperYZoom == -3)
				$('#y-zoom-upper-increase-button').addClass 'ui-disabled'
			if (upperYZoom == -1)
				$('#y-zoom-upper-decrease-button').removeClass 'ui-disabled'

		$('body').off 'click', '#y-zoom-upper-decrease-button'
		$('body').on 'click', '#y-zoom-upper-decrease-button', (event) ->
			if upperYZoom == 0 then return
			upperYZoom += 1
			setYExtremes()
			analysisChartObj.redraw()
			if upperYZoom == 0
				$('#y-zoom-upper-decrease-button').addClass 'ui-disabled'
			if upperYZoom == -2
				$('#y-zoom-upper-increase-button').removeClass 'ui-disabled'

		$('body').off 'click', '#y-zoom-lower-increase-button'
		$('body').on 'click', '#y-zoom-lower-increase-button', (event) ->
			if lowerYZoom == -3 then return
			#$('#y-zoom-lower-decrease-button').prop 'disabled', null
			lowerYZoom -= 1
			setYExtremes()
			analysisChartObj.redraw()
			if lowerYZoom == -3
				$('#y-zoom-lower-increase-button').addClass 'ui-disabled'
			if lowerYZoom == -1
				$('#y-zoom-lower-decrease-button').removeClass 'ui-disabled'

		$('body').off 'click', '#y-zoom-lower-decrease-button'
		$('body').on 'click', '#y-zoom-lower-decrease-button', (event) ->
			if lowerYZoom == 0 then return
			lowerYZoom += 1
			setYExtremes()
			analysisChartObj.redraw()
			if lowerYZoom == 0
				$('#y-zoom-lower-decrease-button').addClass 'ui-disabled'
			if lowerYZoom == -2
				$('#y-zoom-lower-increase-button').removeClass 'ui-disabled'

		$('body').off 'pageshow', '.showSMBasicPGAnalysisPage'
		$('body').on 'pageshow', '.showSMBasicPGAnalysisPage', (event) ->
			loadChart()
			
			# Detect click on a series.
			for i in [0..9]
				Highcharts.addEvent analysisChartObj.series[i], 'click', (e) ->
					console.log e.point.series
			
			for i in [0..9]
				analysisChartObj.series[i].setData []

			selectedItem = getSelectedMenuItem()
			which = selectedItem.val()
			currentWhich = which
			
			#$('[name=range]').val(['oneWeek']).checkboxradio 'refresh'

	onSaveConfig = (inData, outData) ->
		$('#analysis-config-popup').popup('close')
		currentData.seriesArr[inData.micNum - 1].baseLevel = inData.baseLevel
		currentData.seriesArr[inData.micNum - 1].hiLimit = inData.hiAlarm
		currentData.seriesArr[inData.micNum - 1].hihiLimit = inData.hihiAlarm
		updateYAxis seriesColors[inData.micNum - 1], true

	filterIsOn = () ->
		selectedItem = getSelectedMenuItem()
		which = selectedItem.val()
		id = which+'-filter-active'
		$('#'+id).val() == 'on'

	computeAverage = (ratio) ->
		analysisChartObj.series[5].setData []
		rawDataSeriesObj = currentData.seriesArr[0]
		if rawDataSeriesObj.series.length == 0 then return
		lastComputedValue = rawDataSeriesObj.series[0].v
		lastValue = rawDataSeriesObj.series[0].v
		sum = 0
		min = 999999
		max = -999999
		for i in [0..(rawDataSeriesObj.series.length-1)]
			item = rawDataSeriesObj.series[i]
			dt = Globalize.parseDate item.t
			dtJSTime = dateTimeToJSTime(dt) # Unix time * 1000
			timezone = currentData.timezone
			dtJSTimeTzCorrected = dtJSTime + timezone.offset*60000
			xy = null
			newValue = lastComputedValue + (item.v - lastComputedValue)*(1-ratio/100)
			sum += newValue
			xy = [dtJSTimeTzCorrected, newValue]
			analysisChartObj.series[5].addPoint xy, false
			lastComputedValue = newValue
			lastValue = item.v
			min = Math.min min, newValue
			max = Math.max max, newValue
		avg = sum/rawDataSeriesObj.series.length
		$('#min-labfilter').text Globalize.format(min, 'n0')
		$('#average-labfilter').text Globalize.format(avg, 'n0')
		$('#max-labfilter').text Globalize.format(max, 'n0')

	yMinInputChange = (input) ->
		curveIndex = lastNum input.attr 'id'
		min = input.val()
		if not isNumeric min
			min = 0
			input.val min
		dataArr[curveIndex].analysisCurveMin = min
		if selectedCurveIndex?
			if selectedCurveIndex == curveIndex
				setYAxisLimits min, dataArr[curveIndex].analysisCurveMax
		else
			setYAxisLimits getMinMin(), getMaxMax()

	yMaxInputChange = (input) ->
		curveIndex = lastNum input.attr 'id'
		max = input.val()
		if not isNumeric max
			max = 0
			input.val max
		dataArr[curveIndex].analysisCurveMax = max
		if selectedCurveIndex?
			if selectedCurveIndex == curveIndex
				setYAxisLimits dataArr[curveIndex].analysisCurveMin, max
		else
			setYAxisLimits getMinMin(), getMaxMax()

	setYAxisLimits = (min, max) ->
		analysisChartObj.yAxis[0].setExtremes min, max, false, false
		analysisChartObj.redraw()
	
	updateYAxis = (axisColor, redraw=false) ->
		selectedMenuItem = getSelectedMenuItem()
		i = lastNum selectedMenuItem.val()
		if i = 1
			seriesColors = pgweb.CurveChart.inst().smbasicMIC1AnalysisSeriesColors
		else
			seriesColors = pgweb.CurveChart.inst().smbasicMIC2AnalysisSeriesColors
		
		item = currentData.seriesArr[i-1]
		
		addBaseLevelPlotLine item.baseLevel
		addHiLimitPlotLine item.hiLimit
		addHiHiLimitPlotLine item.hihiLimit
		
		addBelowBasePlotBand item.baseLevel
		addBaseToHiPlotBand item.baseLevel, item.hiLimit
		addHiToHiHiPlotBand item.hiLimit, item.hihiLimit
		addAboveHiHiPlotBand item.hihiLimit

		analysisChartObj.yAxis[0].update
			labels:
				enabled: true
				style:
					color: '#aaaaaa'
		, redraw

	addAboveHiHiPlotBand = (hihiLevel) ->
		plotBandObj =
			from: 65
			to: hihiLevel
			color:
				linearGradient: { x1:0, y1: 0, x2:0, y2: 1 }
				stops: [
					[0.00, '#ff000044'] # Top
					[1.00, '#ff000033'] # HiHi
				]
			id: 'above-hihi-plotband'
		analysisChartObj.yAxis[0].removePlotBand 'above-hihi-plotband'
		analysisChartObj.yAxis[0].addPlotBand plotBandObj

	addHiToHiHiPlotBand = (hiLevel, hihiLevel) ->
		plotBandObj =
			from: hiLevel
			to: hihiLevel
			color:
				linearGradient: { x1:0, y1: 0, x2:0, y2: 1 }
				stops: [
					[0.00, '#ff000044'] # HiHi
					[0.10, '#ff000044']
					[0.80, '#ffaa0055']
					[1.00, '#ffaa0055'] # Hi
				]
			id: 'hi-to-hihi-plotband'
		analysisChartObj.yAxis[0].removePlotBand 'hi-to-hihi-plotband'
		analysisChartObj.yAxis[0].addPlotBand plotBandObj

	addBaseToHiPlotBand = (baseLevel, hiLevel) ->
		plotBandObj =
			from: baseLevel
			to: hiLevel
			color:
				linearGradient: { x1:0, y1: 0, x2:0, y2: 1 }
				stops: [
					[0.00, '#ffaa0055'] # Hi
					[0.30, '#ffaa0055']
					[0.95, '#00ff0033']
					[1.00, '#00ff0033'] # Base
				]
			id: 'base-to-hi-plotband'
		analysisChartObj.yAxis[0].removePlotBand 'base-to-hi-plotband'
		analysisChartObj.yAxis[0].addPlotBand plotBandObj

	addBelowBasePlotBand = (baseLevel) ->
		plotBandObj =
			from: 0
			to: baseLevel
			color:
				linearGradient: { x1:0, y1: 0, x2:0, y2: 1 }
				stops: [
					[0, '#00ff0033'] # Base
					[1, '#00ff0044'] # Bottom
				]
			id: 'below-base-plotband'
		analysisChartObj.yAxis[0].removePlotBand 'below-base-plotband'
		analysisChartObj.yAxis[0].addPlotBand plotBandObj

	addBaseLevelPlotLine = (value) ->
		plotLineObj =
			color: seriesColors[2]
			dashStyle: 'Dash'
			width: 2
			value: value
			id: 'mic-limit-plotline'
		analysisChartObj.yAxis[0].removePlotLine 'mic-limit-plotline'
		analysisChartObj.yAxis[0].addPlotLine plotLineObj

	removeBaseLevelPlotLine = ->
		analysisChartObj.yAxis[0].removePlotLine 'mic-limit-plotline'

	addHiLimitPlotLine = (value) ->
		plotLineObj =
			color: seriesColors[3]
			dashStyle: 'Dot'
			width: 2
			value: value
			id: 'mic-hi-limit-plotline'
		analysisChartObj.yAxis[0].removePlotLine 'mic-hi-limit-plotline'
		analysisChartObj.yAxis[0].addPlotLine plotLineObj

	removeHiLimitPlotLine = ->
		analysisChartObj.yAxis[0].removePlotLine 'mic-hi-limit-plotline'

	addHiHiLimitPlotLine = (value) ->
		plotLineObj =
			color: seriesColors[4]
			dashStyle: 'Dot'
			width: 2
			value: value
			id: 'mic-hihi-limit-plotline'
		analysisChartObj.yAxis[0].removePlotLine 'mic-hihi-limit-plotline'
		analysisChartObj.yAxis[0].addPlotLine plotLineObj

	removeHiHiLimitPlotLine = ->
		analysisChartObj.yAxis[0].removePlotLine 'mic-hihi-limit-plotline'

	showCurve = (curveIndex, show) ->
		if show
			analysisChartObj.series[curveIndex].show()
		else
			analysisChartObj.series[curveIndex].hide()
		dataArr[curveIndex].show = show
	
	updateSeries = (curveIndex, config) ->
		pgwebFormat = analysisChartObj.series[curveIndex].pgwebFormat
		pgwebMin = analysisChartObj.series[curveIndex].pgwebMin
		pgwebMax = analysisChartObj.series[curveIndex].pgwebMax
		
		analysisChartObj.series[curveIndex].update config, false
		
		analysisChartObj.series[curveIndex].pgwebFormat = pgwebFormat
		analysisChartObj.series[curveIndex].pgwebMin = pgwebMin
		analysisChartObj.series[curveIndex].pgwebMax = pgwebMax

	chartToolTipFormatter = ->
		# Creating a Date from this.x gives the wrong timezone (adds offset from UTC), so we have to adjust it.
		dBrowser = new Date this.x
		dLocal = new Date dBrowser.getTime() + dBrowser.getTimezoneOffset()*60000
		dStr = Globalize.format dLocal, 'F' # d.toISOString().replace("T", " ").substring(0, 19);
		html = '<div style="color: #ddd">'
		html += dStr
		html += '</div><br /><div>'
		for i in [0..(this.points.length-1)]
			y = this.points[i].y
			curveIndex = this.points[i].series.index
			inputElem = $('#'+currentWhich+'-curve-buttons input')[curveIndex]
			labelElem = $(inputElem).prev()
			labelText = labelElem.text().trim()
			nDecimals = formatStringToNDecimals analysisChartObj.series[curveIndex].pgwebFormat
			if not labelText
				selectedItem = getSelectedMenuItem()
				labelText = selectedItem.text()
			html += '<div style="font-size: 1.3em; padding-top: .5em;">'
			html += '<span style="color: #ddd">'+labelText+'</span>: <b>'+Globalize.format(y, 'n'+nDecimals)+'</b>'
			html += '</div><br/>'
		html += '</div>'
		return  html

	getSelectedMenuItem = ->
		item = $('[name=what-curve]').find ':selected'
		$(item[0])

	showHideControls = (which) ->
		showHideControl which, 'mic1', '#mic1-curve-buttons'
		showHideControl which, 'mic2', '#mic2-curve-buttons'
	
	showHideControl = (which, name, control) ->
		if which == name
			$(control).show()
		else
			$(control).hide()

	loadChart = ->
		periods =
			free: 0
			sixMonths: 180
			threeMonths: 90
			oneMonth: 30
			oneWeek: 7

		showEveryPoint = $('#show-every-point').prop 'checked'

		period = $('[name=range]:checked').val()
		if (!period)
			period = 'oneWeek'
		days = periods[period]

		min = null
		max = null
		if days == 0 # Free selection of start and end time.
			# Order of start date and end date does not matter.
			date1 = $('[name=free-from]').val()
			date2 = $('[name=free-to]').val()
			if date2 < date1
				dateTmp = date1
				date1 = date2
				date2 = dateTmp
			min = new Date date1+" 00:00:00.000"
			max = new Date date2+" 23:59:59.999"
			if min == 'Invalid Date'
				now = new Date()
				dateStr = now.toISOString().substr 0, 10
				min = new Date dateStr+" 00:00:00.000"
				$('[name=free-from]').val dateStr
			if max == 'Invalid Date'
				now = new Date()
				dateStr = now.toISOString().substr 0, 10
				max = new Date dateStr+" 23:59:59.999"
				$('[name=free-to]').val dateStr
			min = new Date(min.getTime() - min.getTimezoneOffset()*60000)
			max = new Date(max.getTime() - max.getTimezoneOffset()*60000)
		else
			min = getMinXFromDays days, timezone.offset
			max = getMaxXFromDays days, timezone.offset
		msg = ''
		if not showEveryPoint
			if days == 0
				timeDiff = (max.getTime() - min.getTime())/1000; # Convert ms into s.
				periodMinutes = Math.floor(timeDiff/1000)/60; # Period length in minutes.
				periodHours = 0
				if periodMinutes >= 60
					periodHours = Math.floor periodMinutes/60
					periodMinutes = Math.floor periodMinutes % 60
				msg = periodHours+" h "+periodMinutes.toFixed(1)+" min"
			else if days > 0 and days <= 7 # Up to 1 week
				msg = "10 min" # 10 minutes resolution = max 1008 values
			else if days > 7 and days <= 31 # Up to 1 month
				msg = "1 h" # 1 hour resolution = max 744 values
			else if days > 31 && days <= 93 # Up to 3 months
				msg = "3 h" # 3 hours resolution = max 744 values
			else if days > 93 && days <= 186 # Up to 6 months
				msg = "6 h" # 6 hours resolution = max 744 values
			else # More than 6 months
				msg = "24 h" # 24 hours resolution
			msg = t.TrendsPage_MaxOneValuePer + ' ' + msg
		$('#show-every-point-message').html msg

		howMuchData = days
		which = $('[name=what-curve]').val()
		yAxisConfig
		seriesColors = pgweb.CurveChart.inst().standardSeriesColors
		showHideControls which
		if which == 'mic1' or which == 'mic2'
			if $('[name=moduleTypeName]').val() == 'smbasicPG'
				if lastNum(which) == 1
					seriesColors = pgweb.CurveChart.inst().smbasicMIC1AnalysisSeriesColors
				else
					seriesColors = pgweb.CurveChart.inst().smbasicMIC2AnalysisSeriesColors
				yAxisConfig = pgweb.CurveChart.inst().yAxisFloatFixedConfig seriesColors[0], false, .001, 1 # Do not show first axis label.
			else
				yAxisConfig = pgweb.CurveChart.inst().yAxisFloatConfig seriesColors[0], false, .001, 1
		currentWhich = which
		zoom = ''
		if $('.showSMBasicPGAnalysisPage .allow-zoom-button').is(':checked')
			zoom = 'xy'
		title = chartTitle which
		renderTo = $(".ui-page-active .analysis-container").get()[0]
		analysisChartObj = pgweb.CurveChart.inst().create min, max, zoom, title, yAxisConfig, 0, seriesColors, renderTo, chartToolTipFormatter, true
		moduleId = $.url().param().moduleId
		if days == 0
			loadChartDataFromAjax which, 0, min, max, moduleId, showEveryPoint
		else
			loadChartDataFromAjax which, days, undefined, undefined, moduleId, showEveryPoint

	loadChartDataFromAjax = (which, days, from, to, moduleId, showEveryPoint) ->
		waitStart()
		if days == 0
			fromISO = from.toISOString()
			toISO = to.toISOString()
		$.ajax
			url: "/pgweb/ajax/smbasicpg/analysisCurve.php"
			dataType: 'json'
			data:
				which: which
				days: days
				from: fromISO
				to: toISO
				moduleId: moduleId
				showEveryPoint: showEveryPoint
			success: (data) ->
				if data.result == "OK"
					currentData = data
					for i in [0..9]
						analysisChartObj.series[i].setData []
					nCurves = data.seriesArr.length
					for curveIndex in [0..(nCurves-1)]
						dataSeriesObj = data.seriesArr[curveIndex]
						if dataSeriesObj.series.length > 0
							for i in [0..(dataSeriesObj.series.length-1)]
								item = dataSeriesObj.series[i]
								dt = Globalize.parseDate item.t
								dtJSTime = dateTimeToJSTime(dt) # Unix time * 1000
								timezone = data.timezone
								dtJSTimeTzCorrected = dtJSTime + timezone.offset*60000
								xy = [dtJSTimeTzCorrected, item.v]
								analysisChartObj.series[curveIndex].addPoint xy, false
						analysisChartObj.series[curveIndex].pgwebFormat = data.seriesArr[curveIndex].format
						analysisChartObj.series[curveIndex].pgwebMin = data.seriesArr[curveIndex].min
						analysisChartObj.series[curveIndex].pgwebMax = data.seriesArr[curveIndex].max
					if days == 0
						from = dateTimeToJSTime from
						to = dateTimeToJSTime to
						analysisChartObj.xAxis[0].setExtremes from, to, false
					else
						setXAxisInterval days

					for curveIndex in [0..(nCurves-1)]
						switchCurve curveIndex, nCurves, seriesColors[curveIndex], which

					micNumber = lastNum which
					if filterIsOn()
						micMean = $('#mic'+micNumber+'-filter').val()
						computeAverage micMean
						analysisChartObj.series[5].show()

					$('#min-raw').text Globalize.format(data.seriesArr[0].min, 'n0')
					$('#average-raw').text Globalize.format(data.seriesArr[0].avg, 'n0')
					$('#max-raw').text Globalize.format(data.seriesArr[0].max, 'n0')

					$('#min-filter').text Globalize.format(data.seriesArr[1].min, 'n0')
					$('#average-filter').text Globalize.format(data.seriesArr[1].avg, 'n0')
					$('#max-filter').text Globalize.format(data.seriesArr[1].max, 'n0')

					$('#mic-base-level').val Globalize.format(data.seriesArr[0].baseLevel, 'n0')
					$('#mic-hihi-level').val Globalize.format(data.seriesArr[0].hihiLimit, 'n0')
					$('#mic-hi-level').val Globalize.format(data.seriesArr[0].hiLimit, 'n0')
					$('#mic-filter').val Globalize.format(data.seriesArr[0].filter, 'n0')
					$('#mic-num').text micNumber
					
					$('#mic-hihi-level').removeClass 'level-highlight'
					$('#mic-hi-level').removeClass 'level-highlight'
			
					analysisChartObj.redraw()

				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Failed to load chart data: "+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()
	
	calculateHiHiLimit = (normalValue) ->
		maxValue = 70
		normalValue + (maxValue - normalValue)/3

	switchCurve = (curveIndex, nCurves, axisColor, which) ->
		waitStart()
		title = chartTitle which
		analysisChartObj.setTitle {text: title}
		updateSeries curveIndex, {
			type: 'line'
			dashStyle: selectedCurveDashStyle
			lineWidth: selectedCurveLineWidth
			marker: { enabled: false }
		}
		updateYAxis axisColor
		setYExtremes()
		for i in [0..(nCurves-1)]
			analysisChartObj.series[i].show()
		analysisChartObj.series[curveIndex].select true
		waitStop()

	setXAxisInterval = (days) ->
		minXLocal = getMinXFromDays days, timezone.offset
		maxXLocal = getMaxXFromDays days, timezone.offset
		minXLocal = dateTimeToJSTime minXLocal
		maxXLocal = dateTimeToJSTime maxXLocal
		analysisChartObj.xAxis[0].setExtremes minXLocal, maxXLocal, false

	setYExtremes = ->
		factor = 1.2
		baseMax = 65 #analysisChartObj.series[0].pgwebMax
		baseMin = 19 #analysisChartObj.series[0].pgwebMin
		dist = baseMax - baseMin
		
		if (upperYZoom < 0)
			max = baseMin + dist*Math.pow 1/factor, -upperYZoom
		else
			max = baseMin + dist*Math.pow factor, upperYZoom
		
		if (lowerYZoom < 0)
			min = baseMax - dist*Math.pow 1/factor, -lowerYZoom
		else
			min = baseMax - dist*Math.pow factor, lowerYZoom
		
		if min < 19
			min = 19
		if max > 65
			max = 65
		
		analysisChartObj.yAxis[0].setExtremes min, max

	chartTitle = (which) ->
		if not currentData? then return
		menuItem = getSelectedMenuItem()
		currentData.moduleName + ', ' + menuItem.text()

$(document).on 'pagecreate', '.showSMBasicPGAnalysisPage', (event) ->
	pgweb.AnalysisSMBasicPG.inst().destructor()
	pgweb.AnalysisSMBasicPG.inst().init()
class pgweb.PVStatus
	@SWITCHED_OFF = 0
	@NO_ALARMS = 1
	@OPERATION_ALARM = 2
	@SYSTEM_ALARM = 3
	@OPERATION_SYSTEM_ALARM = 4

	value = @SWITCHED_OFF
	string = ''
	
	@strings:
		0:	'SwitchedOff'
		1:	'NoAlarms'
		2:	'OperationAlarm'
		3:	'SystemAlarm'
		4:	'OperationSystemAlarm'
	
	@translatedStrings:
		0:	t.PVStatus_SwitchedOff
		1:	t.PVStatus_NoAlarms
		2:	t.PVStatus_OperationAlarm
		3:	t.PVStatus_SystemAlarm
		4:	t.PVStatus_OperationSystemAlarm

	@values:
		'SwitchedOff':           @SWITCHED_OFF
		'NoAlarms':              @NO_ALARMS
		'OperationAlarm':        @OPERATION_ALARM
		'SystemAlarm':           @SYSTEM_ALARM
		'OperationSystemAlarm':  @OPERATION_SYSTEM_ALARM

	@colors:
		0: 'gray'
		1: 'green'
		2: 'yellow'
		3: 'red'
		4: 'yellowred'
	
	constructor: (value) ->
		@value = value
		@string = PVStatus.strings[value]
		@color = PVStatus.colors[value]

	@toString: (value) ->
		@strings[value]

	@toValue: (string) ->
		@values[string]

	@toColor: (value) ->
		@colors[value]

	@toTranslatedString: (value) ->
		@translatedStrings[value]

###
v = new PVStatus(PVStatus.OPERATION_ALARM)
console.log v.value+' '+v.string+' '+v.color
console.log 3+' '+PVStatus.toString(3)+' '+PVStatus.toColor(3)
console.log PVStatus.toValue('OperationSystemAlarm')+' OperationSystemAlarm'+' '+PVStatus.toColor(4)
###
class pgweb.ModuleListMap extends pgweb.Map
	
	instance = null
	intervalId = null
	
	@inst: ->
		# Run only on module list page.
		if $.url().param().action != 'showModules'
			return
		if not instance?
			instance = new @
		instance
	
	init: ->
		super()
		@initInterval()
		@initEventHandlers()

		$('body').on 'change', '#sonitus-circles-avg-onoff', (e) =>
			timeRange = $(e.target).val()
			SonitusSectionCircles.clearAllCircles()
			for module in @getModulesWithCoords()
				SonitusSectionCircles.drawForOneModule @getMap(), module, timeRange

		$('body').on 'click', '.map-marker', (e) =>
			tr = $(e.target).closest 'tr'
			coordsStr = tr.find('.module-list-td-gis_coordinates .table-value').text()
			[lat, lon] = (parseFloat coord for coord in coordsStr.split ' ')
			if USE_BAIDU_MAPS
				pgweb.Main.openBaiduMap lat, lon
			else
				projection = $('#projection').val()
				if projection not in ['', 'wgs84']
					# Convert to wgs84
					[lat, lon] = xy2ll projection, lat, lon
				pgweb.Main.openGoogleMap lat, lon
	
	initInterval: ->
		clearInterval intervalId
		intervalId = setInterval =>
			if pgweb.Main.inst().autoUpdateButtonIsOn()
				@update false
		, pgweb.Main.getUpdateInterval()

	initEventHandlers: ->
		# On click on external link button, open it in a window stripped of toolbars.
		$('.module-list-td-external_link a').click ->
			url = $(this).prop 'href'
			moduleName = $(this).parent().parent().find('.module-list-td-module_name .module-list-address').text()
			pgweb.Main.inst().openInStrippedWindow url, moduleName
			false

	# Display markers for all the modules visible in the table.
	update: (fitBounds) ->
		if $.url().param().action != 'showModules' then return
		#if not pgweb.Main.inst().autoUpdateButtonIsOn() then return
		@ajaxUpdate fitBounds
	
	ajaxUpdate: (fitBounds) ->
		waitStart()
		@modules = []
		$('#filter-onoff').slider 'disable'
		$.ajax
			url: "/pgweb/ajax/module/moduleListMap.php"
			dataType: 'json'
			type: 'GET'
			data:
				networkId: $.url().param().networkId
				moduleTypeId: $.url().param().moduleTypeId
			success: (data) =>
				@modules = data.modules
				switch data.result
					when "OK"
						@afterAjaxUpdate fitBounds
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get module data.', data.result);
			error: ajaxFailure
			complete: ->
				waitStop()
	
	# Called when ajax finished.
	afterAjaxUpdate: (fitBounds) ->
		$('#filter-onoff').slider 'enable'

		# See if some module has disappeared. If so, remove it from the table.
		# (Removals in the map will be handled automatically, since it always reloads alla map needles.)
		
		# All ids in the rows.
		rowIds = (lastNum($(tr).prop('id')) for tr in $('.module-table tbody tr'))
		hiddenRowIds = (lastNum($(tr).prop('id')) for tr in $('.module-table tbody tr:hidden'))
		# All ids got by ajax.
		ajaxIds = (module.id for module in @modules)

		# Find new ids (got by ajax but not existing in the rows).
		newIds = []
		for ajaxId in ajaxIds
			if not (ajaxId in rowIds)
				newIds.push ajaxId
		# Find removed ids (existing in the rows but not got by ajax).
		removedIds = []
		for rowId in rowIds
			if not (rowId in ajaxIds)
				removedIds.push rowId

		# Hide and remove the rows of removed ids.
		for id in removedIds
			$('#module-id-'+id).hide 'slow', ->
				$('#module-id-'+id).remove()

		# Simplest approach to add new rows: Just reload the page.
		# Easier than handling sorting etc.
		if newIds.length > 0
			location.reload()
			return
		
		# Update table with data from ajax call.
		for module in @modules
			@updateListRow module
		
		if !@getMap() then return

		modulesWithCoords = @getModulesWithCoords()

		# Get the points of the modules to be viewed (for map bounds calculation).
		pointsForBoundsCalc = (@correctCoords [module.gis_latitude, module.gis_longitude] for module in modulesWithCoords)
		
		# If there are no modules to be viewed on the map, do nothing more.
		if pointsForBoundsCalc.length == 0
			@clearMarkers()
			return
		
		# Fit bounds perfectly to the points.
		if fitBounds
			bounds = new L.LatLngBounds pointsForBoundsCalc
			@fitBounds bounds
		
		SonitusSectionCircles.clearAllCircles()
		for module in modulesWithCoords
			if module.module_type_name == 'gw102'
				SonitusSectionCircles.drawForOneModule @getMap(), module,  $('#sonitus-circles-avg-onoff').val()
		
		# Display the map needles.
		@createMarkers()
		
	updateListRow: (module) ->
		@setValueAndColor module.id, 'timer', module.timer_fmt, module.timer_color
		@setValueAndColor module.id, 'temp', module.temp_fmt, module.temp_color
		@setValueAndColor module.id, 'batt', module.batt_fmt, module.batt_color
		@setValueAndColor module.id, 'batt2', module.batt2_fmt, module.batt2_color
		@setValueAndColor module.id, 'csq', module.csq_fmt, module.csq_color
		@setValueAndColor module.id, 'com_error', module.com_error, module.com_error_color
		for di in [1..module.nDIs]
			@setValueAndColor module.id, 'di'+di, module['di'+di], module['di'+di+'_color']
		for an in [1..module.nANs]
			@setValueAndColor module.id, 'an'+an, module['an'+an+'_fmt'], module['an'+an+'_color']
		for mic in [1..module.nMICs]
			@setValueAndColor module.id, 'mic'+mic, module['mic'+mic+'_fmt'], module['mic'+mic+'_color']
		@setValueAndColor module.id, 'pv_status', module.pv_status, module.pv_status_color
		$('#module-id-'+module.id+' .module-list-td-technical_name div').html escapeStringForHTML module.technical_name
		$('#module-id-'+module.id+' .module-list-td-address div').html escapeStringForHTML module.address
		for ch in [1..module.nChannels]
			@setQpgSymbol module.id, ch, module['ch'+ch+'_qpg_symbol']
		@setMapMarker module.id, module.gis_latitude, module.gis_longitude, module.gis_active
		@setUnfinishedTasksExist module.id, module.unfinishedTasksExist

	setUnfinishedTasksExist: (id, unfinishedTasksExist) ->
		tag = $('#module-id-'+id+' .module-list-td-tasks > div')
		if unfinishedTasksExist
			$(tag).html '<i class="fa fa-pencil-square-o fa-lg"/>'
		else
			$(tag).html ''

	setMapMarker: (id, gis_latitude, gis_longitude, gis_active) ->
		tag = $('#module-id-'+id+' .module-list-td-gis_active > div')
		$(tag).html if gis_active
			if gis_latitude.toString().length > 0 and gis_longitude.toString().length > 0
				'<div class="map-marker"><i class="fa fa-map-marker fa-lg"/></div>'
			else
				''
		else
			if gis_latitude.toString().length > 0 and gis_longitude.toString().length > 0
				'<div class="map-marker"><i class="fa fa-map-marker fa-lg gis-coords-but-inactive"/></div>'
			else
				''

	setValueAndColor: (id, which, value, color) ->
		if /^di\d$/.test which
			diTags = $('#module-id-'+id+' .module-list-td-di > div')
			for diTag, i in diTags
				di = i+1
				if di == lastNum which
					$(diTag).removeClass 'di-gray'
					$(diTag).removeClass 'di-green'
					$(diTag).removeClass 'di-red'
					$(diTag).addClass 'di-'+color
		else if which == 'com_error'
			selector = '#module-id-'+id+' .module-list-td-com_error > div'
			$(selector).removeClass 'di-gray'
			$(selector).removeClass 'di-green'
			$(selector).removeClass 'di-red'
			if color
				$(selector).addClass 'di-'+color
		else if which == 'pv_status'
			selector = '#module-id-'+id+' .module-list-td-pv_status > div'
			$(selector).removeClass 'pvstatus-gray'
			$(selector).removeClass 'pvstatus-green'
			$(selector).removeClass 'pvstatus-yellow'
			$(selector).removeClass 'pvstatus-red'
			$(selector).removeClass 'pvstatus-yellowred'
			if color
				$(selector).addClass 'pvstatus-'+color
		else
			selector = '#module-id-'+id+' .module-list-td-'+which+' div'
			$(selector).html value
			$(selector).removeClass 'gauge-display-gray'
			$(selector).removeClass 'gauge-display-green'
			$(selector).removeClass 'gauge-display-orange'
			$(selector).removeClass 'gauge-display-red'
			if color
				$(selector).addClass 'gauge-display-'+color

	setQpgSymbol: (id, ch, html) ->
		qpgTags = $('#module-id-'+id+' .module-list-td-qpg > div.all-qpg-container')
		for qpgTag in qpgTags
			tagCh = lastNum($(qpgTag).attr('class').split(' ')[1])
			if tagCh == ch
				$(qpgTag).html html
class pgweb.ChannelListPage
	
	instance = null
	_tfb = null
	
	@inst: ->
		if not instance?
			instance = new @
		instance

	init: ->
		_tfb = new pgweb.TableFilterBehaviour(@)
		_tfb.setKeyupCallBack -> {}
		_tfb.setSwitchOnFilterCallBack -> {}
		_tfb.setSwitchOffFilterCallBack -> {}
		
		$('body').on 'change', '#channel-category', (e) ->
			selCatId = $(e.target).val()
			if selCatId != 'all' and selCatId != 'without'
				selCatId = parseInt selCatId
			$('#channel-table tbody tr').each ->
				tr = $(@)
				catId = parseInt $(this).attr 'pgweb-data-channelCategoryId'
				show = filterCategoryOneRow selCatId, catId
				if _tfb.columnFilterIsOn()
					show = show and _tfb.filterColumnsOneRow tr
				if show
					tr.show()
				else
					tr.hide()
	
		pgweb.Main.detachableListHeaderPrefix = 'channel'

		pgweb.ExportToClipboard.init 'channel-table'

	runFilter: ->
		$('#channel-table tbody tr').each ->
			tr = $(@)
			selCatId = $('#channel-category').val()
			show = true
			if selCatId
				if selCatId != 'all' and selCatId != 'without'
					selCatId = parseInt selCatId
				catId = parseInt $(this).attr 'pgweb-data-channelCategoryId'
				show = filterCategoryOneRow selCatId, catId
			if _tfb.columnFilterIsOn()
				show = show and _tfb.filterColumnsOneRow tr
			if show
				tr.show()
			else
				tr.hide()
	
	filterCategoryOneRow = (selCatId, catId) ->
		show = true
		if selCatId == 'without'
			if catId then show = false
		else if selCatId == 'all'
			# NOP
		else if catId != selCatId then show = false
		show

$(document).on 'pageshow', '.listChannelsPage', (event) ->
	pgweb.ChannelListPage.inst().init()
class pgweb.ModuleListPage
	
	instance = null
	_tfb = null
	
	@inst: ->
		if $.url().param().action != 'showModules'
			return
		if not instance?
			instance = new @
		instance

	init: ->
		_tfb = new pgweb.TableFilterBehaviour(@)
		_tfb.setKeyupCallBack @keyupCallBack
		_tfb.setSwitchOnFilterCallBack @switchOnFilterCallBack
		_tfb.setSwitchOffFilterCallBack @switchOffFilterCallBack

		pgweb.ModuleListMap.inst().setAfterCreateMarkersCallback @afterCreateMarkersCallBack

		pgweb.ModuleListMap.inst().id = 'module-list-map'
		pgweb.ModuleListMap.inst().init()

		$('body').on 'change', '#map-onoff', ->
			mapOn = $(@).val()=='on'
			if mapOn
				switchOnMap()
			else
				switchOffMap()

		$('body').on 'change', '.needle-button', (e) =>
			@runFilter()

		pgweb.Main.detachableListHeaderPrefix = 'module'

		pgweb.ExportToClipboard.init 'module-table'

	runFilter: ->
		map = pgweb.ModuleListMap.inst()
		if not map then return
		isGreen  = $('#needle-button-green').is  ':checked'
		isYellow = $('#needle-button-yellow').is ':checked'
		isRed    = $('#needle-button-red').is    ':checked'
		isGray   = $('#needle-button-gray').is   ':checked'
		$('#module-table tbody tr').each ->
			tr = $(@)
			moduleId = lastNum tr.prop 'id'
			module = map.getModuleById moduleId
			show = switch module.pv_status_color
				when 'green' then isGreen
				when 'red' then isRed
				when 'yellowred' then isRed or isYellow
				when 'yellow' then isYellow
				when 'gray' then isGray
				else false
			if _tfb.columnFilterIsOn()
				show = show and _tfb.filterColumnsOneRow tr
			tr.toggle show

			map.toggleMarker module, show, map.getMap()

		# Toggle layergroups.
		map.toggleLayers isGreen, isYellow, isRed, isGray
	
	keyupCallBack: =>
		@runFilter()
		
	switchOnFilterCallBack: =>
		@runFilter()
	
	switchOffFilterCallBack: =>
		@runFilter()

	afterCreateMarkersCallBack: =>
		@runFilter()

	switchOnMap = =>
		pgweb.ModuleListMap.inst().id = 'module-list-map'
		pgweb.ModuleListMap.inst().show()

	switchOffMap = =>
		pgweb.ModuleListMap.inst().id = 'module-list-map'
		pgweb.ModuleListMap.inst().hide()

$(document).on 'pageshow', '.listPage', (event) ->
	pgweb.ModuleListPage.inst().init()
class pgweb.ChartTableView
	instance = null
	
	constructor: ->
		# When the table button is clicked, tell the world that the table computation should begin.
		$('body').on 'click', '#chart-table-button', (event, ui) =>
			pgweb.Event.trigger 'begin_compute_trends_table', pgweb.TrendsPage.getCurrentData()

		# When we get a message that the table computation is complete, show the table.
		pgweb.Event.on 'end_compute_trends_table', (event, data) =>
			@show JSON.parse data

		$('body').on 'click', '#chart-table-popup-ok', (event, ui) =>
			$('#chart-table-popup').popup 'close'

		$('body').on 'click', '#chart-table-copy-clipboard', (event, ui) =>
			@copyToClipboard()

	@inst: ->
		if not instance?
			instance = new @
		instance

	show: (data) ->
		$('#chart-info-date').text data.date
		$('#chart-info-startdate').text data.startdate
		$('#chart-info-enddate').text data.enddate
		$('#chart-info-network-name').text data.networkName
		$('#chart-info-system-name').text data.systemName
		$('#chart-info-technical-name').text data.technicalName
		$('#chart-info-address').text data.address
		
		$('#chart-info-channel-tr').hide()
		$('#chart-info-section-desc-tr').hide()
		$('#chart-info-alarm-section-tr').hide()
		if (/^ch\d$/.test data.which) or (/^chTdr\dW\d$/.test data.which)
			$('#chart-info-channel-tr').show()
			$('#chart-info-channel-td').text data.channelData.channel
			$('#chart-info-section-desc-tr').show()
			$('#chart-info-section-desc-td').text data.channelData.sectionDescription
			$('#chart-info-alarm-section-tr').show()
			$('#chart-info-alarm-section-td').text data.channelData.alarmSection
		
		for i in [1..data.diDescriptions.length]
			$('#chart-info-td-di'+i).html data.diDescriptions[i-1]
			$('#chart-info-tr-di'+i).show()
		for i in [(data.diDescriptions.length+1)..8]
			$('#chart-info-td-di'+i).text ''
			$('#chart-info-tr-di'+i).hide()

		for i in [1..data.anDescriptions.length]
			$('#chart-info-td-an'+i).html data.anDescriptions[i-1]
			$('#chart-info-tr-an'+i).show()
		for i in [(data.anDescriptions.length+1)..8]
			$('#chart-info-td-an'+i).text ''
			$('#chart-info-tr-an'+i).hide()
		
		$('#chart-table tbody').html ''
		$('#chart-table thead').html ''
		$('#chart-table-popup').popup 'open'
		# Table column headers
		tr = $('<tr>').append $('<th class="topleft">').html t.TrendsPage_Time
		for head in data.headers
			name = head.name
			if data.moduleTypeName == 'smbasicPG' and name.substr(0, 2) == 'AN'
				name = 'MIC'+name.substr(-1)
			tr.append $('<th>').html head.text
		$('#chart-table thead').append tr

		# Table rows
		for row in data.rows
			tr = $('<tr>')
			# Time column cells
			dUtc = new Date(row.t)
			dLocal = new Date(dUtc.getTime() + data.timezone.offset*60000)
			date = dLocal
			dStr = Globalize.format(date, 'd')+' '+Globalize.format(date, 'T')
			tr.append $('<th>').html dStr
			
			# Value cells
			for head in data.headers
				value = row.cols[head.name]
				nDecimals = formatStringToNDecimals head.format
				tr.append $('<td>').html Globalize.format value, 'n'+nDecimals
			$('#chart-table tbody').append tr

	copyToClipboard: ->
		sep = "\t"

		text = $('#chart-info').html().replace /\n/g, ''
		text = text.replace /\s*id="[\w\d-]*"\s*/ig, ' '
		text = text.replace /\t/g, ''
		text = text.replace /\s\s+/g, ' '
		text = text.replace /<tr [^>]*style="display: none;">.*?<\/tr>/ig, ''
		text = text.replace /<tr [^>]*style="display: table-row;"><th>/ig, ''
		text = text.replace /<\/*tbody>/ig, ''
		text = text.replace /<span .*?>/ig, ''
		text = text.replace /<\/span>/ig, ''
		text = text.replace /<tr\s*><th>/ig, ''
		text = text.replace /<\/td><\/tr>/ig, "\n"
		text = text.replace /<\/th><td\s?>/ig, sep
		text1 = text

		text = $('#chart-table').html().trim()
		text = text.replace /\t/g, ''
		text = text.replace /<\/*thead>\n*/ig, ''
		text = text.replace /<\/*tbody>/ig, ''
		text = text.replace /\s*class=".*"\s*/ig, ''
		text = text.replace /<\/th><th>/ig, sep
		text = text.replace /<\/td><td>/ig, sep
		text = text.replace /<tr><th>/ig, ''
		text = text.replace /<\/th><\/tr>/ig, "\n"
		text = text.replace /<\/td><\/tr>/ig, "\n"
		text = text.replace /<\/th><td>/ig, sep
		text = text.replace /&nbsp;/ig, ''
		text = text+"\n"
		text2 = text

		pgweb.Main.inst().copyToClipboard text1+"\n"+text2
		
		$('#chart-table-popup-error-message').before '<div id="copy-finished" style="display: none">'+t.CopyToClipBoardFinished+'</div>'
		$('#copy-finished').slideDown(500).delay(1500).slideUp 500, -> @.remove()
			
$(-> pgweb.ChartTableView.inst())

class pgweb.ChartTable

	constructor: ->
		pgweb.Event.on 'begin_compute_trends_table', (event, indata) =>
			data = @compute JSON.parse indata
			pgweb.Event.trigger 'end_compute_trends_table', data

	instance = null
	
	@inst: ->
		if not instance?
			instance = new @
		instance

	compute: (data) ->
		# Get texts of the series buttons. These will be used as the headers.
		buttonTexts = ($(b).text() for b in $('.curve-buttons label:visible').toArray())
		# If the first button is an overview button, do not use the text of it.
		if $('.curve-buttons label:visible').first().closest('div').find('input').val() == 'overview'
			buttonTexts.splice 0, 1
		
		headers = []
		for seriesArrItem, i in data.seriesArr
			# Write tag meaning to each point.
			val.tagMeaning = seriesArrItem.name for key, val of seriesArrItem.series

			headers.push
				name: seriesArrItem.name
				text: buttonTexts[i]
				format: seriesArrItem.format
		# Concatenate all series data
		s = [].concat (val.series for val in data.seriesArr)...
		# Sort by 1) time, 2) name.
		s.sort @compare
		# Merge all items with equal timestamp.
		lastTime = ''
		rows = []
		for item in s
			if item.t isnt lastTime
				newItem =
					t: item.t
					cols: {}
				rows.push newItem
			newItem.cols[item.tagMeaning] = item.v
			lastTime = item.t
		data.headers = headers
		data.rows = rows
		data
	
	compare: (a,b) ->
		if a.t < b.t then -1
		else if a.t > b.t then 1
		#else if a.tagMeaning < b.tagMeaning then -1 
		#else if a.tagMeaning > b.tagMeaning then 1 
		else 0

$(-> pgweb.ChartTable.inst())

class pgweb.TasksPanel

	@init: ->
		$(document).on 'pageshow', '.showModulePage', (event) ->
			loadTasks($.url().param().moduleId)

			$('body').on 'click', '#tasks-panel-settings-button', ->
				$('#module-tasks-button').click()
	
	@load: ->
		loadTasks $.url().param().moduleId

	loadTasks = (assoc, assocId) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/task/getTasks.php"
			dataType: 'json'
			type: "GET"
			data:
				moduleId: $.url().param().moduleId
			success: (data) ->
				thead = $('#tasks-panel thead')
				tbody = $('#tasks-panel tbody')
				thead.html ''
				tbody.html ''
				switch data.result
					when 'OK'
						if data.unfinishedTasks.length > 0
							$('#tasks-panel-nonetext').hide()
							$('#tasks-panel-table').show()
						else
							$('#tasks-panel-nonetext').show()
							$('#tasks-panel-table').hide()
						html = ''
						for task in data.unfinishedTasks
							html += getHtmlRow task
						tbody.html html
						$('#tasks-panel-edit-error-message').html ''
					else
						$('#tasks-panel-error-message').html t.Tasks_FetchingTaskListFailed
			error: ajaxFailure
			complete: -> waitStop()

	getHtmlRow = (ta) ->
		task = new pgweb.Task ta.id, ta.module_id, ta.moduleTypeIselectedd, ta.channel_id, ta.selectedChannelNumber, \
			ta.tag_id, ta.selectedTag, ta.assigned_to_user_id, ta.closed_by_user_id, ta.system_name, \
			ta.identity, ta.name, ta.category, ta.type, ta.progress, ta.remark
		html = ''
		html += "<tr id=\"panel-task-row#{t.id}\">"
		#html += '  <td>'
		#html += task.getIdentityStr()
		#html += '  </td>'
		html += '  <td>'
		html += ta.name
		html += '  </td>'
		html += '  <td>'
		html += ta.type
		html += '  </td>'
		
		html += '</tr>'

	isImage = (filename) ->
		['.jpg', '.jpeg', '.png', '.gif', '.svg'].some (end) -> filename.endsWith end

	isPDF = (filename) ->
		['.pdf'].some (end) -> filename.endsWith end

pgweb.TasksPanel.init()
class pgweb.ModuleUpdate
	data: null
	
	@updatePage: (moduleData) ->
		@data = moduleData

		$('.update-module_name').html @data.module_name
		$('.update-system_name').html @data.system_name
		$('.update-address').html @data.address
		$('.update-technical_name').html @data.technical_name

		$('.update-timer').html @data.timerValueBar
		$('.update-timer').parent().find('.explanation').html @data.timerExplanation
		$('.update-timerGauge').html @data.timerGauge
		
		$('.update-temp').html @data.tempValueBar
		$('.update-temp').parent().find('.explanation').html @data.tempExplanation
		$('.update-tempGauge').html @data.tempGauge
		
		$('.update-batt').html @data.battValueBar
		$('.update-batt').parent().find('.explanation').html @data.battExplanation
		$('.update-battGauge').html @data.battGauge

		$('.update-batt2').html @data.batt2ValueBar
		$('.update-batt2').parent().find('.explanation').html @data.batt2Explanation
		$('.update-batt2Gauge').html @data.batt2Gauge

		$('.update-mainSupplyVolt').html @data.mainSupplyVoltValueBar
		$('.update-mainSupplyVolt').parent().find('.explanation').html @data.mainSupplyVoltExplanation
		$('.update-mainSupplyVoltGauge').html @data.mainSupplyVoltGauge

		$('.update-extSupplyVolt').html @data.extSupplyVoltValueBar
		$('.update-extSupplyVolt').parent().find('.explanation').html @data.extSupplyVoltExplanation
		$('.update-extSupplyVoltGauge').html @data.extSupplyVoltGauge

		$('.update-csq').html @data.csqValueBar
		$('.update-csq').parent().find('.explanation').html @data.csqExplanation
		$('.update-csqGauge').html @data.csqGauge

		$('.update-humidity').html @data.humidityValueBar
		$('.update-humidity').parent().find('.explanation').html @data.humidityExplanation
		$('.update-humidityGauge').html @data.humidityGauge

		if @data.nDIs then for di in [1..@data.nDIs]
			$('.update-di'+di).html @data['di'+di+'Symbol']
			$('.update-di'+di).parent().find('.ui-block-b').html @data['di'+di+'DescAndTagCategoryName']
		
		$('.update-comError').html @data['comErrorSymbol']
		$('.update-ups').html @data['upsSymbol']
		$('.update-fs1prog').html @data['fs1progSymbol']
		$('.update-fs1stop').html @data['fs1stopSymbol']
		$('.update-dew').html @data['dewSymbol']
		$('.update-open').html @data['openSymbol']
		
		if @data.nChannels then for ch in [1..@data.nChannels]
			$(".update-ch#{ch}Category").html @data["ch#{ch}CategoryLabel"]
			$(".update-ch#{ch}AlarmSection").html @data['channel'+ch].alarm_section.firstPart 20
			$(".update-ch#{ch}SectionDescription").html @data['channel'+ch].section_description.firstPart 20
			$('.update-qpg'+ch).html @data["ch#{ch}_qpg_symbol"]
			$(".update-ch#{ch}LoopRes").html @data["ch#{ch}LoopResGauge"]
			for w in [1..2]
				$(".update-ch#{ch}w#{w}GalvVolt").html @data["ch#{ch}w#{w}GalvVoltGauge"]
				$(".update-ch#{ch}w#{w}AcRes").html @data["ch#{ch}w#{w}AcResGauge"]
				
				$(".update-ch#{ch}w#{w}Divergence").html @data["ch#{ch}w#{w}DivergenceGauge"]
				$(".update-ch#{ch}w#{w}StatusCode").html @data["ch#{ch}w#{w}StatusCodeGauge"]
				$(".update-ch#{ch}w#{w}Eldf").html @data["ch#{ch}w#{w}EldfGauge"]
				
			if @data["ch#{ch}QpgGauge"] # Not split
				$(".update-ch#{ch}w1Qpg").attr 'rowspan', 2
				$(".update-ch#{ch}w2Qpg").remove()
				$(".update-ch#{ch}w1Qpg").html @data["ch#{ch}QpgGauge"]
			else
				$(".update-ch#{ch}w1Qpg").attr 'rowspan', 1
				$(".update-ch#{ch}w2Qpg").remove()
				$(".limits-table .update-ch#{ch}w2AcRes").after '<td class="update-ch'+ch+'w2Qpg"/>'
				$(".update-ch#{ch}w1Qpg").html @data["ch#{ch}QpgW1Gauge"]
				$(".update-ch#{ch}w2Qpg").html @data["ch#{ch}QpgW2Gauge"]
		
		if @data.nANs then for an in [1..@data.nANs]
			$('.update-an'+an+'PanelRow').html @data["an#{an}PanelRow"]
			$('.update-an'+an+'Gauge').html @data["an#{an}Gauge"]
			$('.update-mic'+an+'PanelRow').html @data["mic#{an}PanelRow"]
			$('.update-mic'+an+'Gauge').html @data["mic#{an}Gauge"]
		
		$('.update-temp1WPanelRow').html @data.temp1WPanelRow
		$('.update-temp1WGauge').html @data.temp1WGauge
		
		if @data.nAVs then for av in [1..@data.nAVs]
			$('.update-av'+av+'PanelRow').html @data["av#{av}PanelRow"]
			$('.update-av'+av+'Gauge').html @data["av#{av}Gauge"]
		
		if @data.nRTDs then for rtd in [1..@data.nRTDs]
			$('.update-rtd'+rtd+'PanelRow').html @data["rtd#{rtd}PanelRow"]
			$('.update-rtd'+rtd+'Gauge').html @data["rtd#{rtd}Gauge"]
		
		if @data.nDIs then for di in [1..@data.nDIs]
			$('.update-di'+di+'PanelRow').html @data["di#{di}PanelRow"]
		
		if @data.nDOs then for doIndex in [1..@data.nDOs]
			$('.update-do'+doIndex+'PanelRow').html @data["do#{doIndex}PanelRow"]
		
		if @data.nWLVs then for wlv in [1..@data.nWLVs]
			$('.update-wlv'+wlv+'LevelGauge').html @data["wlv#{wlv}LevelGauge"]
			$('.update-wlv'+wlv+'LevelVelGauge').html @data["wlv#{wlv}LevelVelGauge"]
			$('.update-wlv'+wlv+'VolumeGauge').html @data["wlv#{wlv}VolumeGauge"]
			$('.update-wlv'+wlv+'VolumeVelGauge').html @data["wlv#{wlv}VolumeVelGauge"]
class pgweb.DocumentsPanel

	@init: ->
		loadDocuments 'module', $.url().param().moduleId

		pgweb.Main.onEvent 'click', '#documents-panel-settings-button', ->
			$('#module-document-button').click()
	
	@load: ->
		loadDocuments 'module', $.url().param().moduleId

	loadDocuments = (assoc, assocId) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/document/getDocuments.php"
			dataType: 'json'
			type: "GET"
			data:
				networkId: $.url().param().networkId
				assoc: assoc
				assocId: assocId
			success: (data) ->
				thead = $('#documents-panel thead')
				tbody = $('#documents-panel tbody')
				thead.html ''
				tbody.html ''
				switch data.result
					when 'OK'
						if data.documents.length > 0
							$('#documents-panel-nonetext').hide()
							$('#documents-panel-table').show()
						else
							$('#documents-panel-nonetext').show()
							$('#documents-panel-table').hide()
						html = ''
						for d in data.documents
							html += getHtmlRow d, data.isAdmin, data.userId
						tbody.html html
						$('#user-document-edit-error-message').html ''
					else
						$('#user-document-error-message').html t.UserDocument_FetchingDocumentListFailed
			error: ajaxFailure
			complete: -> waitStop()

	getHtmlRow = (d, isAdmin, currentUserId) ->
		html = ''
		html += "<tr id=\"panel-doc-row#{d.id}\">"
		html += '  <td>'
		if isImage d.filename
			html += "<img src=\"/pgweb/userdocs/#{d.filename}\" class=\"preview\"/>"
		else if isPDF d.filename
			html += "<img src=\"/pgweb/images/pdf_icon.png\"/>"
		else
			html += "<img src=\"/pgweb/images/file_icon.png\" class=\"general-file\"/>"
		html += '  </td>'
		html += '  <td>'
		html += '    <div class="link">'
		html += "      <a href=\"/pgweb/userdocs/#{d.filename}\" class=\"doc-link\">"
		html +=          escapeStringForHTML d.description
		html += '      </a>'
		html += '    </div>'
		html += '    <div class="time">'
		html +=        pgweb.Main.dbTimeUTCToGlobalizedFormat d.uploaded_time_utc
		html += '    </div>'
		html += '    <div class="name">'
		if d.user_id
			html += d.user_firstname+' '+d.user_surname
		else
			html += '<i>'+t.UserDocument_System+'</i>'
		html += '    </div>'
		html += '  </td>'
		
		html += '</tr>'

	isImage = (filename) ->
		['.jpg', '.jpeg', '.png', '.gif', '.svg'].some (end) -> filename.toLowerCase().endsWith end

	isPDF = (filename) ->
		['.pdf'].some (end) -> filename.toLowerCase().endsWith end

pgweb.Main.onPageShow '.showModulePage', ->
	pgweb.DocumentsPanel.init()
class pgweb.ModulePage

	instance = null
	intervalId = null

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	originalNetworkId = 0
	menuButtonsTimeoutId = null
	getCoordsMap = null

	constructor: ->
		$('body').on 'click', '.user-save-module-button', (event) ->
			userSaveModule()
		
		$('body').on 'change', '#batteryPowered', (event) ->
			batteryPoweredChanged $(this)
		
		$('body').on 'click', '.favorite-icon', (event) ->
			id = $('.module-id').val()
			toggleFavorite id

		$('body').on 'popupafteropen', '#module-info-popup', ->
			originalNetworkId = $('[name=network_id]').val()
			#if $('#activation').val() == 'on'
			#	$('#network_id').selectmenu 'disable'
		
		$('body').on 'popupafterclose', '#module-info-popup', ->
			moduleTypeId = $.url().param 'moduleTypeId'
			moduleId = $.url().param 'moduleId'
			location.href = '?action=showModule&networkId='+originalNetworkId+'&moduleTypeId='+moduleTypeId+'&moduleId='+moduleId
		
		$('body').on 'click', '#refresh-values-button', (event) ->
			id = $('.module-id').val()
			refreshValues id

		$('body').on 'click', '#module-document-button', (event, ui) =>
			button = $(event.target).closest 'button'
			moduleId = button.attr 'pgweb-data-assoc-id'
			$('#user-document-popup').find('[name=document-assoc]').val 'module'
			$('#user-document-popup').find('[name=document-assoc-id]').val moduleId
			$('#user-document-popup-title').text $('[name=moduleName]').val()
			$('#user-document-popup').popup 'open', {transition: 'pop'}

		$('body').on 'click', '.map-marker-module-page', (e) =>
			lat = commaToDot $('[name="gisLatitude"]').val()
			lon = commaToDot $('[name="gisLongitude"]').val()
			if USE_BAIDU_MAPS
				pgweb.Main.openBaiduMap lat, lon
			else
				projection = $('#projection').val()
				if projection not in ['', 'wgs84']
					# Convert to wgs84
					[lat, lon] = xy2ll projection, lat, lon
				pgweb.Main.openGoogleMap lat, lon

		getCoordsMap = new pgweb.GetCoordsMap 'module-map'

		#$('body').on 'change', '#activation', (event) ->
		#	if $('#activation').val() == 'on'
		#		$('#network_id').val originalNetworkId
		#		$('#network_id').selectmenu 'refresh'
		#		$('#network_id').selectmenu 'disable'
		#	else
		#		$('#network_id').selectmenu 'enable'
		
		$('body').on 'change', '.power-checkboxes', (e) ->
			targetId = $(e.currentTarget).prop 'id'
			batteryPower = $('#batteryPower').prop 'checked'
			externalPower  = $('#externalPower').prop 'checked'
			if not (batteryPower or externalPower)
				sel =  if targetId == 'batteryPower' then '#externalPower' else '#batteryPower'
				$(sel).prop('checked', true).checkboxradio 'refresh'

		$('body').on 'click', '#module-note-button', (e) ->
			pgweb.NotePopup.init $('.module-id').val(), 'MOD', 0
			$('#note-edit-popup').popup 'open', {transition: 'pop'}

		$('body').on 'click', '.channel-note-button', (e) ->
			channelNumber = lastNum $(e.currentTarget).attr 'id'
			pgweb.NotePopup.init $('.module-id').val(), 'CH', channelNumber
			$('#note-edit-popup').popup 'open', {transition: 'pop'}

		$('body').on 'click', '#module-info-button', (e) ->
			$('#module-info-popup').popup 'open', {transition: 'pop'}

		$('body').on 'click', '#module-menu-button', (e) ->
			visible = $('#module-info-button').is ':visible'
			showMenuButtons not visible

		showMenuButtons false

		anHeight = $($('.gaugemeter-container-an')[0]).height()
		diHeight = $($('.gaugemeter-container-di')[0]).height()
		if anHeight < diHeight
			$($('.gaugemeter-container-an')[0]).height diHeight-1
		else
			$($('.gaugemeter-container-di')[0]).height anHeight-1

		initInterval()

		# Only run if there is a document popup on the page.
		if $('#user-document-popup').length > 0
			pgweb.UserDocumentPopup.inst()

		# pipeguard-dagarna
		if pgweb.Login.inst().isSuperAdmin()
			$('#module-page-map').css 'visibility', 'visible'
			$('#tasks-panel').css 'display', 'block'
			$('#documents-panel').css 'visibility', 'visible'
	
	showMenuButtons = (visible) ->
		if visible
			$('#info-panel-buttons .menu-button').show()
			$('#module-menu-button').removeClass 'ui-first-child'
			window.clearTimeout menuButtonsTimeoutId
			menuButtonsTimeoutId = window.setTimeout ->
				showMenuButtons false
			, 5000
		else
			$('#info-panel-buttons .menu-button').hide()
			$('#module-menu-button').addClass 'ui-first-child'

	initInterval = ->
		clearInterval intervalId
		intervalId = setInterval =>
			if $.url().param().action == 'showModule'
				if pgweb.Main.inst().autoUpdateButtonIsOn()
					ajaxUpdate()
					moduleTypeName = $('[name=moduleTypeName]').val()
					if moduleTypeName == 'gw102'
						pgweb.SonitusPanel.updateAllPanels $.url().param 'moduleId'
		, pgweb.Main.getUpdateInterval()
	
	ajaxUpdate = ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/module/updateModulePage.php"
			dataType: 'json'
			type: 'POST'
			data:
				moduleId: $.url().param 'moduleId'
			success: (data) ->
				if data.result == "OK"
					pgweb.ModuleUpdate.updatePage data.module
				else
					console.log data.result + '\n\n' + data.debug
			error: ajaxFailure
			complete: ->
				waitStop()
	
	# Send refresh command to MTDP server.
	refreshValues = (moduleId) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/module/refreshModuleValues.php"
			dataType: 'json'
			type: 'GET'
			data:
				moduleId: moduleId
			success: (data) ->
				if data.result == "OK"
					$('#refresh-values-message').html t.ModuleSettings_RefreshValuesMessage
					$('#refresh-values-message').show 300, ->
						setTimeout ->
							$('#refresh-values-message').hide()
						, 4000
				else
					$('#module-save-error-message').html t.ModuleSettings_RefreshModuleValuesFailed+"<br/>"+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()
		
	preloadTrends: (moduleId) ->
		$.ajax
			url: "/pgweb/ajax/trend/preloadTrends.php"
			dataType: 'json'
			type: 'GET'
			data:
				moduleId: moduleId
				days: 7
			success: (data) ->
				if data.result == "OK"
					#console.log "Preloaded trends data for module id #{moduleId}."
				else
					$('#module-save-error-message').html "Preload failed<br/>"+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()
	
	toggleFavorite = (moduleId) ->
		waitStart()
		isFavorite = $('.favorite-icon').hasClass 'favorite-icon-selected'
		if isFavorite
			$('.favorite-icon').removeClass 'favorite-icon-selected'
		else
			$('.favorite-icon').addClass 'favorite-icon-selected'
		$.ajax
			url: "/pgweb/ajax/module/setModuleFavorite.php"
			dataType: 'json'
			type: 'POST'
			data:
				module_id: moduleId
				is_favorite: not isFavorite
			success: (data) =>
				switch data.result
					when "OK" then
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						alert data.debug
			error: ajaxFailure,
			complete: -> waitStop()
		return true

	userSaveModule = ->
		$('#module-save-error-message').html ''
		network_id = $('[name=network_id]').val()
		
		# Used for redirection after save is complete, in case the module changed network.
		originalNetworkId = network_id
		
		system_name = $('[name=system_name]').val()
		area_id = $('[name=area_id]').val()
		moduleTypeName = $('[name=moduleTypeName]').val()
		readableModuleTypeName = $('[name=readableModuleTypeName]').val()
		id = $('.module-id').val()
		activation = $('select[name=activation]').val()
		gis_active = $('select[name=gpsActive]').val()
		gis_latitudeStr = allowAltDecimal $('input[name=gisLatitude]').val()
		gis_longitudeStr = allowAltDecimal $('input[name=gisLongitude]').val()
		gis_latitude = null
		gis_longitude = null
		technical_name = $('input[name=technicalName]').val()
		address = $('input[name=address]').val()
		note = $('textarea[name=module-comment]').val()
		hihi_limit_timer = $('input[name=activeTimerHighHigh]').val()
		hi_limit_timer = $('input[name=activeTimerHigh]').val()
		
		# Some modules don't have csq.
		if not (moduleTypeName in ['pg1004', 'r03', 'r30', 'y04'])
			lo_limit_csq = $('input[name=csqLow]').val()
		
		# Some modules don't have batt.
		if moduleTypeName not in ['pg1104', 'pg1004', 'mt301', 'mt102', 'r03', 'r30', 'admFlow']
			lo_limit_batt = $('input[name=voltageLow]').val().replace ',', '.'

		# Module types sm-basicPG and mt151 and mt156 have an additional voltage.
		if moduleTypeName in ['smbasicPG', 'mt151', 'mt156']
			lo_limit_batt2 = $('input[name=voltage2Low]').val().replace ',', '.'
		
		battery_powered = $('input[name=batteryPowered]').prop 'checked'
		
		lo_limit_temp1w = undefined
		hi_limit_temp1w = undefined

		# Some modules don't have temp (in Module Health panel).
		if moduleTypeName not in ['mt703', 'mt301', 'mt102', 'pg1104', 'pg1004', 'mt151', 'mt156', 'r30', 'cc58', 'admFlow']
			hi_limit_temp = $('input[name=tempHigh]').val().replace ',', '.'
			lo_limit_temp = $('input[name=tempLow]').val().replace ',', '.'

		# Some modules have external supply voltage.
		if moduleTypeName in ['cc58']
			lo_limit_ext_supply_volt = $('input[name=extSupplyVoltLow]').val().replace ',', '.'
			hi_limit_ext_supply_volt = undefined #$('input[name=extSupplyVoltHigh]').val().replace ',', '.'
		
		# Some modules have main supply voltage.
		if moduleTypeName in ['mt331', 'gw102']
			hi_limit_main_supply_volt = $('input[name=mainSupplyVoltHigh]').val().replace ',', '.'
			lo_limit_main_supply_volt = $('input[name=mainSupplyVoltLow]').val().replace ',', '.'
		
		if moduleTypeName in ['y04']
			hi_limit_humidity = $('input[name=humidityHigh]').val().replace ',', '.'
		
		di1_active = $('select[name=activation_di1').val()
		di2_active = $('select[name=activation_di2').val()
		di1_description = $('input[name=di1text]').val()
		di2_description = $('input[name=di2text]').val()
		di1_invert = $('input[name=di1_invert').prop 'checked'
		di2_invert = $('input[name=di2_invert').prop 'checked'
		di1_alarming = $('input[name=di1_alarming').prop 'checked'
		di2_alarming = $('input[name=di2_alarming').prop 'checked'
		di1_tag_category_id = $('select[name=di1_tag_category_id]').val()
		di2_tag_category_id = $('select[name=di2_tag_category_id]').val()

		if moduleTypeName in ['cc58']
			battery_power = $('input[name=batteryPower]').prop('checked')
			external_power = $('input[name=externalPower]').prop('checked')

		errStr = ''
		
		if moduleTypeName not in ['pg1004']
			if (!/^[\w-]+-\d\d\d$/.test system_name) or (!system_name.startsWith readableModuleTypeName+'-')
				errStr += t.ModuleSettings_InvalidSystemName+'<br/>'
		else
			if (!/^PG1004_\S+$/.test system_name)
				errStr += t.ModuleSettings_InvalidPG1004SystemName+'<br/>'
		
		gisLatExists = false
		gisLngExists = false

		if gis_latitudeStr.length > 0
			if isNumeric gis_latitudeStr
				gis_latitude = Globalize.parseFloat gis_latitudeStr
				gisLatExists = true
			else
				errStr += t.ModuleSettings_GisLatitudeWrongFormat+'<br/>'
		
		if gis_longitudeStr.length > 0
			if isNumeric gis_longitudeStr
				gis_longitude = Globalize.parseFloat gis_longitudeStr
				gisLngExists = true
			else
				errStr += t.ModuleSettings_GisLongitudeWrongFormat+'<br/>'
		
		if ((not gisLatExists) or (not gisLngExists)) and gis_active == "on"
			errStr += t.ModuleSettings_GisActiveButNoCoordinates+'<br/>'

		if (gis_latitudeStr.length > 0 and gis_longitudeStr.length == 0) or (gis_latitudeStr.length == 0 and gis_longitudeStr.length > 0)
			errStr += t.ModuleSettings_GisCoordWrongFormat+'<br/>'

		projection = $('#projection').val()
		if projection not in ['', 'wgs84']
			[gis_latitude, gis_longitude] = xy2ll projection, gis_latitude, gis_longitude
		if gis_latitude < -90 or gis_latitude > 90 or gis_longitude < -180 or gis_longitude > 180
			errStr += t.ModuleSettings_GisCoordInvalid+'<br/>'
		if !/^\d*$/.test(hihi_limit_timer)
			errStr += t.ModuleSettings_TimerHiHiWrongFormat+'<br/>'
		if !/^\d*$/.test(hi_limit_timer)
			errStr += t.ModuleSettings_TimerHiWrongFormat+'<br/>'
		# Some modules don't have csq.
		if not moduleTypeName in ['pg1004', 'r03', 'r30', 'y04']
			if (!/^\d*$/.test(lo_limit_csq))
				errStr += t.ModuleSettings_CsqLoWrongFormat+'<br/>'
		
		# Some modules don't have batt.
		if moduleTypeName not in ['pg1104', 'pg1004', 'mt301', 'mt102', 'r03', 'r30', 'admFlow']
			if !/^\d*\.?\d*$/.test lo_limit_batt
				errStr += t.ModuleSettings_VoltageLoWrongFormat+'<br/>'
		# Module type sm-basicPG has an additional voltage.
		if moduleTypeName in ['smbasicPG', 'mt151', 'mt156']
			if !/^\d*\.?\d*$/.test lo_limit_batt2
				errStr += t.ModuleSettings_Voltage2LoWrongFormat+'<br/>'
		# Some modules don't have temp (in Module Health panel).
		if moduleTypeName not in ['mt703', 'mt301', 'mt102', 'pg1104', 'pg1004', 'mt151', 'mt156', 'r30', 'cc58', 'admFlow']
			if !/^[-+]?\d*[\.,]?\d*$/.test hi_limit_temp
				errStr += t.ModuleSettings_TempHiWrongFormat+'<br/>'
			if !/^[-+]?\d*[\.,]?\d*$/.test lo_limit_temp
				errStr += t.ModuleSettings_TempLoWrongFormat+'<br/>'
		# Some modules have temp1w (in Module Health panel).
		if moduleTypeName in []
			if !/^[-+]?\d*[\.,]?\d*$/.test hi_limit_temp1w
				errStr += t.ModuleSettings_TempHiWrongFormat+'<br/>'
			if !/^[-+]?\d*[\.,]?\d*$/.test lo_limit_temp1w
				errStr += t.ModuleSettings_TempLoWrongFormat+'<br/>'
		
		if moduleTypeName == 'mt331' or moduleTypeName == 'gw102'
			if !/^\d*\.?\d*$/.test(hi_limit_main_supply_volt)
				errStr += t.ModuleSettings_MainSupplyVoltHiWrongFormat+'<br/>'
			if !/^\d*\.?\d*$/.test(lo_limit_main_supply_volt)
				errStr += t.ModuleSettings_MainSupplyVoltLoWrongFormat+'<br/>'

		if moduleTypeName == 'cc58'
			#if !/^\d*\.?\d*$/.test(hi_limit_ext_supply_volt)
				#errStr += t.ModuleSettings_ExtSupplyVoltHiWrongFormat+'<br/>'
			if !/^\d*\.?\d*$/.test(lo_limit_ext_supply_volt)
				errStr += t.ModuleSettings_ExtSupplyVoltLoWrongFormat+'<br/>'

		if moduleTypeName == 'y04'
			if !/^\d*$/.test(hi_limit_humidity)
				errStr += t.ModuleSettings_HumidityHiWrongFormat+'<br/>'
		
		if not errStr
			if hihi_limit_timer != '' and hi_limit_timer != ''
				if (parseFloat hihi_limit_timer) <= (parseFloat hi_limit_timer)
					errStr += t.ModuleSettings_TimerHiHiNotHigherThanHi+'<br/>'
			if lo_limit_csq != ''
				if (parseFloat lo_limit_csq) <= 0 or (parseFloat lo_limit_csq) >= 31
					errStr += t.ModuleSettings_CsqLoOutOfRange+'<br/>'
			if hi_limit_temp != '' and lo_limit_temp != ''
				if (parseFloat hi_limit_temp) <= (parseFloat lo_limit_temp)
					errStr += t.ModuleSettings_TempHiNotHigherThanLo+'<br/>'
			if moduleTypeName in []
				if hi_limit_temp1w != '' and lo_limit_temp1w != ''
					if (parseFloat hi_limit_temp1w) <= (parseFloat lo_limit_temp1w)
						errStr += t.ModuleSettings_TempHiNotHigherThanLo+'<br/>'
		
		if errStr
			$('#module-save-error-message').html errStr
			return false
		
		waitStart()
		$.ajax
			url: "/pgweb/ajax/module/saveModule.php"
			dataType: 'json'
			type: 'POST'
			data:
				module:
					id: id,
					activation: activation
					network_id: network_id
					system_name: system_name
					area_id: area_id
					gis_active: gis_active
					gis_latitude: gis_latitude
					gis_longitude: gis_longitude
					technical_name: technical_name
					address: address
					note: note
					hihi_limit_timer: hihi_limit_timer
					hi_limit_timer: hi_limit_timer
					lo_limit_csq: lo_limit_csq
					lo_limit_batt: lo_limit_batt
					lo_limit_batt2: lo_limit_batt2
					hi_limit_temp: hi_limit_temp
					lo_limit_temp: lo_limit_temp
					hi_limit_temp1w: hi_limit_temp1w
					lo_limit_temp1w: lo_limit_temp1w
					hi_limit_humidity: hi_limit_humidity
					battery_powered: battery_powered
					hi_limit_ext_supply_volt: hi_limit_ext_supply_volt
					lo_limit_ext_supply_volt: lo_limit_ext_supply_volt
					hi_limit_main_supply_volt: hi_limit_main_supply_volt
					lo_limit_main_supply_volt: lo_limit_main_supply_volt
					di1_active: di1_active
					di2_active: di2_active
					di1_invert: di1_invert
					di2_invert: di2_invert
					di1_alarming: di1_alarming
					di2_alarming: di2_alarming
					di1_description: di1_description
					di2_description: di2_description
					di1_tag_category_id: di1_tag_category_id
					di2_tag_category_id: di2_tag_category_id
					battery_power: if battery_power then 1 else 0
					external_power: if external_power then 1 else 0
			success: (data) ->
				if data.result == "OK"
					$('#module-info-popup').popup 'close'
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else if data.result == 'DUPLICATE_SYSTEM_NAME'
					$('#module-save-error-message').html t.ModuleSettings_SystemNameTaken
				else
					$('#module-save-error-message').html t.ModuleSettings_SavingFailed+"<br/>"+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()
		true
		
	batteryPoweredChanged = (checkbox) ->
		if checkbox.prop 'checked'
			$('#di2text').val t.ModuleSettings_BatteryVoltageLow
		else
			$('#di2text').val ''
	
pgweb.Main.onPageShow '.showModulePage', ->
	pgweb.ModulePage.inst()
class pgweb.ModulePageMap extends pgweb.Map
	
	instance = null
	intervalId = null

	modules = []
	
	@inst: ->
		# Run only on module page.
		if $.url().param().action != 'showModule'
			return
		if not instance?
			instance = new @
		instance
	
	init: ->
		super {hideMapHeightButton: true}

	initInterval: ->
		clearInterval intervalId
		intervalId = setInterval =>
			if pgweb.Main.inst().autoUpdateButtonIsOn()
				@update false
		, pgweb.Main.getUpdateInterval()
		if not pgweb.Main.inst().autoUpdateButtonIsOn()
			@ajaxUpdate true

	# Display a marker for the module.
	update: (fitBounds) ->
		if $.url().param().action != 'showModule' then return
		@ajaxUpdate fitBounds

	ajaxUpdate: (fitBounds) ->
		@module = null
		$('#filter-onoff').slider 'disable'
		$.ajax
			url: "/pgweb/ajax/module/modulePageMap.php"
			dataType: 'json'
			type: 'GET'
			data:
				moduleId: $.url().param().moduleId
			success: (data) =>
				@modules = [data.module]
				switch data.result
					when "OK"
						@afterAjaxUpdate fitBounds
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get module data.', data.result);
			error: ajaxFailure

	# Called when ajax finished.
	afterAjaxUpdate: (fitBounds) ->
		module = @modules[0]

		if module.gis_latitude and module.gis_longitude and module.gis_active
			#pipeguarddagarna $('#module-page-map').show()

			# Get the points of the modules to be viewed (for map bounds calculation).
			pointsForBoundsCalc = []
			pointsForBoundsCalc.push @correctCoords [module.gis_latitude+.01, module.gis_longitude+.01]
			pointsForBoundsCalc.push @correctCoords [module.gis_latitude-.01, module.gis_longitude-.01]

			if fitBounds
				bounds = new L.LatLngBounds pointsForBoundsCalc
				@fitBounds bounds
			
			# Display the map needles.
			@createMarkers()
		else
			$('#module-page-map').hide()

$(document).on 'pageshow', '.showModulePage', (event) ->
	if $('#module-page-map').length > 0
		map = pgweb.ModulePageMap.inst()
		if map
			map.id = 'module-page-map'
			if !map.isInitialized()
				map.init()
			map.initInterval()
class pgweb.AnPanel

	instance = null

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	init: ->
		$('select.mapping-template-id-an').each -> # For all channels
			an = lastNum $(this).prop 'id'
			templateId = parseInt $(this).val()
			onTemplateChange an, templateId
		
		$('body').on 'click', '.user-save-mt7x3-an-button', (event) ->
			moduleTypeName = $('[name=moduleTypeName]').val()
			nANs =
				'mt713': 3, 'mt151': 6, 'mt156': 4, 'smbasicPG': 2, 'mt703': 2,
				'mt301': 2, 'mt331': 2, 'gw102': 0, 'mt102': 6, 'cc58': 3
			userSave moduleTypeName, nANs[moduleTypeName]
		
		$('body').on 'popupafterclose', '#an-edit-popup', (event) ->
			location.reload()
		
		$('body').on 'change', '.mapping-template-id-an', (event) ->
			an = lastNum $(this).prop 'id'
			templateId = parseInt $(this).val()
			onTemplateChange an, templateId

		$('body').on 'keyup', '.sensor-height-an', (event) ->
			an = lastNum $(this).prop 'id'
			templateId = parseInt $('#mapping_template_id_an'+an).val()
			mt = mappingTemplates[templateId]
			mappingDataJSON = $('#mapping_data'+an).val().replaceAll("'", '"').replaceAll('NaN', 100)
			if mappingDataJSON
				mappingData = JSON.parse mappingDataJSON
			else
				mappingData = {}
			sensorHeight = $('#sensor_height_an'+an).val()
			mappingData.sensor_height = sensorHeight
			r = window['pgweb']['MappingTemplate'][mt.function_name](mappingData)
			$('#rawMin_an'+an).val r.raw_low
			$('#rawMax_an'+an).val r.raw_hi
			$('#euMin_an'+an).val r.eu_low
			$('#euMax_an'+an).val r.eu_hi

	onTemplateChange = (an, templateId) ->
		if templateId == 0 # Manual
			$('#manual-sensor-first-an'+an).show();
			$('#manual-sensor-second-an'+an).show();
			$('#sensor_height_an'+an).closest('.sensor-height').hide()
		else
			$('#manual-sensor-first-an'+an).hide();
			$('#manual-sensor-second-an'+an).hide();
			mt = mappingTemplates[templateId]
			if mt.function_name # If there is a function name, use it to compute the parameters.
				mappingDataJSON = $('#mapping_data'+an).val().replaceAll("'", '"').replaceAll('NaN', 100)
				if mappingDataJSON
					mappingData = JSON.parse mappingDataJSON
				else
					mappingData = {}
				r = window['pgweb']['MappingTemplate'][mt.function_name](mappingData)
				$('#rawMin_an'+an).val r.raw_low
				$('#rawMax_an'+an).val r.raw_hi
				$('#euMin_an'+an).val r.eu_low
				$('#euMax_an'+an).val r.eu_hi
				switch templateId
					when 3, 4
						$('#sensor_height_an'+an).closest('.sensor-height').show()
			else # No function name, take the parameters directly.
				$('#sensor_height_an'+an).closest('.sensor-height').hide()
				$('#rawMin_an'+an).val mt.raw_low
				$('#rawMax_an'+an).val mt.raw_hi
				$('#euMin_an'+an).val mt.eu_low
				$('#euMax_an'+an).val mt.eu_hi
			$('#unit_an'+an).val mt.unit
			$('#format_an'+an).val mt.format

	userSave = (moduleTypeName, nAN) ->
		$('#mt7x3-an-save-error-message').html ''
		id = $('.module-id').val()
		anData = []
		for i in [1..nAN]
			if not isDefined(i) then continue

			rawMax = $('input[name=rawMax_an'+i+']').val()
			if rawMax? then rawMax = rawMax.trim()
			rawMin = $('input[name=rawMin_an'+i+']').val()
			if rawMin? then rawMin = rawMin.trim()
			euMax = $('input[name=euMax_an'+i+']').val()
			if euMax? then euMax = euMax.trim()
			euMin = $('input[name=euMin_an'+i+']').val()
			if euMin? then euMin = euMin.trim()
			anData[i] =
				activation: $('select[name=activation_an'+i+']').val()
				tagCategoryId: parseInt $('select[name=category_an'+i+']').val()
				mappingTemplateId: parseInt $('select[name=mapping_template_id_an'+i+']').val()
				description: $('input[name=description_an'+i+']').val().trim()
				rawMax: rawMax
				rawMin: rawMin
				euMax: euMax
				euMin: euMin
				unit: $('input[name=unit_an'+i+']').val().trim()
				format: $('input[name=format_an'+i+']').val().trim()
				limitHighHigh: $('input[name=limitHighHigh_an'+i+']').val().trim()
				limitHigh: $('input[name=limitHigh_an'+i+']').val().trim()
				limitLow: $('input[name=limitLow_an'+i+']').val().trim()
				limitLowLow: $('input[name=limitLowLow_an'+i+']').val().trim()
				signed: parseInt($('input[name=signed'+i+']').val().trim())
				nBits: parseInt $('input[name=n_bits'+i+']').val().trim()
				sensorHeight: $('input[name=sensor_height_an'+i+']').val().trim()

		if moduleTypeName in ['mt331', 'cc58', 'microPG']
			temp1wData =
				name: 'Temp1W'
				activation: $('select[name=activation_temp1w]').val()
				tagCategoryId: parseInt $('select[name=category_temp1w]').val()
				limitHigh: $('input[name=limitHigh_temp1w]').val().trim()
				limitLow: $('input[name=limitLow_temp1w]').val().trim()
			if moduleTypeName in ['cc58', 'microPG']
				temp1wData.limitHighHigh = $('input[name=limitHighHigh_temp1w]').val().trim()
				temp1wData.limitLowLow = $('input[name=limitLowLow_temp1w]').val().trim()
			else
				temp1wData.max = $('input[name=euMax_temp1w]').val().trim()
				temp1wData.min = $('input[name=euMin_temp1w]').val().trim()


		if moduleTypeName in ['cc58', 'microPG']
			humidityData =
				name: 'Humidity'
				activation: $('select[name=activation_humidity]').val()
				tagCategoryId: parseInt $('select[name=category_humidity]').val()
				limitHighHigh: $('input[name=limitHighHigh_humidity]').val().trim()
				limitHigh: $('input[name=limitHigh_humidity]').val().trim()
				limitLow: $('input[name=limitLow_humidity]').val().trim()
				limitLowLow: $('input[name=limitLowLow_humidity]').val().trim()
		
		if moduleTypeName in ['cc58']
			tempData =
				activation: $('select[name=activation_temp]').val()
				tagCategoryId: parseInt $('select[name=category_temp]').val()
				limitHighHigh: $('input[name=limitHighHigh_temp]').val().trim()
				limitHigh: $('input[name=limitHigh_temp]').val().trim()
				limitLow: $('input[name=limitLow_temp]').val().trim()
				limitLowLow: $('input[name=limitLowLow_temp]').val().trim()

			if hasOptionCard()
				temp2Data =
					activation: $('select[name=activation_temp2]').val()
					tagCategoryId: parseInt $('select[name=category_temp2]').val()
					description: $('input[name=description_temp2]').val().trim()
					max: $('input[name=euMax_temp2]').val().trim()
					min: $('input[name=euMin_temp2]').val().trim()
					limitHighHigh: $('input[name=limitHighHigh_temp2]').val().trim()
					limitHigh: $('input[name=limitHigh_temp2]').val().trim()
					limitLow: $('input[name=limitLow_temp2]').val().trim()
					limitLowLow: $('input[name=limitLowLow_temp2]').val().trim()
				temp3Data =
					activation: $('select[name=activation_temp3]').val()
					tagCategoryId: parseInt $('select[name=category_temp3]').val()
					description: $('input[name=description_temp3]').val().trim()
					max: $('input[name=euMax_temp3]').val().trim()
					min: $('input[name=euMin_temp3]').val().trim()
					limitHighHigh: $('input[name=limitHighHigh_temp3]').val().trim()
					limitHigh: $('input[name=limitHigh_temp3]').val().trim()
					limitLow: $('input[name=limitLow_temp3]').val().trim()
					limitLowLow: $('input[name=limitLowLow_temp3]').val().trim()

		if moduleTypeName in ['microPG']
			airtempData =
				name: 'AirTemp'
				activation: $('select[name=activation_airtemp]').val()
				tagCategoryId: parseInt $('select[name=category_airtemp]').val()
				limitHighHigh: $('input[name=limitHighHigh_airtemp]').val().trim()
				limitHigh: $('input[name=limitHigh_airtemp]').val().trim()
				limitLow: $('input[name=limitLow_airtemp]').val().trim()
				limitLowLow: $('input[name=limitLowLow_airtemp]').val().trim()

		errStr = ''

		for i in [1..nAN]
			if not isDefined(i) then continue

			if anData[i].rawMax?
				if not /^-?\d+$/.test anData[i].rawMax
					errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_RawMaxWrongFormat+'<br/>'
			if anData[i].rawMin?
				if not /^-?\d+$/.test anData[i].rawMin
					errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_RawMinWrongFormat+'<br/>'
			if anData[i].signed
				if anData[i].nBits == 32
					min = -0x7fffffff
					max =  0x7fffffff
				else
					min = -0x7fff
					max = 0x7fff
			else
				if anData[i].nBits == 32
					min = 0
					max = 0xffffffff
				else
					min = 0
					max = 0xffff
			if anData[i].rawMax?
				if anData[i].rawMax < min or anData[i].rawMax > max
					errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_RawMaxOutOfRange.replace('%1', min).replace('%2', max)+'<br/>'
			if anData[i].rawMin?
				if anData[i].rawMin < min or anData[i].rawMin > max
					errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_RawMinOutOfRange.replace('%1', min).replace('%2', max)+'<br/>'

			if anData[i].euMax?
				if not isNumeric anData[i].euMax
					errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_EUMaxWrongFormat+'<br/>'
			if anData[i].euMin?
				if not isNumeric anData[i].euMin
					errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_EUMinWrongFormat+'<br/>'

			if anData[i].mappingTemplateId == 3
				if not isNumeric anData[i].sensorHeight
					errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_SensorHeightWrongFormat+'<br/>'

			if anData[i].rawMax? and anData[i].rawMin?
				if anData[i].rawMax.length > 0 and anData[i].rawMin.length > 0
					if anData[i].rawMax == anData[i].rawMin
						errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_RawMinEqualToRawMax+'<br/>'
			if anData[i].euMax? and anData[i].euMin?
				if anData[i].euMax.length > 0 and anData[i].euMin.length > 0
					if anData[i].euMax == anData[i].euMin
						errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_EuMinEqualToEuMax+'<br/>'

			if anData[i].limitHighHigh
				if not isNumeric anData[i].limitHighHigh
					errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
			if anData[i].limitHigh
				if not isNumeric anData[i].limitHigh
					errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
			if anData[i].limitLow
				if not isNumeric anData[i].limitLow
					errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_LimitLowWrongFormat+'<br/>'
			if anData[i].limitLowLow
				if not isNumeric anData[i].limitLowLow
					errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_LimitLowLowWrongFormat+'<br/>'
		
		if moduleTypeName in ['cc58', 'microPG']
			if humidityData.limitHighHigh
				if not isNumeric humidityData.limitHighHigh
					errStr += t.ModuleList_HumidityCC58+': '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
			if humidityData.limitHigh
				if not isNumeric humidityData.limitHigh
					errStr += t.ModuleList_HumidityCC58+': '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
			if humidityData.limitLow
				if not isNumeric humidityData.limitLow
					errStr += t.ModuleList_HumidityCC58+': '+t.ModuleSettings_LimitLowWrongFormat+'<br/>'
			if humidityData.limitLowLow
				if not isNumeric humidityData.limitLowLow
					errStr += t.ModuleList_HumidityCC58+': '+t.ModuleSettings_LimitLowLowWrongFormat+'<br/>'

		if moduleTypeName in ['microPG']
			if airtempData.limitHighHigh
				if not isNumeric airtempData.limitHighHigh
					errStr += t.ModuleList_AirTemp+': '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
			if airtempData.limitHigh
				if not isNumeric airtempData.limitHigh
					errStr += t.ModuleList_AirTemp+': '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
			if airtempData.limitLow
				if not isNumeric airtempData.limitLow
					errStr += t.ModuleList_AirTemp+': '+t.ModuleSettings_LimitLowWrongFormat+'<br/>'
			if airtempData.limitLowLow
				if not isNumeric airtempData.limitLowLow
					errStr += t.ModuleList_AirTemp+': '+t.ModuleSettings_LimitLowLowWrongFormat+'<br/>'

		if moduleTypeName in ['cc58']
			if tempData.limitHighHigh
				if not isNumeric tempData.limitHighHigh
					errStr += t.ModuleList_Temp+': '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
			if tempData.limitHigh
				if not isNumeric tempData.limitHigh
					errStr += t.ModuleList_Temp+': '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
			if tempData.limitLow
				if not isNumeric tempData.limitLow
					errStr += t.ModuleList_Temp+': '+t.ModuleSettings_LimitLowWrongFormat+'<br/>'
			if tempData.limitLowLow
				if not isNumeric tempData.limitLowLow
					errStr += t.ModuleList_Temp+': '+t.ModuleSettings_LimitLowLowWrongFormat+'<br/>'

		if moduleTypeName in ['mt331']
			if not isNumeric temp1wData.max
				errStr += t.ModuleList_Temp1w+': '+t.ModuleSettings_MaxWrongFormat+'<br/>'
			if not isNumeric temp1wData.min
				errStr += t.ModuleList_Temp1w+': '+t.ModuleSettings_MinWrongFormat+'<br/>'
		if moduleTypeName in ['mt331', 'cc58', 'microPG']
			if temp1wData.limitHigh
				if not isNumeric temp1wData.limitHigh
					errStr += t.ModuleList_Temp1w+': '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
			if temp1wData.limitLow
				if not isNumeric temp1wData.limitLow
					errStr += t.ModuleList_Temp1w+': '+t.ModuleSettings_LimitLowWrongFormat+'<br/>'
		if moduleTypeName in ['cc58', 'microPG']
			if temp1wData.limitHighHigh
				if not isNumeric temp1wData.limitHighHigh
					errStr += t.ModuleList_Temp1w+': '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
			if temp1wData.limitLowLow
				if not isNumeric temp1wData.limitLowLow
					errStr += t.ModuleList_Temp1w+': '+t.ModuleSettings_LimitLowLowWrongFormat+'<br/>'

		if moduleTypeName in ['cc58']
			if hasOptionCard()
				if not isNumeric temp2Data.max
					errStr += t.ModuleList_Temp2+': '+t.ModuleSettings_MaxWrongFormat+'<br/>'
				if not isNumeric temp2Data.min
					errStr += t.ModuleList_Temp2+': '+t.ModuleSettings_MinWrongFormat+'<br/>'
				if temp2Data.limitHighHigh
					if not isNumeric temp2Data.limitHighHigh
						errStr += t.ModuleList_Temp2+': '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
				if temp2Data.limitHigh
					if not isNumeric temp2Data.limitHigh
						errStr += t.ModuleList_Temp2+': '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
				if temp2Data.limitLow
					if not isNumeric temp2Data.limitLow
						errStr += t.ModuleList_Temp2+': '+t.ModuleSettings_LimitLowWrongFormat+'<br/>'
				if temp2Data.limitLowLow
					if not isNumeric temp2Data.limitLowLow
						errStr += t.ModuleList_Temp2+': '+t.ModuleSettings_LimitLowLowWrongFormat+'<br/>'

				if not isNumeric temp3Data.max
					errStr += t.ModuleList_Temp3+': '+t.ModuleSettings_MaxWrongFormat+'<br/>'
				if not isNumeric temp3Data.min
					errStr += t.ModuleList_Temp3+': '+t.ModuleSettings_MinWrongFormat+'<br/>'
				if temp3Data.limitHighHigh
					if not isNumeric temp3Data.limitHighHigh
						errStr += t.ModuleList_Temp3+': '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
				if temp3Data.limitHigh
					if not isNumeric temp3Data.limitHigh
						errStr += t.ModuleList_Temp3+': '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
				if temp3Data.limitLow
					if not isNumeric temp3Data.limitLow
						errStr += t.ModuleList_Temp3+': '+t.ModuleSettings_LimitLowWrongFormat+'<br/>'
				if temp3Data.limitLowLow
					if not isNumeric temp3Data.limitLowLow
						errStr += t.ModuleList_Temp3+': '+t.ModuleSettings_LimitLowLowWrongFormat+'<br/>'

		if not errStr
			for i in [1..nAN]
				if not isDefined(i) then continue
				
				compLimitHighHigh = Globalize.parseFloat anData[i].limitHighHigh
				compLimitHighMax = Globalize.parseFloat anData[i].limitHigh
				compLimitHighMin = Globalize.parseFloat anData[i].limitHigh
				compLimitLowMax = Globalize.parseFloat anData[i].limitLow
				compLimitLowMin = Globalize.parseFloat anData[i].limitLow
				compLimitLowLow = Globalize.parseFloat anData[i].limitLowLow
				
				if anData[i].limitHighHigh == '' then compLimitHighHigh = Number.MAX_VALUE
				if anData[i].limitHigh == ''
					compLimitHighMax = Number.MAX_VALUE
					compLimitHighMin = -Number.MAX_VALUE
				if anData[i].limitLow == ''
					compLimitLowMax = Number.MAX_VALUE
					compLimitLowMin = -Number.MAX_VALUE
				if anData[i].limitLowLow == ''
					compLimitLowLow = -Number.MAX_VALUE
				if not (compLimitHighHigh > compLimitHighMin and
						compLimitHighMax > compLimitLowMin and
						compLimitLowMax > compLimitLowLow)
					errStr += t.ModuleList_AN+i+' '+t.ModuleSettings_LimitsNotInCorrectOrder+'<br/>'

			if moduleTypeName in ['cc58'] and hasOptionCard()
				i = 3
				for data in [temp2Data, temp3Data]
					compLimitHighHigh = Globalize.parseFloat data.limitHighHigh
					compLimitHighMax = Globalize.parseFloat data.limitHigh
					compLimitHighMin = Globalize.parseFloat data.limitHigh
					compLimitLowMax = Globalize.parseFloat data.limitLow
					compLimitLowMin = Globalize.parseFloat data.limitLow
					compLimitLowLow = Globalize.parseFloat data.limitLowLow
					
					if data.limitHighHigh == '' then compLimitHighHigh = Number.MAX_VALUE
					if data.limitHigh == ''
						compLimitHighMax = Number.MAX_VALUE
						compLimitHighMin = -Number.MAX_VALUE
					if data.limitLow == ''
						compLimitLowMax = Number.MAX_VALUE
						compLimitLowMin = -Number.MAX_VALUE
					if data.limitLowLow == ''
						compLimitLowLow = -Number.MAX_VALUE
					if not (compLimitHighHigh > compLimitHighMin and
							compLimitHighMax > compLimitLowMin and
							compLimitLowMax > compLimitLowLow)
						errStr += 'AI'+i+' '+t.ModuleSettings_LimitsNotInCorrectOrder+'<br/>'
					i += 1

			if moduleTypeName in ['microPG']
				for data in [humidityData, airtempData, temp1wData]
					compLimitHighHigh = Globalize.parseFloat data.limitHighHigh
					compLimitHighMax = Globalize.parseFloat data.limitHigh
					compLimitHighMin = Globalize.parseFloat data.limitHigh
					compLimitLowMax = Globalize.parseFloat data.limitLow
					compLimitLowMin = Globalize.parseFloat data.limitLow
					compLimitLowLow = Globalize.parseFloat data.limitLowLow
					
					if data.limitHighHigh == '' then compLimitHighHigh = Number.MAX_VALUE
					if data.limitHigh == ''
						compLimitHighMax = Number.MAX_VALUE
						compLimitHighMin = -Number.MAX_VALUE
					if data.limitLow == ''
						compLimitLowMax = Number.MAX_VALUE
						compLimitLowMin = -Number.MAX_VALUE
					if data.limitLowLow == ''
						compLimitLowLow = -Number.MAX_VALUE
					if not (compLimitHighHigh > compLimitHighMin and
							compLimitHighMax > compLimitLowMin and
							compLimitLowMax > compLimitLowLow)
						errStr += data.name+' '+t.ModuleSettings_LimitsNotInCorrectOrder+'<br/>'

		if errStr
			$('#mt7x3-an-save-error-message').html errStr
			return false
		
		waitStart()
		moduleData = {id: id, an: [], humidity: humidityData, temp: tempData, airtemp: airtempData, temp1w: temp1wData, temp2: temp2Data, temp3: temp3Data}
		for i in [1..nAN]
			if not isDefined(i) then continue
			
			moduleData.an[i] = {}
			moduleData.an[i].activation = anData[i].activation
			moduleData.an[i].tagCategoryId = anData[i].tagCategoryId
			moduleData.an[i].mappingTemplateId = anData[i].mappingTemplateId
			moduleData.an[i].description = anData[i].description
			moduleData.an[i].rawMax = anData[i].rawMax
			moduleData.an[i].rawMin = anData[i].rawMin
			if anData[i].euMax
				moduleData.an[i].euMax = Globalize.parseFloat anData[i].euMax
			if anData[i].euMin
				moduleData.an[i].euMin = Globalize.parseFloat anData[i].euMin
			moduleData.an[i].unit = anData[i].unit
			moduleData.an[i].format = anData[i].format
			moduleData.an[i].limitHighHigh = anData[i].limitHighHigh
			moduleData.an[i].limitHigh = anData[i].limitHigh
			moduleData.an[i].limitLow = anData[i].limitLow
			moduleData.an[i].limitLowLow = anData[i].limitLowLow
			moduleData.an[i].sensorHeight = Globalize.parseFloat anData[i].sensorHeight
		
		$.ajax
			url: "/pgweb/ajax/module/saveAn.php"
			dataType: 'json'
			type: 'POST'
			data:
				module: moduleData
			success: (data) ->
				if data.result == "OK"
					$('#an-edit-popup').popup 'close'
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					$('#mt7x3-an-save-error-message').html t.ModuleSettings_SavingFailed+"<br/>"+data.debug
			error: ajaxFailure,
			complete: ->
				waitStop()
		true

	isDefined = (i) ->
		$('input[name=description_an'+i+']').length > 0

	hasOptionCard = ->
		$('select[name=activation_temp2]').length > 0

$(document).on 'pageshow', '.showModulePage', (event) ->
	pgweb.AnPanel.inst().init()
class pgweb.WaterLevelVolumePanel

	instance = null

	@inst: ->
		if not instance?
			instance = new @
		instance

	nWLVs = {'mt713': 4, 'gw102': 4}
	
	constructor: ->
		moduleTypeName = $('[name=moduleTypeName]').val()
		
		$('body').on 'click', '.user-save-mt7x3-wlv-button', (event) ->
			userSave moduleTypeName, nWLVs[moduleTypeName]
		
		$('body').on 'popupafterclose', '#wlv-edit-popup', (event) ->
			location.reload()

	#ultrasoundToManual = (i) ->
		#sensorFloorDistance = (allowAltDecimal $('input[name=sensorFloorDistance_wlv'+i+']').val())*10
		#floorArea = allowAltDecimal $('input[name=floorArea_wlv'+i+']').val()

		#$('input[name=levelRawHi_wlv'+i+']').val sensorFloorDistance - 2000
		#$('input[name=levelRawLo_wlv'+i+']').val sensorFloorDistance
		#$('input[name=levelEuHi_wlv'+i+']').val 200
		#$('input[name=levelEuLo_wlv'+i+']').val 0
		
		#$('input[name=volumeRawHi_wlv'+i+']').val sensorFloorDistance - 2000
		#$('input[name=volumeRawLo_wlv'+i+']').val sensorFloorDistance
		#$('input[name=volumeEuHi_wlv'+i+']').val 2000*floorArea/1000
		#$('input[name=volumeEuLo_wlv'+i+']').val 0
	
	#manualToUltrasound = (i) ->
		#$('input[name=sensorFloorDistance_wlv'+i+']').val $('input[name=levelRawLo_wlv'+i+']').val()/10
		#$('input[name=floorArea_wlv'+i+']').val $('input[name=levelEuHi_wlv'+i+']').val()/200
	
	userSave = (moduleTypeName, nWLV) ->
		$('#mt7x3-wlv-save-error-message').html ''
		id = $('.module-id').val()
		wlvData = []
		for i in [1..nWLV]
			if not isDefined(i) then continue
			wlvData[i] =
				activation_level: $('select[name=activation_level_wlv'+i+']').val()
				activation_volume: $('select[name=activation_volume_wlv'+i+']').val()
				dataSourceTagName: $('select[name=dataSource_wlv'+i+']').val()
				description: $('input[name=description_wlv'+i+']').val().trim()
				floorArea: allowAltDecimal $('input[name=floorArea_wlv'+i+']').val().trim()
				limitHighHigh_level: allowAltDecimal $('input[name=limitHighHigh_level_wlv'+i+']').val().trim()
				limitHigh_level: allowAltDecimal $('input[name=limitHigh_level_wlv'+i+']').val().trim()
				limitHighHigh_volume: allowAltDecimal $('input[name=limitHighHigh_volume_wlv'+i+']').val().trim()
				limitHigh_volume: allowAltDecimal $('input[name=limitHigh_volume_wlv'+i+']').val().trim()
				limitHighHigh_level_vel: allowAltDecimal $('input[name=limitHighHigh_level_vel_wlv'+i+']').val().trim()
				limitHigh_level_vel: allowAltDecimal $('input[name=limitHigh_level_vel_wlv'+i+']').val().trim()
				limitHighHigh_volume_vel: allowAltDecimal $('input[name=limitHighHigh_volume_vel_wlv'+i+']').val().trim()
				limitHigh_volume_vel: allowAltDecimal $('input[name=limitHigh_volume_vel_wlv'+i+']').val().trim()
		
		errStr = ''

		for i in [1..nWLV]
			if not isDefined(i) then continue

			if not isNumeric wlvData[i].floorArea
				errStr += t.ModuleSettings_LevelObject+' #'+i+': '+t.ModuleSettings_FloorAreaWrongFormat+'<br/>'
			if wlvData[i].limitHighHigh_level
				if not isNumeric wlvData[i].limitHighHigh_level
					errStr += t.ModuleSettings_LevelObject+' #'+i+': '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
			if wlvData[i].limitHigh_level
				if not isNumeric wlvData[i].limitHigh_level
					errStr += t.ModuleSettings_LevelObject+' #'+i+': '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
			if wlvData[i].limitHighHigh_volume
				if not isNumeric wlvData[i].limitHighHigh_volume
					errStr += t.ModuleSettings_LevelObject+' #'+i+': '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
			if wlvData[i].limitHigh_volume
				if not isNumeric wlvData[i].limitHigh_volume
					errStr += t.ModuleSettings_LevelObject+' #'+i+': '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
			if wlvData[i].limitHighHigh_level_vel
				if not isNumeric wlvData[i].limitHighHigh_level_vel
					errStr += t.ModuleSettings_LevelObject+' #'+i+': '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
			if wlvData[i].limitHigh_level_vel
				if not isNumeric wlvData[i].limitHigh_level_vel
					errStr += t.ModuleSettings_LevelObject+' #'+i+': '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
			if wlvData[i].limitHighHigh_volume_vel
				if not isNumeric wlvData[i].limitHighHigh_volume_vel
					errStr += t.ModuleSettings_LevelObject+' #'+i+': '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
			if wlvData[i].limitHigh_volume_vel
				if not isNumeric wlvData[i].limitHigh_volume_vel
					errStr += t.ModuleSettings_LevelObject+' #'+i+': '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
		
		if errStr == ''
			for i in [1..nWLV]
				if not isDefined(i) then continue
				
				compLimitHighHigh = Globalize.parseFloat wlvData[i].limitHighHigh_level
				compLimitHigh = Globalize.parseFloat wlvData[i].limitHigh_level
				if (compLimitHighHigh < compLimitHigh)
					errStr += t.ModuleSettings_LevelObject+' #'+i+' '+t.ModuleSettings_Level+': '+t.ModuleSettings_LimitsNotInCorrectOrder+'<br/>'

				compLimitHighHigh = Globalize.parseFloat wlvData[i].limitHighHigh_volume
				compLimitHigh = Globalize.parseFloat wlvData[i].limitHigh_volume
				if (compLimitHighHigh < compLimitHigh)
					errStr += t.ModuleSettings_LevelObject+' #'+i+' '+t.ModuleSettings_Volume+': '+t.ModuleSettings_LimitsNotInCorrectOrder+'<br/>'

				compLimitHighHigh = Globalize.parseFloat wlvData[i].limitHighHigh_level_vel
				compLimitHigh = Globalize.parseFloat wlvData[i].limitHigh_level_vel
				if (compLimitHighHigh < compLimitHigh)
					errStr += t.ModuleSettings_LevelObject+' #'+i+' '+t.ModuleSettings_LevelChange+': '+t.ModuleSettings_LimitsNotInCorrectOrder+'<br/>'

				compLimitHighHigh = Globalize.parseFloat wlvData[i].limitHighHigh_volume_vel
				compLimitHigh = Globalize.parseFloat wlvData[i].limitHigh_volume_vel
				if (compLimitHighHigh < compLimitHigh)
					errStr += t.ModuleSettings_LevelObject+' #'+i+' '+t.ModuleSettings_VolumeChange+': '+t.ModuleSettings_LimitsNotInCorrectOrder+'<br/>'
		
		if errStr
			$('#mt7x3-wlv-save-error-message').html errStr
			return false
		
		waitStart()
		moduleData = {id: id, wlv: []}
		for i in [1..nWLV]
			if not isDefined(i) then continue
			
			moduleData.wlv[i] = {}
			moduleData.wlv[i].activation_level = wlvData[i].activation_level
			moduleData.wlv[i].activation_volume = wlvData[i].activation_volume
			moduleData.wlv[i].dataSourceTagName = wlvData[i].dataSourceTagName
			moduleData.wlv[i].description = wlvData[i].description
			moduleData.wlv[i].floorArea = wlvData[i].floorArea
			moduleData.wlv[i].limitHighHigh_level = wlvData[i].limitHighHigh_level
			moduleData.wlv[i].limitHigh_level = wlvData[i].limitHigh_level
			moduleData.wlv[i].limitHighHigh_volume = wlvData[i].limitHighHigh_volume
			moduleData.wlv[i].limitHigh_volume = wlvData[i].limitHigh_volume
			moduleData.wlv[i].limitHighHigh_level_vel = wlvData[i].limitHighHigh_level_vel
			moduleData.wlv[i].limitHigh_level_vel = wlvData[i].limitHigh_level_vel
			moduleData.wlv[i].limitHighHigh_volume_vel = wlvData[i].limitHighHigh_volume_vel
			moduleData.wlv[i].limitHigh_volume_vel = wlvData[i].limitHigh_volume_vel
		$.ajax
			url: "/pgweb/ajax/module/saveWaterLevelVolume.php"
			dataType: 'json'
			type: 'POST'
			data:
				module: moduleData
			success: (data) ->
				if data.result == "OK"
					$('#wlv-edit-popup').popup 'close'
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					$('#mt7x3-wlv-save-error-message').html t.ModuleSettings_SavingFailed+"<br/>"+data.debug
			error: ajaxFailure,
			complete: ->
				waitStop()
		true

	isDefined = (i) ->
		$('input[name=description_wlv'+i+']').length > 0

$ -> pgweb.WaterLevelVolumePanel.inst()
class pgweb.ChannelPanel

	instance = null
	originalNetworkId = 0

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	constructor: ->
		if not pgweb.Login.inst().isSuperAdmin() # // pipeguarddagarna
			$(document).on 'pageshow', '.showModulePage', (event) ->
				$('.switch-panel-button').hide()
			$('.switch-panel-button').hide()

		$('body').on 'click', '.user-save-channel-button', (event) ->
			userSaveChannel event.target

		$('body').on 'popupafteropen', '.channel-edit-popup', (event) ->
			originalNetworkId = $('[name=network_id]').val()

		$('body').on 'popupafterclose', '.channel-edit-popup', (event) ->
			moduleTypeId = $.url().param 'moduleTypeId'
			moduleId = $.url().param 'moduleId'
			location.href = '?action=showModule&networkId='+originalNetworkId+'&moduleTypeId='+moduleTypeId+'&moduleId='+moduleId

		$('body').on 'click', '.channel-document-button', (event, ui) =>
			button = $(event.target).closest 'button'
			channelId = button.attr 'pgweb-data-assoc-id'
			moduleChannelPanel = button.closest '.module-channel-panel'
			channelNumber = lastNum moduleChannelPanel.prop 'id'
			$('#user-document-popup').find('[name=document-assoc]').val 'channel'
			$('#user-document-popup').find('[name=document-assoc-id]').val channelId
			$('#user-document-popup-title').text t.ModulePage_Channel+' '+channelNumber
			$('#user-document-popup').popup 'open', {transition: 'pop'}

		$('body').on 'click', '.switch-panel-button', (event) ->
			button = $(event.currentTarget)
			ch = lastNum button.attr 'id'
			container = $('#qpg-chart-ch'+ch).closest('.qpg-chart-container')
			table = ((button.closest '.module-channel-panel').find '.module-channel-table')
			if container.is ':visible'
				container.css 'display', 'none'#hide()
				table.show()
				button.removeClass 'ui-btn-b'
				button.addClass 'ui-btn-a'
			else
				container.css 'display', 'block'#show()
				table.hide()
				button.addClass 'ui-btn-b'
				button.removeClass 'ui-btn-a'
				pgweb.AnalysisQPG.startChannel ch

		$('body').on 'click', '.channel-edit-popup-button', (event) ->
			ch =lastNum $(this).attr 'id'
			$('#channel-edit-popup'+ch).popup().popup 'open', transition: 'pop'


	userSaveChannel = (button) ->
		$('#channel-save-error-message').html ''
		popup = $(button).closest '[data-rel=popup]'
		channelNumber = popup.find('.channel-number').val()
		id = $('#channel-edit-popup'+channelNumber+' .channel-id').val()
		active = $('#channel-edit-popup'+channelNumber+' select[name=activation]').val()
		paused = $('#channel-edit-popup'+channelNumber+' select[name=paused]').val()
		accepted_break = $('#channel-edit-popup'+channelNumber+' input[name=acceptedBreak]').prop 'checked'
		alarm_section = $('#channel-edit-popup'+channelNumber+' input[name=alarmSection]').val()
		section_description = $('#channel-edit-popup'+channelNumber+' input[name=sectionDescription]').val()
		channel_category_id = $('#channel-edit-popup'+channelNumber+' select[name=channelCategoryId]').val()
		note = $('#channel-edit-popup'+channelNumber+' textarea[name=channel-comment]').val()
		hi_limit_loopRes = $('#channel-edit-popup'+channelNumber+' input[name=loopResHi]').val().replace ',', '.'
		lo_limit_loopRes = $('#channel-edit-popup'+channelNumber+' input[name=loopResLo]').val().replace ',', '.'
		hihi_limit_w1GalvVolt = $('#channel-edit-popup'+channelNumber+' input[name=w1GalvVoltHihi]').val()
		hi_limit_w1GalvVolt = $('#channel-edit-popup'+channelNumber+' input[name=w1GalvVoltHi]').val()
		lo_limit_w1AcRes = $('#channel-edit-popup'+channelNumber+' input[name=w1AcResLo]').val()
		lolo_limit_w1AcRes = $('#channel-edit-popup'+channelNumber+' input[name=w1AcResLolo]').val()
		hihi_limit_qpg = $('#channel-edit-popup'+channelNumber+' input[name=qpgHiHi]').val()
		hi_limit_qpg = $('#channel-edit-popup'+channelNumber+' input[name=qpgHi]').val()
		lo_limit_qpg5acres = $('#channel-edit-popup'+channelNumber+' input[name=qpg5AcResLo]').val()
		wire1_length = $('#channel-edit-popup'+channelNumber+' input[name=wire1Length]').val()
		wire2_length = $('#channel-edit-popup'+channelNumber+' input[name=wire2Length]').val()
		if wire1_length == null then wire1_length = ''
		if wire2_length == null then wire2_length = ''
		errStr = ''
		if hi_limit_loopRes? and hi_limit_loopRes != ''
			if !/^\d*\.?\d+$/.test hi_limit_loopRes
				errStr += t.ChannelSettings_LoopResHiWrongFormat+'<br/>'
		if lo_limit_loopRes? and lo_limit_loopRes != ''
			if !/^\d*\.?\d+$/.test lo_limit_loopRes
				errStr += t.ChannelSettings_LoopResLoWrongFormat+'<br/>'
		if !/^\d*$/.test hihi_limit_w1GalvVolt
			errStr += t.ChannelSettings_GalvVoltHiHiWrongFormat+'<br/>'
		if !/^\d*$/.test hi_limit_w1GalvVolt
			errStr += t.ChannelSettings_GalvVoltHiWrongFormat+'<br/>'
		if !/^\d*$/.test lo_limit_w1AcRes
			errStr += t.ChannelSettings_AcResLoWrongFormat+'<br/>'
		if !/^\d*$/.test lolo_limit_w1AcRes
			errStr += t.ChannelSettings_AcResLoLoWrongFormat+'<br/>'
		if !/^\d*$/.test(hihi_limit_qpg) || hihi_limit_qpg < 0 || hihi_limit_qpg > 4
			errStr += t.ChannelSettings_QpgHiHiWrongFormat+'<br/>'
		if !/^\d*$/.test(hi_limit_qpg) || hi_limit_qpg < 0 || hi_limit_qpg > 4
			errStr += t.ChannelSettings_QpgHiWrongFormat+'<br/>'
		if !/^\d*$/.test(lo_limit_qpg5acres) || lo_limit_qpg5acres < 1 || lo_limit_qpg5acres > 5
			errStr += t.ChannelSettings_Qpg5AcResLimitWrongFormat+'<br/>'
		if wire1_length? and wire1_length != ''
			if !/^\d*[,.]?\d*$/.test(wire1_length) || wire1_length < 1 || wire1_length > 100000
				errStr += t.ChannelSettings_Wire1LengthWrongFormat+'<br/>'
		if wire2_length? and wire2_length != ''
			if !/^\d*[,.]?\d*$/.test(wire2_length) || wire2_length < 1 || wire2_length > 100000
				errStr += t.ChannelSettings_Wire2LengthWrongFormat+'<br/>'
		if !errStr
			if hi_limit_loopRes? && lo_limit_loopRes?
				if (parseFloat hi_limit_loopRes) <= (parseFloat lo_limit_loopRes)
					errStr += t.ChannelSettings_LoopResHiNotGreaterThanLo+'<br/>'
			if hihi_limit_w1GalvVolt? && hi_limit_w1GalvVolt?
				if (parseFloat hihi_limit_w1GalvVolt) <= (parseFloat hi_limit_w1GalvVolt)
					errStr += t.ChannelSettings_GalvVoltHiHiNotGreaterThanHi+'<br/>'
			if lo_limit_w1AcRes? && lolo_limit_w1AcRes?
				if (parseFloat lo_limit_w1AcRes) <= (parseFloat lolo_limit_w1AcRes)
					errStr += t.ChannelSettings_AcResLoLoNotLowerThanLo+'<br/>'
			if hi_limit_qpg? && hihi_limit_qpg?
				if (parseFloat hihi_limit_qpg) <= (parseFloat hi_limit_qpg)
					errStr += t.ChannelSettings_QPGHiHiNotHigherThanHi+'<br/>'
			if lo_limit_w1AcRes?
				if (parseFloat lo_limit_w1AcRes) <= (parseFloat lo_limit_qpg5acres)
					errStr += t.ChannelSettings_AcResLoNotHigherThanQpg5Limit+'<br/>'
			if lolo_limit_w1AcRes?
				if (parseFloat lolo_limit_w1AcRes) <= (parseFloat lo_limit_qpg5acres)
					errStr += t.ChannelSettings_AcResLoLoNotHigherThanQpg5Limit+'<br/>'
		if errStr
			$('#channel-save-error-message'+channelNumber).html errStr
			return false

		waitStart()
		$.ajax
			url: "/pgweb/ajax/module/saveChannel.php"
			dataType: 'json'
			type: 'POST'
			data:
				channel:
					id: id
					active: active
					paused: paused
					accepted_break: accepted_break
					alarm_section: alarm_section
					section_description: section_description
					channel_category_id: channel_category_id
					note: note
					hi_limit_loopRes: hi_limit_loopRes
					lo_limit_loopRes: lo_limit_loopRes
					hihi_limit_w1GalvVolt: hihi_limit_w1GalvVolt
					hi_limit_w1GalvVolt: hi_limit_w1GalvVolt
					lo_limit_w1AcRes: lo_limit_w1AcRes
					lolo_limit_w1AcRes: lolo_limit_w1AcRes
					hihi_limit_qpg: hihi_limit_qpg
					hi_limit_qpg: hi_limit_qpg
					lo_limit_qpg5acres: lo_limit_qpg5acres
					wire1_length: wire1_length
					wire2_length: wire2_length
			success: (data) ->
				if data.result == "OK"
					$('#channel-edit-popup'+channelNumber).popup 'close'
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else if data.result == 'LOOP_IS_NOT_SPLIT'
					$('#channel-save-error-message'+channelNumber).html t.ChannelSettings_AcceptedBreakLoopIsNotSplit
				else
					$('#channel-save-error-message'+channelNumber).html t.ChannelSettings_SavingFailed+"<br/>"+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()
		
		true

$ -> pgweb.ChannelPanel.inst()
class pgweb.RtdPanel

	instance = null

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	constructor: ->
		$('body').on 'click', '.user-save-mt7x3-rtd-button', (event) ->
			moduleTypeName = $('[name=moduleTypeName]').val()
			nRTDs = {'mt156': 10}
			userSave moduleTypeName, nRTDs[moduleTypeName]
		
		$('body').on 'popupafterclose', '#rtd-edit-popup', (event) ->
			location.reload()
	
	userSave = (moduleTypeName, nRTD) ->
		$('#mt7x3-rtd-save-error-message').html ''
		id = $('.module-id').val()
		rtdData = []
		for i in [1..nRTD]
			if not isDefined(i) then continue

			rtdData[i] =
				activation: $('select[name=activation_rtd'+i+']').val()
				description: $('input[name=description_rtd'+i+']').val().trim()
				format: $('input[name=format_rtd'+i+']').val().trim()
				limitHighHigh: $('input[name=limitHighHigh_rtd'+i+']').val().trim()
				limitHigh: $('input[name=limitHigh_rtd'+i+']').val().trim()
				limitLow: $('input[name=limitLow_rtd'+i+']').val().trim()
				limitLowLow: $('input[name=limitLowLow_rtd'+i+']').val().trim()
				signed: parseInt($('input[name=signed'+i+']').val().trim())
				nBits: $('input[name=n_bits'+i+']').val().trim()
		
		errStr = ''

		for i in [1..nRTD]
			if not isDefined(i) then continue

			if rtdData[i].signed
				if rtdData[i].nBits == 32
					min = -0x7fffffff
					max =  0x7fffffff
				else
					min = -0x7fff
					max = 0x7fff
			else
				if rtdData[i].nBits == 32
					min = 0
					max = 0xffffffff
				else
					min = 0
					max = 0xffff
			if rtdData[i].limitHighHigh
				if not isNumeric rtdData[i].limitHighHigh
					errStr += t.ModuleList_RTD+i+' '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
			if rtdData[i].limitHigh
				if not isNumeric rtdData[i].limitHigh
					errStr += t.ModuleList_RTD+i+' '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
			if rtdData[i].limitLow
				if not isNumeric rtdData[i].limitLow
					errStr += t.ModuleList_RTD+i+' '+t.ModuleSettings_LimitLowWrongFormat+'<br/>'
			if rtdData[i].limitLowLow
				if not isNumeric rtdData[i].limitLowLow
					errStr += t.ModuleList_RTD+i+' '+t.ModuleSettings_LimitLowLowWrongFormat+'<br/>'
		
		if not errStr
			for i in [1..nRTD]
				if not isDefined(i) then continue
				
				compLimitHighHigh = Globalize.parseFloat rtdData[i].limitHighHigh
				compLimitHighMax = Globalize.parseFloat rtdData[i].limitHigh
				compLimitHighMin = Globalize.parseFloat rtdData[i].limitHigh
				compLimitLowMax = Globalize.parseFloat rtdData[i].limitLow
				compLimitLowMin = Globalize.parseFloat rtdData[i].limitLow
				compLimitLowLow = Globalize.parseFloat rtdData[i].limitLowLow
				if rtdData[i].limitHighHigh == '' then compLimitHighHigh = Number.MAX_VALUE
				if rtdData[i].limitHigh == ''
					compLimitHighMax = Number.MAX_VALUE
					compLimitHighMin = -Number.MAX_VALUE
				if rtdData[i].limitLow == ''
					compLimitLowMax = Number.MAX_VALUE
					compLimitLowMin = -Number.MAX_VALUE
				if rtdData[i].limitLowLow == ''
					compLimitLowLow = -Number.MAX_VALUE
				if not (compLimitHighHigh > compLimitHighMin and
						compLimitHighMax > compLimitLowMin and
						compLimitLowMax > compLimitLowLow)
					errStr += t.ModuleList_RTD+i+' '+t.ModuleSettings_LimitsNotInCorrectOrder+'<br/>'
		
		if errStr
			$('#mt7x3-rtd-save-error-message').html errStr
			return false
		
		waitStart()
		moduleData = {id: id, rtd: []}
		for i in [1..nRTD]
			if not isDefined(i) then continue
			
			moduleData.rtd[i] = {}
			moduleData.rtd[i].activation = rtdData[i].activation
			moduleData.rtd[i].description = rtdData[i].description
			moduleData.rtd[i].format = rtdData[i].format
			moduleData.rtd[i].limitHighHigh = rtdData[i].limitHighHigh
			moduleData.rtd[i].limitHigh = rtdData[i].limitHigh
			moduleData.rtd[i].limitLow = rtdData[i].limitLow
			moduleData.rtd[i].limitLowLow = rtdData[i].limitLowLow
		
		$.ajax
			url: "/pgweb/ajax/module/saveRtd.php"
			dataType: 'json'
			type: 'POST'
			data:
				module: moduleData
			success: (data) ->
				if data.result == "OK"
					$('#rtd-edit-popup').popup 'close'
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					$('#mt7x3-rtd-save-error-message').html t.ModuleSettings_SavingFailed+"<br/>"+data.debug
			error: ajaxFailure,
			complete: ->
				waitStop()
		true

	isDefined = (i) ->
		$('select[name=activation_rtd'+i+']').length > 0

$ -> pgweb.RtdPanel.inst()
class pgweb.DoPanel

	@userSaveDo: (nDO) ->
		$('#module-save-error-message').html ''
		id = $('.module-id').val()
		doData = new Array()
		for i in [1..nDO]
			doData[i] =
				active: if $('input[name=do'+i+'on]').prop('checked') then 1 else 0
				description: $('input[name=do'+i+'text]').val()
			if doData[i].description == undefined
				doData[i].description = ''
		waitStart()
		moduleData = {id: id, do: []}
		for i in [1..nDO]
			moduleData.do[i] = {}
			moduleData.do[i].active = doData[i].active
			moduleData.do[i].description = doData[i].description
		$.ajax
			url: "/pgweb/ajax/module/saveMt7x3Do.php"
			dataType: 'json'
			type: 'POST'
			data:
				module: moduleData
			success: (data) ->
				if data.result == "OK"
					$('#do-edit-popup').popup 'close'
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					$('#mt7x3-do-save-error-message').html t.ModuleSettings_SavingFailed+"<br/>"+data.debug
			error: ajaxFailure
			complete: waitStop
		true

	@init: ->
		$('body').on 'click', '.user-save-mt7x3-do-button', (event) =>
			moduleTypeName = $('[name=moduleTypeName]').val()
			nDOs = {'mt151': 8}
			@userSaveDo nDOs[moduleTypeName]
		
		$('#do-edit-popup').on 'popupafterclose', ->
			location.reload()

$ -> pgweb.DoPanel.init()
class pgweb.AvPanel

	instance = null

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	init: ->
		$('select.mapping-template-id-av').each -> # For all channels
			av = lastNum $(this).prop 'id'
			templateId = parseInt $(this).val()
			onTemplateChange av, templateId
		
		$('body').on 'click', '.user-save-mt7x3-av-button', (event) ->
			moduleTypeName = $('[name=moduleTypeName]').val()
			nAVs = {'mt102': 8, 'gw102': 8, 'mt151': 8, 'mt156': 8, 'mt713': 8}
			userSave moduleTypeName, nAVs[moduleTypeName]
		
		$('body').on 'popupafterclose', '#av-edit-popup', (event) ->
			location.reload()

		$('body').on 'change', '.mapping-template-id-av', (event) ->
			av = lastNum $(this).prop 'id'
			templateId = parseInt $(this).val()
			onTemplateChange av, templateId

		$('body').on 'keyup', '.sensor-height-av', (event) ->
			av = lastNum $(this).prop 'id'
			templateId = parseInt $('#mapping_template_id_av'+av).val()
			mt = mappingTemplates[templateId]
			mappingDataJSON = $('#mapping_data'+av).val().replaceAll("'", '"').replaceAll('NaN', 100)
			if mappingDataJSON
				mappingData = JSON.parse mappingDataJSON
			else
				mappingData = {}
			sensorHeight = $('#sensor_height_av'+av).val()
			mappingData.sensor_height = sensorHeight
			r = window['pgweb']['MappingTemplate'][mt.function_name](mappingData)
			$('#rawMin_av'+av).val r.raw_low
			$('#rawMax_av'+av).val r.raw_hi
			$('#euMin_av'+av).val r.eu_low
			$('#euMax_av'+av).val r.eu_hi

	onTemplateChange = (av, templateId) ->
		if templateId == 0 # Manual
			$('#manual-sensor-first-av'+av).show();
			$('#manual-sensor-second-av'+av).show();
			$('#sensor_height_av'+av).closest('.sensor-height').hide()
		else
			$('#manual-sensor-first-av'+av).hide();
			$('#manual-sensor-second-av'+av).hide();
			mt = mappingTemplates[templateId]
			if mt.function_name # If there is a function name, use it to compute the parameters.
				mappingDataJSON = $('#mapping_data'+av).val().replaceAll("'", '"').replaceAll('NaN', 100)
				if mappingDataJSON
					mappingData = JSON.parse mappingDataJSON
				else
					mappingData = {}
				r = window['pgweb']['MappingTemplate'][mt.function_name](mappingData)
				$('#rawMin_av'+av).val r.raw_low
				$('#rawMax_av'+av).val r.raw_hi
				$('#euMin_av'+av).val r.eu_low
				$('#euMax_av'+av).val r.eu_hi
				switch templateId
					when 3, 4
						$('#sensor_height_av'+av).closest('.sensor-height').show()
			else # No function name, take the parameters directly.
				$('#sensor_height_av'+av).closest('.sensor-height').hide()
				$('#rawMin_av'+av).val mt.raw_low
				$('#rawMax_av'+av).val mt.raw_hi
				$('#euMin_av'+av).val mt.eu_low
				$('#euMax_av'+av).val mt.eu_hi
			$('#unit_av'+av).val mt.unit
			$('#format_av'+av).val mt.format
	
	userSave = (moduleTypeName, nAV) ->
		$('#mt7x3-av-save-error-message').html ''
		id = $('.module-id').val()
		avData = []
		for i in [1..nAV]
			if not isDefined(i) then continue

			rawMax = $('input[name=rawMax_av'+i+']').val()
			if rawMax? then rawMax = rawMax.trim()
			rawMin = $('input[name=rawMin_av'+i+']').val()
			if rawMin? then rawMin = rawMin.trim()
			euMax = $('input[name=euMax_av'+i+']').val()
			if euMax? then euMax = euMax.trim()
			euMin = $('input[name=euMin_av'+i+']').val()
			if euMin? then euMin = euMin.trim()
			avData[i] =
				activation: $('select[name=activation_av'+i+']').val()
				tagCategoryId: parseInt $('select[name=category_av'+i+']').val()
				mappingTemplateId: parseInt $('select[name=mapping_template_id_av'+i+']').val()
				description: $('input[name=description_av'+i+']').val().trim()
				rawMax: rawMax
				rawMin: rawMin
				euMax: euMax
				euMin: euMin
				unit: $('input[name=unit_av'+i+']').val().trim()
				format: $('input[name=format_av'+i+']').val().trim()
				limitHighHigh: $('input[name=limitHighHigh_av'+i+']').val().trim()
				limitHigh: $('input[name=limitHigh_av'+i+']').val().trim()
				limitLow: $('input[name=limitLow_av'+i+']').val().trim()
				limitLowLow: $('input[name=limitLowLow_av'+i+']').val().trim()
				signed: parseInt($('input[name=signed'+i+']').val().trim())
				nBits: parseInt $('input[name=n_bits'+i+']').val().trim()
				sensorHeight: $('input[name=sensor_height_av'+i+']').val().trim()

		errStr = ''

		for i in [1..nAV]
			if not isDefined(i) then continue

			if avData[i].rawMax?
				if not /^-?\d+$/.test avData[i].rawMax
					errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_RawMaxWrongFormat+'<br/>'
			if avData[i].rawMin?
				if not /^-?\d+$/.test avData[i].rawMin
					errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_RawMinWrongFormat+'<br/>'
			if avData[i].signed
				if avData[i].nBits == 32
					min = -0x7fffffff
					max =  0x7fffffff
				else
					min = -0x7fff
					max = 0x7fff
			else
				if avData[i].nBits == 32
					min = 0
					max = 0xffffffff
				else
					min = 0
					max = 0xffff
			if avData[i].rawMax?
				if avData[i].rawMax < min or avData[i].rawMax > max
					errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_RawMaxOutOfRange.replace('%1', min).replace('%2', max)+'<br/>'
			if avData[i].rawMin?
				if avData[i].rawMin < min or avData[i].rawMin > max
					errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_RawMinOutOfRange.replace('%1', min).replace('%2', max)+'<br/>'

			if avData[i].euMax?
				if not isNumeric avData[i].euMax
					errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_EUMaxWrongFormat+'<br/>'
			if avData[i].euMin?
				if not isNumeric avData[i].euMin
					errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_EUMinWrongFormat+'<br/>'

			if avData[i].mappingTemplateId == 3
				if not isNumeric avData[i].sensorHeight
					errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_SensorHeightWrongFormat+'<br/>'

			if avData[i].rawMax? and avData[i].rawMin?
				if avData[i].rawMax.length > 0 and avData[i].rawMin.length > 0
					if avData[i].rawMax == avData[i].rawMin
						errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_RawMinEqualToRawMax+'<br/>'
			if avData[i].euMax? and avData[i].euMin?
				if avData[i].euMax.length > 0 and avData[i].euMin.length > 0
					if avData[i].euMax == avData[i].euMin
						errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_EuMinEqualToEuMax+'<br/>'

			if avData[i].limitHighHigh
				if not isNumeric avData[i].limitHighHigh
					errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
			if avData[i].limitHigh
				if not isNumeric avData[i].limitHigh
					errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
			if avData[i].limitLow
				if not isNumeric avData[i].limitLow
					errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_LimitLowWrongFormat+'<br/>'
			if avData[i].limitLowLow
				if not isNumeric avData[i].limitLowLow
					errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_LimitLowLowWrongFormat+'<br/>'

		if not errStr
			for i in [1..nAV]
				if not isDefined(i) then continue
				
				compLimitHighHigh = Globalize.parseFloat avData[i].limitHighHigh
				compLimitHighMax = Globalize.parseFloat avData[i].limitHigh
				compLimitHighMin = Globalize.parseFloat avData[i].limitHigh
				compLimitLowMax = Globalize.parseFloat avData[i].limitLow
				compLimitLowMin = Globalize.parseFloat avData[i].limitLow
				compLimitLowLow = Globalize.parseFloat avData[i].limitLowLow
				if avData[i].limitHighHigh == '' then compLimitHighHigh = Number.MAX_VALUE
				if avData[i].limitHigh == ''
					compLimitHighMax = Number.MAX_VALUE
					compLimitHighMin = -Number.MAX_VALUE
				if avData[i].limitLow == ''
					compLimitLowMax = Number.MAX_VALUE
					compLimitLowMin = -Number.MAX_VALUE
				if avData[i].limitLowLow == ''
					compLimitLowLow = -Number.MAX_VALUE
				if not (compLimitHighHigh > compLimitHighMin and
						compLimitHighMax > compLimitLowMin and
						compLimitLowMax > compLimitLowLow)
					errStr += t.ModuleList_AV+i+' '+t.ModuleSettings_LimitsNotInCorrectOrder+'<br/>'
		
		if errStr
			$('#mt7x3-av-save-error-message').html errStr
			return false
		
		waitStart()
		moduleData = {id: id, av: []}
		for i in [1..nAV]
			if not isDefined(i) then continue
			
			moduleData.av[i] = {}
			moduleData.av[i].activation = avData[i].activation
			moduleData.av[i].tagCategoryId = avData[i].tagCategoryId
			moduleData.av[i].mappingTemplateId = avData[i].mappingTemplateId
			moduleData.av[i].description = avData[i].description
			moduleData.av[i].rawMax = avData[i].rawMax
			moduleData.av[i].rawMin = avData[i].rawMin
			if avData[i].euMax
				moduleData.av[i].euMax = Globalize.parseFloat avData[i].euMax
			if avData[i].euMin
				moduleData.av[i].euMin = Globalize.parseFloat avData[i].euMin
			moduleData.av[i].unit = avData[i].unit
			moduleData.av[i].format = avData[i].format
			moduleData.av[i].limitHighHigh = avData[i].limitHighHigh
			moduleData.av[i].limitHigh = avData[i].limitHigh
			moduleData.av[i].limitLow = avData[i].limitLow
			moduleData.av[i].limitLowLow = avData[i].limitLowLow
			moduleData.av[i].sensorHeight = Globalize.parseFloat avData[i].sensorHeight
		
		$.ajax
			url: "/pgweb/ajax/module/saveAv.php"
			dataType: 'json'
			type: 'POST'
			data:
				module: moduleData
			success: (data) ->
				if data.result == "OK"
					$('#av-edit-popup').popup 'close'
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					$('#mt7x3-av-save-error-message').html t.ModuleSettings_SavingFailed+"<br/>"+data.debug
			error: ajaxFailure,
			complete: ->
				waitStop()
		true

	isDefined = (i) ->
		$('input[name=rawMax_av'+i+']').length > 0


$(document).on 'pageshow', '.showModulePage', (event) ->
	pgweb.AvPanel.inst().init()
class pgweb.AdmFlowPanel

	instance = null

	allNames = {
		base: ['flow_forward', 'flow_return', 'flow_speed_forward', 'flow_speed_return', 
					'pressure_forward', 'pressure_return', 'temp_forward', 'temp_return']
		deviation: ['flow_deviation', 'pressure_deviation', 'temp_diff', 'flow_deviation_percent']
	}

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	init: ->
		for what in ['base', 'deviation']
			
			$('body').on 'click', '.user-save-admflow-'+what+'-values-button', what, (event) ->
				moduleTypeName = $('[name=moduleTypeName]').val()
				userSave moduleTypeName, event.data

			$('body').on 'popupafterclose', '#admflow-'+what+'-values-edit-popup', (event) ->
				location.reload()

	userSave = (moduleTypeName, what) ->
		$('#admflow-'+what+'-values-save-error-message').html ''
		id = $('.module-id').val()
		items = []
		errStr = ''
		names = allNames[what]
		for name in names
			tagName = name.snakeToPascal()
			item =
				name: name
				activation: $('select[name=activation_'+name+']').val() == 'on'
				limitHighHigh: $('input[name=limitHighHigh_'+name+']').val().trim()
				limitHigh: $('input[name=limitHigh_'+name+']').val().trim()
				limitLow: $('input[name=limitLow_'+name+']').val().trim()
				limitLowLow: $('input[name=limitLowLow_'+name+']').val().trim()

			if items.limitHighHigh
				if not isNumeric items[i].limitHighHigh
					errStr += t['ADMFlow_'+tagName]+' '+t.ModuleSettings_LimitHighHighWrongFormat+'<br/>'
			if items.limitHigh
				if not isNumeric items[i].limitHigh
					errStr += t['ADMFlow_'+tagName]+' '+t.ModuleSettings_LimitHighWrongFormat+'<br/>'
			if items.limitLow
				if not isNumeric items[i].limitLow
					errStr += t['ADMFlow_'+tagName]+' '+t.ModuleSettings_LimitLowWrongFormat+'<br/>'
			if items.limitLowLow
				if not isNumeric items[i].limitLowLow
					errStr += t['ADMFlow_'+tagName]+' '+t.ModuleSettings_LimitLowLowWrongFormat+'<br/>'
			
			items.push item

		if not errStr
			for item in items
				lolo = Globalize.parseFloat item.limitLowLow
				lo   = Globalize.parseFloat item.limitLow
				hi   = Globalize.parseFloat item.limitHigh
				hihi = Globalize.parseFloat item.limitHighHigh
				rightOrder = pgweb.Main.checkRightAlarmLimitOrder lolo, lo, hi, hihi
				if not rightOrder
					errStr += t['ADMFlow_'+item.name.snakeToPascal()]+': '+t.ModuleSettings_LimitsNotInCorrectOrder+'<br/>'

		if errStr
			$('#admflow-'+what+'-values-save-error-message').html errStr
			return false
		
		waitStart()
		moduleData = {id: id, items: items}
		
		$.ajax
			url: "/pgweb/ajax/module/saveAdmFlowValues.php"
			dataType: 'json'
			type: 'POST'
			data:
				what: what
				module: moduleData
			success: (data) ->
				if data.result == "OK"
					$('#admflow-'+what+'-values-edit-popup').popup 'close'
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					$('#admflow-'+what+'-values-save-error-message').html t.ModuleSettings_SavingFailed+"<br/>"+data.debug
			error: ajaxFailure,
			complete: ->
				waitStop()
		true

$(document).on 'pageshow', '.showModulePage', (event) ->
	pgweb.AdmFlowPanel.inst().init()
class pgweb.DiPanel 

	instance = null

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	constructor: ->
		$('body').on 'click', '.user-save-mt7x3-di-button', (event) ->
			moduleTypeName = $('[name=moduleTypeName]').val()
			nDIs =
				'mt713': 5, 'nanoPG': 2, 'mt703': 3, 'mt301': 4, 'mt331': 8, 'gw102': 2, 
				'mt102': 8, 'mt151': 16, 'mt156': 12, 'smbasicPG': 2, 'cc58': 7
			userSave nDIs[moduleTypeName]
		
		$('body').on 'popupafterclose', '#di-edit-popup', (event) ->
			location.reload()

		$('body').on 'click', '#set-output-on-button', (event) ->
			id = $('.module-id').val()
			setOutput id, 8, 1

		$('body').on 'click', '#set-output-off-button', (event) ->
			id = $('.module-id').val()
			setOutput id, 8, 0

	setOutput = (moduleId, doNumber, value) ->
		$.ajax
			url: "/pgweb/ajax/module/setOutput.php"
			dataType: 'json'
			type: 'GET'
			data:
				moduleId: moduleId
				doNumber: doNumber
				value: value
			success: (data) ->
				if data.result == "OK"
					$('#set-output-error-message').html t.ModuleSettings_CommandReceivedSetOutput
					$('#set-output-error-message').show 300, ->
						setTimeout ->
							$('#set-output-error-message').hide()
						, 4000
				else
					$('#set-output-error-message').html t.ModuleSettings_SetOutputFailed+"<br/>"+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()

	userSave = (nDI) ->
		$('#module-save-error-message').html ''
		id = $('.module-id').val()
		diData = []
		for i in [1..nDI]
			diData[i] =
				active: $('select[name=activation_di'+i).val()
				description: $('input[name=di'+i+'text]').val()
				invert: $('input[name=di'+i+'_invert').prop 'checked'
				alarming: $('input[name=di'+i+'_alarming').prop 'checked'
				tag_category_id: $('select[name=di'+i+'_tag_category_id').val()
			
			if not diData[i].description?
				diData[i].description = ''
		
		waitStart()
		moduleData = {id: id, di: []}
		for i in [1..nDI]
			moduleData.di[i] = {}
			moduleData.di[i].active = diData[i].active
			moduleData.di[i].description = diData[i].description
			moduleData.di[i].invert = diData[i].invert
			moduleData.di[i].alarming = diData[i].alarming
			moduleData.di[i].tag_category_id = diData[i].tag_category_id
		
		$.ajax
			url: '/pgweb/ajax/module/saveDi.php'
			dataType: 'json'
			type: 'POST'
			data: 
				module: moduleData
			success: (data) ->
				if data.result == "OK"
					$('#di-edit-popup').popup 'close'
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					$('#mt7x3-di-save-error-message').html t.ModuleSettings_SavingFailed+"<br/>"+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()
		
		true

$ -> pgweb.DiPanel.inst()
class pgweb.DvPanel

	@userSaveDv: (nDV) ->
		$('#module-save-error-message').html ''
		id = $('.module-id').val()
		dvData = new Array()
		for i in [1..nDV]
			dvData[i] =
				active: if $('input[name=dv'+i+'on]').prop 'checked' then 1 else 0
				description: $('input[name=dv'+i+'text]').val()
			if dvData[i].description == undefined
				dvData[i].description = ''
		waitStart()
		moduleData = {id: id, dv: []}
		for i in [1..nDV]
			moduleData.dv[i] = {}
			moduleData.dv[i].active = dvData[i].active
			moduleData.dv[i].description = dvData[i].description
		$.ajax
			url: "/pgweb/ajax/module/saveMt7x3Dv.php"
			dataType: 'json'
			type: 'POST'
			data:
				module: moduleData
			success: (data) ->
				if data.result == "OK"
					$('#dv-edit-popup').popup 'close'
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					$('#mt7x3-dv-save-error-message').html t.ModuleSettings_SavingFailed+"<br/>"+data.debug
			error: ajaxFailure
			complete: waitStop
		true

	@init: ->
		$('body').on 'click', '.user-save-mt7x3-dv-button', (event) =>
			moduleTypeName = $('[name=moduleTypeName]').val()
			nDVs = {'mt102': 8, 'mt151': 8, 'mt156': 8, 'mt713': 8}
			@userSaveDv nDVs[moduleTypeName]

		$('#dv-edit-popup').on 'popupafterclose', ->
			location.reload()

$ -> pgweb.DvPanel.init()
class pgweb.TrendTool
	instance = null
	trendsChartObj = null
	timezone = { 'identifier': '', 'offset': 0}
	dataArr = []
	selectedCurveType = 'line'
	unselectedCurveType = 'line'
	selectedCurveDashStyle = 'Solid'
	unselectedCurveDashStyle = 'ShortDot'
	selectedCurveLineWidth = 4
	unselectedCurveLineWidth = 2
	selectedCurveIndex = null
	trendToolView = null
	moduleIdTags = null
	tagDataArr = null

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	constructor: ->
		# Create the Highcharts object.
		min = -100
		max = 100
		zoom =  ''
		title = 'title'
		seriesColors = pgweb.CurveChart.inst().standardSeriesColors
		yAxisConfig = pgweb.CurveChart.inst().yAxisFloatConfig(seriesColors[0], false, .001, 1)
		title = "title"
		activeCurveIndex = 0
		renderTo = $(".trend-tool-container").get()[0]
		trendsChartObj = pgweb.CurveChart.inst().create min, max, zoom, title, yAxisConfig, activeCurveIndex, seriesColors, renderTo, @toolTipFormatter, false
		
		# Detect click on a series.
		for i in [0..9]
			Highcharts.addEvent trendsChartObj.series[i], 'click', (e) ->
				console.log e.point.series.pgwebData.curveIndex
		for i in [0..9]
			trendsChartObj.series[i].setData []
		
		# Load a view and wait for it to finish. Then load all curves.
		trendToolViewId = $.url().param().trendToolViewId
		deferred = @loadViewFromAjax trendToolViewId
		$.when(deferred).done =>
			# Start calls to loadCurveFromAjax and wait until all are finished.
			deferreds = []
			for moduleIdTag, i in moduleIdTags
				deferreds.push @loadCurveFromAjax i, moduleIdTag.tagMeaning, 14, undefined, undefined, moduleIdTag.moduleId, true
			trendsChartObj.reflow()
			if deferreds.length > 0
				$.when(deferreds...).done ->
					trendsChartObj.reflow()
					for data, i in dataArr
						addDataToTable data, i
					unselectAllCurves()
					setYAxisLimits getMinMin(), getMaxMax()
					$('#trend-tool-view-save-button').removeClass 'ui-disabled'
					$('#trend-tool-view-saveasnew-button').removeClass 'ui-disabled'
					if dataArr.length > 0
						$('#trend-tool-view-new-button').removeClass 'ui-disabled'
		
		#$('body').on 'mouseover', '.trend-tool-table-color', ->
		#	$(@).addClass 'trend-tool-table-color-mouseover'
		
		#$('body').on 'mouseout', '.trend-tool-table-color', ->
		#	$(@).removeClass 'trend-tool-table-color-mouseover'

		# When a row in the table is clicked, mark the row and the curve as selected, except when clicking
		# on the show checkbox.
		$('body').on 'click', '.trend-tool-table-tr', (e) ->
			selectedTd = $(e.target.closest 'td')
			if not selectedTd.hasClass 'trend-tool-show-td'
				selectedTr = $(e.target.closest 'tr')
				curveIndex = lastNum selectedTr.attr 'id'
				$('.trend-tool-table-tr td').removeClass 'trend-tool-row-selected'
				if curveIndex == selectedCurveIndex
					selectedCurveIndex = null
					unselectAllCurves()
					setYAxisLimits getMinMin(), getMaxMax()
				else
					selectedTr.find('td').addClass 'trend-tool-row-selected'
					selectedCurveIndex = curveIndex
					setYAxisLimits dataArr[curveIndex].trendCurveMin, dataArr[curveIndex].trendCurveMax
					setCurveSelected curveIndex
		
		# Checkbox for toggling visibility of a curve.
		$('body').on 'change', '.trend-tool-show-checkbox', (e) ->
			checkBox = $(e.target)
			curveIndex = lastNum checkBox.attr 'id'
			show = checkBox.prop 'checked'
			showCurve curveIndex, show

			if selectedCurveIndex == null
				min = getMinMin()
				max = getMaxMax()
			else
				min = dataArr[selectedCurveIndex].trendCurveMin
				max = dataArr[selectedCurveIndex].trendCurveMax
			setYAxisLimits min, max

			e.stopImmediatePropagation()
			e.preventDefault()
		
		# Dropdown for opening a saved view.
		$('body').on 'change', '#trend-tool-open-select', (e) ->
			viewId = $('select[name=open]').val()
			networkId = $.url().param().networkId
			if viewId
				window.location = '?action=showTrendTool&trendToolViewId='+viewId+'&networkId='+networkId
		
		# Dropdown for module selection.
		$('body').on 'change', '#trend-tool-module-select', (e) =>
			$('#trend-tool-tag-div').css('display', 'inline-block')
			moduleId = $('#trend-tool-module-select').val()
			@loadTagsFromAjax moduleId
		
		# Dropdown for tag selection.
		$('body').on 'change', '#trend-tool-tag-select', (e) =>
			$('#trend-tool-row-add-button').show()
		
		# Button for adding a tag to the table.
		$('body').on 'click', '#trend-tool-row-add-button', (e) =>
			curveIndex = dataArr.length
			tagMeaning = $('#trend-tool-tag-select').val()
			days = periodToDays $('[name=range]:checked').val()
			from = null
			to = null
			moduleId = $('#trend-tool-module-select').val()
			showEveryPoint = false
			deferred = @loadCurveFromAjax curveIndex, tagMeaning, days, from, to, moduleId, showEveryPoint
			$.when(deferred).done =>
				addDataToTable dataArr[curveIndex], curveIndex
				$('#trend-tool-row-add-button').hide()
				if trendToolViewId == 0
					$('#trend-tool-view-save-button').removeClass 'ui-disabled'
				$('#trend-tool-view-saveasnew-button').removeClass 'ui-disabled'
				$('#trend-tool-view-new-button').removeClass 'ui-disabled'
		
		# Button for removing hidden curves.
		$('body').on 'click', '#trend-tool-remove-hidden', (e) =>
			$('.trend-tool-show-checkbox').each (e) ->
				index = lastNum $(@).attr 'id'
				show = $(@).prop 'checked'
				if not show
					dataArr[index].remove = true
					$(@).closest('tr').remove()
					if $('#trend-tool-table tbody tr').length == 0
						$('#trend-tool-table-container').hide()
						$('#trend-tool-row-add-button').show()
						$('#trend-tool-view-save-button').addClass 'ui-disabled'
						$('#trend-tool-view-saveasnew-button').addClass 'ui-disabled'
		
		# Button for saving the view.
		$('body').on 'click', '#trend-tool-view-save-button', (e) =>
			viewId = $.url().param().trendToolViewId
			@saveViewToAjax(viewId)
		
		# Button for saving the view as new.
		$('body').on 'click', '#trend-tool-view-saveasnew-button', (e) =>
			viewId = 0
			@saveViewToAjax(viewId)
		
		# Button for creating a new view.
		$('body').on 'click', '#trend-tool-view-new-button', (e) =>
			networkId = $.url().param().networkId
			window.location = '?action=showTrendTool&trendToolViewId=0&networkId='+networkId
		
		# Button for deleting a view.
		$('body').on 'click', '#trend-tool-view-delete-button', (e) =>
			viewId = $.url().param().trendToolViewId
			@deleteViewWithAjax(viewId)
		
		$('body').on 'click', '.trend-tool-y-max-input', (e) =>
			e.stopImmediatePropagation()
			e.preventDefault()
		
		$('body').on 'click', '.trend-tool-y-min-input', (e) =>
			e.stopImmediatePropagation()
			e.preventDefault()
		
		$('body').on 'keypress', '.trend-tool-y-min-input', (e) =>
			if e.charCode == 13 # Enter key
				yMinInputChange $(e.target)

		$('body').on 'keypress', '.trend-tool-y-max-input', (e) =>
			if e.charCode == 13 # Enter key
				yMaxInputChange $(e.target)
		
		$('body').on 'mouseleave', '.trend-tool-y-min-input', (e) =>
			yMinInputChange $(e.target)

		$('body').on 'mouseleave', '.trend-tool-y-max-input', (e) =>
			yMaxInputChange $(e.target)

		$('body').on 'click', '.trend-tool-color-input', (e) =>
			e.stopImmediatePropagation()
			#e.preventDefault()
		
		$('body').on 'change', '.trend-tool-color-input', (e) =>
			input = $(e.target)
			newColor = input.val()
			index = lastNum input.attr 'id'
			updateSeries index, color: newColor
			trendsChartObj.redraw()
		
	yMinInputChange = (input) ->
		curveIndex = lastNum input.attr 'id'
		min = input.val()
		if not isNumeric min
			min = 0
			input.val min
		dataArr[curveIndex].trendCurveMin = min
		if selectedCurveIndex?
			if selectedCurveIndex == curveIndex
				setYAxisLimits min, dataArr[curveIndex].trendCurveMax
		else
			setYAxisLimits getMinMin(), getMaxMax()

	yMaxInputChange = (input) ->
		curveIndex = lastNum input.attr 'id'
		max = input.val()
		if not isNumeric max
			max = 0
			input.val max
		dataArr[curveIndex].trendCurveMax = max
		if selectedCurveIndex?
			if selectedCurveIndex == curveIndex
				setYAxisLimits dataArr[curveIndex].trendCurveMin, max
		else
			setYAxisLimits getMinMin(), getMaxMax()

	# Return the lowest min of all visible curves.
	getMinMin = ->
		minmin =  9999999999
		for data in dataArr
			if data.show
				minmin = Math.min data.trendCurveMin, minmin
		minmin
	
	# Return the highest max of all visible curves.
	getMaxMax = ->
		maxmax = -9999999999
		for data in dataArr
			if data.show
				maxmax = Math.max data.trendCurveMax, maxmax
		maxmax
	
	# Return the lowest min of all visible curve values.
	getMinMinVal = ->
		minmin =  9999999999
		for data in dataArr
			if data.show
				for coord in data.dataSeries.coords
					minmin = Math.min coord.v, minmin
		minmin

	# Return the highest max of all visible curve values.
	getMaxMaxVal = ->
		maxmax = -9999999999
		for data in dataArr
			if data.show
				for coord in data.dataSeries.coords
					maxmax = Math.max coord.v, maxmax
		maxmax
	
	setYAxisLimits = (min, max) ->
		trendsChartObj.yAxis[0].setExtremes min, max, false, false
		trendsChartObj.redraw()
	
	showCurve = (curveIndex, show) ->
		if show
			trendsChartObj.series[curveIndex].show()
		else
			trendsChartObj.series[curveIndex].hide()
		dataArr[curveIndex].show = show
	
	unselectAllCurves = ->
		for i in [0..7]
			updateSeries i,
				type: unselectedCurveType
				dashStyle: unselectedCurveDashStyle
				lineWidth: unselectedCurveLineWidth
				marker:
					enabled: false
			if dataArr[i]?
				if dataArr[i].show
					trendsChartObj.series[i].show()
				else
					trendsChartObj.series[i].hide()

	setCurveSelected = (index) ->
		updateSeries index,
			type: selectedCurveType
			dashStyle: selectedCurveDashStyle
			lineWidth: selectedCurveLineWidth
			marker:
				enabled: true
		trendsChartObj.series[index].show()
		for i in [0..7]
			if i != index
				updateSeries i,
					type: unselectedCurveType
					dashStyle: unselectedCurveDashStyle
					lineWidth: unselectedCurveLineWidth
					marker:
						enabled: false
			if dataArr[i]?
				if dataArr[i].show
					trendsChartObj.series[i].show()
				else
					trendsChartObj.series[i].hide()
	
	updateSeries = (curveIndex, config) ->
		pgwebData = trendsChartObj.series[curveIndex].pgwebData
		trendsChartObj.series[curveIndex].update config, false
		trendsChartObj.series[curveIndex].pgwebData =  pgwebData

	addDataToTable = (data, index) =>
		checked = if data.show then 'checked="checked"' else ''
		color = data.color #pgweb.CurveChart.inst().standardSeriesColors[index]
		html = '<tr class="trend-tool-table-tr" id="trend-tool-table-tr'+index+'">'
		html += '<td class="trend-tool-show-td"><label for="trend-tool-show-checkbox'+index+'">&nbsp;</label>'
		html += '<input type="checkbox" data-inline="true" name="show'+index+'" id="trend-tool-show-checkbox'+index+'" class="trend-tool-show-checkbox" '+checked+'/></td>'
		html += '<td>'+data.networkName+'</td>'
		html += '<td>'+data.moduleName+'</td>'
		html += '<td>'+data.dataSeries.name+'</td>'
		html += '<td>'+data.description+'</td>'
		html += '<td><input type="text" data-inline="true" name="yMin" class="trend-tool-y-min-input" id="trend-tool-y-min-input'+index+'" value="'+data.trendCurveMin+'"/></td>'
		html += '<td><input type="number" data-inline="true" name="yMax" class="trend-tool-y-max-input" id="trend-tool-y-max-input'+index+'" value="'+data.trendCurveMax+'"/></td>'
		html += '<td><xdiv class="trend-tool-table-color" style="background-color: '+color+'"></xdiv><input type="color" class="trend-tool-color-input" id="trend-tool-color-input'+index+'" value="'+color+'"/></td>'
		html += '</tr>'
		$('#trend-tool-table tbody').append html
		$('#trend-tool-show-checkbox'+index).checkboxradio()
		$('#trend-tool-y-min-input'+index).textinput()
		$('#trend-tool-y-max-input'+index).textinput()
		$('#trend-tool-color-input'+index).textinput()
		$('#trend-tool-table-container').show()
		
	toolTipFormatter: ->
		# Creating a Date from this.x gives the wrong timezone (adds offset from UTC), so we have to adjust it.
		dBrowser = new Date @x
		dLocal = new Date dBrowser.getTime() + dBrowser.getTimezoneOffset()*60000
		dStr = Globalize.format dLocal, 'F' #d.toISOString().replace("T", " ").substring 0, 19
		html = '<div style="color: #ddd">'
		html += dStr
		html += '</div><br /><div>'
		#for point, i in @points
		point = @point
		y = point.y
		chartSeries = point.series
		pgwebData = chartSeries.pgwebData
		dataSeries = pgwebData.dataSeries
		nDecimals = formatStringToNDecimals dataSeries.format
		labelText = dataSeries.name
		systemName = pgwebData.systemName
		html += '<div style="font-size: 1.3em; padding-top: .5em;">'
		html += '<span style="color: #ddd">'+systemName+', '+labelText+'</span>: <b>'+Globalize.format(y, 'n'+nDecimals)+'</b>'
		html += '</div><br/>'
		html += '</div>'
		html
	
	getCurvesFromTable: () ->
		curves = []
		orderNumber = 1
		$('.trend-tool-table-tr').each ->
			i = lastNum $(@).attr 'id'
			moduleId = dataArr[i].moduleId
			tagMeaning = dataArr[i].dataSeries.name
			show = $(@).find('.trend-tool-show-checkbox').prop 'checked'
			yMin = $(@).find('.trend-tool-y-min-input').val()
			yMax = $(@).find('.trend-tool-y-max-input').val()
			color = $(@).find('.trend-tool-color-input').val()
			data =
				moduleId: moduleId
				tagMeaning: tagMeaning
				show: show
				yMin: yMin
				yMax: yMax
				color: color
				orderNumber: orderNumber
			curves.push data
			orderNumber += 1
		curves
	
	saveViewToAjax: (trendToolViewId) ->
		waitStart()
		name = $('#trend-tool-view-name').val()
		days = periodToDays $('[name=range]:checked').val()
		fromDate = ''
		toDate = ''
		showAllValues = true
		networkId = $.url().param().networkId
		viewData =
			name: name
			days: days
			fromDate: fromDate
			toDate: toDate
			showAllValues: showAllValues
			trendToolViewId: trendToolViewId
		curves = @getCurvesFromTable()
		$.ajax
			url: "/pgweb/ajax/trendTool/trendToolSaveView.php"
			method: 'post'
			dataType: 'json'
			data:
				view: viewData
				curves: curves
				networkId: networkId
			success: (data) ->
				if data.result == "OK"
					$('#trend-tool-open-select option[value="'+trendToolViewId+'"]').html name
					$('#trend-tool-open-select').selectmenu('refresh')
					$('#trend-tool-save-msg').hide()
					$('#trend-tool-save-msg').html 'The trend view has been saved.'
					$('#trend-tool-save-msg').show 300, ->
						setTimeout ->
							$('#trend-tool-save-msg').hide 300, ->
								if trendToolViewId != data.viewId # Saved as new.
									window.location = '?action=showTrendTool&trendToolViewId='+data.viewId+'&networkId='+networkId
							$('#trend-tool-save-msg').html ''
						, 2000
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Failed to load trend tool view data: "+data.debug
			error: ajaxFailure,
			complete: ->
				waitStop()

	deleteViewWithAjax: (trendToolViewId) ->
		waitStart()
		networkId = $.url().param().networkId
		viewData =
			trendToolViewId: trendToolViewId
		$.ajax
			url: "/pgweb/ajax/trendTool/trendToolDeleteView.php"
			method: 'post'
			dataType: 'json'
			data:
				view: viewData
				networkId: networkId
			success: (data) ->
				if data.result == "OK"
					$('#trend-tool-open-select option[value="'+trendToolViewId+'"]').remove()
					$('#trend-tool-open-select').selectmenu('refresh')
					$('#trend-tool-save-msg').hide()
					$('#trend-tool-save-msg').html 'The trend view has been deleted.'
					$('#trend-tool-view-name').val ''
					$('#trend-tool-save-msg').show 300, ->
						setTimeout ->
							$('#trend-tool-save-msg').hide 300, ->
								window.location = '?action=showTrendTool&trendToolViewId=0&networkId='+networkId
							$('#trend-tool-save-msg').html ''
						, 2000
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Failed to delete trend tool view: "+data.debug
			error: ajaxFailure,
			complete: ->
				waitStop()

	loadTagsFromAjax: (moduleId) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/trendTool/trendToolTag.php"
			dataType: 'json'
			data:
				moduleId: moduleId
			success: (data) ->
				if data.result == "OK"
					tagDataArr = data.tagDataArr
					$('.trend-tool-tag-dynamic').remove()
					for tagData in tagDataArr
						$('#trend-tool-tag-select').append '<option class="trend-tool-tag-dynamic" value="'+tagData.tagMeaning+'">'+tagData.tagMeaning+'</option>'
					$('#trend-tool-tag-select').selectmenu('refresh')
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Failed to load trend tool tag data: "+data.debug
			error: ajaxFailure,
			complete: ->
				waitStop()
	
	loadViewFromAjax: (trendToolViewId) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/trendTool/trendToolView.php"
			dataType: 'json'
			data:
				trendToolViewId: trendToolViewId
			success: (data) ->
				if data.result == "OK"
					trendToolView = data.trendToolView
					moduleIdTags = data.moduleIdTags
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Failed to load trend tool view data: "+data.debug
			error: ajaxFailure,
			complete: ->
				waitStop()
	
	loadCurveFromAjax: (curveIndex, tagMeaning, days, from, to, moduleId, showEveryPoint) ->
		waitStart()
		if days == 0
			fromISO = from.toISOString()
			toISO = to.toISOString()
		$.ajax
			url: "/pgweb/ajax/trendTool/trendToolCurve.php"
			dataType: 'json'
			data:
				tagMeaning: tagMeaning
				days: days
				from: fromISO
				to: toISO
				moduleId: moduleId
				showEveryPoint: showEveryPoint
				curveIndex: curveIndex
			success: (data) ->
				if data.result == "OK"
					data.curveIndex = curveIndex
					dataArr[curveIndex] = data
					
					chartSeries = trendsChartObj.series[curveIndex]

					for coord, i in data.dataSeries.coords
						dt = Globalize.parseDate coord.t
						dtJSTime = dateTimeToJSTime dt # Unix time * 1000
						timezone = data.timezone
						dtJSTimeTzCorrected = dtJSTime + timezone.offset*60000
						xy = [dtJSTimeTzCorrected, coord.v]
						chartSeries.addPoint xy, false
					
					chartSeries.pgwebData = data
					chartSeries.setOptions 'color': data.color
					
					if days == 0
						trendsChartObj.xAxis[0].setExtremes from, to, false
					else
						setXAxisInterval days

					showCurve curveIndex, data.show
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else if data.result == 'NO_SUCH_TAG'
					alert data.result+': '+tagMeaning
				else
					alert "Failed to load chart data: "+data.debug
			error: ajaxFailure,
			complete: ->
				waitStop()

	setXAxisInterval = (days) ->
		minXLocal = getMinXFromDays days, timezone.offset
		maxXLocal = getMaxXFromDays days, timezone.offset
		minXLocal = dateTimeToJSTime minXLocal
		maxXLocal = dateTimeToJSTime maxXLocal
		trendsChartObj.xAxis[0].setExtremes minXLocal, maxXLocal, false

	periodToDays = (period) ->
		periods =
			free: 0
			sixMonths: 180
			threeMonths: 90
			oneMonth: 30
			oneWeek: 7
		periods[period]

$(document).on 'pagecreate', '.showTrendToolPage', (event) ->
	pgweb.TrendTool.inst()
class pgweb.TrendsPage
	trendsChartObj = null
	howMuchData = 0
	selectedCurveDashStyle = 'Solid'
	unSelectedCurveDashStyle = 'ShortDot'
	selectedCurveLineWidth = 3
	unSelectedCurveLineWidth = 2
	channelIndexMappings = { acRes1: 0, galvVolt1: 1, acRes2: 2, galvVolt2: 3, loopRes: 4 }
	channelTdrW1IndexMappings = { tdrDiverg1: 0, tdrStatusCode1: 1, tdrEldf1: 2, tdrIndication1: 3, tdrDamage1: 4 }
	channelTdrW2IndexMappings = { tdrDiverg2: 0, tdrStatusCode2: 1, tdrEldf2: 2, tdrIndication2: 3, tdrDamage2: 4 }
	voltIndexMappings = { batt: 0, mainSupplyVolt: 1 }
	admflowIndexMappings = { flow_forward: 0, flow_return: 1, flow_speed_forward: 2, flow_speed_return: 3, \
		pressure_forward: 4, pressure_return: 5, temp_forward: 6, temp_return: 7, flow_deviation: 8, \
		flow_deviation_percent: 9, pressure_deviation: 10, temp_diff: 11 }
	timezone = { identifier: '', offset: 0 }
	overviewScaled = false
	currentData = null
	currentCurveIndex = null
	upperYZoom = 0
	lowerYZoom = 0
	currentWhich = null
	moduleTypeName = null
	themeType = null
	pline = null
	clickX = null
	clickY = null
	periods =
		free: 0,
		sixMonths: 180,
		threeMonths: 90, 
		oneMonth: 30, 
		oneWeek: 7

	@inst: ->
		if not instance?
			instance = new @
		instance

	chartToolTipFormatter: ->
		# Creating a Date from @x gives the wrong timezone (adds offset from UTC), so we have to adjust it.
		dBrowser = new Date @x
		dLocal = new Date(dBrowser.getTime() + dBrowser.getTimezoneOffset()*60000)
		dStr = Globalize.format dLocal, 'F' #d.toISOString().replace("T", " ").substring(0, 19);
		html = '<div class="trends-tooltip-title">'
		html += dStr
		html += '</div><div class="trends-tooltip-body">'
		for i in [0..@points.length-1]
			if moduleTypeName == 'cc58'
				if currentWhich == 'an'
					if i > 3 and not pgweb.TrendsPage.hasOptionCard()
						continue
			y = @points[i].y
			curveIndex = @points[i].series.index
			if overviewScaled and @points
				if curveIndex == 0 or curveIndex == 2
					if $('#module-type-name').val() == 'pulsPG'
						y *= 200;
					else
						y *= 100;
				else if curveIndex == 1 or curveIndex == 3
					y *= 10;
			curveIndexOffset = if currentWhich in ['di', 'do', 'dv', 'an', 'av', 'dout', 'admFlowCore'] \
					or (/^chTdr\dW\d$/.test currentWhich)
				0
			else
				if moduleTypeName == 'cc58'
					if currentWhich in ['volt']
						0
					else
						1
				else
					1
			inputElem = $('#'+currentWhich+'-curve-buttons input')[curveIndex + curveIndexOffset]
			labelElem = $(inputElem).prev()
			labelText = labelElem.text().trim()
			nDecimals = formatStringToNDecimals trendsChartObj.series[curveIndex].pgwebFormat
			if not labelText
				selectedItem = $('[name=what-curve]').find ':selected'
				labelText = selectedItem.text()
			unit = currentData.seriesArr[curveIndex].unit
			html += '<div class="trends-tooltip-row">'
			html += '<span>'+labelText+'</span>: <b>'+Globalize.format(y, 'n'+nDecimals)+' '+unit+'</b>'
			html += '</div>'
		html += '</div>'
		html

	loadChart: ->
		currentCurveIndex = null
		showEveryPoint = $('#show-every-point').prop 'checked'

		period = $('[name=range]:checked').val() #$.cookie('pgweb_trends_period_'+$.cookie('pgweb_idHash'));
		if !period
			period = 'oneWeek'
		days = periods[period]

		minmax = pgweb.TrendsPage.getMinMax days
		min = minmax[0]
		max = minmax[1]
		msg = ''
		if not showEveryPoint
			if days == 0
				timeDiff = (max.getTime() - min.getTime())/1000 # Convert ms into s.
				periodMinutes = Math.floor(timeDiff/1000)/60 # Period length in minutes.
				periodHours = 0
				if periodMinutes >= 60
					periodHours = Math.floor(periodMinutes/60)
					periodMinutes = Math.floor(periodMinutes%60)
				msg = periodHours + " h " + periodMinutes.toFixed(1) + " min"
			else if days > 0 and days <= 7 # Up to 1 week
				msg = "10 min" # 10 minutes resolution = max 1008 values
			else if days > 7 and days <= 31 # Up to 1 month
				msg = "1 h" # 1 hour resolution = max 744 values
			else if days > 31 and days <= 93 # Up to 3 months
				msg = "3 h" # 3 hours resolution = max 744 values
			else if days > 93 and days <= 186 # Up to 6 months
				msg = "6 h" # 6 hours resolution = max 744 values
			else # More than 6 months
				msg = "24 h" # 24 hours resolution
			msg = t.TrendsPage_MaxOneValuePer + ' ' + msg
		$('#show-every-point-message').html msg

		pgweb.TrendsPage.showZoomXResetButton false

		howMuchData = days
		which = $('[name=what-curve]').val()
		seriesColors = pgweb.CurveChart.inst().standardSeriesColors
		@showHideControls which
		if which == 'an'
			if moduleTypeName == 'smbasicPG'
				seriesColors = pgweb.CurveChart.inst().smbasicANSeriesColors
				yAxisConfig = pgweb.CurveChart.inst().yAxisFloatFixedConfig seriesColors[0], false, .001, 1 # Don't show first axis label.
			else
				yAxisConfig = pgweb.CurveChart.inst().yAxisFloatConfig seriesColors[0], false, .001, 1
			subWhich = $('[name=an]:checked').val()
			if moduleTypeName == 'cc58'
				activeCurveIndex = lastNum(subWhich)-1
				activeCurveIndex = @getExtraANIndexCC58 subWhich, activeCurveIndex
			else
				activeCurveIndex = lastNum(subWhich)-1
		else if which == 'rtd'
			yAxisConfig = pgweb.CurveChart.inst().yAxisFloatConfig seriesColors[0], false, .001, 1
			subWhich = $('[name=rtd]:checked').val()
			activeCurveIndex = lastNum(subWhich)-1
		else if which == 'av'
			yAxisConfig = pgweb.CurveChart.inst().yAxisFloatConfig seriesColors[0], false, .001, 1
			subWhich = $('[name=av]:checked').val()
			av = lastNum subWhich
			activeCurveIndex = lastNum $('[class^="av-curve-button av'+av+'-curve-button av-index"]').attr 'class'
		else if which == 'di'
			yAxisConfig = pgweb.CurveChart.inst().yAxisBinConfig seriesColors[0]
			subWhich = $('[name=di]:checked').val()
			activeCurveIndex = lastNum(subWhich) - 1
		else if which == 'do'
			yAxisConfig = pgweb.CurveChart.inst().yAxisBinConfig seriesColors[0]
			subWhich = $('[name=do]:checked').val()
			activeCurveIndex = lastNum(subWhich) - 1
		else if which == 'dv'
			yAxisConfig = pgweb.CurveChart.inst().yAxisBinConfig seriesColors[0]
			subWhich = $('[name=dv]:checked').val()
			dv = lastNum subWhich
			activeCurveIndex = lastNum $('[class^="dv-curve-button dv'+dv+'-curve-button dv-index"]').attr 'class'
		else if which == 'dout'
			yAxisConfig = pgweb.CurveChart.inst().yAxisBinConfig seriesColors[0]
			subWhich = $('[name=dout]:checked').val()
			activeCurveIndex = lastNum(subWhich) - 1
		else if /^ch\d$/.test which
			seriesColors = pgweb.CurveChart.inst().channelSeriesColors
			yAxisConfig = pgweb.CurveChart.inst().yAxisFloatConfig seriesColors[0], false, .001, 1
			subWhich = $('[name='+which+']:checked').val()
			activeCurveIndex = lastNum(subWhich) - 1
		else if /^chTdr\dW\d$/.test which
			seriesColors = pgweb.CurveChart.inst().channelTdrSeriesColors
			yAxisConfig = pgweb.CurveChart.inst().yAxisFloatConfig seriesColors[0], false, .001, 1
			subWhich = $('[name='+which+']:checked').val()
			activeCurveIndex = lastNum(subWhich) - 1
		else if which == 'admFlowCore'
			seriesColors = pgweb.CurveChart.inst().admFlowSeriesColors
			yAxisConfig = pgweb.CurveChart.inst().yAxisFloatConfig seriesColors[0]
			subWhich = $('[name=admFlowCore]:checked').val()
			activeCurveIndex = admflowIndexMappings[subWhich.camelToSnake()]
		else
			yAxisConfig = pgweb.CurveChart.inst().yAxisIntConfig seriesColors[0], false
			activeCurveIndex = 0
		currentWhich = which
		zoom = ''
		if $('.showTrendsPage .allow-zoom-button').is ':checked'
			zoom = 'xy'
		zoom = 'x'
		title = @chartTitle which
		renderTo = $(".ui-page-active .trends-chart-container").get()[0]
		trendsChartObj = pgweb.CurveChart.inst().create(min, max, zoom, title, yAxisConfig, 
				activeCurveIndex, seriesColors, renderTo, @chartToolTipFormatter, true)
		moduleId = $('#module-id').val()
		if days == 0
			@loadChartDataFromAjax which, 0, min, max, moduleId, showEveryPoint
		else
			@loadChartDataFromAjax which, days, undefined, undefined, moduleId, showEveryPoint

	chartTitle: (which) ->
		titles =
			timer: t.TrendsPage_TitleTimer+' ('+t.TrendsPage_Minutes+')'
			temp: t.TrendsPage_TitleTemp+' (°C)'
			temp1w: t.TrendsPage_TitleTemp1W+' (°C)'
			battery: t.TrendsPage_TitleBattery+' (V)'
			volt: t.TrendsPage_TitleVoltage+' (V)'
			humidity: t.TrendsPage_TitleHumidity+' (%)'
			csq: t.TrendsPage_TitleCSQ+' (0-31)'
			ch1: t.TrendsPage_TitleCh
			ch2: t.TrendsPage_TitleCh
			ch3: t.TrendsPage_TitleCh
			ch4: t.TrendsPage_TitleCh
			ch5: t.TrendsPage_TitleCh
			ch6: t.TrendsPage_TitleCh
			ch7: t.TrendsPage_TitleCh
			ch8: t.TrendsPage_TitleCh
			chTdr1W1: t.TrendsPage_TitleChTdr
			chTdr2W1: t.TrendsPage_TitleChTdr
			chTdr3W1: t.TrendsPage_TitleChTdr
			chTdr4W1: t.TrendsPage_TitleChTdr
			chTdr5W1: t.TrendsPage_TitleChTdr
			chTdr6W1: t.TrendsPage_TitleChTdr
			chTdr7W1: t.TrendsPage_TitleChTdr
			chTdr8W1: t.TrendsPage_TitleChTdr
			chTdr1W2: t.TrendsPage_TitleChTdr
			chTdr2W2: t.TrendsPage_TitleChTdr
			chTdr3W2: t.TrendsPage_TitleChTdr
			chTdr4W2: t.TrendsPage_TitleChTdr
			chTdr5W2: t.TrendsPage_TitleChTdr
			chTdr6W2: t.TrendsPage_TitleChTdr
			chTdr7W2: t.TrendsPage_TitleChTdr
			chTdr8W2: t.TrendsPage_TitleChTdr
			di: t.TrendsPage_TitleDI
			do: t.TrendsPage_TitleDO
			dv: t.TrendsPage_TitleDV
			dout: t.TrendsPage_TitleDOut
			an: t.TrendsPage_TitleAN
			rtd: t.TrendsPage_TitleRTD
			av: t.TrendsPage_TitleAV
			
			period: 'Period'
			dimming: 'Dimming'
			brightness: 'Brightness'
			chargingCurrentToBattByWindTurbine: 'Vindturbin Amp'
			windTurbineSpeed: 'Vindturbin RPM'
			pvInVoltage: 'Solpanel Volt'
			chargingCurrentToBattByPV: 'Solpanel Amp'
			loadPower: 'Batteriförbrukning Watt'
			battVolt: 'Batteriförbrukning Volt'
			remainingBattCapacity: 'Batteriförbrukning Ah'
			loadCurrent: 'Batteriförbrukning Ladd Amp'

			admFlowCore: 'Alla värden'

		moduleName = $('[name=module_name]').val()
		technicalName = $('[name=technical_name]').val()

		if which.substr(0, 5) == 'chTdr'
			titleChannel = titles[which].replace(/%d/, which.substr(5, 1)).replace(/%d/, which.substr(7, 1))
		else if which.substr(0, 2) == 'ch'
			titleChannel = titles[which].replace(/%d/, which.substr(2, 1))
		else
			titleChannel = titles[which]
		selectedCurveButton = $('[name='+which+']:checked')[0]
		labelText = $(selectedCurveButton).prev().text().trim()
		title = ''
		if moduleName
			title += moduleName+', '
		if technicalName
			title += technicalName+', '
		title += titleChannel
		if labelText
			title += ', '+labelText
		escapeStringForHTML title
	
	showHideControls: (which) ->
		@showHideControl which, 'an', '#an-curve-buttons'
		@showHideControl which, 'rtd', '#rtd-curve-buttons'
		@showHideControl which, 'av', '#av-curve-buttons'
		@showHideControl which, 'di', '#di-curve-buttons'
		@showHideControl which, 'do', '#do-curve-buttons'
		@showHideControl which, 'dv', '#dv-curve-buttons'
		@showHideControl which, 'dout', '#dout-curve-buttons'
		@showHideControl which, 'volt', '#volt-curve-buttons'
		@showHideControl which, 'admFlowCore', '#admFlowCore-curve-buttons'
		if which == 'an'
			$('.mic-limits').show()
			$('.mic-filters').show()
		else
			$('.mic-limits').hide()
			$('.mic-filters').hide()
		for ch in [1..8]
			@showHideControl which, 'ch'+ch, '#ch'+ch+'-curve-buttons'
		for ch in [1..8]
			for tr in [1..2]
				@showHideControl which, 'chTdr'+ch+'W'+tr, '#chTdr'+ch+'W'+tr+'-curve-buttons'
	
	showHideControl: (which, name, control) ->
		if which == name
			$(control).show()
		else
			$(control).hide()

	@getCurrentData: -> 
		currentData

	loadChartDataFromAjax: (which, days, from, to, moduleId, showEveryPoint) ->
		waitStart()
		if days == 0
			fromISO = from.toISOString()
			toISO = to.toISOString()
		$.ajax
			url: "/pgweb/ajax/trend/trends.php"
			dataType: 'json'
			data:
				which: which
				days: days
				from: fromISO
				to: toISO
				moduleId: moduleId
				showEveryPoint: showEveryPoint
			success: (data) =>
				if data.result == "OK"
					currentData = data
					@showChannelData data, (/^ch\d$/.test which) or (/^chTdr\dW\d$/.test which)
					@showDiDescriptions data
					@showDoDescriptions data
					@showDvDescriptions data
					@showAnDescriptions data
					@showRtdDescriptions data
					@showAvDescriptions data
					
					for i in [0..15]
						trendsChartObj.series[i].setData []
					for curveIndex in [0..data.seriesArr.length-1]
						dataSeriesObj = data.seriesArr[curveIndex]
						for item, i in dataSeriesObj.series
							dt = Globalize.parseDate item.t
							dtJSTime = dateTimeToJSTime dt # Unix time * 1000
							timezone = data.timezone
							dtJSTimeTzCorrected = dtJSTime + timezone.offset*60000
							xy = [dtJSTimeTzCorrected, item.v]
							trendsChartObj.series[curveIndex].addPoint xy, false
						trendsChartObj.series[curveIndex].pgwebFormat = data.seriesArr[curveIndex].format
						trendsChartObj.series[curveIndex].pgwebMin = data.seriesArr[curveIndex].min
						trendsChartObj.series[curveIndex].pgwebMax = data.seriesArr[curveIndex].max
					if days == 0
						from = dateTimeToJSTime from
						to = dateTimeToJSTime to
						trendsChartObj.xAxis[0].setExtremes from, to, false
					else
						setXAxisInterval days

					seriesColors = pgweb.CurveChart.inst().standardSeriesColors
					switch which
						when 'di'
							whichCurve = $('.di-curve-button:checked').val()
							index = lastNum(whichCurve) - 1
							nCurves = 16
						when 'do'
							whichCurve = $('.do-curve-button:checked').val()
							index = lastNum(whichCurve) - 1
							nCurves = 8
						when 'dv'
							whichCurve = $('.dv-curve-button:checked').val()
							dv = lastNum(whichCurve)
							index = lastNum($('[class^="dv-curve-button dv'+dv+'-curve-button dv-index"]').attr 'class')
							nCurves = 8
						when 'dout'
							whichCurve = $('.dout-curve-button:checked').val()
							index = lastNum(whichCurve) - 1
							nCurves = 8
						when 'an'
							whichCurve = $('.an-curve-button:checked').val()
							index = lastNum(whichCurve) - 1
							nCurves = 6
							if moduleTypeName == 'smbasicPG'
								mic = lastNum whichCurve
								seriesColors = pgweb.CurveChart.inst().smbasicANSeriesColors
								micMean = $('#mic'+mic+'-filter').val()
								if not micMean
									micMean = 0
								@computeAverage micMean, index+2
							else if moduleTypeName == 'cc58'
								nCurves = 8
								index = @getExtraANIndexCC58 whichCurve, index
						when 'rtd'
							whichCurve = $('.rtd-curve-button:checked').val()
							index = lastNum(whichCurve) - 1
							nCurves = 10
						when 'av'
							whichCurve = $('.av-curve-button:checked').val()
							av = lastNum whichCurve
							index = lastNum ($('[class^="av-curve-button av'+av+'-curve-button av-index"]').attr 'class')
							nCurves = 8
						when 'ch1', 'ch2', 'ch3', 'ch4', 'ch5', 'ch6', 'ch7', 'ch8'
							chN = lastNum which
							whichCurve = $('.channel'+chN+'-curve-button:checked').val()
							if whichCurve != 'overview'
								index = channelIndexMappings[whichCurve]
							nCurves = 5
							seriesColors = pgweb.CurveChart.inst().channelSeriesColors
						when 'chTdr1W1', 'chTdr2W1', 'chTdr3W1', 'chTdr4W1', 'chTdr5W1', 'chTdr6W1', 'chTdr7W1', 'chTdr8W1', 'chTdr1W2', 'chTdr2W2', 'chTdr3W2', 'chTdr4W2', 'chTdr5W2', 'chTdr6W2', 'chTdr7W2', 'chTdr8W2'
							chN = which.substr 5, 1
							wire = lastNum which
							whichCurve = $('.channelTdr'+chN+'W'+wire+'-curve-button:checked').val()
							if wire == 1
								index = channelTdrW1IndexMappings[whichCurve]
							else
								index = channelTdrW2IndexMappings[whichCurve]
							nCurves = 6
							seriesColors = pgweb.CurveChart.inst().channelTdrSeriesColors
						when 'volt'
							whichCurve = $('[name=volt]:checked').val()
							if whichCurve != 'overview'
								index = voltIndexMappings[whichCurve]
							nCurves = 2
							seriesColors = pgweb.CurveChart.inst().standardSeriesColors
						when 'admFlowCore'
							whichCurve = $('[name=admFlowCore]:checked').val()
							index = admflowIndexMappings[whichCurve.camelToSnake()]
							nCurves = 12
							seriesColors = pgweb.CurveChart.inst().admFlowSeriesColors
						else
							index = 0
							nCurves = 1
					if whichCurve == 'overview'
						@switchToOverview nCurves, which
					else
						@switchCurve index, nCurves, seriesColors[index], which
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Failed to load chart data: "+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()

	showChannelData: (data, show) ->
		if show
			$('#trends-alarm-section').html escapeStringForHTML data.channelData.alarmSection
			$('#trends-section-description').html escapeStringForHTML data.channelData.sectionDescription
			$('#channel-data').show()
		else
			$('#channel-data').hide()

	hasGt8Active: (data) ->
		if data.seriesArr.length > 8
			for i in [8..data.seriesArr.length-1]
					if parseInt data.seriesArr[i].active
						return true
		false

	@hasOptionCard: ->
		$('#di4-curve-button').length > 0
	
	showDiDescriptions: (data) ->
		if data.diDescriptions.length > 0
			$('#di-data tbody').html ''
			for i in [0..data.diDescriptions.length-1]
				if data.moduleTypeName == 'cc58'
					if i > 2 and not pgweb.TrendsPage.hasOptionCard()
						break
				if i < 8 or @hasGt8Active data
					$('#di-data tbody').append '<tr><td>DI'+(i+1)+'</td><td>'+data.diDescriptions[i]+'</td></tr>'
			$('#di-data').show()
		else
			$('#di-data').hide()

	showDoDescriptions: (data) ->
		if data.doDescriptions.length > 0
			$('#do-data tbody').html ''
			for i in [0..Math.min(data.doDescriptions.length, 8)-1]
				$('#do-data tbody').append '<tr><td>DO'+(i+1)+'</td><td>'+data.doDescriptions[i]+'</td></tr>'
			$('#do-data').show()
		else
			$('#do-data').hide()
	
	showDvDescriptions: (data) ->
		if data.dvDescriptions.length > 0
			$('#dv-data tbody').html ''
			for i in [0..Math.min(data.dvDescriptions.length, 8)-1]
				which = data.seriesArr[i].name
				$('#dv-data tbody').append '<tr><td>'+which+'</td><td>'+data.dvDescriptions[i]+'</td></tr>'
			$('#dv-data').show()
		else
			$('#dv-data').hide()
	
	showAnDescriptions: (data) ->
		if data.anDescriptions.length > 0
			$('#an-data tbody').html ''
			name = 'AN'
			if data.moduleTypeName == 'cc58'
				name = 'AI'
			if data.moduleTypeName == 'smbasicPG'
				name = 'MIC'
			for i in [0..Math.min(data.anDescriptions.length, 8)-1]
				if data.moduleTypeName == 'cc58'
					if i > 0 and not pgweb.TrendsPage.hasOptionCard()
						break
				$('#an-data tbody').append '<tr><td>'+name+(i+1)+'</td><td>'+data.anDescriptions[i]+'</td></tr>'
			$('#an-data').show()
		else
			$('#an-data').hide()

	showRtdDescriptions: (data) ->
		if data.rtdDescriptions.length > 0
			$('#rtd-data tbody').html ''
			for i in [0..Math.min(data.seriesArr.length, 8)-1]
				which = data.seriesArr[i].name
				$('#rtd-data tbody').append '<tr><td>'+which+'</td><td>'+data.rtdDescriptions[i]+'</td></tr>'
			$('#rtd-data').show()
		else
			$('#rtd-data').hide()

	showAvDescriptions: (data) ->
		if data.avDescriptions.length > 0
			$('#av-data tbody').html ''
			for i in [0..Math.min(data.seriesArr.length, 8)-1]
				which = data.seriesArr[i].name
				$('#av-data tbody').append '<tr><td>'+which+'</td><td>'+data.avDescriptions[i]+'</td></tr>'
			$('#av-data').show()
		else
			$('#av-data').hide()
	
	switchCurve: (curveIndex, nCurves, axisColor, which) =>
		return if currentCurveIndex == curveIndex
		waitStart()
		currentCurveIndex = curveIndex
		title = @chartTitle which
		trendsChartObj.setTitle { text: title }
		if overviewScaled
			if (/^ch\d$/.test which) or (/^chTdr\dW\d$/.test which)
				for index in [0..nCurves-1]
					if index == 0 or index == 2
						if $('#module-type-name').val() == 'pulsPG'
							@scaleSeries index, 200
						else
							@scaleSeries index, 100
						overviewScaled = false
					else
						if index == 1 or index == 3
							@scaleSeries index, 10
							overviewScaled = false
		
		@updateSeries curveIndex,
			type: 'area'
			dashStyle: selectedCurveDashStyle
			lineWidth: selectedCurveLineWidth
			marker: { enabled: true }
		@updateYAxis axisColor
		@setYExtremes()
		for i in [0..nCurves-1]
			if i != curveIndex
				@updateSeries i,
					type: 'line'
					dashStyle: unSelectedCurveDashStyle
					lineWidth: unSelectedCurveLineWidth
					marker: { enabled: false }
		for i in [0..nCurves-1]
			trendsChartObj.series[i].show()
		if nCurves <= 15
			for i in [nCurves..15]
				trendsChartObj.series[i].hide()
		if which == 'di'
			if nCurves > 8
				anyGt8Active = @hasGt8Active
				for i in [8..nCurves-1]
					if not anyGt8Active currentData
						radio = $('#di'+(i+1)+'-curve-button').closest '[class=ui-radio]'
						radio.hide()
						trendsChartObj.series[i].hide()

		trendsChartObj.series[curveIndex].select true
		waitStop()
	
	updateYAxis: (axisColor, redraw=false) ->
		if $('#module-type-name').val() == 'smbasicPG'
			#/*step = function (e) {
				#pline.translate(e.pageX - clickX, e.pageY - clickY)
			#}
			#stop = function () {
				#$(document).unbind('.ppline');
			#}
			#start = function (e) {
				#$(document).bind({
					#'mousemove.ppline': step,
					#'mouseup.ppline': stop
				#});
				#clickX = e.pageX - pline.translateX;
				##clickY = e.pageY - pline.translateY; #uncomment if plotline should be also moved vertically
			#}*/
			if currentWhich.startsWith 'an'
				for i in [1..2]
					seriesColors = pgweb.CurveChart.inst().smbasicANSeriesColors
					
					# Base levels.
					plotLineObj =
						color: seriesColors[i-1]
						dashStyle: 'Dash'
						width: 2
						value: $('#mic'+i+'-limit').val()
						id: 'mic'+i+'-plotline'
					trendsChartObj.yAxis[0].removePlotLine 'mic'+i+'-plotline'
					#trendsChartObj.yAxis[0].addPlotLine plotLineObj

					# HiHi limits.
					plotLineObj =
						color: seriesColors[i-1]
						dashStyle: 'Dot'
						width: 2
						value: currentData.seriesArr[i-1+2].hihiLimit
						id: 'mic'+i+'-hihi-limit'
					trendsChartObj.yAxis[0].removePlotLine 'mic'+i+'-hihi-limit'
					#trendsChartObj.yAxis[0].addPlotLine(plotLineObj);
					#/*pline = trendsChartObj.yAxis[0].plotLinesAndBands[0].svgElem.attr({
							#stroke:'yellow'
						#}).css({
							#'cursor': 'pointer'
						#}).translate(0, 0).on('mousedown', start);*/
		trendsChartObj.yAxis[0].update
			labels:
				enabled: true,
				style:
					color: axisColor
				#/*formatter: () {
					#axisDecimals = formatStringToNDecimals(trendsChartObj.series[curveIndex].pgwebFormat);
					#return floatNumberFormatter(@value, axisDecimals);
				#}*/
			, redraw
	
	switchToOverview: (nCurves, which) =>
		return if currentCurveIndex == -1
		waitStart()
		currentCurveIndex = -1
		title = @chartTitle which
		trendsChartObj.setTitle { text: title }
		trendsChartObj.yAxis[0].update
			labels:
				enabled: false
		trendsChartObj.yAxis[0].setExtremes 0, 100, false, false
		for curveIndex in [0..nCurves-1]
			if (/^ch\d$/.test which) or (/^chTdr\dW\d$/.test which)
				if curveIndex == 0 or curveIndex == 2
					if $('#module-type-name').val() == 'pulsPG'
						@scaleSeries curveIndex, 1/200
					else
						@scaleSeries curveIndex, 1/100
					overviewScaled = true
				else
					if curveIndex == 1 or curveIndex == 3
						@scaleSeries curveIndex, 1/10
						overviewScaled = true
			else if which == 'volt'
				if $('#module-type-name').val() == 'gw102'
					null
					#@scaleSeries curveIndex, 0.5
					#overviewScaled = true

			markerEnabled = false
			if trendsChartObj.series[curveIndex].data.length == 1
					markerEnabled = true
			@updateSeries curveIndex, 
				type: 'line',
				dashStyle: selectedCurveDashStyle,
				lineWidth: selectedCurveLineWidth,
				marker: { enabled: markerEnabled }
		trendsChartObj.redraw()
		waitStop()

	scaleSeries: (curveIndex, scale) ->
		len = trendsChartObj.series[curveIndex].data.length
		for i in [0..len-1]
			if trendsChartObj.series[curveIndex].data[i]
				trendsChartObj.series[curveIndex].data[i].update [trendsChartObj.series[curveIndex].data[i].x, trendsChartObj.series[curveIndex].data[i].y*scale], false, false

	updateSeries: (curveIndex, config) ->
		pgwebFormat = trendsChartObj.series[curveIndex].pgwebFormat
		pgwebMin = trendsChartObj.series[curveIndex].pgwebMin
		pgwebMax = trendsChartObj.series[curveIndex].pgwebMax
		trendsChartObj.series[curveIndex].update config, false
		trendsChartObj.series[curveIndex].pgwebFormat = pgwebFormat
		trendsChartObj.series[curveIndex].pgwebMin = pgwebMin
		trendsChartObj.series[curveIndex].pgwebMax = pgwebMax
	
	seriesConfigs: (activeCurveIndex, seriesColors, which) ->
		arr = []
		moduleId = $('#module-id').val()
		step = ''
		if moduleId == 4786 or moduleId == 4950 # Genius demo or power pole demo
			if ['period', 'dimming', 'brightness'].indexOf(which) > -1
				step = 'left'
		for i in [0..9]
			arr[i] =
				name: i
				color: seriesColors[i]
				type: if activeCurveIndex == i then 'area' else 'line'
				yAxis: 0
				animation: false
				data: []
				dashStyle: if activeCurveIndex == i then selectedCurveDashStyle else unSelectedCurveDashStyle
				lineWidth: if activeCurveIndex == i then selectedCurveLineWidth else unSelectedCurveLineWidth
				marker:
					enabled: activeCurveIndex == i
				index: i
				step: step
				fillColor:
					linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }
					stops: [
						[0, seriesColors[i]]
						[1, seriesColors[i]+'00']
					]
				fillOpacity: 0.75
		arr

	setYExtremes: ->
		factor = 1.3
		if currentCurveIndex >= 0
			baseMax = trendsChartObj.series[currentCurveIndex].pgwebMax
			baseMin = trendsChartObj.series[currentCurveIndex].pgwebMin
		else
			baseMax = 100
			baseMin = 0
		baseMin -= 2
		baseMax += 2
		dist = baseMax-baseMin
		
		if upperYZoom < 0
			max = baseMin + dist*Math.pow 1/factor, -upperYZoom
		else
			max = baseMin + dist*Math.pow factor, upperYZoom
		
		if lowerYZoom < 0
			min = baseMax - dist*Math.pow 1/factor, -lowerYZoom
		else
			min = baseMax - dist*Math.pow factor, lowerYZoom
		
		trendsChartObj.yAxis[0].setExtremes min, max
	
	computeAverage: (ratio, curveIndex) ->
		#for (curveIndex = 0; curveIndex < Math.min(currentData.seriesArr.length, 8); curveIndex++) {
		trendsChartObj.series[curveIndex].setData []
		dataSeriesObj = currentData.seriesArr[curveIndex]
		return if dataSeriesObj.series.length == 0
		lastComputedValue = dataSeriesObj.series[0].v
		lastValue = dataSeriesObj.series[0].v
		for i in [0..dataSeriesObj.series.length-1]
			item = dataSeriesObj.series[i]
			dt = Globalize.parseDate item.t
			dtJSTime = dateTimeToJSTime dt # Unix time * 1000
			timezone = currentData.timezone
			dtJSTimeTzCorrected = dtJSTime + timezone.offset*60000
			#/*sum = 0;
			#cnt = 0;
			#for (j = 0; j < Math.min(n, i+1); j++) {
				#offsetItem = dataSeriesObj.series[i - j];
				#sum += offsetItem.v;
				#cnt++;
			#}
			#xy = [dtJSTimeTzCorrected, sum/cnt];*/
			
			newValue = lastComputedValue + (item.v - lastComputedValue)*(1-ratio/100)
			
			#/*if (item.v - lastValue > 8)
				#newValue = lastValue + 8;
			#else
			#if (item.v - lastValue < -8)
				#newValue = lastValue - 8;
			#else
				#newValue = item.v;*/
			xy = [dtJSTimeTzCorrected, newValue]
			trendsChartObj.series[curveIndex].addPoint xy, false
			lastComputedValue = newValue
			lastValue = item.v
	
	init: ->
		moduleTypeName = $('[name=moduleTypeName]').val()

		ap = $.mobile.activePage # Crazy, but it's needed.
		if $.mobile.activePage
			if $.mobile.activePage.hasClass 'showTrendsPage'
				@loadChart()

		period = null #$.cookie('pgweb_trends_period_'+$.cookie('pgweb_idHash'))
		if not period
			period = 'oneWeek'
		$('[name=range]').val([period]).checkboxradio 'refresh'

		$('body').off 'pageshow', '.showTrendsPage'
		$('body').on 'pageshow', '.showTrendsPage', (event) =>
			period = null #$.cookie('pgweb_trends_period_'+$.cookie('pgweb_idHash'));
			if not period
				period = 'oneWeek'
			$('[name=range]').val([period]).checkboxradio 'refresh'
			@loadChart()
		
		$('body').off 'change', '.showTrendsPage .allow-zoom-button'
		$('body').on 'change', '.showTrendsPage .allow-zoom-button', (event) =>
			@loadChart()
		
		$('body').off 'change', '.trends-page-range-buttons .range-free'
		$('body').on 'change', '.trends-page-range-buttons .range-free', (event) ->
				#$.cookie('pgweb_trends_period_'+$.cookie('pgweb_idHash'), 'free', { expires: 1000, path: '/' });
				$('#zoom-free-popup').popup 'open'
				$('#free-range-zoom-error-message').text ''
		$('body').off 'change', '.trends-page-range-buttons .range-six-months'
		$('body').on 'change', '.trends-page-range-buttons .range-six-months', (event) =>
			#if (howMuchData < 180) {
				#$.cookie('pgweb_trends_period_'+$.cookie('pgweb_idHash'), 'sixMonths', { expires: 1000, path: '/' });
				@loadChart()
			#}
			#else {
			#	pgweb.TrendsPage.setXAxisInterval(180);
			#}
		$('body').off 'change', '.trends-page-range-buttons .range-three-months'
		$('body').on 'change', '.trends-page-range-buttons .range-three-months', (event) =>
			#if (howMuchData < 90) {
				#$.cookie('pgweb_trends_period_'+$.cookie('pgweb_idHash'), 'threeMonths', { expires: 1000, path: '/' });
				@loadChart()
			#}
			#else {
			#	pgweb.TrendsPage.setXAxisInterval(90);
			#}
		$('body').off 'change', '.trends-page-range-buttons .range-one-month'
		$('body').on 'change', '.trends-page-range-buttons .range-one-month', (event) =>
			#if (howMuchData < 30) {
				#$.cookie('pgweb_trends_period_'+$.cookie('pgweb_idHash'), 'oneMonth', { expires: 1000, path: '/' });
				@loadChart()
			#}
			#else {
			#	pgweb.TrendsPage.setXAxisInterval(30);
			#}
		$('body').off 'change', '.trends-page-range-buttons .range-one-week'
		$('body').on 'change', '.trends-page-range-buttons .range-one-week', (event) =>
			#if (howMuchData < 7) {
				#$.cookie('pgweb_trends_period_'+$.cookie('pgweb_idHash'), 'oneWeek', { expires: 1000, path: '/' });
				@loadChart()
			#}
			#else {
			#	pgweb.TrendsPage.setXAxisInterval(7);
			#}
		$('body').off 'click', '.showTrendsPage #free-zoom-ok'
		$('body').on 'click', '.showTrendsPage #free-zoom-ok', (event) =>
			min = new Date($('[name=free-from]').val())
			max = new Date($('[name=free-to]').val())
			if min == "Invalid Date" or max == "Invalid Date"
				$('#free-range-zoom-error-message').text t.InvalidDate
			else
				@loadChart()
				$('#zoom-free-popup').popup 'close'
		$('body').off 'click', '.showTrendsPage #free-zoom-cancel'
		$('body').on 'click', '.showTrendsPage #free-zoom-cancel', (event) ->
			$('#zoom-free-popup').popup 'close'

		# Select Channel 1, DI, Timer...
		# Uses Ajax except for TDR QPG which uses another page.
		$('body').off 'change', '[name=what-curve]'
		$('body').on 'change', '[name=what-curve]', (event) =>
			overviewScaled = false
			what = $(event.target).val()
			if what.substring(0, 8) == 'chTdrQPG'
				url = '?action=showPulsPGOverview'
				url += '&networkId='+$.url().param().networkId
				url += '&moduleTypeId='+$.url().param().moduleTypeId
				url += '&moduleId='+$.url().param().moduleId
				channel = what.substr 8, 1
				url += '&channel='+channel
				wire = what.substr 10, 1
				url += '&wire='+wire
				$.mobile.changePage url, {reload: true}
				return
			@loadChart()

		for i in [1..8]
			$('body').off 'change', '.channel'+i+'-curve-button'
			$('body').on 'change', '.channel'+i+'-curve-button', (event) =>
				which = $(event.target).attr 'name'
				subWhich = $(event.target).val()
				if subWhich == 'overview'
					@switchToOverview 5, which
				else
					index = channelIndexMappings[subWhich]
					@switchCurve index, 5, pgweb.CurveChart.inst().channelSeriesColors[index], which

		for i in [1..8]
			$('body').off 'change', '.channelTdr'+i+'W1-curve-button'
			$('body').on 'change', '.channelTdr'+i+'W1-curve-button', (event) =>
				which = $(event.target).attr 'name'
				subWhich = $(event.target).val()
				index = channelTdrW1IndexMappings[subWhich]
				@switchCurve index, 6, pgweb.CurveChart.inst().channelTdrSeriesColors[index], which
			$('body').off 'change', '.channelTdr'+i+'W2-curve-button'
			$('body').on 'change', '.channelTdr'+i+'W2-curve-button', (event) =>
				which = $(event.target).attr 'name'
				subWhich = $(event.target).val()
				index = channelTdrW2IndexMappings['subWhich']
				@switchCurve index, 6, pgweb.CurveChart.inst().channelTdrSeriesColors[index], which

		$('body').off 'change', '.volt-overview-curve-button'
		$('body').on 'change', '.volt-overview-curve-button', (event) =>
			which = $(event.target).attr 'name'
			@switchToOverview 2, which

		$('body').off 'change', '.batt-curve-button'
		$('body').on 'change', '.batt-curve-button', (event) =>
			which = $(event.target).attr 'name'
			subWhich = $(event.target).val()
			index = 0
			@switchCurve index, 2, pgweb.CurveChart.inst().standardSeriesColors[index], which

		$('body').off 'change', '.mainSupplyVolt-curve-button'
		$('body').on 'change', '.mainSupplyVolt-curve-button', (event) =>
			which = $(event.target).attr 'name'
			subWhich = $(event.target).val()
			index = 1
			@switchCurve index, 2, pgweb.CurveChart.inst().standardSeriesColors[index], which

		$('body').off 'change', '.an-curve-button'
		$('body').on 'change', '.an-curve-button', (event) =>
			which = $(event.target).attr 'name'
			subWhich = $(event.target).val()
			index = lastNum(subWhich) - 1
			seriesColors = pgweb.CurveChart.inst().standardSeriesColors
			if moduleTypeName == 'smbasicPG'
				if subWhich.startsWith 'mic'
					index += 1
				if lastNum(subWhich) == 2
					index += 1
				seriesColors = pgweb.CurveChart.inst().smbasicANSeriesColors
			else if moduleTypeName == 'cc58'
				index = @getExtraANIndexCC58 subWhich, index
			@switchCurve index, 8, seriesColors[index], which

		$('body').off 'change', '.rtd-curve-button'
		$('body').on 'change', '.rtd-curve-button', (event) =>
			which = $(event.target).attr 'name'
			subWhich = $(event.target).val()
			index = lastNum(subWhich) - 1
			seriesColors = pgweb.CurveChart.inst().standardSeriesColors
			@switchCurve index, 10, seriesColors[index], which

		$('body').off 'change', '.av-curve-button'
		$('body').on 'change', '.av-curve-button', (event) =>
			which = $(event.target).attr 'name'
			subWhich = $(event.target).val()
			av = lastNum subWhich
			index = lastNum($('[class^="av-curve-button av'+av+'-curve-button av-index"]').attr 'class')
			@switchCurve index, 8, pgweb.CurveChart.inst().standardSeriesColors[index], which

		$('body').off 'change', '.di-curve-button'
		$('body').on 'change', '.di-curve-button', (event) =>
			which = $(event.target).attr 'name'
			subWhich = $(event.target).val()
			index = lastNum(subWhich) - 1
			@switchCurve index, 16, pgweb.CurveChart.inst().standardSeriesColors[index], which

		$('body').off 'change', '.do-curve-button'
		$('body').on 'change', '.do-curve-button', (event) =>
			which = $(event.target).attr 'name'
			subWhich = $(event.target).val()
			index = lastNum(subWhich) - 1
			@switchCurve index, 8, pgweb.CurveChart.inst().standardSeriesColors[index], which

		$('body').off 'change', '.dv-curve-button'
		$('body').on 'change', '.dv-curve-button', (event) =>
			which = $(event.target).attr 'name'
			subWhich = $(event.target).val()
			dv = lastNum subWhich
			index = lastNum($('[class^="dv-curve-button dv'+dv+'-curve-button dv-index"]').attr 'class')
			@switchCurve index, 8, pgweb.CurveChart.inst().standardSeriesColors[index], which

		$('body').off 'change', '.dout-curve-button'
		$('body').on 'change', '.dout-curve-button', (event) =>
			which = $(event.target).attr 'name'
			subWhich = $(event.target).val()
			index = lastNum(subWhich) - 1
			@switchCurve index, 8, pgweb.CurveChart.inst().standardSeriesColors[index], which

		$('body').off 'change', '.admFlowCore-curve-button'
		$('body').on 'change', '.admFlowCore-curve-button', (event) =>
			which = $(event.target).attr 'name'
			subWhich = $(event.target).val()
			index = admflowIndexMappings[subWhich.camelToSnake()]
			@switchCurve index, 12, pgweb.CurveChart.inst().admFlowSeriesColors[index], which

		$('body').off 'change', '#show-every-point'
		$('body').on 'change', '#show-every-point', (event) =>
			@loadChart()

		$('body').off 'click', '#y-zoom-upper-increase-button'
		$('body').on 'click', '#y-zoom-upper-increase-button', (event) =>
			return if upperYZoom == -5
			upperYZoom -= 1
			@setYExtremes()
			trendsChartObj.redraw()
			if upperYZoom == -5
				$('#y-zoom-upper-increase-button').addClass 'ui-disabled'
			if upperYZoom == 4
				$('#y-zoom-upper-decrease-button').removeClass 'ui-disabled'

		$('body').off 'click', '#y-zoom-upper-decrease-button'
		$('body').on 'click', '#y-zoom-upper-decrease-button', (event) =>
			return if upperYZoom == 5
			upperYZoom += 1
			@setYExtremes()
			trendsChartObj.redraw()
			if upperYZoom == 5
				$('#y-zoom-upper-decrease-button').addClass 'ui-disabled'
			if upperYZoom == -4
				$('#y-zoom-upper-increase-button').removeClass 'ui-disabled'

		$('body').off 'click', '#y-zoom-lower-increase-button'
		$('body').on 'click', '#y-zoom-lower-increase-button', (event) =>
			return if lowerYZoom == -5
			lowerYZoom -= 1
			@setYExtremes()
			trendsChartObj.redraw()
			if lowerYZoom == -5
				$('#y-zoom-lower-increase-button').addClass 'ui-disabled'
			if lowerYZoom == 4
				$('#y-zoom-lower-decrease-button').removeClass 'ui-disabled'

		$('body').off 'click', '#y-zoom-lower-decrease-button'
		$('body').on 'click', '#y-zoom-lower-decrease-button', (event) =>
			return if lowerYZoom == 5
			lowerYZoom += 1
			@setYExtremes()
			trendsChartObj.redraw()
			if lowerYZoom == 5
				$('#y-zoom-lower-decrease-button').addClass 'ui-disabled'
			if lowerYZoom == -4
				$('#y-zoom-lower-increase-button').removeClass 'ui-disabled'
		
		$('body').off 'change', '.mic-limit'
		$('body').on 'change', '.mic-limit', (event) ->
			curveIndex = event.target.id[3] - 1
			selectedCurveIndex = lastNum($('[name=an]:checked').val()) - 1
			#if curveIndex == selectedCurveIndex
			axisColor = pgweb.CurveChart.inst().smbasicANSeriesColors[selectedCurveIndex]
			@updateYAxis axisColor, true
			#}
			moduleId = $.url().param().moduleId
			micNumber = curveIndex + 1
			val = $('#mic'+micNumber+'-limit').val()
			$.ajax
				url: '/pgweb/ajax/smbasicpg/updateMicNormalValue.php'
				dataType: 'json'
				type: 'POST'
				data:
					moduleId: moduleId
					micNumber: micNumber
					value: val
				success: (data) ->
					if data.result == "OK"
					else if data.result == 'NOT_LOGGED_IN'
						handleInactivity()
					else
						alert 'Saving normal value failed. '+data.debug
				error: ajaxFailure
				complete: ->
					waitStop()

		$('body').off 'change', '.mic-filter'
		$('body').on 'change', '.mic-filter', (event) ->
			curveIndex = event.target.id[3] - 1
			moduleId = $.url().param().moduleId
			micNumber = curveIndex + 1
			micMean = $('#mic'+micNumber+'-filter').val()
			$.ajax
				url: "/pgweb/ajax/smbasicpg/updateMicFilterLevel.php"
				dataType: 'json'
				type: 'POST'
				data:
					moduleId: moduleId
					micNumber: micNumber
					value: micMean
				success: (data) ->
					if (data.result == "OK")
						# nop
					else if data.result == 'NOT_LOGGED_IN'
						handleInactivity()
					else
						alert 'Saving filter failed. '+data.debug
				error: ajaxFailure
				complete: ->
					waitStop()
			@computeAverage micMean, curveIndex + 2
			trendsChartObj.redraw()
		
		$('body').off 'click', '#x-zoom-reset-button'
		$('body').on 'click', '#x-zoom-reset-button', (event) =>
			period = $('[name=range]:checked').val()
			days = periods[period]
			if days == 0
				minmax = pgweb.TrendsPage.getMinMax days
				min = minmax[0]
				max = minmax[1]
				from = dateTimeToJSTime min
				to = dateTimeToJSTime max
				trendsChartObj.xAxis[0].setExtremes from, to
			else
				setXAxisInterval days
			pgweb.TrendsPage.showZoomXResetButton false

		pgweb.TrendsPage.showZoomXResetButton false
	
	setXAxisInterval = (days) ->
		minXLocal = getMinXFromDays days, timezone.offset
		maxXLocal = getMaxXFromDays days, timezone.offset
		minXLocal = dateTimeToJSTime minXLocal
		maxXLocal = dateTimeToJSTime maxXLocal
		trendsChartObj.xAxis[0].setExtremes minXLocal, maxXLocal, true

	@showZoomXResetButton: (show) ->
		if show
			$('#x-zoom-reset-button').show()
			$('#drag-to-zoom-x-label').hide()
		else
			$('#x-zoom-reset-button').hide()
			$('#drag-to-zoom-x-label').show()
	
	@getMinMax: (days) ->
		if days == 0 # Free selection of start and end time.
			#dt = Globalize.parseDate(item.t);
			# Order of start date and end date does not matter.
			date1 = $('[name=free-from]').val()
			date2 = $('[name=free-to]').val()
			if date2 < date1
				dateTmp = date1
				date1 = date2
				date2 = dateTmp
			min = new Date date1+" 00:00:00.000"
			max = new Date date2+" 23:59:59.999"
			if min=='Invalid Date'
				now = new Date()
				dateStr = now.toISOString().substr 0, 10
				min = new Date dateStr+" 00:00:00.000"
				$('[name=free-from]').val dateStr
			if max=='Invalid Date'
				now = new Date()
				dateStr = now.toISOString().substr 0, 10
				max = new Date dateStr+" 23:59:59.999"
				$('[name=free-to]').val dateStr
			min = new Date(min.getTime() - min.getTimezoneOffset()*60000)
			max = new Date(max.getTime() - max.getTimezoneOffset()*60000)
		else
			min = getMinXFromDays days, timezone.offset
			max = getMaxXFromDays days, timezone.offset
		[min, max]

	getExtraANIndexCC58: (subWhich, index) ->
		if pgweb.TrendsPage.hasOptionCard()
			index = {'an1': 0, 'an2': 1, 'an3': 2, 'temp2': 3, 'temp3': 4, 'temp': 5, 'humidity': 6, 'temp1w': 7}[subWhich]
		else
			index = {'an1': 0, 'temp': 1, 'humidity': 2, 'temp1w': 3}[subWhich]
		index

$(document).on 'pagecreate', '.showTrendsPage', (event) ->
	pgweb.TrendsPage.inst().init()
class pgweb.PowerPoleMap
	instance = null
	marker = null
	map = null
	
	constructor: ->
		createMap()
		#map.invalidateSize()

	@inst: ->
		if not instance?
			instance = new @
		instance

	ensureNoMap = ->
		if map
			map.remove()
			map = undefined

	createMap = ->
		ensureNoMap()
		
		hasCoords = if $('#gisLatitude').val() then true else false
		lat = if $('#gisLatitude').val() then $('#gisLatitude').val().replace ',', '.' else 60
		lng = if $('#gisLongitude').val() then $('#gisLongitude').val().replace ',', '.' else 15
		
		if hasCoords then zoom = 13 else zoom = 3
		
		map = L.map('powerpole-map',
			zoomAnimationThreshold: 17
			attributionControl: false
		).setView [lat, lng], zoom
		attribution = ''
		config =
			attribution: attribution
			maxZoom: 21
			maxNativeZoom: 19

		marker = new L.marker([lat, lng])
		map.addLayer marker
		map.setView [lat ,lng]

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', config).addTo map

$(document).on 'pageshow', '.showPowerPolePage', (event) ->
	pgweb.PowerPoleMap.inst()
class pgweb.AlarmProfileDialog
	@moveAlarmReceiverFromButtonToSearchList: (receiver, button) ->
		sendMethod = new pgweb.SendMethod 'value': receiver.send_method
		sendMethodTranslated = t['AlarmProfile_SendMethod_'+sendMethod.toString()]
		pgwebData = button.attr 'pgweb-data'
		li = $('<li></li>')
			.append receiver.name+' ('+sendMethodTranslated+')'
			.attr 'pgweb-data': pgwebData
			.attr 'data-filtertext': receiver.name+' '+receiver[sendMethod.toColumn()]
			.addClass 'ui-screen-hidden'
		$('#alarm-profile-receivers-searchbox').append li
		$('#alarm-profile-receivers-searchbox').listview 'refresh'
		button.closest('.ui-btn').hide 'slow', ->
			button.remove()

	@moveAlarmReceiverFromSearchListToButton: (receiver) ->
		sendMethod = new pgweb.SendMethod {'value': receiver.send_method}
		sendMethodTranslated = t['AlarmProfile_SendMethod_'+sendMethod.toString()]
		button = $('<input type="submit"></input>')
			.attr {'value': receiver.name+' ('+sendMethodTranslated+')'}
			.attr 'data-mini': false
			.attr 'data-icon': 'delete'
			.attr 'data-iconpos': 'right'
			.attr 'data-iconshadow': false
			.addClass 'receiver-button'
			.attr 'pgweb-data': escapePgwebData(JSON.stringify receiver)
		$('#alarm-profile-receivers').append button
		# Remove from searchbox list.
		$('#alarm-profile-receivers-searchbox li').each (index, li) ->
			obj = $.parseJSON unescapePgwebData($(li).attr 'pgweb-data')
			if obj.user_id
				if obj.user_id == receiver.user_id and obj.send_method == receiver.send_method
					$(li).remove()
			if obj.mt_write_receiver_id
				if obj.mt_write_receiver_id == receiver.mt_write_receiver_id and obj.send_method == receiver.send_method
					$(li).remove()
		button.button()
		button.parent().hide()
		button.parent().show duration: 200

	@saveAlarmProfile: ->
		receivers = new Array()
		$('#alarm-profile-receivers input[type=submit]').each (index, button) ->
			receiverData = $.parseJSON unescapePgwebData $(this).attr 'pgweb-data'
			receiver = new AlarmReceiver receiverData
			receivers.push receiver
		alarmProfile = new AlarmProfile
			id: $('[name=id]').first().val()
			network_id: $('[name=networkId]').first().val()
			number: $('[name=number]').first().val()
			color_index: $('[name=color_index]:checked').val()
			name: $('[name=name]').first().val()
			active: $('[name=active]').val() == "on"
			on_alarm: $('[name=on_alarm]:checked').val() == "on"
			on_return: $('[name=on_return]:checked').val() == "on"
			period: $('[name=period]').first().val()
			buffer: $('[name=buffer]:checked').val() == "on"
			receivers: receivers
		errStr = ''
		if (alarmProfile.name.length == 0)
			errStr += t.AlarmProfile_MissingName+'<br/>'
		if not (/^([-+]?\([1-7](-[1-7])?, *[0-2]?\d-[0-2]?\d\))*$/.test(alarmProfile.period) or
				/^[1-7](-[1-7])?, *[0-2]?\d-[0-2]?\d$/.test(alarmProfile.period) or
				alarmProfile.period.length == 0)
			errStr += t.AlarmProfile_InvalidPeriod+'<br/>'
		if errStr
			$('#alarm-profile-save-error-message').html errStr
			return false
		waitStart()
		$.ajax
			url: "/pgweb/ajax/alarm/saveAlarmProfile.php"
			dataType: 'json'
			type: 'POST'
			data:
				alarmProfile: alarmProfile
				isNew: $('#alarm-profile-edit-popup').data 'isNew'
			success: (data) ->
				if data.result == "OK"
					$('#alarm-profile-edit-popup').popup 'close'
					$('#alarm-profile-edit-popup').one 'popupafterclose', ->
						$.mobile.changePage "", reloadPage: true
				else if data.result == "DUPLICATE_NAME"
					$('#alarm-profile-save-error-message').html t.AlarmProfile_DuplicateName
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Saving alarm profile failed: "+data.debug
			error: ajaxFailure
			complete: waitStop

	@removeAlarmProfile: ->
		if not confirm 'Please confirm removal of this alarm profile.' then return
		alarmProfileId = $('[name=id]').first().val()
		waitStart()
		$.ajax
			url: "/pgweb/ajax/alarm/removeAlarmProfile.php"
			dataType: 'json'
			type: 'POST'
			data:
				id: alarmProfileId
			success: (data) ->
				if data.result == "OK"
					$('#alarm-profile-edit-popup').popup 'close'
					$('#alarm-profile-edit-popup').one 'popupafterclose', ->
						$.mobile.changePage "", reloadPage: true
				else
					alert "Saving alarm profile failed: "+data.debug
			error: ajaxFailure
			complete: waitStop
	
	@init: ->
		# Click on New button to add a new profile. Profile edit popup opens.
		$('body').on 'click', '#alarm-profile-new-button', (event) ->
			waitStart()
			# Mark popup as being used for adding a new profile.
			$('#alarm-profile-edit-popup').data 'isNew', true
			# Don't show Remove button.
			$('.user-save-alarm-profile-remove-button').hide()
			$('#alarm-profile-edit-popup h1').html t.AlarmProfile_NewAlarmProfile
			# Open the popup.
			$('#alarm-profile-edit-popup').popup 'open', transition: 'pop'

		# Click on an edit button to edit an existing profile.
		$('body').on 'click', '.alarm-profile-edit-button', (event) ->
			waitStart()
			escapedJsonData = $(this).closest('tr').attr 'pgweb-data'
			alarmProfileData = $.parseJSON(unescapePgwebData escapedJsonData)
			alarmProfile = new AlarmProfile alarmProfileData
			$('#alarm-profile-edit-popup').data 'alarmProfile', alarmProfile
			$('#alarm-profile-edit-popup').popup 'open', transition: 'pop'
		
		# Profile edit popup opened.
		$('body').on 'popupafteropen', '#alarm-profile-edit-popup', (event, ui) =>
			popup = $(event.currentTarget)
			# No clear button in search field.
			$('.showAlarmProfilePage .ui-input-search .ui-input-clear').remove()
			
			if popup.data 'isNew'
				# Press first color button.
				$('#color-index-1').prop('checked', true).checkboxradio 'refresh'
			else
				alarmProfile = popup.data 'alarmProfile'
				popup.find('[name=id]').val alarmProfile.id
				popup.find('[name=name]').val alarmProfile.name
				$('#alarm-profile-edit-popup-name-box h2').html alarmProfile.getNameWithNumber()
				$('[name=color_index]').prop 'checked', false
				$('#color-index-'+alarmProfile.color_index).prop 'checked', true
				$('[name=color_index]').checkboxradio 'refresh'
				if alarmProfile.active
					popup.find('[name=active] option[value=on]').prop 'selected', true
				else
					popup.find('[name=active] option[value=off]').prop 'selected', true
				popup.find('[name=active]').slider 'refresh'
				popup.find('[name=on_alarm]').prop('checked', alarmProfile.on_alarm).checkboxradio 'refresh'
				popup.find('[name=on_return]').prop('checked', alarmProfile.on_return).checkboxradio 'refresh'
				popup.find('[name=period]').val alarmProfile.period
				popup.find('[name=buffer]').prop('checked', alarmProfile.buffer).checkboxradio 'refresh'
				for receiver in alarmProfile.receivers
					# Add receiver (button).
					@moveAlarmReceiverFromSearchListToButton receiver
			waitStop()
		
		# Profile edit popup closed.
		$('body').on 'popupafterclose', '#alarm-profile-edit-popup', (event, ui) =>
			# Assume that popup will open for edit of existing profile.
			$(this).data 'isNew', false
			# Hide Remove button.
			$('.user-save-alarm-profile-remove-button').show()
			$(this).find('h1').html t.AlarmProfile_EditAlarmProfile
			# Clear fields.
			$(this).find('[name=name]').val ''
			$('#alarm-profile-edit-popup-name-box h2').html ''
			$('[name=color_index]').prop('checked', false).checkboxradio 'refresh'
			$(this).find('[name=active] option[value=on]').prop 'selected', false
			$(this).find('[name=active]').slider 'refresh'
			$(this).find('[name=on_alarm]').prop('checked', false).checkboxradio 'refresh'
			$(this).find('[name=on_return]').prop('checked', false).checkboxradio 'refresh'
			$(this).find('[name=period]').val ''
			$(this).find('[name=buffer]').prop('checked', false).checkboxradio 'refresh'
			
			$('#alarm-profile-receivers input[type="submit"]').each (index, button) =>
				alarmReceiver = new AlarmReceiver $.parseJSON unescapePgwebData $(button).attr 'pgweb-data'
				@moveAlarmReceiverFromButtonToSearchList alarmReceiver, $(button)

		$('body').on 'click', '#alarm-profile-receivers-searchbox li', (event) => 
			# Add one receiver (button).
			escapedJsonData = $(event.currentTarget).attr 'pgweb-data'
			receiverData = $.parseJSON unescapePgwebData escapedJsonData
			receiver = new AlarmReceiver receiverData
			@moveAlarmReceiverFromSearchListToButton receiver
			# Clear search field.
			$('.showAlarmProfilePage .ui-input-search input').val ''
			# Remove clear button.
			$('.showAlarmProfilePage .ui-input-search .ui-input-clear').remove()
			# Hide list items.
			$('#alarm-profile-receivers-searchbox li').addClass 'ui-screen-hidden'
			# Focus search field.
			$('.showAlarmProfilePage .ui-input-search input').focus()
		
		# In profile edit popup, click on a receiver to remove it.
		$('body').on 'click', '.receiver-button', (event) =>
			receiver = new AlarmReceiver $.parseJSON unescapePgwebData $(event.currentTarget).attr 'pgweb-data'
			@moveAlarmReceiverFromButtonToSearchList receiver, $(event.currentTarget)

		# Click on Save button to save a profile.
		$('body').on 'click', '.user-save-alarm-profile-button', =>
			@saveAlarmProfile()

		# Click on Remove button to remove a profile.
		$('body').on 'click', '.user-save-alarm-profile-remove-button', =>
			@removeAlarmProfile()
		
		pgweb.HelpDialog.register 'alarm-profile-period-help', 'alarm-profile-period-help-button'

pgweb.AlarmProfileDialog.init()
class pgweb.SendMethod
	value: 0
	string: ''
	strings: ['info_email', 'alarm_email', 'sms', 'mt_write']
	values:
		'info_email': 0
		'alarm_email': 1
		'sms': 2
		'mt_write': 3
	columns: ['info_email', 'alarm_email', 'tel', 'mt_write']

	constructor: (options) ->
		$.extend @, options
		if not options.string
			@string = @toString()
		if not options.value
			@value = @toValue()
	
	toString: -> @strings[@value]

	toValue: ->
		@values[@string]

	toColumn: -> @columns[@value]
class pgweb.AlarmSettingsDialog

	@moveAlarmSettingProfileFromButtonToSearchList: (settingProfile, button) =>
		pgwebData = button.attr 'pgweb-data'
		ap = new AlarmProfile
			number: settingProfile.alarm_profile_number
			color_index: settingProfile.alarm_profile_color_index
			name: settingProfile.alarm_profile_name
			active: settingProfile.alarm_profile_active
		li = $('<li></li>')
			.append ap.getNameWithNumber()
			.attr 'pgweb-data': pgwebData
			.attr 'data-filtertext': settingProfile.alarm_profile_number+' '+settingProfile.alarm_profile_name
			.addClass 'ui-screen-hidden'
		$('#alarm-settings-profiles-searchbox').append li
		$('#alarm-settings-profiles-searchbox').listview 'refresh'
		
		button.closest('.ui-btn').hide 'slow', -> button.remove()

	@moveAlarmSettingProfileFromSearchListToButton: (settingProfile) =>
		ap = new AlarmProfile
			number: settingProfile.alarm_profile_number
			color_index: settingProfile.alarm_profile_color_index
			name: settingProfile.alarm_profile_name
			active: settingProfile.alarm_profile_active
		button = $('<input type="submit"></input>')
			.attr 'value': ap.getNameWithNumber()
			.attr 'data-mini': false
			.attr 'data-icon': 'delete'
			.attr 'data-iconpos': 'right'
			.attr 'data-iconshadow': false
			.addClass 'alarm-setting-profile-button'
			.attr 'pgweb-data': escapePgwebData JSON.stringify settingProfile
		$('#alarm-settings-profiles').append button
		# Remove from searchbox list.
		$('#alarm-settings-profiles-searchbox li').each (index, li) ->
			settingProfileInList = $.parseJSON unescapePgwebData $(li).attr('pgweb-data')
			if settingProfileInList.alarm_profile_id == settingProfile.alarm_profile_id
				$(li).remove()
		button.button()
		button.parent().hide()
		button.parent().show duration: 200

	@saveSettings: =>
		alarmSetting = $('#alarm-settings-edit-popup').data 'alarmSetting'
		alarmSetting.alarmSettingProfiles = new Array()
		alarmSetting.delay = 0
		$('#alarm-settings-profiles input[type=submit]').each (index, button) ->
			settingProfileData = $.parseJSON unescapePgwebData $(this).attr 'pgweb-data'
			settingProfile = new AlarmSettingProfile settingProfileData
			alarmSetting.alarmSettingProfiles.push settingProfile
		alarmSetting.override_template_alarm_profiles = $('[name=override_template_alarm_profiles]:checked').val() == "on"
		errStr = ''
		if errStr
			$('#alarm-settings-save-error-message').html errStr
			return false
		waitStart()
		$.ajax
			url: "/pgweb/ajax/alarm/saveAlarmSetting.php"
			dataType: 'json'
			type: 'POST'
			data:
				alarmSetting: alarmSetting
				moduleTypeId: $('[name=module_type_id]').val()
			success: (data) ->
				if data.result == "OK"
					$('#alarm-settings-edit-popup').popup 'close'
					$('#alarm-settings-edit-popup').one 'popupafterclose', ->
						$.mobile.changePage "", reloadPage: true
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Saving alarm settings failed: "+data.debug
			error: ajaxFailure
			complete: waitStop

	@tagMeaningNameToTranslatedString: (tagMeaningName, moduleTypeName) =>
		simpleTagName = tagMeaningName
		channel = ''
		if /^L\d/.test tagMeaningName then channel = tagMeaningName.substr 1,1
		if /LoopRes$/.test tagMeaningName then simpleTagName = 'LoopRes'
		if /AcRes$/.test tagMeaningName then simpleTagName = 'AcRes'
		if /GalvVolt$/.test tagMeaningName then simpleTagName = 'GalvVolt'
		if /QPG$/.test tagMeaningName then simpleTagName = 'QPG'
		if /DI\d$/.test tagMeaningName then simpleTagName = 'DI'
		if /DO\d$/.test tagMeaningName then simpleTagName = 'DO'
		if /DV\d$/.test tagMeaningName then simpleTagName = 'DV'
		if /AN\d$/.test tagMeaningName
			if moduleTypeName == 'smbasicPG'
				simpleTagName = 'MIC'
			else
				simpleTagName = 'AN'
			if moduleTypeName == 'cc58'
				simpleTagName = 'ANCC58'
		if /AV\d$/.test tagMeaningName then simpleTagName = 'AV'
		if /RTD\d+$/.test tagMeaningName then simpleTagName = 'RTD'
		if /L\dW\dTDRDamage$/.test tagMeaningName then simpleTagName = 'TDRDamage'
		if /L\dW\dTDRIndication$/.test tagMeaningName then simpleTagName = 'TDRIndication'
		if /^DOut\d$/.test tagMeaningName then simpleTagName = 'DOut'
		if moduleTypeName == 'cc58'
			if tagMeaningName == 'Humidity'
				simpleTagName = 'HumidityCC58'
			if tagMeaningName == 'Batt'
				simpleTagName = 'BattCC58'
			if tagMeaningName == 'CSQ'
				simpleTagName = 'CSQCC58'
			if tagMeaningName == 'Temp2'
				simpleTagName = 'Temp2CC58'
			if tagMeaningName == 'Temp3'
				simpleTagName = 'Temp3CC58'
		transl = ''
		if channel.length > 0
			transl = t.Channel+' '+channel+', '
		transl += t['AlarmSettings_Tag'+simpleTagName]
		if simpleTagName in ['DI', 'DO', 'DV', 'AN', 'ANCC58', 'AV', 'MIC', 'DOut', 'RTD']
			transl += lastNum(tagMeaningName)
		transl

	@init: =>
		# Click on an edit button to edit an existing setting.
		$('body').on 'click', '.alarm-settings-edit-button', (e) =>
			waitStart()
			escapedJsonData = $(e.currentTarget).attr 'pgweb-data'
			alarmSettingData = $.parseJSON unescapePgwebData escapedJsonData
			alarmSetting = new AlarmSetting alarmSettingData
			$('#alarm-settings-edit-popup').data 'alarmSetting', alarmSetting
			# I have no clue why setTimeout is needed here! 0 ms!!
			window.setTimeout ->
				$('#alarm-settings-edit-popup').popup 'open', transition: 'pop'
			, 0

		# Alarm settings edit popup opened.
		$('body').on 'popupafteropen', '#alarm-settings-edit-popup', (e, ui) =>
			# No clear button in search field.
			$('#alarm-settings-edit-popup .ui-input-search .ui-input-clear').remove()
			
			alarmSetting = $(e.currentTarget).data 'alarmSetting'
			title = @tagMeaningNameToTranslatedString alarmSetting.tag_meaning_name, alarmSetting.moduleTypeName
				
			lt = new AlarmLimitType value: alarmSetting.limit_type
			title += ' ' + lt.toSymbol()
			$(e.currentTarget).find('h2').html title
			
			$('#override-template-alarm-profiles-checkbox').prop('checked', alarmSetting.override_template_alarm_profiles).checkboxradio 'refresh'
			if alarmSetting.override_template_alarm_profiles or $('#is-template').val()
				$('#alarm-settings-profiles-searchbox-and-list').show 'fast'
			else
				$('#alarm-settings-profiles-searchbox-and-list').hide 'fast'
			
			for alarmSettingProfile in alarmSetting.alarmSettingProfiles
				# Add alarmSettingProfile (button).
				@moveAlarmSettingProfileFromSearchListToButton alarmSettingProfile
			waitStop()
		
		# Alarm settings edit popup closed.
		$('body').on 'popupafterclose', '#alarm-settings-edit-popup', (e, ui) =>
			$(e.currentTarget).find('h2').html '&nbsp'
			$('#override-template-alarm-profiles-checkbox').prop('checked', false).checkboxradio 'refresh'
			$('#alarm-settings-profiles-searchbox-and-list').hide()
			# Clear fields and move all buttons to search list.
			$('#alarm-settings-profiles input[type=submit]').each (index, button) =>
				alarmSettingProfile = new AlarmSettingProfile $.parseJSON unescapePgwebData $(button).attr 'pgweb-data'
				@moveAlarmSettingProfileFromButtonToSearchList alarmSettingProfile, $(button)

		# Searchbox item clicked.
		$('body').on 'click', '#alarm-settings-profiles-searchbox li', (e) =>
			# Add one setting profile (button).
			escapedJsonData = $(e.currentTarget).attr 'pgweb-data'
			settingProfileData = $.parseJSON unescapePgwebData escapedJsonData
			settingProfile = new AlarmSettingProfile settingProfileData
			@moveAlarmSettingProfileFromSearchListToButton settingProfile
			# Clear search field.
			$('#alarm-settings-edit-popup .ui-input-search input').val ''
			# Remove clear button.
			$('#alarm-settings-edit-popup .ui-input-search .ui-input-clear').remove()
			# Hide list items.
			$('#alarm-settings-profiles-searchbox li').addClass 'ui-screen-hidden'
			# Focus search field.
			$('#alarm-settings-edit-popup .ui-input-search input').focus()
		
		# In alarm settings edit popup, click on a profile to remove it.
		$('body').on 'click', '.alarm-setting-profile-button', (e) =>
			button = $(e.currentTarget)
			settingProfile = new AlarmSettingProfile $.parseJSON unescapePgwebData button.attr 'pgweb-data'
			@moveAlarmSettingProfileFromButtonToSearchList settingProfile, button

		# Click on Save button to save a profile.
		$('body').on 'click', '.user-save-alarm-settings-button', =>
			@saveSettings()
		
		$('body').on 'change', '#override-template-alarm-profiles-checkbox', (e) =>
			if $(e.currentTarget).prop 'checked'
				$('#alarm-settings-profiles-searchbox-and-list').show 'fast'
			else
				$('#alarm-settings-profiles-searchbox-and-list').hide 'fast'
		
		$('body').on 'change', '.alarm-settings-template-module-type', (e) ->
			params = $.url().param()
			params.moduleTypeId = $(e.currentTarget).val()
			$.mobile.changePage '?'+$.param(params), reloadPage: true

pgweb.AlarmSettingsDialog.init()
class pgweb.AlarmsPage

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	constructor: ->

	init: ->
		$('body').off 'click', '.alarm-row'
		$('body').on 'click', '.alarm-row', (event) ->
			tr = $(event.target).closest('tr')[0]
			alarmId = tr.id
			if $(tr).hasClass('alarm-row-unacked') or $(tr).hasClass('alarm-row-unacked_rtn')
				$(tr).toggleClass 'alarm-row-selected'
			if isReader
				return
			enableAckButton = false
			$('.alarm-row').each (index, element) ->
				if $(element).hasClass 'alarm-row-selected'
					enableAckButton = true

			# Bug in JQuery Mobile 1.4.5, should be .button('disable')
			# instead of adding/removing class ui-disabled.
			if enableAckButton
				$('.ack-button').removeClass 'ui-disabled'
			else
				$('.ack-button').addClass 'ui-disabled'
		
		$('body').off 'click', '.ack-button'
		$('body').on 'click', '.ack-button', (event) =>
			@userAckAlarm()

	userAckAlarm: ->
		alarmIds = []
		$('.alarm-table tr').each (index, element) ->
			if index == 0
				return
			if $(element).hasClass 'alarm-row-selected'
				alarmId = element.id.substring 5
				alarmIds.push alarmId

		waitStart()
		$.ajax
			url: '/pgweb/ajax/alarm/ackAlarm.php'
			dataType: 'json'
			type: 'POST'
			data:
				alarmIds: alarmIds
			success: (data) ->
				if data.result == 'OK'
					$.mobile.changePage '', {reloadPage: true}
				else if data.result == 'NO DATA'
					# Do nothing.
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Alarm ack failed: "+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()

$(document).on 'pagecreate', '.showAlarmsPage', (event) ->
	pgweb.AlarmsPage.inst().init()
class pgweb.TableFilterBehaviour
	
	instance = null
	_table = null

	_keyupCallBack = -> {}
	_switchOnFilterCallBack = -> {}
	_switchOffFilterCallBack = -> {}
	
	constructor: (table) ->
		_table = table
		
		$('body').off 'click', '.table-header-filter, .table-header-filter *'
		$('body').on 'click', '.table-header-filter, .table-header-filter *', (event) ->
			headerFilter = $(@).closest '.table-header-filter'
			if headerFilter.context.className != 'table-header-filter' then return
			if $(event.target).context.localName == 'input' then return
			clickedElem = headerFilter
			$('.table-header-filter').each ->
				if $(@).attr('id') == clickedElem.attr 'id'
					$(@).find('.table-header-filter-input').toggle()
				else $(@).find('.table-header-filter-input').hide()
			if headerFilter.find('.table-header-filter-input:visible').length > 0
				textToInput headerFilter
				focusFilterInput headerFilter
			else
				value = inputValue headerFilter
				inputToText headerFilter

		$('body').off 'keyup', '.table-header-filter-input input'
		$('body').on 'keyup', '.table-header-filter-input input', (event) ->
			tableHeaderFilter = $(@).closest '.table-header-filter'
			if event.keyCode == 13
				leaveFilterInput tableHeaderFilter
			else
				inputToText tableHeaderFilter
			_table.runFilter()
			_keyupCallBack()

		$('body').off 'blur', '.table-header-filter-input input'
		$('body').on 'blur', '.table-header-filter-input input', (event) ->
			tableHeaderFilter = $(@).closest '.table-header-filter'
			leaveFilterInput tableHeaderFilter
		
		pgweb.HelpDialog.register('filter-help', 'filter-help-button');
		
		$('body').off 'change', '#filter-onoff'
		$('body').on 'change', '#filter-onoff', (event) ->
			filterOn = $(@).val() == 'on'
			if filterOn
				switchOnFilter()
				$('#filter-help-button').show 'fast'
			else
				switchOffFilter()
				$('#filter-help-button').hide 'fast'
				$('#filter-help').hide 'fast'

	setKeyupCallBack: (cb) -> _keyupCallBack = cb
	
	setSwitchOnFilterCallBack: (cb) -> _switchOnFilterCallBack = cb
	
	setSwitchOffFilterCallBack: (cb) -> _switchOffFilterCallBack = cb

	focusFilterInput = (filter) ->
		filter.find('.table-header-filter-input input').focus()

	leaveFilterInput = (filter) ->
		inputToText filter
		filter.find('.table-header-filter-input').hide()

	textToInput = (filter) ->
		value = (filterValue filter).replace('&lt;', '<').replace('&gt;', '>')
		filter.find('.table-header-filter-input input').val value
	
	inputToText = (filter) ->
		value = inputValue filter
		filter.find('.table-header-filter-value').html value.replace('<', '&lt;').replace('>', '&gt;')
	
	inputValue = (filter) ->
		filter.find('.table-header-filter-input input').val()
	
	filterValue = (filter) ->
		filter.find('.table-header-filter-value').html()

	switchOnFilter = ->
		_table.runFilter()
		$('#filter-header').show()
		_switchOnFilterCallBack()

	switchOffFilter = ->
		_table.runFilter()
		$('#filter-header').hide()
		_switchOffFilterCallBack()

	columnFilterIsOn: ->
		$('#filter-onoff').val() == 'on'

	filterColumnsOneRow: (tr) ->
		show = true
		$('.table-header-filter').each ->
			columnName = $(@).attr('id').substr 2
			cellContent = tr.find('.module-list-td-'+columnName+' .table-value').html()
			if cellContent
				cellContent = cellContent.trim()
			text = $(@).find('.table-header-filter-value').html()
			if text.length > 0
				if text == '=.'
					if cellContent != '-' and cellContent != ''
						show = false
				else if text == '!=.'
					if not (cellContent != '-' and cellContent != '')
						show = false
				else if text.substr(0, 8) == '&lt;&gt;' or text.substr(0, 2) == '!='
					if text.substr(0, 8) == '&lt;&gt;'
						l = 8
					if text.substr(0, 2) == '!='
						l = 2
					if text.length > l
						val = text.substr(l)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							if isNumeric(val)
								if not (parseFloat(commaToDot cellContent) != parseFloat(commaToDot val))
									show = false
							else
								if not (cellContent.toLowerCase() != val.toLowerCase())
									show = false
				else if text.substr(0, 5) == '&lt;='
					if text.length > 5
						val = text.substr(5)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							if isNumeric(val)
								if not (parseFloat(commaToDot cellContent) <= parseFloat(commaToDot val))
									show = false
							else
								if not (cellContent.toLowerCase() <= val.toLowerCase())
									show = false
				else if text.substr(0, 4) == '&lt;'
					if text.length > 4
						val = text.substr(4)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							if isNumeric(val)
								if not (parseFloat(commaToDot cellContent) < parseFloat(commaToDot val))
									show = false
							else
								if not (cellContent.toLowerCase() < val.toLowerCase())
									show = false
				else if text.substr(0, 5) == '&gt;='
					if text.length > 5
						val = text.substr(5)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							if isNumeric(val)
								if not (parseFloat(commaToDot cellContent) >= parseFloat(commaToDot val))
									show = false
							else
								if not (cellContent.toLowerCase() >= val.toLowerCase())
									show = false
				else if text.substr(0, 4) == '&gt;'
					if text.length > 4
						val = text.substr(4)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							if isNumeric(val)
								if not (parseFloat(commaToDot cellContent) > parseFloat(commaToDot val))
									show = false
							else
								if not (cellContent.toLowerCase() > val.toLowerCase())
									show = false
				else if text.substr(0, 1) == '='
					if text.length > 1
						val = text.substr(1)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							if isNumeric(val)
								if not (parseFloat(commaToDot cellContent) == parseFloat(commaToDot val))
									show = false
							else
								if not (cellContent.toLowerCase() == val.toLowerCase())
									show = false
				else if text.substr(0, 1) == '!'
					if text.length > 1
						val = text.substr(1)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							re = new RegExp(val, 'i')
							if re.test(cellContent)
								show = false
				else
					re = new RegExp(text, 'i')
					if !re.test(cellContent)
						show = false
		show

class pgweb.GetCoordsMap
	marker = null
	map = null
	mapId = null

	constructor: (_mapId) ->
		mapId = _mapId

		$('body').on 'change', '#'+mapId+'-button', =>
			showMap = $('#'+mapId+'-button').is ':checked'
			if showMap
				$('#'+mapId).show 300, ->
					createMap()
					map.invalidateSize()
			else
				$('#'+mapId).hide 300, ->
					ensureNoMap()

		$('body').on 'keyup', '#gisLatitude', =>
			updateCoords()

		$('body').on 'keyup', '#gisLongitude', =>
			updateCoords()

	ensureNoMap = ->
		if map
			map.remove()
			map = undefined

	createMap = ->
		ensureNoMap()

		normalm = L.tileLayer.baiduLayer 'Normal.Map'
		#satellitem = L.tileLayer.baiduLayer 'Satellite.Map'
		normal = L.layerGroup [normalm]
		
		projection = $('#projection').val()
		
		hasCoords = if $('#gisLatitude').val() then true else false
		
		# If there are no coordinates, show Europe.
		latDefault = 60
		lngDefault = 15
		
		lat = if $('#gisLatitude').val() then $('#gisLatitude').val().replace ',', '.' else latDefault
		lng = if $('#gisLongitude').val() then $('#gisLongitude').val().replace ',', '.' else lngDefault
		
		if hasCoords then zoom = 13 else zoom = 3

		if hasCoords and projection not in ['', 'wgs84']
			# Convert to wgs84
			[lat, lng] = xy2ll projection, lat, lng

		if USE_BAIDU_MAPS
			crs = L.CRS.Baidu # As defined in js/leaflet.baidu.
			[lat, lng] = CoordinateConvert.wgs84ToBd09 [lat, lng]
		else
			crs = L.CRS.EPSG3857 # Default CRS for Leaflet.

		map = L.map(mapId,
			crs: crs
			zoomAnimationThreshold: 17
			attributionControl: false
		).setView [lat, lng], zoom
		attribution = ''
		config =
			attribution: attribution
			maxZoom: 21
			maxNativeZoom: 19

		if hasCoords
			marker = new L.marker [lat, lng]
			map.addLayer marker

		if USE_BAIDU_MAPS
			map.addLayer(normal)
		else
			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', config).addTo map

		map.on 'click', (e) =>
			lat = e.latlng.lat
			lng = e.latlng.lng
			
			if USE_BAIDU_MAPS
				[lat, lng] = CoordinateConvert.bd09ToWgs84 [lat, lng]
			
			projection = $('#projection').val()
			nDec = 6
			if projection not in ['', 'wgs84']
				nDec = 3
				[lat, lng] = ll2xy projection, lat, lng
			
			$('#gisLatitude').val formatNumberNoThousands Math.round(lat*1000000)/1000000, 'n'+nDec
			$('#gisLongitude').val formatNumberNoThousands Math.round(lng*1000000)/1000000, 'n'+nDec
			
			if marker then map.removeLayer marker
			marker = new L.marker e.latlng
			map.addLayer marker

	updateCoords = ->
		lat = $('#gisLatitude').val().replace ',', '.'
		lng = $('#gisLongitude').val().replace ',', '.'
		if not map then return
		if marker then map.removeLayer marker
		if USE_BAIDU_MAPS
			[lat, lng] = CoordinateConvert.wgs84ToBd09 [lat, lng]
		marker = new L.marker([lat, lng])
		map.addLayer marker
		map.setView [lat ,lng]
class pgweb.Clock
	clock = null
	timezoneOffset = null
	networkTimezoneOffset = null
	
	@setClock: (time) ->
		clock = time
	
	@setTimezoneOffset: (offset) ->
		timezoneOffset = offset

	@setNetworkTimezoneOffset: (offset) ->
		networkTimezoneOffset = offset

	@setHeaderClock: ->
		data = @clockData timezoneOffset
		$('.clock').html '' # Don't know why this is needed!
		symbol = ''
		tzInfo = ''
		if @networkDiffers()
			symbol = '<i class="fa fa-user"></i> '
			tzInfo = ' ' + data.tzInfo
		$('.clock').html symbol + data.time + tzInfo

	@setNetworkHeaderClock: ->
		data = @clockData networkTimezoneOffset
		$('.networkClock').html '' # Don't know why this is needed!
		$('.networkClock').html '<i class="fa fa-sitemap"></i> ' + data.time + ' ' + data.tzInfo

	@clearNetworkHeaderClock: ->
		$('.networkClock').html ''

	@clockData: (offset) ->
		now = new Date clock*1000
		now = new Date now.getTime() + now.getTimezoneOffset()*60000 + offset*60000
		plusminus = if offset > 0 then '+' else (if offset == 0 then '±' else '')
		tzInfo = plusminus + pad(Math.floor(offset/60), 2) + pad(offset % 60, 2)
		{
			'time': Globalize.format(now, 'd') + ' '+Globalize.format(now, 'T')
			'tzInfo': 'UTC' + tzInfo
		}

	@networkDiffers: ->
		networkTimezoneOffset != '' and networkTimezoneOffset != timezoneOffset and $.url().param().networkId > 0

	@init: ->
		window.setInterval =>
			clock++
			@setHeaderClock()
			if @networkDiffers()
				@setNetworkHeaderClock()
		, 1000

$ ->
	if $('.clock').length > 0
		pgweb.Clock.init()
class pgweb.ExportToClipboard
	tableId = null

	@init: (tableId_) ->
		tableId = tableId_

		$('body').on 'click', '#clipboard-copy-button', ->
			onClipboardCopyButtonClick()

	onClipboardCopyButtonClick = ->
		title = $('[data-role=content] h1').text()
		text = title + '\n'
		userClock = $('.clock').text().trim()
		networkClock = $('.networkClock').text().trim()
		if networkClock
			text += '👤 '+userClock + '\n'
			text += '🖧 '+networkClock + '\n'
		else
			text += userClock + '\n\n'

		user = $('#user-button .button-text').text()
		text += user + '\n\n'

		if tableId != 'task-table'
			$("#title-header th").each (i, th) ->
				if $(th).is ':visible'
					text += clipboardCopyHeader th
		text = text.trim()+'\n'
		
		$("##{tableId} tbody tr").each (i, tr) ->
			if tableId == 'task-table'
				switch
					when $(tr).hasClass 'task-row'
						$(tr).find('td').each (j, td) ->
							if $(td).is ':visible'
								text += $(td).text().trim().replaceAll('\n', ' ') + '\t'
						text = text.trim() + '\n'
					when $(tr).hasClass 'sub-title'
						text += '\n' + $(tr).find('td').text() + '\n\n'
					when $(tr).hasClass 'sub-head'
						$(tr).find('th').each (j, th) ->
							if $(th).is ':visible'
								text += $(th).text() + '\t'
						text = text.trim() + '\n'
			else
				if $(@).is ':visible'
					valueDivs = $(@).find 'td .table-value'
					valueDivs.each (j, div) ->
						td = $(div).closest 'td'
						if td.is ':visible'
							text += (clipboardCopyCell td).trim() + '\t'
					text = text.trim() + '\n'

		pgweb.Main.inst().copyToClipboard text
		pgweb.ErrorDialog.inst().show(t.CopyToClipBoardFinished, t.TableCopied)

	clipboardCopyHeader = (th) ->
		switch $(th).attr('id').split('-').last()
			when 'system_name'
				t.ModulePage_SystemName+'\t'
			when 'external_link', 'other', 'symbol'
				''
			when 'di', 'do', 'qpg'
				prefix = $(th).attr('id').split('-')[1].toUpperCase()
				clipboardExpandColumnTitle th, prefix
			when 'value'
				stripHTML($(th).html()).trim() + '\t' + t.Unit
			else
				stripHTML($(th).html()).trim()+'\t'

	clipboardCopyCell = (td) ->
		valueStr = td.find('.table-value').html().trim()
		firstClass = ((td.attr 'class').split ' ')[0]
		switch firstClass.split('-').last()
			when 'pv_status'
				pgweb.PVStatus.toTranslatedString valueStr
			when 'di', 'do'
				clipboardExpandColumnValue valueStr
			when 'other', 'symbol'
				''
			when 'qpg'
				# Don't use .table-value, use .table-value-export instead.
				valueStr = (td.find '.table-value-export').html()
				clipboardExpandColumnValue valueStr
			when 'value'
				unit = td.find('.tag-category-unit').text()
				valueStr + '\t' + unit
			else
				valueStr

	clipboardExpandColumnTitle = (th, prefix) ->
		spanOrA = $(th).find 'span'
		if spanOrA.length == 0
			spanOrA = $(th).find 'a'
		# The channel table shows only one QPG value. The module table shows QPG 1-n
		if tableId in ['channel-table'] and prefix == 'QPG'
			prefix
		else
			lastN = lastNum spanOrA.html()
			n = if not lastN then 8 else lastN
			[1..n].reduce (acc, i) ->
				acc + prefix + i + '\t'
			, ''

	clipboardExpandColumnValue = (valueStr) ->
		valueStr.split('').reduce ((acc, val) ->
			acc + val + '\t'
		), ''
class pgweb.ModuleSearchBox
	searchbox = null
	lasttime = null
	nowtime = null
	query = ''
	delay = 400
	ongoing = false

	@init: ->
		$('body').on 'listviewbeforefilter', '#module-searchbox', (event, data) ->
			searchbox = $(this)
			getInfo data
		
		$('body').on 'popupafteropen', '#search-modules-popup', (event) ->
			$('#search-modules-popup').find('input').focus()

		$('body').on 'click', '#search-modules-button', (event) ->
			$('#search-modules-popup').popup 'open', {transition: 'pop'}

		setInterval checkSearchBox, 250

	getInfo = (data) ->
		searchbox.html ''
		# Remove ugly shadow on clear button (only theme 'a').
		$('.ui-input-clear').removeClass 'ui-shadow'
		query = $(data.input).val()
		if query.length > 2
			lasttime = nowtime;
			nowtime = getCurrentTime()
		else query = ''

	checkSearchBox = ->
		if not query then return
		
		mynowtime = getCurrentTime()
		if mynowtime - nowtime < delay then return

		if not ongoing
			ajaxFind query
		query = ''

	ajaxFind = (storedQuery) ->
		ongoing = true
		waitStart()
		networkId = $.url().param().networkId
		$.ajax
			url: "/pgweb/ajax/module/searchModules.php"
			dataType: 'json'
			type: 'POST'
			data:
				networkId: networkId
				query: storedQuery
			success: (data) ->
				if data.result == "OK"
					searchbox.html ''
					$.each data.modules, (i, moduleData) ->
						url = '?action=showModule&networkId='+networkId+'&moduleTypeId=0&moduleId='+moduleData.id
						li = $('<li></li>')
							.append(
								$('<a></a>')
									.attr('href', url)
									.append(moduleData.system_name+' ['+moduleData.where+']')
							)
						searchbox.append li
						searchbox.listview 'refresh'
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Searching modules failed: "+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()
				ongoing = false

	getCurrentTime = ->
		mynowdate = new Date()
		mynowdate.getTime()

$ ->
	# Run on all pages where there is a module search button. 
	if $('#search-modules-button').length > 0
		pgweb.ModuleSearchBox.init()
class pgweb.ColumnToggleMemory
	
	constructor: ->
		tableId = $('[data-mode=columntoggle]').attr('id')
		if !tableId then return
		
	instance = null
	
	pageId = null
	
	@inst: ->
		if not instance?
			instance = new @
		instance

	@init: ->
		$(document).on 'pagecreate', '[data-role=page]', (event) ->
			pageId = $(event.target).attr('id')
			tableId = getTableId()
			if !tableId then return
			$('#'+tableId+'-popup').popup {history: false}

			# Handle click on checkboxes in column select menu.
			$('body').on 'change', '.ui-table-columntoggle-popup .ui-checkbox input', (event) ->
				tableId = $(event.target).closest('.ui-table-columntoggle-popup').attr('id')
				label = $(event.target).parent().find('label')
				checkBoxText = label.text().trim()
				selectedHeader = findHeaderByText checkBoxText
				bool = $(event.target).is(':checked')
				setColumnToggleCookie tableId, selectedHeader.attr('id'), bool
				label.addClass 'columntoggle-remembered'
			
			# Add reset button
			html = '<div><input type="button" class="columntoggle-reset-button" id="columntoggle-reset-button" '
			html += 'value="'+t.Reset+'" data-theme="b"/></div>'
			$('#'+tableId+'-popup fieldset .ui-controlgroup-controls').parent().parent().append html
			$('.columntoggle-reset-button').button()
			$('body').on 'click', '.columntoggle-reset-button', (event) ->
				onResetButtonClick()
			
			# First we need to clear all checkboxes which have cookie = false.
			checkOrClearCheckBoxes tableId, false
			
			# Then we can set all checkboxes which have cookie = true.
			checkOrClearCheckBoxes tableId, true
	
	checkOrClearCheckBoxes = (tableId, check) ->
		getHeaders().each (i, el) ->
			headerId = $(el).attr('id')
			if !headerId then return
			headerText = $('#'+headerId).html().trim()
			if headerText
				columnToggleMenuItem = findColumnToggleMenuItemByText headerText
				if columnToggleMenuItem
					input = columnToggleMenuItem.find('input')
					if existsColumnToggleCookie tableId, headerId
						input.parent().find('label').addClass 'columntoggle-remembered'
						if check
							if getColumnToggleCookie(tableId, headerId) == true # Cookie is true
								if not input.is(':checked') # ... but checkbox is false
									input.click() # ... so simulate a click to set it to true
						else
							if getColumnToggleCookie(tableId, headerId) == false # Cookie is false
								if input.is(':checked') # ... but checkbox is true
									input.click() # ... so simulate a click to set it to false
	
	onResetButtonClick = ->
		tableId = getTableId()
		getHeaders().each (i, el) ->
			headerId = $(el).attr('id')
			if !headerId then return
			if existsColumnToggleCookie tableId, headerId
				removeColumnToggleCookie tableId, headerId
		location.reload()
	
	# Find a th element by looking for its text e.g. 'Adress'
	findHeaderByText = (headerTextToFind) ->
		selectedHeader = undefined
		headers = getHeaders()
		headers.each (i, el) ->
			if selectedHeader then return
			header = $(el)
			headerText = header.text()
			if headerText == headerTextToFind
				selectedHeader = header
		selectedHeader
	
	getHeaders = ->
		headers = $('#'+pageId+' [data-mode=columntoggle] th > span')
		if headers.length == 0
			headers = $('#'+pageId+' [data-mode=columntoggle] th')
		headers
	
	getTableId = ->
		$('#'+pageId+' [data-mode=columntoggle]').attr('id')
	
	# Find a column toggle column menu item by looking for its text e.g. 'Adress'
	findColumnToggleMenuItemByText = (checkBoxTextToFind) ->
		retItem = undefined
		tableId = getTableId()
		$('#'+tableId+'-popup label').each (j, item) ->
			checkBoxText = $(item).text().trim()
			if checkBoxText == checkBoxTextToFind
				retItem = $(item).parent()
		retItem

	existsColumnToggleCookie = (tableId, selectedHeaderId) ->
		cookieName = getColumnToggleCookieName tableId, selectedHeaderId
		(pgwebGetCookie cookieName) != undefined
	
	getColumnToggleCookie = (tableId, selectedHeaderId) ->
		cookieName = getColumnToggleCookieName tableId, selectedHeaderId
		Number(pgwebGetCookie cookieName) == 1
	
	setColumnToggleCookie = (tableId, selectedHeaderId, bool) ->
		cookieName = getColumnToggleCookieName tableId, selectedHeaderId
		pgwebSetCookie cookieName, Number(bool)

	removeColumnToggleCookie = (tableId, selectedHeaderId) ->
		cookieName = getColumnToggleCookieName tableId, selectedHeaderId
		pgwebRemoveCookie cookieName
	
	getColumnToggleCookieName = (tableId, selectedHeaderId) ->
		ret = 'columntoggle_' + tableId.removeEnd('-table').undasherize() + '_'
		ret += selectedHeaderId.removeStart('coltitle-').undasherize() + '_' + pgwebGetCookie 'idHash'
		ret

pgweb.ColumnToggleMemory.init()
$(-> pgweb.ColumnToggleMemory.inst())
class pgweb.ErrorDialog
	
	instance = null
	
	@inst: ->
		if not instance?
			instance = new @
		instance
	
	show: (title, message, details) ->
		$('#error-dialog').popup()

		$('#error-dialog-title').html(title)
		$('#error-dialog-message').html(message)
		if details
			$('#error-dialog-details').show()
			$('#error-dialog-details p').html(details)
		else
			$('#error-dialog-details').hide()
		
		$('#error-dialog').popup 'open'

$(-> pgweb.ErrorDialog.inst())
class pgweb.FrontpageMessageDialog
	
	instance = null
	
	@inst: ->
		if not instance?
			instance = new @
			instance.init()
		instance
	
	init: ->
		$('body').on 'click', '.message-save-button', (event, ui) =>
			@saveMessage()

		pgweb.HelpDialog.register 'frontpage-message-help', 'frontpage-message-help-button'
	
	saveMessage: ->
		$('#message-save-error-message').html ''
		message_sv = $('textarea[name=message_sv]').val()
		message_en = $('textarea[name=message_en]').val()
		waitStart()
		$.ajax
			url: "/pgweb/ajax/common/saveMessage.php"
			dataType: 'json'
			type: 'POST'
			data:
				messages:
					message_sv: message_sv
					message_en: message_en
			success: (data) =>
				switch data.result
					when "OK"
						@displayMessage data.html_sv, data.html_en
						@setWarningBubble data.html_sv, data.html_en
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						$('#message-save-error-message').html "Saving message failed.<br/>"+data.debug
			error: ajaxFailure,
			complete: -> waitStop()
		return true
	
	displayMessage: (html_sv, html_en) ->
		$('#frontpage-message-edit-popup').popup 'close'
		switch Globalize.culture().name
			when 'sv-SE'
				if html_sv is ""
					$('#frontpage-message-box-sv').html '<i>'+t.MainPage_NoMessages+'</i>'
				else
					$('#frontpage-message-box-sv').html html_sv
			else
				if html_en is ""
					$('#frontpage-message-box-en').html '<i>'+t.MainPage_NoMessages+'</i>'
				else
					$('#frontpage-message-box-en').html html_en

	setWarningBubble: (html_sv, html_en) ->
		if Globalize.culture().name == 'sv-SE'
			msg = html_sv
		else
			msg = html_en
		if msg
			$('#message-bubble-text').html msg
			$('#message-warning-button').show()
		else
			$('#message-bubble-text').text ''
			$('#message-warning-button').hide()

$(-> pgweb.FrontpageMessageDialog.inst())
class pgweb.Event
	@on: (events, handler) ->
		$('html').on events, 'body', handler

	@trigger: (event, params) ->
		$('body').trigger event, JSON.stringify params
class pgweb.CurveChart

	standardSeriesColors: [
		'#4572A7', '#dd3333', '#cccc33', '#59cc4E', 
		'#bb44bb', '#995500', '#ff8800', '#44dddd', 
		'#ff0000', '#00ff00', '#0000aa', '#008800',
		'#aa0000', '#880088', '#008888', '#888800']
	smbasicANSeriesColors: ['#dd3333', '#ff7777', '#4572A7', '#77aadd']
	smbasicMIC1AnalysisSeriesColors: ['#cc2222', '#ff9999', '#00ff00', '#ffaa00', '#ff0000', '#ffffff']
	smbasicMIC2AnalysisSeriesColors: ['#4572A7', '#88bbee', '#00ff00', '#ffaa00', '#ff0000', '#ffffff']
	channelSeriesColors: ['#4572A7', '#59B54E', '#85B2ff', '#99ff8E', '#D9B54E', '#3572A7', '#29B54E', '#55B2ff']
	channelTdrSeriesColors: ['#4572A7', '#59B54E', '#B54EB5', '#ffbb00', '#ff4000']
	admFlowSeriesColors: [
		'#ff3333', '#6699ff', '#aa2222', '#3355bb', 
		'#ff7700', '#00eedd', '#ff00cc', '#aa00dd', 
		'#ffdd00', '#007777', '#00dd00', '#aa8800',
	]

	@inst: ->
		if not instance?
			instance = new @
		instance

	create: (min, max, zoomType, title, yAxisConfigs, activeCurveIndex, seriesColors, renderTo, toolTipFormatter, sharedToolTip, events) ->
		themeType = parseInt $('#theme-type').val()
		defaultBackground =
			linearGradient: [0, 0, 0, 400]
			stops: [
				[0, 'rgb(66, 66, 66)']
				[1, 'rgb(16, 16, 16)']
			]
		lightBackground =
			linearGradient: [0, 0, 0, 400]
			stops: [
				[0, 'rgb(235, 235, 235)']
				[1, 'rgb(195, 195, 195)']
			]
		
		Highcharts.theme =
			colors: [
				"#5d9DfF", "#7798BF", "#55BF3B", "#DF5353", "#aaeeee", "#ff0066", "#eeaaee",
				"#55BF3B", "#DF5353", "#7798BF", "#aaeeee"]
			chart:
				backgroundColor: if themeType == 1 then lightBackground else defaultBackground
				borderWidth: 0
				borderRadius: 15
				plotBackgroundColor: null
				plotShadow: false
				plotBorderWidth: 0
			title:
				style:
					color: if themeType == 1 then '#444' else '#FFF'
					font: '16px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif'
			subtitle:
				style:
					color: '#DDD'
					font: '12px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif'
			xAxis:
				gridLineWidth: 0
				gridLineColor: 'rgba(255, 255, 255, .1)'
				lineColor: '#999'
				tickColor: '#999'
				labels:
					style:
						color: if themeType == 1 then '#444' else '#999'
						font: 'bold 14px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif'
				title:
					style:
						color: '#AAA'
						font: 'bold 12px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif'
			yAxis:
				alternateGridColor: null
				minorTickInterval: null
				gridLineColor: if themeType == 1 then 'rgba(255, 255, 255, .5)' else 'rgba(255, 255, 255, .1)'
				lineWidth: 0
				tickWidth: 0
				labels:
					style:
						color: if themeType == 1 then '#444' else '#999'
						font: 'bold 14px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif'
				title:
					style:
						color: if themeType == 1 then '#444' else '#999'
						font: 'bold 12px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif'
				crosshair: {}
			legend:
				itemStyle:
					color: if themeType == 1 then '#444' else '#CCC'
				itemHoverStyle:
					color: if themeType == 1 then '#aaa' else '#FFF'
				itemHiddenStyle:
					color: if themeType == 1 then '#999' else '#333'
			labels:
				style:
					color: '#CCC'
			tooltip:
				backgroundColor:
					linearGradient: [0, 0, 0, 50]
					stops: if themeType == 1 then [
						[0, 'rgba(160, 160, 160, .8)']
						[1, 'rgba(120, 120, 120, .8)']
					] else [
						[0, 'rgba(96, 96, 96, .8)']
						[1, 'rgba(16, 16, 16, .8)']
					]
				borderWidth: 0
				style:
					color: '#FFF'

			toolbar:
				itemStyle:
					color: '#CCC'

			navigation:
				buttonOptions:
					backgroundColor:
						linearGradient: [0, 0, 0, 20]
						stops: [
							[0.4, '#606060']
							[0.6, '#333333']
						]
					borderColor: '#000000'
					symbolStroke: '#C0C0C0'
					hoverSymbolStroke: '#FFFFFF'

			exporting:
				buttons:
					contextButton: {}

			# scroll charts
			rangeSelector:
				buttonTheme:
					fill:
						linearGradient: [0, 0, 0, 20]
						stops: [
							[0.4, '#888']
							[0.6, '#555']
						]
					stroke: '#000000'
					style:
						color: '#CCC'
						fontWeight: 'bold'
					states:
						hover:
							fill:
								linearGradient: [0, 0, 0, 20]
								stops: [
									[0.4, '#BBB']
									[0.6, '#888']
								]
							stroke: '#000000'
							style:
								color: 'white'
						select:
							fill:
								linearGradient: [0, 0, 0, 20]
								stops: [
									[0.1, '#000']
									[0.3, '#333']
								]
							stroke: '#000000'
							style:
								color: '#3333ff'
				inputStyle:
					backgroundColor: '#333'
					color: 'silver'
				labelStyle:
					color: 'silver'

			navigator:
				handles:
					backgroundColor: '#666'
					borderColor: '#AAA'
				outlineColor: '#CCC'
				maskFill: 'rgba(16, 16, 16, 0.5)'
				series:
					color: '#7798BF'
					lineColor: '#A6C7ED'

			scrollbar:
				barBackgroundColor:
					linearGradient: [0, 0, 0, 20]
					stops: [
						[0.4, '#888']
						[0.6, '#555']
					]
				barBorderColor: '#CCC'
				buttonArrowColor: '#CCC'
				buttonBackgroundColor:
					linearGradient: [0, 0, 0, 20]
					stops: [
						[0.4, '#888']
						[0.6, '#555']
					]
				buttonBorderColor: '#CCC'
				rifleColor: '#FFF'
				trackBackgroundColor:
					linearGradient: [0, 0, 0, 10]
					stops: [
						[0, '#000']
						[1, '#333']
					]
				trackBorderColor: '#666'

			# special colors for some of the demo examples
			legendBackgroundColor: 'rgba(48, 48, 48, 0.8)'
			legendBackgroundColorSolid: 'rgb(70, 70, 70)'
			dataLabelsColor: '#444'
			textColor: '#E0E0E0'
			maskColor: 'rgba(255,255,255,0.3)'

		# Apply the theme
		highchartsOptions = Highcharts.setOptions Highcharts.theme
		Highcharts.setOptions
			global:
				useUTC: true
		
		if !events
			events = {}
		if !events.selection
			events.selection = (e) ->
				pgweb.TrendsPage.showZoomXResetButton true
		chartObj = new Highcharts.Chart
			chart:
				renderTo: renderTo
				zooming:
					type: zoomType
				animation: false
				events: events
			accessibility:
				enabled: false
			title:
				text: title
			subtitle:
				text: null
			animation: false
			credits:
				text: 'Pipeguard'
				enabled: false
			xAxis: [
				startOnTick: false
				endOnTick: false
				type: 'datetime'
				min: min
				max: max
				#labels: {
				#	formatter: function() {
				#		return Globalize.format(new Date(this.value), 'f')
				dateTimeLabelFormats:
					second: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.T)
					minute: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.t)
					hour: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.t)
					day: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.M)
					week: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.M)
					month: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.Y)
					year: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.Y)
				crosshair: {}
			]
			yAxis: yAxisConfigs
			tooltip:
				useHTML: true
				shared: sharedToolTip
				formatter: toolTipFormatter
			plotOptions:
				area:
					marker:
						enabled: true
						symbol: 'circle'
					#animation: true
				series:
					animation: false
					turboThreshold: 10000
			legend:
				enabled: false
			series: @seriesConfigs seriesColors
			
		chartObj

	seriesConfigs: (seriesColors) ->
		arr = []
		moduleId = $('#module-id').val()
		for i in [0..15]
			arr[i] =
				name: i
				color: seriesColors[i]
				type: 'line'
				yAxis: 0
				animation: false
				data: []
				dashStyle: 'Solid'
				lineWidth: 2
				marker: { enabled: false }
				index: i
				step: ''
				fillColor:
					linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1}
					stops: [
						[0, seriesColors[i]]
						[1, seriesColors[i]+'00']
					]
				fillOpacity: 0.75
		arr

	yAxisGeneralConfig: (color, opposite, minTickInterval, axisDecimals, showFirstLabel, showLastLabel) ->
		labels:
			formatter: ->
				floatNumberFormatter this.value, axisDecimals
			style:
				color: color
		title:
			text: null
			style:
				color: color
		minTickInterval: minTickInterval
		showFirstLabel: showFirstLabel
		showLastLabel: showLastLabel
		opposite: opposite
		endOnTick: false
	
	yAxisBinConfig: (color) ->
		@yAxisGeneralConfig color, false, 1, 0, false, false

	yAxisIntConfig: (color, opposite) ->
		@yAxisGeneralConfig color, opposite, 1, 0, true, true

	yAxisFloatConfig: (color, opposite, minTickInterval, axisDecimals) ->
		@yAxisGeneralConfig color, opposite, minTickInterval, axisDecimals, true, true

	yAxisFloatFixedConfig: (color, opposite, minTickInterval, axisDecimals) ->
		@yAxisGeneralConfig color, opposite, minTickInterval, axisDecimals, false, true
class pgweb.ExergiOverviewPage
	instance = null
	intervalId = null
	overvakningGauge = null
	referenstryckGauge = null
	returtempGauge = null
	larmtradGauge = null
	kammareGauge = null
	akustisktGauge = null
	larmtradColumnChart = null
	
	constructor: ->
		@init()
	
	@inst: ->
		if not instance?
			instance = new @
		instance
	
	init: ->
		#overvakningGauge = new pgweb.ExergiOverviewSolidGauge
		overvakningGauge = new pgweb.ExergiOverviewBackgroundGauge
			containerIdSuffix: 'overvakning'
			unit: '%'
			min: 0
			initValue: 0
			stops: [
				[0.1, '#ff0000']  # red
				[0.5, '#ffff00'], # yellow
				[0.9, '#00ff00'], # green
			]
			decimals: 0
		
		#referenstryckGauge = new pgweb.ExergiOverviewSolidGauge
		referenstryckGauge = new pgweb.ExergiOverviewBackgroundGauge
			containerIdSuffix: 'referenstryck'
			unit: 'bar'
			min: 5
			max: 12
			initValue: 5
			stops: [
				[0.1, '#ff0000']  # red
				[0.3, '#ffff00']  # yellow
				[0.5, '#00ff00']  # green
				[0.7, '#ffff00'], # yellow
				[0.9, '#ff0000'], # red
			]
			decimals: 1
		
		#returtempGauge = new pgweb.ExergiOverviewSolidGauge
		returtempGauge = new pgweb.ExergiOverviewBackgroundGauge
			containerIdSuffix: 'returtemp'
			unit: '°C'
			min: 10
			max: 60
			initValue: 10
			stops: [
				[0.1, '#ff0000']  # red
				[0.3, '#ffff00']  # yellow
				[0.5, '#00ff00']  # green
				[0.7, '#ffff00'], # yellow
				[0.9, '#ff0000'], # red
			]
			decimals: 1
	
		#larmtradGauge = new pgweb.ExergiOverviewSolidGauge
		larmtradGauge = new pgweb.ExergiOverviewBackgroundGauge
			containerIdSuffix: 'larmtrad'
			unit: '%'
			min: 0
			initValue: 0
			stops: [
				[0.1, '#ff0000']  # red
				[0.5, '#ffff00'], # yellow
				[0.9, '#00ff00'], # green
			]
			size: .8
			decimals: 0
		
		#kammareGauge = new pgweb.ExergiOverviewSolidGauge
		kammareGauge = new pgweb.ExergiOverviewBackgroundGauge
			containerIdSuffix: 'kammare'
			unit: '%'
			min: 0
			initValue: 0
			stops: [
				[0.1, '#ff0000']  # red
				[0.5, '#ffff00'], # yellow
				[0.9, '#00ff00'], # green
			]
			size: .8
			decimals: 0
		
		#akustisktGauge = new pgweb.ExergiOverviewSolidGauge
		akustisktGauge = new pgweb.ExergiOverviewBackgroundGauge
			containerIdSuffix: 'akustiskt'
			unit: '%'
			min: 0
			initValue: 0
			stops: [
				[0.1, '#ff0000']  # red
				[0.5, '#ffff00'], # yellow
				[0.9, '#00ff00'], # green
			]
			size: .8
			decimals: 0
		
		larmtradColumnChart = new pgweb.ExergiOverviewColumnChart
			containerIdSuffix: 'larmtradcolumns'
			initValues: [77, 23, 35, 11]

		kammareColumnChart = new pgweb.ExergiOverviewColumnChart
			containerIdSuffix: 'kammarecolumns'
			initValues: [70, 28, 10, 3]

		akustisktColumnChart = new pgweb.ExergiOverviewColumnChart
			containerIdSuffix: 'akustisktcolumns'
			initValues: [80, 7, 2, 4]

		intervalId = null
		
		clearInterval intervalId
		intervalId = setInterval ->
			update false
		, 120000
		
		update()
	
	update = ->
		networkIds = $('#exergi-overview-network-ids').val()
		$.ajax
			url: "/pgweb/ajax/exergioverview/getStatistics.php"
			dataType: 'json'
			type: 'GET'
			data:
				networkIds: networkIds
			success: (data) => 
				switch data.result
					when "OK"
						overvakningGauge.updateValue      data.overvakning
						referenstryckGauge.updateValue    data.referenstryck
						returtempGauge.updateValue        data.returtemp
						larmtradGauge.updateValue         data.larmtrad
						kammareGauge.updateValue          data.kammare
						akustisktGauge.updateValue        data.akustiskt
						larmtradColumnChart.updateValues  [
							data.larmtradsovervakning1, 
							data.larmtradsovervakning2, 
							data.larmtradsovervakning3, 
							data.larmtradsovervakning4
						]
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get module data.', data.result);
			error: ajaxFailure

$(->
	if $('.exergi-overview-chart-table').length > 0
		pgweb.ExergiOverviewPage.inst())
class pgweb.ExergiOverviewSolidGauge
	chart: null
	
	constructor: (config) ->
		containerIdSuffix = config.containerIdSuffix
		unit = config.unit ? ''
		min = config.min ? 0
		max = config.max ? 100
		initValue = config.initValue ? 0
		stops = config.stops ? [
			[0.1, '#00ff00'], # green
			[0.5, '#ffff00'], # yellow
			[0.9, '#ff0000']  # red
		]
		size = config.size ? 1.0
		
		gaugeConfig =
			chart:
				type: 'solidgauge'
				width: 260*size
				height: 170*size
				backgroundColor: 'transparent'#'#383838'
				margin: 0
			title: null
			pane:
				center: ['50%', '75%']
				size: '140%'
				startAngle: -90
				endAngle: 90
				background:
					backgroundColor: '#555'
					innerRadius: '60%'
					outerRadius: '100%'
					shape: 'arc'
			exporting:
				enabled: false
			tooltip:
				enabled: false
			yAxis:
				stops: stops
				lineWidth: 0
				tickWidth: 0
				minorTickInterval: null
				tickAmount: 2
				labels:
					y: 16
					style:
						color: '#ccc'
						fontSize: 15
						fontWeight: 'bold'
				min: min
				max: max
				title: null
				tickPositioner: -> [min, max]
				endOnTick: true
				startOnTick: true
			credits:
				enabled: false
			series: [
				data: [initValue]
				dataLabels:
					format:
						'<div style="text-align:center;color:#ccc;font-weight:bold;position:relative;top:8px">' +
						'<span style="font-size:'+35*size+'px;">{y}</span><br/>' +
						'<span style="font-size:'+15*size+'px;">'+unit+'</span>' +
						'</div>'
				tooltip:
					valueSuffix: ' ' + unit
			]
			plotOptions:
				solidgauge:
					dataLabels:
						y: 0
						borderWidth: 0
						useHTML: true
		
		@chart = Highcharts.chart 'exergi-overview-chart-'+containerIdSuffix, gaugeConfig
	
	updateValue: (value) ->
		@chart.series[0].setData [value]
class pgweb.ExergiOverviewMap extends pgweb.Map
	
	instance = null
	intervalId = null

	greenMarkerLayer = null
	yellowMarkerLayer = null
	redMarkerLayer = null
	
	@inst: ->
		if not instance?
			instance = new @
		instance
	
	initInterval: ->
		clearInterval intervalId
		intervalId = setInterval =>
			@update false
		, 120000
	
	update: (fitBounds) ->
		if $.url().param().action != 'showExergiOverview' then return
		
		networkIds = $('#exergi-overview-network-ids').val()
		
		@modules = []
		$.ajax
			url: "/pgweb/ajax/exergioverview/overviewMap.php"
			dataType: 'json'
			type: 'GET'
			data:
				networkIds: networkIds
			success: (data) =>
				@modules = data.modules
				switch data.result
					when "OK"
						@internalUpdate fitBounds
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get module data.', data.result);
			error: ajaxFailure

	# Display markers for all the modules.
	internalUpdate: (fitBounds) ->
		@fitToBounds() if fitBounds
		
		# Display the map needles.
		@createMarkers()

$(document).on 'pageshow', '.exergiOverviewPage', (event) ->
	map = pgweb.ExergiOverviewMap.inst()
	map.id = 'exergi-overview-map'
	if !map.isInitialized()
		map.init()
	map.initInterval()
class pgweb.ExergiOverviewColumnChart
	
	constructor: (config) ->
		containerIdSuffix = config.containerIdSuffix
		initValues = config.initValues
		
		chartConfig =
			chart:
				type: 'column'
				backgroundColor: 'transparent'#'#383838'
				width: 208
				height: 130
				margin: 5
			title: null
			legend:
				enabled: false
			exporting:
				enabled: false
			xAxis:
				visible: false
				categories: [
					'Jan',
					'Feb',
					'Mar',
					'Apr',
				],
				crosshair: false
			yAxis:
				visible: true
				min: 0
				max: 100
				gridLineColor: 'transparent'
				#stackLabels:
				#	enabled: false
				#	style:
				#		color: 'white'
				#	verticalAlign: 'top'
				endOnTick: true
				startOnTick: true
				maxPadding: 0
			tooltip:
				enabled: false
				#headerFormat: '<span style="font-size:10px">{point.key}</span><table>'
				#pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
				#	'<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>'
				#footerFormat: '</table>'
				#shared: true
				#useHTML: true
			plotOptions:
				column:
					stacking: 'normal'
					pointWidth: 34
					pointPadding: 0
					groupPadding: 0
					borderWidth: 0
					dataLabels:
						enabled: true
						format: '{y}%'
			credits:
				enabled: false
			series: [
				data: [
					color: 'green'
					y: initValues[0]
				,
					color: 'red'
					y: initValues[1]
				,
					color: 'yellow'
					y: initValues[2]
				,
					color: 'gray'
					y: initValues[3]
				]
			]
		
		chart = Highcharts.chart 'exergi-overview-chart-'+containerIdSuffix, chartConfig

	updateValues: (values) ->
		#@chart.series[0].setData [value]
class pgweb.OvikOverviewMap

	instance = null
	maximized = false
	fullscreen = false
	map = null
	markerLayer = null
	allLayers = []
	layers = []
	modules: null
	lastHighlightedLayer = null
	lastHighlightedLayerColor = null

	@inst: ->
		# Run only on Övik overview page.
		if $.url().param().action != 'showOvikOverview'
			return
		if not instance?
			instance = new @
		instance

	init: ->
		# Map will always update, so hide the control for auto-updating.
		$('#auto-update-container').hide()

		initGeoJSON()

		# Create the map object.
		map = @createMap()

		# Add the map fullscreen toggle button.
		map.addControl @createFullscreenButton()

		# Add the map height toggle button.
		map.addControl @createMaximizeButton()

		# Add the return zoom button.
		map.addControl @createReturnZoomButton()

		map.on 'resize', =>
			@fitToBounds()

		map.on 'zoomend', (obj) ->
			onZoomEnd()

		maximized = @getMaximizedCookie()
		if ($.url().attr 'anchor') == 'fullscreen'
			$('.map-fullscreen-button').trigger 'click'
		else
			if maximized
				maximized = not maximized
				$('.map-maximize-button').trigger 'click'
		
		@ajaxLoadModules()

		setInterval =>
			@updatePopups()
		, pgweb.Main.getUpdateInterval()
		
		setTimeout =>
			@updatePopups()
		, 2000
		
		$(document).on 'keyup', (event) ->
			if event.key == 'F11'
				if fullscreen
					location.reload()
		
		@ajaxGetTemperature()
		setInterval =>
			@ajaxGetTemperature()
		, 600000
		
	onZoomEnd = ->
		#console.log "zoom="+map.getZoom()
		if not layers? then return
		for layer in layers
			if map.getZoom() < layer.visibleZoomLevel
				#console.log 'unzoomat för att ta bort lager'
				if layer.visible
					#console.log 'tar bort lager '+layer.file
					if layer.geojson
						map.removeLayer layer.geojson
					layer.visible = false
			else
				#console.log 'inzoomat för att lägga till lager'
				if not layer.visible
					#console.log 'lägger till lager '+layer.file
					if layer.geojson
						map.addLayer layer.geojson
					layer.visible = true
				weight = Math.min map.getZoom()/5 - 1, 2
				if layer.geojson
					layer.geojson.setStyle weight: weight

	initGeoJSON = ->
		# Data for the GeoJSON layers

		allLayers = []

		allLayers[OVIK_OVERVIEW_NETWORK_ID] = [ # Övik Energi, Tryck
				index: 0
				file: 'ovik_ledningar_WGS84_20170420'
				color: '#ff00ff'
				visibleZoomLevel: 1
				clickable: false
			,
				index: 1
				file: 'ovik_ventiler_WGS84_20170420'
				color: '#ff0000'
				visibleZoomLevel: 1
				clickable: false
		]

	isInitialized: ->
		return not $('#ovik-overview-map').is ':empty' 
	
	getMaximizedCookie: ->
		idHash = pgwebGetCookie 'idHash'
		Number(pgwebGetCookie 'ovikoverviewmap_maximized_'+idHash) == 1
	
	setMaximizedCookie: (bool) ->
		idHash = pgwebGetCookie 'idHash'
		pgwebSetCookie 'ovikoverviewmap_maximized_'+idHash, Number(bool)
	
	fitToBounds: ->
		# Get the points of the modules to be viewed (for map bounds calculation).
		#pointsForBoundsCalc = ([module.gis_latitude, module.gis_longitude] for module in @modules)
		pointsForBoundsCalc = [[ 63.24, 18.61], [63.34, 18.70]]

		# Fit bounds to the points.
		bounds = new L.LatLngBounds(pointsForBoundsCalc)
		map.fitBounds bounds
	
	refresh: ->
		map.invalidateSize()
		
	# Create the map object.
	createMap: ->
		map = L.map('ovik-overview-map',
			zoomAnimationThreshold: 17
			attributionControl: false
		)
		attribution = ""
		config =
			attribution: attribution
			maxZoom: 21
			maxNativeZoom: 19
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', config).addTo map
		
		addGeoJSONLayers map
		
		map

	addGeoJSONLayers = (map) ->
		networkId = OVIK_OVERVIEW_NETWORK_ID
		layers = allLayers[networkId]
		if layers
			for layer in layers
				getGeoJSONByAjax layer
			map.on 'click', ->
				if lastHighlightedLayer
					lastHighlightedLayer.setStyle color: lastHighlightedLayerColor
	
	getGeoJSONByAjax = (layer) ->
		$.getJSON 'shapefiles/'+layer.file+'.json', (data, textStatus, jqXHR) ->
			calledFile = this.url.substring 11, this.url.indexOf '.json'
			layerData = findLayer layers, calledFile
			geojsonFeature = data
			geojson = L.geoJson geojsonFeature, 
				style:
					color: layerData.color
					opacity: 1
				onEachFeature: (feature, featureLayer) ->
					featureGroup = L.featureGroup([featureLayer])
					featureGroup.on 'click', (e) ->
						#onFeatureClick feature, featureGroup, layerData
					featureGroup.addTo map
			layerData.visible = true
			layers[layerData.index].geojson = geojson
			onZoomEnd()
	
	# Find the layer which has a specific file.
	findLayer = (layers, file) ->
		for layer in layers
			if layer.file == file
				return layer

	# Create the markers with popups.
	createMarkers: ->
		# Classes needed for the map needles
		MapNeedle = L.Icon.extend
			options:
				shadowUrl: 'images/mapneedle_shadow.png'
				iconSize: [20, 32],
				shadowSize: [21, 25],
				iconAnchor: [10, 32],
				shadowAnchor: [5, 25],
				popupAnchor: [0, -32]
		icons =
			grayIcon: new MapNeedle
				iconUrl: 'images/mapneedle_gray.png'
			greenIcon: new MapNeedle
				iconUrl: 'images/mapneedle_green.png'
			yellowIcon: new MapNeedle
				iconUrl: 'images/mapneedle_yellow.png'
			yellowredIcon: new MapNeedle
				iconUrl: 'images/mapneedle_yellowred.png'
			redIcon: new MapNeedle
				iconUrl: 'images/mapneedle_red.png'

		# If the marker layer exists, remove all markers from it, else create the marker layer
		# and add it to the map.
		if (markerLayer?)
			markerLayer.clearLayers()
		else
			markerLayer = L.layerGroup()
		markerLayer.addTo map

		arr = [
			  # 001 Översjälavägen
				module_name: 'OEAB_MT102_1451001'
				popup_position: [63.330, 18.600]
				in_map: true
			, # 002 Hampnässkolan
				module_name: 'OEAB_MT102_1509001'
				popup_position: [63.275, 18.575]
				in_map: true
			, # 003 Dagis Domsjö
				module_name: 'OEAB_MT102_1716001'
				popup_position: [63.245, 18.640]
				in_map: true
			, # 004 Alneskolan
				module_name: 'OEAB_MT102_1716002'
				popup_position: [63.270, 18.835]
				in_map: true
			, # 005 Vårdhemmet Arnäs
				module_name: 'OEAB_MT102_1716003'
				popup_position: [63.330 , 18.835]
				in_map: true
			, # 006 Bredbyn
				module_name: 'OEAB_MT102_1716004'
				popup_position: [63.330, 18.475]
				in_map: false
			, # 007 Bjästa
				module_name: 'OEAB_MT102_1716005'
				popup_position: [63.260, 18.475]
				in_map: false
			, # 008 Husum
				module_name: 'OEAB_MT102_1716006'
				popup_position: [63.300, 18.475]
				in_map: false
			, # 009 Skärpeskolan
				module_name: 'OEAB_MT102_1719001'
				popup_position: [63.330, 18.735]
				in_map: true
			#, # 010 Fabriksområdet
			#	module_name: 'OEAB_MT102_1701001'
			#	popup_position: [63.290 , 18.866]
			#	in_map: false
		]

		setTimeout =>
			for module in @modules
				
				obj = (a for a in arr when a.module_name == module.module_name)[0]
				if !obj then continue

				coords = [module.gis_latitude, module.gis_longitude]
				url = "?action=showModule&networkId=#{module.network_id}&moduleTypeId=0&moduleId=#{module.id}"
				html = ''
				#if not obj.in_map
				html += "<a href=\""+url+"\" target=\"_blank\"><h3>#{module.address}</h3>"
				html += "<div id=\"overview-bars#{module.id}\" class=\"overview-bars overview-timeralarm\"></div></a>"
				
				iconName = pgweb.PVStatus.toColor(module.pv_status)+'Icon'
				marker = L.marker(coords, 
					icon: icons[iconName]
					title: module.module_name
				)
				markerLayer.addLayer(marker)
				
				className = 'overview-popup'
				#if not obj.in_map
				className += ' overview-popup-not-in-map'
				if obj.module_name=='OEAB_MT102_1716005'
					className += ' overview-popup-not-in-map-6bars'
				popup = L.popup(
					autoPan: false
					closeButton: false
					closeOnClick: false
					autoClose: false
					offset: [0, 64]
					className: className
				).setLatLng(obj.popup_position).setContent(html)
				map.addLayer popup
				
				# If the module's coordinates are in the map view, draw a line between it
				# and the popup.
				if obj.in_map
					latlngs = [coords, [obj.popup_position[0]+0.0003, obj.popup_position[1]]]
					line = L.polyline(latlngs, {color: '#f00', opacity: 1, weight: 3})
					map.addLayer line
		, 500
		
	clearMarkers: ->
		if (markerLayer?)
			markerLayer.clearLayers()
	
	# Create the map resize toggle button.
	createMaximizeButton: ->
		MaximizeButton = L.Control.extend(
			options:
				position: 'topright'
			onAdd: (map) =>
				button = L.DomUtil.create('button', 'map-maximize-button')
				$(button).html('<i class="fa fa-arrows-v fa-lg"></i>')
				$('body').off 'click', '.map-maximize-button'
				$('body').on 'click', '.map-maximize-button', (event, ui) =>
					maximized = not maximized
					@setMaximized maximized
				return button
		)
		return new MaximizeButton()

	setMaximized: (val) ->
		maximized = val
		if maximized
			@setMaximizedButtonPressed()
			height = 500
		else
			@setMaximizedButtonReleased()
			height = 200
		@setMaximizedCookie maximized
		$('#ovik-overview-map').animate
			height: "#{height}px"
			100
			@refresh

	# Create the return zoom button.
	createReturnZoomButton: ->
		MaximizeButton = L.Control.extend(
			options:
				position: 'topright'
			onAdd: (map) =>
				button = L.DomUtil.create('button', 'map-return-zoom-button')
				$(button).html('<i class="fa fa-square-o fa-lg" style="margin-top: 2px"></i>')
				$('body').off 'click', '.map-return-zoom-button'
				$('body').on 'click', '.map-return-zoom-button', (event, ui) =>
					@fitToBounds()
				return button
		)
		return new MaximizeButton()

	setMaximizedButtonPressed: ->
		$('.map-maximize-button').css
			'background-color': '#ddf'
		
	setMaximizedButtonReleased: ->
		$('.map-maximize-button').css
			'background-color': '#fff'
	
	# Create the map fullscreen button.
	createFullscreenButton: ->
		FullscreenButton = L.Control.extend(
			options:
				position: 'topright'
			onAdd: (map) =>
				button = L.DomUtil.create('button', 'map-fullscreen-button')
				$(button).html('<i class="fa fa-expand fa-lg"></i>')
				$('body').off 'click', '.map-fullscreen-button'
				$('body').on 'click', '.map-fullscreen-button', (event, ui) =>
					fullscreen = not fullscreen
					if fullscreen
						$('#overview-logo').show()
						$('#ovik-overview-map').css
							position: 'fixed'
							width: '100%'
							height: $(window).height()
							top: 0
							left: 0
							'z-index': 1000
						$('.map-maximize-button').hide()
						$(button).html('<i class="fa fa-sign-out fa-lg" style="margin-top: 1px; margin-left: 2px;"></i>')

						url = $.url().attr('path')+'?'+$.url().attr('query')+'#fullscreen'
						$.mobile.navigate url
					else
						$('#overview-logo').hide()
						if maximized
							height = 500.toString()
							@setMaximizedButtonPressed()
						else
							height = 200.toString()
							@setMaximizedButtonReleased()
						$('#ovik-overview-map').css
							position: 'relative'
							width: 'auto'
							height: height+'px'
							top: 0
							left: 0
							'z-index': 0
						$('.map-maximize-button').show()
						$(button).html('<i class="fa fa-expand fa-lg"></i>')

						$.mobile.navigate $.url().attr('path')+'?'+$.url().attr('query')
						
						@setMaximized true
						setTimeout =>
							@fitToBounds()
						, 3000
					@refresh()

				return button
		)
		return new FullscreenButton()

	ajaxLoadModules: ->
		$.ajax
			url: "/pgweb/ajax/ovik/ovikOverviewMap.php"
			dataType: 'json'
			type: 'GET'
			data:
				networkId: OVIK_OVERVIEW_NETWORK_ID
				authCode: $.url().param('authCode')
			success: (data) => 
				switch data.result
					when "OK"
						@modules = data.modules
						@displayModules()
						@fitToBounds()
						@updatePopups()
					when 'NOT_AUTHENTICATED'
						# Do nothing.
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get Övik overview map data.', data.result);
			error: ajaxFailure

	ajaxUpdatePopup: (moduleId) ->
		$.ajax
			url: "/pgweb/ajax/ovik/ovikOverviewBars.php"
			dataType: 'json'
			type: 'GET'
			data:
				moduleId: moduleId
				authCode: $.url().param('authCode')
			success: (data) => 
				switch data.result
					when "OK"
						$("#overview-bars"+moduleId).html data.html
					when 'NOT_AUTHENTICATED'
						# Do nothing.
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get Övik overview value data.', data.result);
			error: (jqXHR, str, ex) ->
				if jqXHR.readyState == 0 and jqXHR.statusText == 'error' and jqXHR.status == 0 and jqXHR.responseText == ''
					# Empty error, do nothing.
					# console.log 'Empty error!'
				else
					ajaxFailure jqXHR, str, ex

	ajaxGetTemperature: () ->
		#console.log 'Temperature'
		#$('#overview-temperature').html "-28 °C"
		#return
		waitStart()
		$.ajax
			url: $.url().attr('base')+'/pgweb/ajax/ovik/ovikOverviewWeather.php'
			dataType: 'json'
			type: 'GET'
			success: (data) => 
				$('#overview-temperature').html Math.round(data.main.temp)+' C°'
			error: (jqXHR, str, ex) =>
				ajaxFailure jqXHR, str, ex
				$('#overview-temperature').html ''
			complete: -> waitStop()

	displayModules: ->
		@createMarkers()

	updatePopups: ->
		for module in @modules
			@ajaxUpdatePopup module.id

$(-> 
	ovikOverviewMap = pgweb.OvikOverviewMap.inst()
	if ovikOverviewMap
		if !ovikOverviewMap.isInitialized()
			ovikOverviewMap.init()
)
class pgweb.OvikOverviewPage

	constructor: ->
		$('body').on 'pageshow', '.ovikOverviewPage', =>
			pgweb.OvikOverviewMap.inst().init()
		$('body').on 'pageshow', '.advenOverviewPage', =>
			pgweb.AdvenOverviewMap.inst().init()
		
	instance = null
	
	@inst: ->
		if not instance?
			instance = new @
		instance

$(-> pgweb.OvikOverviewPage.inst())
class pgweb.MappingTemplate

	@calcUltrasonicMaxbotixMB7138AN5V: (mappingData) ->
		h = mappingData.sensor_height
		d = 1715/350
		raw_low = Math.round(h*d)
		raw_hi = 0
		eu_low = 0
		eu_hi = h
		{ raw_low: raw_low, raw_hi: raw_hi, eu_low: eu_low, eu_hi: eu_hi }

	@calcUltrasonicMaxbotixMB7138Serial: (mappingData) ->
		h = mappingData.sensor_height
		d = 3500/350
		raw_low = Math.round(h*d)
		raw_hi = 0
		eu_low = 0
		eu_hi = h
		{ raw_low: raw_low, raw_hi: raw_hi, eu_low: eu_low, eu_hi: eu_hi }
# The PHP version of this class is tag/TagCategorySymbol.php.
class pgweb.TagCategorySymbol
	@NONE = 0
	@MIC = 1
	@TEMPERATURE = 2
	@BOLT = 3
	@WATER = 4

	@symbols:
		0: "None"
		1: "Mic"
		2: "Temperature"
		3: "Bolt"
		4: 'Water'

	# If value ends with .png, a png image will be used instead.
	@awesomeNames:
		0: ""
		1: "microphone"
		2: "thermometer-half"
		3: "bolt"
		4: "waterdrop.png"

	# Normally, for png images the color is set according to light or dark theme, but it can
	# be overridden (for example on admin pages).
	# For Font Awesome characters, the color is set automatically by CSS.
	@html: (symbol, size, color = null) ->
		if !symbol then symbol = 0
		if @awesomeNames[symbol].endsWith '.png'
			themeType = parseInt $('#theme-type').val()
			if !color
				color = if themeType == 0 then "white" else "black"
			fname = @awesomeNames[symbol].replace ".png", '-'+color+".png"
			'<img src="images/'+fname+'" style="width: '+size+'px"/>'
		else
			'<i class="fa fa-'+@awesomeNames[symbol]+'"></i>'
class pgweb.TagCategoryListPage
	
	instance = null
	
	@inst: ->
		if not instance?
			instance = new @
		instance

	init: ->
		pgweb.TagCategoryListMap.inst().id = 'tag-category-list-map'
		pgweb.TagCategoryListMap.inst().init()

		if pgweb.TagCategoryListMap.inst().showCookie()
			pgweb.TagCategoryListMap.inst().show()
		else
			pgweb.TagCategoryListMap.inst().hide()

		$('body').on 'change', '#map-onoff', ->
			mapOn = $(@).val()=='on'
			if mapOn
				switchOnMap()
			else
				switchOffMap()
		
		$('body').on 'change', '.needle-button', (e) =>
			checkbox = $(e.currentTarget)
			checked = checkbox.is ':checked'
			color = checkbox.val()
			tclm = pgweb.TagCategoryListMap.inst()

			for tag in tclm.tags

				# Toggle rows.
				tr = @findTr tag.tag_id
				if tag.dropletColor == color
					tr.toggle checked
				
				# Toggle map needles.
				tclm.toggleMapNeedles color, checked

		pgweb.ExportToClipboard.init 'tag-table'

	findTr: (tagIdToFind) ->
		for tr in $('.module-table tbody tr')
			tagId = lastNum $(tr).attr 'id'
			if tagId == tagIdToFind
				return $(tr)

	switchOnMap = ->
		pgweb.TagCategoryListMap.inst().id = 'tag-category-list-map'
		pgweb.TagCategoryListMap.inst().show()

	switchOffMap = ->
		pgweb.TagCategoryListMap.inst().id = 'tag-category-list-map'
		pgweb.TagCategoryListMap.inst().hide()

$(document).on 'pageshow', '.tagCategoryListPage', (event) ->
	pgweb.TagCategoryListPage.inst().init()
class pgweb.UserSettings
	constructor: ->
		if $('[name="avatar_file"]').length > 0
			if $('[name="avatar_file"]').val().trim()
				$('#avatar-symbol').hide()
				$('#avatar-image').show()
			else
				$('#avatar-symbol').show()
				$('#avatar-image').hide()

		$('body').on 'popupafterclose', '.avatar-popup', =>
			$('#avatar-popup-error-message').html ''
			$('#avatar-upload-button').prop 'disabled', true
			$('#avatar-filename').val ''
			if $('#avatar-filename').val() or $('[name="avatar_file"]').val()
				$('#avatar-remove-button').prop 'disabled', false
			else
				$('#avatar-remove-button').prop 'disabled', true

		$('body').on 'popupafteropen', '.avatar-popup', (e) =>
			if $('#avatar-filename').val() or $('[name="avatar_file"]').val()
				$('#avatar-remove-button').prop 'disabled', false
			else
				$('#avatar-remove-button').prop 'disabled', true
			$('#avatar-filename-displayed').val ''
			$('#avatar-filename-displayed-div').text ''

		# Button for selecting a file in the OS. Simulate a click on
		# the invisible file input element.
		$('body').on 'click', '#avatar-select-file-button', (e) ->
			$('#avatar-filename').click()
			false # Needed to not behave like a submit button.

		# The real file input element changes. Copy the filename excluding
		# the path to the fake input element.
		$('body').on 'change', '#avatar-filename', (e) ->
			$('#avatar-popup-error-message').html ''
			filenamePath = $('#avatar-filename').val()
			filename = filenamePath.split('\\').pop().split('/').pop()
			$('#avatar-filename-displayed').val filename
			$('#avatar-filename-displayed-div').text filename
			if filename
				$('#avatar-upload-button').prop 'disabled', false
				$('#avatar-remove-button').prop 'disabled', false
			else
				$('#avatar-upload-button').prop 'disabled', true

		# Do the upload.
		$('body').on 'click', '#avatar-upload-button', (e) ->
			userId = $('[name=user_id]').val()
			uploadAvatar userId
			false

		# Remove the avatar.
		$('body').on 'click', '#avatar-remove-button', (e) ->
			$('#avatar-symbol').show()
			$('#avatar-image').find('img').attr 'src', ''
			$('#avatar-image').hide()
			$('#avatar-filename-displayed').val ''
			$('#avatar-filename-displayed-div').text ''
			$('[name="avatar_file"]').val ''
			$('#avatar-filename').val ''
			$('#avatar-edit-message').show()
			$('#avatar-popup').popup 'close'
			false

		$('body').on 'click', '#avatar-popup-cancel', (e) ->
			$('#avatar-popup').popup 'close'

		$('body').on 'click', '.save-user-settings-button', (event) ->
			waitStart()
			languageCode = $("#settingsPage input[name=language]:checked").val()
			timezone = $("#settingsPage [name=timezone]").val()
			password = $("#user-settings-password-input").val()
			password2 = $("#user-settings-password2-input").val()
			avatarFile = $('[name="avatar_file"]').val()
			try
				if password != password2
					throw t.UserSettings_PasswordsMustBeSame
				if password != "" and !passwordStrengthIsOK password
					throw t.UserSettings_PasswordIsNotSecure
				themeId = $('[name=theme]:checked').val()
				$.ajax
					url: "/pgweb/ajax/user/saveSettings.php"
					dataType: 'json'
					type: 'POST'
					data:
						languageCode: languageCode
						timezone: timezone
						themeId: themeId
						password: password
						avatarFile: avatarFile
					success: (data) ->
						if data.result == "OK"
							infoMessage t.UserSettings_SettingsHaveBeenSaved
							$('#settingsPage input').attr 'disabled', true
							setTimeout ->
								location.reload true
							, 2000
						else if data.result == 'NOT_LOGGED_IN'
							handleInactivity()
						else
							alert t.UserSettings_SaveFailedMessage+": "+data.debug
					error: ajaxFailure
					complete: waitStop
			catch ex
				errorMessage ex
				waitStop()

	instance = null
	
	@inst: ->
		if not instance?
			instance = new @
		instance

	uploadAvatar = (userId) ->
		errStr = ''
		##if $('[name=description]').val() == '' then errStr += t.UserDocument_PleaseEnterDescription+'<br/>'
		if errStr
			$('#avatar-popup-error-message').html errStr
			return false
		formData = new FormData $('#avatar-inputs')[0]
		formData.append 'userId', userId
		waitStart()
		$.ajax
			url: "/pgweb/ajax/user/avatarUpload.php"
			dataType: 'json'
			type: "POST"
			data: formData
			processData: false  # tell jQuery not to process the data
			contentType: false   # tell jQuery not to set contentType
			success: (data) ->
				switch data.result
					when 'OK'
						$('#avatar-symbol').hide()
						$('#avatar-image').find('img').attr 'src', 'images/user/avatar/'+data.filename
						$('#avatar-image').show()
						$('[name="avatar_file"]').val data.filename
						$('#avatar-filename-displayed').val ''
						$('#avatar-filename-displayed-div').text ''
						$('#avatar-popup').popup 'close'
						$('#avatar-edit-message').show()
					when 'FILE_ERROR: 0'
						$('#avatar-popup-error-message').html t.UserSettings_FileSizeTooLarge
					when 'INVALID_DATA'
						$('#avatar-popup-error-message').html t.UserSettings_InvalidData
					when 'INVALID_FILE_EXTENSION'
						$('#avatar-popup-error-message').html t.UserSettings_FileExtensionNotPermitted
					when 'INVALID_FILE_TYPE'
						$('#avatar-popup-error-message').html t.UserSettings_InvalidFileType
					when 'FILE_SIZE_TOO_LARGE'
						$('#avatar-popup-error-message').html t.UserSettings_FileSizeTooLarge
					else
						$('#avatar-popup-error-message').html t.UserSettings_UploadFailed
			error: ajaxFailure
			complete: -> waitStop()
		false

$(-> pgweb.UserSettings.inst())
class pgweb.UserDocumentPopup
	instance = null

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	constructor: ->
		$('body').on 'popupafterclose', '.user-document-popup', =>
			$('#user-document-nonetext').hide()
			$('#user-document-table').hide()
			$('#user-document-table thead').html ''
			$('#user-document-table tbody').html ''
			$('#user-document-error-message').html ''
		
		$('body').on 'popupafteropen', '.user-document-popup', (e) =>
			$('#user-document-nonetext').hide()
			$('#user-document-table').hide()
			popup = $(e.target)
			assoc = popup.find('[name=document-assoc]').val()
			assocId = popup.find('[name=document-assoc-id]').val()
			loadDocuments assoc, assocId
		
		# The wrapper around the real file input element could not
		# be hidden by CSS so remove it here.
		$('#user-document-filename').parent().hide()
		
		# Open the add document input form.
		$('body').on 'click', '#user-document-new-button', (e) ->
			assoc = $('[name=document-assoc]').val()
			if assoc == 'mic'
				micNum = $('[name=mic-num]').val()
				pgweb.SonitusPanel.startRecording micNum
			else
				$('#user-document-table-inputs').show 300, ->
				$('#user-document-new-button').hide()
		
		# Close the add document input form.
		$('body').on 'click', '#user-document-add-form-close-icon', (e) ->
			$('#user-document-table-inputs').hide 300, ->
			$('#user-document-new-button').show()
			$('#user-document-error-message').html ''
		
		# Button for selecting a file in the OS. Simulate a click on
		# the invisible file input element.
		$('body').on 'click', '#user-document-select-file-button', (e) ->
			$('#user-document-filename').click()
			false # Needed to not behave like a submit button.
		
		# The real file input element changes. Copy the filename excluding
		# the path to the fake input element.
		$('body').on 'change', '#user-document-filename', (e) ->
			filenamePath = $('#user-document-filename').val()
			filename = filenamePath.split('\\').pop().split('/').pop()
			$('#user-document-filename-displayed').val filename
		
		# Do the upload.
		$('body').on 'click', '#user-document-upload-button', (e) ->
			networkId = $('[name=network_id]').val()
			assoc = $('[name=document-assoc]').val()
			assocId = $('[name=document-assoc-id]').val()
			uploadDocument networkId, assoc, assocId
		
		$('body').on 'click', '.doc-trash-button', (e) ->
			try
				div = $(e.target).closest('div')
				if div.hasClass 'doc-trash-button-disabled' then throw 'DISABLED'
				id = lastNum div.prop 'id'
				if confirm t.UserDocument_DeleteQuestion
					deleteDocument id
			catch e
				if e == 'DISABLED'
					# Do nothing.
				else
					console.log e

		$('body').on 'click', '.doc-edit-button', (e) ->
			try
				div = $(e.target).closest('div')
				id = lastNum div.prop 'id'
				if div.hasClass 'doc-edit-button-disabled' then throw 'DISABLED'
				if div.hasClass 'doc-edit-button-editing'
					# We are already editing. Event focusout will be triggered if there are changes.
					newDescription = $('#doc-description-input'+id).val().trim()
					description = $('#doc-row'+id+' a').text().trim()
					if description == newDescription
						# No change, so save will not be performed, so we have to return to normal mode.
						toNormalMode id
				else
					# Enter edit mode.
					toEditMode id
					$('#doc-description-input'+id).off 'focusout'
					$('#doc-description-input'+id).on 'focusout', ->
						saveDescription id
					$('#doc-description-input'+id).off 'keyup'
					$('#doc-description-input'+id).on 'keyup', (e) ->
						if e.keyCode == 13
							# Enter key was pressed. Trigger event focusout in order to save changes.
							$('#doc-description-input'+id).blur()
			catch ex
				if e == 'DISABLED'
					# Do nothing.
				else
					console.log ex

		$('body').on 'click', '#user-document-refresh-button', (e) ->
			assoc = $('[name=document-assoc]').val()
			assocId = $('[name=document-assoc-id]').val()
			loadDocuments assoc, assocId

		# This also handles links in the document panel!
		$('body').on 'click', '.doc-link', (e) ->
			name = $(e.currentTarget).html().trim()
			url = $(e.currentTarget).attr 'href'
			pgweb.Main.inst().openInStrippedWindow(url, name)
			false

	saveDescription = (id) ->
		$('#user-document-edit-error-message').html ''
		errStr = ''
		newDescription = $('#doc-description-input'+id).val().trim()
		if newDescription == ''
			errStr += 'Description must not be empty.'
		if errStr
			$('#user-document-edit-error-message').html errStr
		else
			description = $('#doc-row'+id+' a').text().trim()
			if description == newDescription
				toNormalMode id
				return
			networkId = $('[name=network_id]').val()
			$.ajax
				url: "/pgweb/ajax/document/documentEdit.php"
				dataType: 'json'
				type: "POST"
				data:
					networkId: networkId
					id: id
					description: newDescription
				success: (data) ->
					switch data.result
						when 'OK'
							toNormalMode id
						when 'ALREADY_USED_DESCRIPTION'
							$('#user-document-edit-error-message').html 'Description already used.'
						else
							$('#user-document-edit-error-message').html data.result
				error: ajaxFailure
				complete: -> waitStop()
	
	toEditMode = (id) ->
		description = $('#doc-row'+id+' a').text().trim()
		$('#doc-row'+id+' a').hide()
		$('#doc-row'+id+' .doc-description-td').append '<input id="doc-description-input'+id+'" type="text" value="'+description+'"/>'
		$('#doc-description-input'+id).textinput()
		$('#doc-edit-button'+id).addClass 'doc-edit-button-editing'

	toNormalMode = (id) ->
		newDescription = $('#doc-description-input'+id).val().trim()
		$('#doc-description-input'+id).remove()
		$('#doc-row'+id+' a').text newDescription
		$('#doc-row'+id+' a').show()
		$('#doc-edit-button'+id).removeClass 'doc-edit-button-editing'
	
	uploadDocument = (networkId, assoc, assocId) ->
		errStr = ''
		if $('[name=description]').val() == '' then errStr += t.UserDocument_PleaseEnterDescription+'<br/>'
		if $('[name=filename]').val() == '' then errStr += t.UserDocument_PleaseSelectFile+'<br/>'
		if errStr
			$('#user-document-error-message').html errStr
			return false
		formData = new FormData $('#user-document-table-inputs')[0]
		formData.append 'networkId', networkId
		formData.append 'assoc', assoc
		formData.append 'assocId', assocId
		waitStart()
		$.ajax
			url: "/pgweb/ajax/document/documentUpload.php"
			dataType: 'json'
			type: "POST"
			data: formData
			processData: false  # tell jQuery not to process the data
			contentType: false   # tell jQuery not to set contentType
			success: (data) ->
				switch data.result
					when 'OK'
						$('#user-document-description').val ''
						$('#user-document-filename').val ''
						$('#user-document-filename-displayed').val ''
						$('#user-document-table-inputs').hide 300, ->
						$('#user-document-new-button').show()
						assoc = $('[name=document-assoc]').val()
						assocId = $('[name=document-assoc-id]').val()
						num = if data.numberOfDocuments > 0 then data.numberOfDocuments else ''
						$('#user-document-number-'+assoc+assocId).text num
						loadDocuments assoc, assocId

						pgweb.DocumentsPanel.load()
					when 'FILE_ERROR: 0'
						$('#user-document-error-message').html t.UserDocument_FileSizeTooLarge
					when 'INVALID_DATA'
						$('#user-document-error-message').html t.UserDocument_InvalidData
					when 'INVALID_FILE_EXTENSION'
						$('#user-document-error-message').html t.UserDocument_FileExtensionNotPermitted
					when 'FILE_SIZE_TOO_LARGE'
						$('#user-document-error-message').html t.UserDocument_FileSizeTooLarge
					else
						$('#user-document-error-message').html t.UserDocument_UploadFailed
			error: ajaxFailure
			complete: -> waitStop()
		false
	
	deleteDocument = (id) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/document/deleteDocument.php"
			dataType: 'json'
			type: "GET"
			data:
				networkId: $.url().param().networkId
				docId: id
			success: (data) ->
				switch data.result
					when 'OK'
						$('#doc-row'+id).hide 600, ->
							$('#doc-row'+id).remove()
							nDocs = $('#user-document-table tbody tr').length
							popup = $('#user-document-popup')
							assoc = popup.find('[name=document-assoc]').val()
							assocId = popup.find('[name=document-assoc-id]').val()
							if nDocs == 0
								$('#user-document-table').hide()
								$('#user-document-nonetext').show 300
								$('#user-document-number-'+assoc+assocId).text ''
							else
								$('#user-document-number-'+assoc+assocId).text nDocs
							
							num = parseInt $('#user-document-number-'+assoc+assocId).text()
							if num > 0
								$('#user-document-number-'+assoc+assocId).text num
							else
								$('#user-document-number-'+assoc+assocId).text ''

							pgweb.DocumentsPanel.load()
					else
						$('#user-document-error-message').html t.UserDocument_DeletingDocumentFailed
			error: ajaxFailure
			complete: -> waitStop()
	
	loadDocuments = (assoc, assocId) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/document/getDocuments.php"
			dataType: 'json'
			type: "GET"
			data:
				networkId: $.url().param().networkId
				assoc: assoc
				assocId: assocId
			success: (data) ->
				thead = $('#user-document-table thead')
				tbody = $('#user-document-table tbody')
				thead.html ''
				tbody.html ''
				switch data.result
					when 'OK'
						if data.documents.length > 0
							$('#user-document-nonetext').hide()
							$('#user-document-table').show()
							thead.html getHtmlHead()
						else
							$('#user-document-nonetext').show()
							$('#user-document-table').hide()
						html = ''
						for d in data.documents
							html += getHtmlRow d, data.isAdmin, data.userId
						tbody.html html
						$('#user-document-edit-error-message').html ''
					else
						$('#user-document-error-message').html t.UserDocument_FetchingDocumentListFailed
			error: ajaxFailure
			complete: -> waitStop()
	
	getHtmlHead = () ->
		html = '<tr><th>'+t.UserDocument_Description+'</th><th>'+t.UserDocument_User+'</th><th>'+t.UserDocument_Uploaded+'</th>'
		if not isReader then html += '<th></th><th></th>'
		html += '</tr>'
	
	getHtmlRow = (d, isAdmin, currentUserId) ->
		html = ''
		html += "<tr id=\"doc-row#{d.id}\">"
		html += '  <td class="doc-description-td">'
		html += "    <a href=\"/pgweb/userdocs/#{d.filename}\" target=\"_blank\" class=\"doc-link\">"
		html +=        escapeStringForHTML d.description
		html += '    </a>'
		html += '  </td>'
		html += '  <td>'
		if d.user_id
			html += d.user_firstname+' '+d.user_surname
		else
			html += '<i>'+t.UserDocument_System+'</i>'
		html += '  </td>'
		html += '  <td>'
		html +=      pgweb.Main.dbTimeUTCToGlobalizedFormat d.uploaded_time_utc
		html += '  </td>'
		
		if not isReader
			html += getEditButtonCellHtml isAdmin, d.id, d.user_id, currentUserId
			html += getTrashButtonCellHtml isAdmin, d.id, d.user_id, currentUserId
		html += '</tr>'
	
	getEditButtonCellHtml = (isAdmin, docId, docUserId, currentUserId) ->
		disableClass = if isAdmin or (docUserId == currentUserId) then '' else 'doc-edit-button-disabled'
		html  = '  <td>'
		html += "    <div id=\"doc-edit-button#{docId}\" class=\"doc-edit-button #{disableClass}\" data-theme=\"b\"><i class=\"fa fa-pencil fa-lg\"></i></div>"
		html += '  </td>'
	
	getTrashButtonCellHtml = (isAdmin, docId, docUserId, currentUserId) ->
		disableClass = if isAdmin or (docUserId == currentUserId)  then '' else 'doc-trash-button-disabled'
		html  = '  <td>'
		html += "    <div id=\"doc-trash-button#{docId}\" class=\"doc-trash-button #{disableClass}\" data-theme=\"b\"><i class=\"fa fa-trash fa-lg\"></i></div>"
		html += '  </td>'
class pgweb.SaveNewPasswordForm

	instance = null
	
	constructor: ->
		$('#save-button').click =>
			code = $.url().param().code
			password = $('#pgweb-password').val()
			password2 = $('#pgweb-password2').val()
			failStr = ''
			if password.trim().length == 0 or password2.trim().length == 0
				failStr +=  t.LoginPage_MissingPassword+'<br/>'
			if password.trim().length < 8
				failStr +=  t.LoginPage_InvalidPassword+'<br/>'
			if password.trim().length > 0 and password2.trim().length > 0
				if password != password2
					failStr += t.UserSettings_PasswordsMustBeSame+'<br/>'
			if failStr
				errorMessage failStr
			else
				@ajaxSaveNewPassword code, password
			false

	@inst: ->
		if not instance?
			instance = new @
		instance

	ajaxSaveNewPassword: (code, password) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/user/saveNewPassword.php"
			dataType: 'json'
			type: 'POST'
			data:
				code: code
				password: password
			success: (data) ->
				switch data.result
					when "OK"
						infoMessage t.LoginPage_NewPasswordSaved
						# Cookie disappears after two days.
						pgwebSetCookie 'savedNewPassword_'+code, 1, 2
						window.setTimeout ->
							window.location = '/pgweb'
						, 2000
					else errorMessage "Failed to save the new password: "+data.debug
			error: ajaxFailure
			complete: -> waitStop()

$(-> pgweb.SaveNewPasswordForm.inst())
class pgweb.InviteUserAcceptForm
	instance = null
	
	constructor: ->
		$('body').on 'click', '#network-register-button', =>
			@checkForm()
		
	@inst: ->
		if not instance?
			instance = new @
		instance
	
	checkForm: ->
		errStr = ''
		if $('[name=alreadyConfirmed]').val() == '0'
			password = $('#pgweb_password').val().trim()
			if password.length == 0
				errStr += 'Missing password.<br>'
			else
				if not pgweb.Main.isStrongPassword password
					errStr += 'The password must contain at least 8 characters a-z, A-Z, 0-9.<br>'
			password2 = $('#pgweb_password2').val().trim()
			if password2.length == 0
				errStr += 'Missing password confirmation.<br>'

			if (pgweb.Main.isStrongPassword password) and password2.length > 0
				if password != password2
					errStr += 'The password and the password confirmation don\'t match.<br>'

			firstname = $('#first_name').val().trim()
			if firstname.length == 0
				errStr += 'Missing first name.<br>'

			surname = $('#surname').val().trim()
			if surname.length == 0
				errStr += 'Missing surname.<br>'

			jobtitle = $('#job_title').val().trim()
			if jobtitle.length == 0
				errStr += 'Missing job title.<br>'

		errorMessage errStr

		return errStr.length == 0

$(-> pgweb.InviteUserAcceptForm.inst())
class pgweb.Login
	
	instance = null
	
	@inst: ->
		if not instance?
			instance = new @
			instance.init()
		instance

	init: ->
		u = pgwebGetCookie 'auth_version'
		newAuth = false
		if u
			if u > 0
				newAuth = true
		if not newAuth
			@forgetCredentials()
		pgwebSetCookie 'auth_version', '1'

		if $.mobile?
			if $.mobile.activePage and $.mobile.activePage[0].id is "loginPage" and @usernameFromCookie()
				@displayCredentials()
		
		$('body').on 'pageshow', '#loginPage', (event) =>
			if @usernameFromCookie()
				@displayCredentials()

		$('body').on 'click', '#loginButton', (event) =>
			@onLoginButtonClick event

		$('body').on 'click', '#logoutButton', (event) =>
			@onLogoutButtonClick event
			
		$('body').on 'click', '#send-new-password-button', (event) =>
			@onSendNewPasswordLinkClick event

	# Take credentials from cookies and display them in the form.
	displayCredentials: ->
		node = $.mobile.activePage.find "[name=pgweb_username]"
		node.val @usernameFromCookie()

		node = $.mobile.activePage.find "[name=pgweb_password]"
		node.val @passwordFromCookie()

		node = $.mobile.activePage.find "[name=remember]"
		node.attr "checked", "checked"
		node.checkboxradio "refresh"

	onLoginButtonClick: ->
		username = $("#pgweb_username").val().trim().toLowerCase()
		password = $("#pgweb_password").val()
		try
			validateMessages = @loginValidate username, password
			if validateMessages.length > 0 then throw "VALIDATE_ERROR"

			@ajaxLogin username, password
			
			rememberCredentialsChecked = $('.ui-page-active [name=remember]')[0].checked
			if rememberCredentialsChecked
				@rememberCredentials username, password
			else
				@forgetCredentials()
		catch ex
			switch ex
				when "VALIDATE_ERROR" then errorMessage validateMessages.join "<br />"
				else alert ex.message
		event.preventDefault()
		window.setTimeout (->
			$('#login-form .ui-btn-active').removeClass "ui-btn-active"
		), 500

	onSendNewPasswordLinkClick: ->
		username = $("#pgweb_username").val()
		try
			if !username then throw "VALIDATE_ERROR"
			@ajaxSendNewPasswordLink username
		catch ex
			switch ex
				when "VALIDATE_ERROR" then errorMessage t.LoginPage_EnterUsername
		event.preventDefault()

	loginValidate: (username, password) ->
		s = []
		if username is "" then s.push t.LoginPage_EnterUsername
		if password is "" then s.push t.LoginPage_EnterPassword
		s

	onLogoutButtonClick: (event) ->
		@ajaxLogout()
		event.preventDefault()

	rememberCredentials: (username, password) ->
		@usernameToCookie username
		@passwordToCookie password

	forgetCredentials: ->
		$.removeCookie 'pgweb_username', path: '/'
		$.removeCookie 'pgweb_password', path: '/'

	usernameFromCookie: ->
		@deobf pgwebGetCookie 'username'

	passwordFromCookie: ->
		@deobf pgwebGetCookie 'password'

	usernameToCookie: (username) ->
		pgwebSetCookie 'username', (@obf username)

	passwordToCookie: (password) ->
		pgwebSetCookie 'password', (@obf password)

	obf: (txt) ->
		btoa txt

	deobf: (txt) ->
		if txt 
			atob txt
		else ''

	ajaxLogin: (username, password) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/user/login.php"
			dataType: 'json'
			type: 'POST'
			data:
				username: username
				password: password
			success: (data) ->
				switch data.result
					when "OK"
						pgwebSetCookie 'idHash', data.idHash
						#$.mobile.changePage $.url().attr('source'), reloadPage: true
						window.location = $.url().attr('source')
					when "LOGIN_FAILED"
						errorMessage t.LoginPage_InvalidCredentials
					else errorMessage "Login failed: "+data.debug
			error: ajaxFailure
			complete: -> waitStop()

	ajaxLogout: ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/user/logout.php"
			dataType: 'json'
			success: (data) ->
				switch data.result
					when "OK"
						pgwebRemoveCookie 'idHash'
						window.location = $.url().attr('source')
					else alert "Logout failed: "+data.debug
			error: ajaxFailure
			complete: -> waitStop()

	ajaxSendNewPasswordLink: (username) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/user/sendNewPasswordLink.php"
			dataType: 'json'
			type: 'POST'
			data:
				username: username
			success: (data) ->
				switch data.result
					when "OK"
						infoMessage t.LoginPage_NewPasswordMailSent
						$('#forgot-password-panel').trigger 'collapse'
					else errorMessage "Failed to send new password: "+data.debug
			error: ajaxFailure
			complete: -> waitStop()

	isSuperAdmin: ->
		@usernameFromCookie() in ['jorgen.wennman@pipeguard.se', 'elias.waldhe@pipeguard.se']

$(-> pgweb.Login.inst())
class pgweb.InviteUserDialog
	instance = null
		
	constructor: ->
		$('body').on 'click', '#network-invite-user-button', (event, ui) =>
			$('#network-invite-user-popup').popup 'open', {transition: 'pop'}
		
		$('body').on 'click', '.network-invite-user-send-button', (event, ui) =>
			send()
		
	@inst: ->
		if not instance?
			instance = new @
		instance
	
	send = ->
		$('#network-invite-user-error-message').html ''
		networkId = $('input[name=network_id]').val()
		organisationId = $('input[name=organisation_id]').val()
		email = $('input[name=email]').val()
		language = $('input[name=language]:checked').val()
		receiveMessagesEmail = $('input[name=receiveMessagesEmail]').prop('checked')
		receiveMessagesSms = $('input[name=receiveMessagesSms]').prop('checked')
		permissionLevel = $('input[name=permissionLevel]:checked').val()
		
		#console.log networkId, email, language, receiveMessagesEmail, receiveMessagesSms, permissionLevel
		
		errStr = ''
		
		if email
			if not pgweb.Main.emailValid email
				errStr += t.NetworkInvitation_InvalidEmail+'<br/>'
		else
			errStr += t.NetworkInvitation_MissingEmail+'<br/>'

		if errStr
			$('#network-invite-user-error-message').html errStr
			return false

		waitStart()
		$.ajax
			url: "/pgweb/ajax/user/networkInviteUser.php"
			dataType: 'json'
			type: 'POST'
			data:
				networkId: networkId
				email: email
				language: language
				receiveMessagesEmail: receiveMessagesEmail
				receiveMessagesSms: receiveMessagesSms
				permissionLevel: permissionLevel
			success: (data) =>
				switch data.result
					when "OK"
						$('#network-invite-user-popup').popup 'close'
						$('#network-invite-user-popup').one 'popupafterclose', =>
							alert t.NetworkInvitation_InvitedMessage
							#location.reload(true);
					when 'NOT_LOGGED_IN'
						handleInactivity()
					when 'EMAIL_ADDRESS_IS_NOT_UNIQUE'
						$('#network-invite-user-error-message').html t.NetworkInvitation_EmailExists+"<br/>"
					when 'NETWORK_HAS_NO_ORGANISATION'
						$('#network-invite-user-error-message').html t.NetworkInvitation_NetworkHasNoOrg+"<br/>"
					else
						$('#network-invite-user-error-message').html t.NetworkInvitation_InvitationFailed+"<br/>"+data.debug
			error: ajaxFailure
			complete: -> waitStop()
		return true

$(-> pgweb.InviteUserDialog.inst())
class pgweb.SonitusSectionShowPage

	instance = null
	selectedFrequencyIndex = 1
	
	constructor: ->
		s = globalSection

		$('body').on 'click', '.sonitus-section-edit-button', ->
			$('#sonitus-new-section-popup').popup 'open'
			$('#section-popup-title').text t.SonitusSection_EditSection
			sectionId = parseInt lastNum @.id
			$('#section-id').val s.id
			$('#section-name').val s.name

			for i in [1, 2]
				# Select module.
				$("#module#{i}").val s["module#{i}_id"]
				$("#module#{i}").selectmenu 'refresh'

				moduleId = parseInt $("#module#{i}").val()
				pgweb.SonitusSectionEdit.inst().populateMic i, moduleId, s['mic_number'+i]
				
			$("#section-length").val s.length

			$("#section-note").val s.note
		
		$('body').on 'click', '.sonitus-section-save-button', =>
			pgweb.SonitusSectionEdit.inst().ajaxSave()
		
		# Tooltip on mic bars, this is also for the mic bars on the section list page.
		$('body').on 'mouseover', '.sonitus-section-micsymbol', (e) ->
			value = $(@).attr 'data-tooltip'
			if value?
				if value.length > 0
					pgweb.Main.showTooltip value
			
		$('body').on 'mouseout', '.sonitus-section-micsymbol', (e) ->
			pgweb.Main.removeTooltip '.sonitus-section-micsymbol'
		
		$('body').on 'click', '.top-header-rest', (e) ->
			if analysisMode()
				header = $(e.target)
				selectedFrequencyIndex = lastNum header.attr 'id'
				setSelectedFrequencyIndex selectedFrequencyIndex
				
				diffDbAB = parseFloat $('#valdiffindex'+selectedFrequencyIndex).text()
				l = globalSection.length
				distFromA = calcDist l, diffDbAB
				distFromB = l - distFromA
				
				if isNaN distFromA
					$('#dist-from-a').text ''
				else
					$('#dist-from-a').text Globalize.format distFromA, 'n1'
				
				if isNaN distFromB
					$('#dist-from-b').text ''
				else
					$('#dist-from-b').text Globalize.format distFromB, 'n1'
				
				if isNaN distFromA
					drawPipeWithLeakCrossPos null, l
				else
					drawPipeWithLeakCrossPos 100*distFromA/l, l
		
		$('body').on 'click', '#map-tab-link', (e) ->
			pgweb.Event.trigger 'map_mode'
		
		$('body').on 'click', '#analysis-tab-link', (e) ->
			setSelectedFrequencyIndex selectedFrequencyIndex
			$('#diff-db-ab').text ''
			$('#time-interval-from').text ''
			$('#time-interval-to').text ''
			$('#dist-from-a').text ''
			$('#dist-from-b').text ''
			drawPipeWithLeakCrossPos null, globalSection.length
			pgweb.Event.trigger 'analysis_mode'
		
		$('body').on 'interval_selected', (e, jsonObj) ->
			obj = JSON.parse jsonObj
			diffDbAB = parseFloat $('#valdiffindex'+selectedFrequencyIndex).text()
			if isNaN diffDbAB
				$('#diff-db-ab').text ''
			else
				$('#diff-db-ab').text Globalize.format diffDbAB, 'n1'
			$('#time-interval-from').text pgweb.Main.unixMilliToIsoTz obj.startTime
			$('#time-interval-to').text pgweb.Main.unixMilliToIsoTz obj.stopTime
			
			l = globalSection.length
			distFromA = calcDist l, diffDbAB
			distFromB = l - distFromA
			
			if isNaN distFromA
				$('#dist-from-a').text ''
			else
				$('#dist-from-a').text Globalize.format distFromA, 'n1'
			if isNaN distFromB
				$('#dist-from-b').text ''
			else
				$('#dist-from-b').text Globalize.format distFromB, 'n1'
			
			if isNaN distFromA
				drawPipeWithLeakCrossPos null, l
			else
				drawPipeWithLeakCrossPos 100*distFromA/l, l
		
		$('body').on 'chart_click', (e) ->
			$('#diff-db-ab').text ''
			$('#time-interval-from').text ''
			$('#time-interval-to').text ''
			$('#dist-from-a').text ''
			$('#dist-from-b').text ''
			drawPipeWithLeakCrossPos null, globalSection.length

		lengthText = Globalize.format s.length, 'n1'
		$('#length').text lengthText + ' m '

		dist = pgweb.Main.distance [s.module1.gis_latitude, s.module1.gis_longitude], [s.module2.gis_latitude, s.module2.gis_longitude]
		asTheCrowFliesText = Globalize.format dist, 'n1'
		$('#as-the-crow-flies').text ' (' + asTheCrowFliesText + ' m ' + t.SonitusSection_AsTheCrowFlies + ')'

		drawPipeWithLeakCrossPos null, globalSection.length
		
		#l = 1000
		#for delta in [-80..80]
		#	console.log delta, (calcDist l, delta)
		#for delta in [-2..2] by .2
		#	console.log delta, (calcDist l, delta)
	
	calcDist = (l, delta) ->
		dist = ''
		$.ajax
			url: "/pgweb/ajax/sonitus/sonitusCalcDist.php"
			dataType: 'json'
			type: 'GET'
			async: false # <-- important: synchronous call
			data:
				l: l
				delta: delta
			success: (data) =>
				@modules = data.modules
				switch data.result
					when "OK"
						dist = data.dist
						if dist == null then dist = NaN
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to compute distance.', data.result);
			error: ajaxFailure
		return dist
	
	@inst: ->
		if not instance?
			instance = new @
		instance

	analysisMode = ->
		$('#analysis-tab-link').hasClass 'ui-btn-active'

	setSelectedFrequencyIndex = (index) ->
		$('#selected-frequency').text index*125
		$('.top-header-rest').removeClass 'selected-frequency'
		header = $('#top-header-rest'+index)
		header.addClass 'selected-frequency'
		diffText = $('#valdiffindex'+index).text()
		if diffText.length > 0
			diffDbAB = Globalize.format diffText, 'n1'
		else
			diffDbAB = ''
		$('#diff-db-ab').text diffDbAB
		$('#dist-from-a').text ''
		$('#dist-from-b').text ''

	# Draw the pipe and set the position of the leak cross at the specified position (%).
	drawPipeWithLeakCrossPos = (pos, length) ->
		PIPE_LENGTH = 500
		ISOLATION_DIAMETER = 60
		PIPE_BARE_LENGTH = 10
		PIPE_DIAMETER = 30
		LEFT_MARGIN = 20
		TOP_MARGIN = 10
		ARROW_DIST_FROM_ISOLATION = 10
		CROSS_SIZE = 32
		
		canvas = $('#leak-canvas').get()[0]
		ctx = canvas.getContext '2d'
		
		canvas.width = PIPE_LENGTH + 60
		canvas.height = 130

		ctx.lineWidth = 0.5
		ctx.strokeStyle = '#333'

		# Pipe isolation
		
		grd = ctx.createLinearGradient 0, TOP_MARGIN, 0, TOP_MARGIN + ISOLATION_DIAMETER
		grd.addColorStop(0.0, "#000");
		grd.addColorStop(0.3, "#666");
		grd.addColorStop(1, "#000");

		ctx.fillStyle = grd
		ctx.beginPath()
		ctx.rect PIPE_BARE_LENGTH + LEFT_MARGIN, TOP_MARGIN, PIPE_LENGTH - 2*PIPE_BARE_LENGTH, ISOLATION_DIAMETER
		ctx.fill()
		ctx.stroke()
		
		# Left bare pipe
		
		left_pipe_topleft_y = TOP_MARGIN + ISOLATION_DIAMETER/2 - PIPE_DIAMETER/2
		grd = ctx.createLinearGradient 0, left_pipe_topleft_y, 0, left_pipe_topleft_y + PIPE_DIAMETER
		grd.addColorStop(0.0, "#666");
		grd.addColorStop(0.3, "#fff");
		grd.addColorStop(1, "#666");

		ctx.fillStyle = grd
		ctx.beginPath()
		ctx.rect LEFT_MARGIN, left_pipe_topleft_y, PIPE_BARE_LENGTH, PIPE_DIAMETER
		ctx.fill()
		ctx.stroke()

		# Right bare pipe
		
		ctx.beginPath()
		right_pipe_topleft_x = LEFT_MARGIN + PIPE_LENGTH - PIPE_BARE_LENGTH
		ctx.rect right_pipe_topleft_x, left_pipe_topleft_y, PIPE_BARE_LENGTH, PIPE_DIAMETER
		ctx.fill()
		ctx.stroke()
		
		# Arrow between ends of pipe

		ctx.strokeStyle = '#aaa'

		arrow_y = TOP_MARGIN + ISOLATION_DIAMETER + ARROW_DIST_FROM_ISOLATION
		arrow_ydist = 30
		ctx.beginPath()
		ctx.moveTo LEFT_MARGIN, arrow_y + arrow_ydist
		ctx.lineTo LEFT_MARGIN + PIPE_LENGTH, arrow_y + arrow_ydist
		ctx.stroke()

		arrowhead ctx, LEFT_MARGIN, arrow_y + arrow_ydist
		arrowhead ctx, LEFT_MARGIN + PIPE_LENGTH, arrow_y + arrow_ydist

		ctx.font = "13px Arial"
		ctx.fillStyle = "#aaa"
		ctx.textAlign = "center"

		lengthLabelX = LEFT_MARGIN + PIPE_LENGTH/2
		lengthText = Globalize.format length, 'n1'
		ctx.fillText lengthText, lengthLabelX, arrow_y + arrow_ydist + 12
		
		ctx.font = "16px Arial"
		ctx.fillText 'A', LEFT_MARGIN - 14, TOP_MARGIN + ISOLATION_DIAMETER/2 + 5
		ctx.fillText 'B', LEFT_MARGIN + PIPE_LENGTH + 14, TOP_MARGIN + ISOLATION_DIAMETER/2 + 5

		if pos == null then return
		
		# Arrow between line between left end and leak
		
		leak_position = LEFT_MARGIN + pos*PIPE_LENGTH/100
		ctx.beginPath()
		ctx.moveTo LEFT_MARGIN, arrow_y
		ctx.lineTo leak_position, arrow_y
		ctx.stroke()

		# Arrow between right end and leak
		
		ctx.beginPath()
		ctx.moveTo LEFT_MARGIN + PIPE_LENGTH, arrow_y
		ctx.lineTo leak_position, arrow_y
		ctx.stroke()

		arrowhead ctx, LEFT_MARGIN, arrow_y
		arrowhead ctx, leak_position, arrow_y
		arrowhead ctx, leak_position, arrow_y
		arrowhead ctx, LEFT_MARGIN + PIPE_LENGTH, arrow_y

		# Measurement labels

		ctx.font = "13px Arial"
		measurementLeftLabelX = (LEFT_MARGIN + leak_position)/2
		measurementRightLabelX = (LEFT_MARGIN + PIPE_LENGTH + leak_position)/2
		distFromAText = Globalize.format length*pos/100, 'n1'
		distFromBText = Globalize.format (length - length*pos/100), 'n1'
		ctx.fillText distFromAText, measurementLeftLabelX, arrow_y + 12
		ctx.fillText distFromBText, measurementRightLabelX, arrow_y + 12
		
		imgObj = new Image()
		imgObj.src = 'images/red-cross-64.png'
		imgObj.onload = ->
			ctx.drawImage imgObj, leak_position - CROSS_SIZE/2, TOP_MARGIN + ISOLATION_DIAMETER/2 - CROSS_SIZE/2, CROSS_SIZE, CROSS_SIZE

	arrowhead = (ctx, xPos, yPos) ->
		ARROW_SIZE = 8
		ctx.beginPath()
		ctx.moveTo xPos, yPos - ARROW_SIZE
		ctx.lineTo xPos, yPos
		ctx.lineTo xPos, yPos + ARROW_SIZE 
		ctx.stroke()
	
$(document).on 'pageshow', '.sonitusSectionShowPage', (event) ->
	pgweb.SonitusSectionShowPage.inst()

class SonitusSectionCircles
	m = 25
	M = 250
	allCircles = []
	
	@drawForOneModule: (map, m, timeRange) ->
		latlng = [m.gis_latitude, m.gis_longitude]
		circles = []
		# Circles around a module, one for each mic.
		# Circles must be sorted in order to draw them sorted as smallest last.
		for mic in [1..4]
			v = if timeRange == '1h'
				m['mic'+mic+'_compound_value']
			else
				m['mic'+mic+'_compound_value_average']
			b = m['mic'+mic+'_base_level']
			l = m['hihi_limit_compoundValue'+mic]
			if v and b and l and latlng
				direction = ['fram', 'retur', 'fram', 'retur'][mic-1]
				[radius, circleColor] = getRadiusAndColor v, b, l, mic
				circles.push
					radius: radius
					circleColor: circleColor
					module: m
		circles.sort sortByRadiusCompare
		for c, i in circles
			drawCircle map, latlng, c.radius, c.circleColor, 0.2 - i*.04, c.module

	sortByRadiusCompare = (a, b) ->
		switch
			when a.radius > b.radius then -1
			when a.radius < b.radius then 1
			else 0
	
	getRadiusAndColor = (v, b, l, mic) ->
		radius = switch
			when v < b then	m
			when v >= b and v < l then valueToRadius v, b, l
			else M
		radiusAdjusted = radius + (mic - 1)*1.0 - 2 # 1 meter adjustment in radius depending on what mic
		circleColor = if mic in [1, 3] then 'red' else 'blue'
		[radiusAdjusted, circleColor]

	drawCircle = (map, latlng, radius, circleColor, opacity, module) ->
		config = getCircleConfig radius, circleColor, opacity
		circle = L.circle latlng, config
			.addTo map
		circle.module = module
		allCircles.push circle
	
	@clearAllCircles: ->
		allCircles.map (circle) -> circle.remove()
		allCircles = []

	@removeCirclesByModuleId: (moduleId) ->
		(getCirclesByModuleId moduleId).map (circle) -> circle.remove()

	@addCirclesByModuleId: (map, moduleId) ->
		sortedCircles = (getCirclesByModuleId moduleId).sort sortByRadiusCompare
		sortedCircles.map (circle) -> circle.addTo map

	getCirclesByModuleId = (moduleId) ->
		allCircles.filter (circle) -> circle.module.id == moduleId

	valueToRadius = (value, base, alarmLevel) ->
		v = value
		b = base
		L = alarmLevel
		l = (M - m*L/b)/(1 - L/b)
		k = (m - l)/b
		k*v + l
	
	getCircleConfig = (radius, circleColor, fillOpacity) ->
		allColors = getRainbowColors()
		frac = (radius-m)/(M-m) # Should be somewhere in 0..1
		nColors = Math.ceil allColors.length*frac
		rainbowStr = allColors[..nColors].join(',')
		color = switch circleColor
			when 'red'      then '#ff0000'
			when 'blue'     then '#0000ff'
			else '#ffffff' # Error
		
		radius: radius
		color: color
		weight: 2
		opacity: 0.5 # Only for lines
		fillColor: 'radialGradient(50%, 50%, 50%, 50%, 50%, '+rainbowStr+')'
		fillOpacity: fillOpacity
		#zIndexOffset: if circleColor == 'red' then 1000 else 1
	
	getRainbowColors = () ->
		[
			'#00dd00'
			'#81dd00'
			'#a6ee00'
			'#cbff00'
			'#f0ff00'
			'#ffff00'
			'#ffc600'
			'#ff8d00'
			'#ff5e00'
			'#ff2500'
			'#ff0000'
		]

class pgweb.SonitusPanel
	
	POINT_WIDTH = 15
	LIMIT_Z_INDEX = 1
	
	_greenStops = [
		[0.00, '#b4e391']
		[0.15, '#d9f492']
		[0.36, '#b9f422']
		[0.76, '#61c419']
		[1.00, '#b4e391']
	]

	_orangeStops = [
		[0.00, '#e3cf91']
		[0.15, '#f4c092']
		[0.36, '#f48422']
		[0.76, '#c59d19']
		[1.00, '#e3cf91']
	]

	_redStops = [
		[0.00, '#e3a091']
		[0.15, '#f4929c']
		[0.36, '#f42237']
		[0.76, '#c53c19']
		[1.00, '#e3a091']
	]

	_grayStops = [
		[0.00, '#a3a3a3']
		[0.15, '#b4b4b4']
		[0.36, '#b0b0b0']
		[0.76, '#848484']
		[1.00, '#a3a3a3']
	]

	_darkStops = [
		[0, 'rgb(55, 55, 55)']
		[1, 'rgb(16, 16, 16)']
	]
	_lightStops = [
		[0, 'rgb(240, 240, 240)']
		[1, 'rgb(190, 190, 190)']
	]

	_currentData = null
	_themeType = null
	_moduleActive = false

	panels = []
	
	constructor: ->
		@mainChartObj = null
		@compChartObj = null

	init: (mic) ->
		_themeType = parseInt $('#theme-type').val()
		_moduleActive = if $('#activation').val() == 'on' then true else false

		@loadMainChart mic
		@loadCompChart mic
		@mainChartObj.mic = mic

		$('body').off 'click', '#user-save-sonitus-panel-config-button-mic'+mic
		$('body').on 'click', '#user-save-sonitus-panel-config-button-mic'+mic, (e) =>
			button = $(e.target)
			popup = button.closest '[data-role=popup]'
			mic = popup.find('.mic-num').val()
			moduleId = $.url().param().moduleId
			name = $('#name'+mic).val()
			baseLevel = parseInt $('#base-level-mic'+mic).val()
			hiAlarm = parseInt $('#hi-level-mic'+mic).val()
			hihiAlarm = parseInt $('#hihi-level-mic'+mic).val()
			inData =
				moduleId: moduleId
				micNum: mic
				name: name
				baseLevel: baseLevel
				hiAlarm: hiAlarm
				hihiAlarm: hihiAlarm
			$.ajax
				url: "/pgweb/ajax/sonitus/saveSonitusPanelConfig.php"
				dataType: 'json'
				method: 'POST'
				data: inData
				success: (data) =>
					if data.result == "OK"
						$('#sonitus-panel-config-popup-mic'+mic).popup 'close'
						_currentData.baseLevel = baseLevel
						_currentData.hihiLimit = hihiAlarm
						_currentData.hiLimit = hiAlarm
						@updateYAxis @mainChartObj, true
						@updateYAxis @compChartObj, true
					else if data.result == 'NOT_LOGGED_IN'
						handleInactivity()
					else
						alert "Failed to save analysis config: "+data.debug
				error: ajaxFailure
				complete: ->
					waitStop()

		$('body').on 'change', '#base-level-mic'+mic, (e) ->
			val = parseFloat $(this).val()
			hihi = parseInt _calculateHiHiLimit val
			oldHiHi = parseInt $('#hihi-level-mic'+mic).val()
			$('#hihi-level-mic'+mic).val hihi
			if oldHiHi != hihi
				$('#hihi-level-mic'+mic).addClass 'level-highlight'

		$('body').on 'popupafterclose', '#sonitus-panel-config-popup-mic'+mic, ->
			moduleTypeId = $.url().param 'moduleTypeId'
			moduleId = $.url().param 'moduleId'
			networkId = $.url().param 'networkId'
			location.href = '?action=showModule&networkId='+networkId+'&moduleTypeId='+moduleTypeId+'&moduleId='+moduleId

		$('body').on 'popupafterclose', '#user-document-popup', ->
			$('#user-document-popup-heading').text t.UserDocument_DocumentsTitle

		$('body').on 'click', '#mic-document-button'+mic, (event, ui) =>
			button = $(event.target).closest 'button'
			tagId = button.attr 'pgweb-data-assoc-id'
			micPanel = button.closest '.gaugemeter-container-sonitus-mic'
			micNumber = lastNum micPanel.prop 'id'
			$('#user-document-popup-heading').text t.UserDocument_RecordingsTitle
			$('#user-document-popup').find('[name=document-assoc]').val 'mic'
			$('#user-document-popup').find('[name=document-assoc-id]').val tagId
			$('#user-document-popup-title').text 'MIC '+micNumber
			$('#user-document-popup').find('[name=mic-num]').val micNumber
			$('#user-document-popup').popup 'open', {transition: 'pop'}

	@startRecording: (micNum) ->
		moduleId = $('.module-id').val()
		waitStart()
		$.ajax
			url: "/pgweb/ajax/sonitus/startRecording.php"
			dataType: 'json'
			method: 'POST'
			data:
				moduleId: moduleId
				micNum: micNum
			success: (data) =>
				if data.result == "OK"
					$('#user-document-new-button i.fa-plus').addClass 'record-button-active'
					$('#user-document-new-button').addClass 'ui-disabled'
					window.setTimeout ->
						$('#user-document-new-button i.fa-plus').removeClass 'record-button-active'
						$('#user-document-new-button').removeClass 'ui-disabled'
					, 10000
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Failed to start recording: "+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()
	
	yLabelFormatter: () ->
		v = pgweb.SonitusCalculator.expToLinY @value
		for p in pgweb.SonitusCalculator.yTickPositions
			if v <= 0.98*p and v >= 1.02*p
				return p

	xLabelFormatter: () ->
		@value*125

	compXLabelFormatter: () ->
		if @value == 0 then '?'
		else @value*125
	
	chartToolTipFormatter: ->
		html  = '<div style="color: #000">'
		html += 'Frequency: '+@.x*125+' Hz<br/>'
		v = (pgweb.SonitusCalculator.expToLinY @.y).toFixed 1
		html += "Value: #{v} dB"
		html += '</div>'
		return html

	loadMainChart: (mic) ->
		config =
			chart:
				borderRadius: 10
				animation: false
				marginRight: 5
				backgroundColor:
					linearGradient: [0, 0, 0, 400]
					stops: if _themeType == 0 then _darkStops else _lightStops
			exporting: false
			title: null
			plotOptions:
				column:
					threshold: -80
					borderWidth: 0
					borderRadius: 5
					color:
						linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 }
						stops: _greenStops
					pointPadding: .1
					groupPadding: 0
					pointWidth: POINT_WIDTH
				series:
					animation: false
					dragDrop:
						draggableX: false
						draggableY: true
						liveRedraw: true
						dragMinY: -79.9
						dragMaxY: 0
					point:
						events:
							dragStart: (e) ->
								console.log 'dragStart'
							drag: (e) ->
								console.log 'drag'
							dragStop: (e) ->
								console.log 'dragStop'
			legend:
				enabled: false
			#	align: 'right'
			#	verticalAlign: 'top'
			#	x: -40
			#	itemStyle:
			#		'font-size': '12px'
			#		color: 'white'
			series: [
				type: 'column'
				name: 'Value'
				data: []
			]
			yAxis:
				endOnTick: false
				title:
					text: 'dB'
					style:
						color: if _themeType == 0 then 'white' else 'black'
				labels:
					style:
						color: if _themeType == 0 then 'white' else 'black'
					formatter: @yLabelFormatter
				tickPositions: pgweb.SonitusCalculator.calcYTickPositions()
				min: -80
				max: 0
				gridLineColor: '#888888'
			xAxis:
				title:
					text: 'Hz'
					style:
						color: if _themeType == 0 then 'white' else 'black'
				labels:
					style:
						color: if _themeType == 0 then 'white' else 'black'
					formatter: @xLabelFormatter
				tickPositions: [1, 8, 15]
			credits:
				text: 'Pipeguard'
				enabled: false
			tooltip:
				formatter: @chartToolTipFormatter
		
		@mainChartObj = Highcharts.chart 'sonitus-mic'+mic+'-chart', config

	loadCompChart: (mic) ->
		config =
			chart:
				borderRadius: 10
				animation: false
				marginRight: 5
				marginLeft: 5
				backgroundColor:
					linearGradient: [0, 0, 0, 400]
					stops: if _themeType == 0 then _darkStops else _lightStops
			exporting: false
			title: null
			plotOptions:
				column:
					threshold: -80
					borderWidth: 0
					borderRadius: 5
					color:
						linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 }
						stops: _greenStops
					pointPadding: .1
					groupPadding: 0
					pointWidth: POINT_WIDTH
				series:
					dragDrop:
						draggableX: false
						draggableY: true
						liveRedraw: true
						dragMinY: -79.9
						dragMaxY: 0
					dataLabels:
						enabled: true
						formatter: ->
							(pgweb.SonitusCalculator.expToLinY @.y).toFixed 1
						style:
							color: if _themeType == 0 then 'white' else 'black'
							fontSize: 12
						zIndex: LIMIT_Z_INDEX + 10
			legend:
				enabled: false
			series: [
				type: 'column'
				name: 'Value'
				data: []
			]
			yAxis:
				endOnTick: false
				title:
					text: ' '
					style:
						color: if _themeType == 0 then 'white' else 'black'
				labels:
					enabled: false
				tickPositions: pgweb.SonitusCalculator.calcYTickPositions()
				min: -80
				max: 0
				gridLineColor: '#888888'
			xAxis:
				title:
					text: 'Max'
					style:
						color: if _themeType == 0 then 'white' else 'black'
				labels:
					style:
						color: if _themeType == 0 then 'white' else 'black'
					formatter: @compXLabelFormatter
			credits:
				text: 'Pipeguard'
				enabled: false
			tooltip:
				enabled: false
		
		@compChartObj = Highcharts.chart 'sonitus-mic'+mic+'-compchart', config
	
	loadFromAjax: (mic, moduleId) ->
		waitStart()
		if $('[name=moduleTypeName]').val() == 'gw102'
			url = "/pgweb/ajax/sonitus/sonitusMicData.php"
		else if $('[name=moduleTypeName]').val() == 'mt331'
			url = "/pgweb/ajax/sonitus/sonitusMicDataMT331.php"
			mic = 1
		$.ajax
			url: url
			dataType: 'json'
			method: 'GET'
			data:
				mic: mic
				moduleId: moduleId
			success: (data) =>
				_currentData = data
				if data.result == "OK"
					@mainChartObj.series[0].setData []
					for item in data.seriesArr
						freqIndex = lastNum item.name
						
						# Add the value column.
						stops = _greenStops
						if item.value?
							if _moduleActive
								if item.value > data.hiLimit
									stops = _orangeStops
								if item.value > data.hihiLimit
									stops = _redStops
							else
								stops = _grayStops
							column =
								x: freqIndex
								y: item.value
							column.y = pgweb.SonitusCalculator.linToExpY column.y
						else
							column =
								x: freqIndex
								y: null
						column.color =
							linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 }
							stops: stops
						@mainChartObj.series[0].addPoint column, true

					stops = _greenStops
					if _moduleActive
						if data.compoundValue > data.hiLimit
							stops = _orangeStops
						if data.compoundValue > data.hihiLimit 
							stops = _redStops
					else
						stops = _grayStops
					compColumn =
						x: 0
						y: if data.compoundValue then (pgweb.SonitusCalculator.linToExpY data.compoundValue) else null
						color:
							linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 }
							stops: stops
					@compChartObj.series[0].setData [compColumn]

					@updateYAxis @mainChartObj, true
					@updateYAxis @compChartObj, true
				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Failed to get sonitus mic chart data: "+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()

	updateYAxis: (chart, redraw=false) ->
		if $('[name=moduleTypeName]').val() != 'gw102'
			return
		@addBaseLevelPlotLine chart, _currentData.baseLevel
		@addHiLimitPlotLine chart, _currentData.hiLimit
		@addHiHiLimitPlotLine chart, _currentData.hihiLimit
		
		@addBelowBasePlotBand chart, _currentData.baseLevel
		@addBaseToHiPlotBand chart, _currentData.baseLevel, _currentData.hiLimit
		@addHiToHiHiPlotBand chart, _currentData.hiLimit, _currentData.hihiLimit
		@addAboveHiHiPlotBand chart, _currentData.hihiLimit
		chart.yAxis[0].update {
		}, redraw

	addAboveHiHiPlotBand: (chart, hihiLevel) ->
		plotBandObj =
			from: pgweb.SonitusCalculator.linToExpY hihiLevel
			to: pgweb.SonitusCalculator.linToExpY 0
			color:
				linearGradient: { x1:0, y1: 0, x2:0, y2: 1 }
				stops: [
					[0.00, if _moduleActive then '#ff000088' else '#aaaaaa66'] # Top
					[1.00, if _moduleActive then '#ff000066' else '#aaaaaa44'] # HiHi
				]
			id: 'above-hihi-plotband'
		chart.yAxis[0].removePlotBand 'above-hihi-plotband'
		chart.yAxis[0].addPlotBand plotBandObj

	addHiToHiHiPlotBand: (chart, hiLevel, hihiLevel) ->
		plotBandObj =
			from: pgweb.SonitusCalculator.linToExpY hiLevel
			to: pgweb.SonitusCalculator.linToExpY hihiLevel
			color:
				linearGradient: { x1:0, y1: 0, x2:0, y2: 1 }
				stops: [
					[0.00, if _moduleActive then '#ff550066' else '#77777766'] # HiHi
					[0.10, if _moduleActive then '#ff880066' else '#99999966']
					[0.80, if _moduleActive then '#ffaa0066' else '#cccccc66']
					[1.00, if _moduleActive then '#ffaa0066' else '#cccccc66'] # Hi
				]
			id: 'hi-to-hihi-plotband'
		chart.yAxis[0].removePlotBand 'hi-to-hihi-plotband'
		chart.yAxis[0].addPlotBand plotBandObj

	addBaseToHiPlotBand: (chart, baseLevel, hiLevel) ->
		plotBandObj =
			from: pgweb.SonitusCalculator.linToExpY baseLevel
			to: pgweb.SonitusCalculator.linToExpY hiLevel
			color:
				linearGradient: { x1:0, y1: 0, x2:0, y2: 1 }
				stops: [
					[0.00, if _moduleActive then '#aaff0066' else '#dddddd66'] # Hi
					[0.05, if _moduleActive then '#aaff0055' else '#dddddd55']
					[0.95, if _moduleActive then '#00ff0033' else '#eeeeee33']
					[1.00, if _moduleActive then '#00ff0033' else '#eeeeee33'] # Base
				]
			id: 'base-to-hi-plotband'
		chart.yAxis[0].removePlotBand 'base-to-hi-plotband'
		chart.yAxis[0].addPlotBand plotBandObj

	addBelowBasePlotBand: (chart, baseLevel) ->
		plotBandObj =
			from: pgweb.SonitusCalculator.linToExpY -80
			to: pgweb.SonitusCalculator.linToExpY baseLevel
			color:
				linearGradient: { x1:0, y1: 0, x2:0, y2: 1 }
				stops: [
					[0, if _moduleActive then '#00ff0033' else '#a0a0a033'] # Base
					[1, if _moduleActive then '#00ff0044' else '#d0d0d044'] # Bottom
				]
			id: 'below-base-plotband'
		chart.yAxis[0].removePlotBand 'below-base-plotband'
		chart.yAxis[0].addPlotBand plotBandObj

	addBaseLevelPlotLine: (chart, value) ->
		plotLineObj =
			color: if _moduleActive then '#00dd00' else '#aaaaaa'
			dashStyle: 'Dash'
			width: 2
			value: pgweb.SonitusCalculator.linToExpY value
			id: 'mic-limit-plotline'
			zIndex: LIMIT_Z_INDEX
		chart.yAxis[0].removePlotLine 'mic-limit-plotline'
		chart.yAxis[0].addPlotLine plotLineObj

	removeBaseLevelPlotLine = (chart) ->
		chart.yAxis[0].removePlotLine 'mic-limit-plotline'

	addHiLimitPlotLine: (chart, value) ->
		plotLineObj =
			color: if _moduleActive then 'orange' else '#aaaaaa'
			dashStyle: 'Dash'
			width: 2
			value: pgweb.SonitusCalculator.linToExpY value
			id: 'mic-hi-limit-plotline'
			zIndex: LIMIT_Z_INDEX
		chart.yAxis[0].removePlotLine 'mic-hi-limit-plotline'
		chart.yAxis[0].addPlotLine plotLineObj

	removeHiLimitPlotLine: (chart) ->
		chart.yAxis[0].removePlotLine 'mic-hi-limit-plotline'

	addHiHiLimitPlotLine: (chart, value) ->
		plotLineObj =
			color: if _moduleActive then 'red' else 'gray'
			dashStyle: 'Dash'
			width: 2
			value: pgweb.SonitusCalculator.linToExpY value
			id: 'mic-hihi-limit-plotline'
			zIndex: LIMIT_Z_INDEX
		chart.yAxis[0].removePlotLine 'mic-hihi-limit-plotline'
		chart.yAxis[0].addPlotLine plotLineObj

	removeHiHiLimitPlotLine: (chart) ->
		chart.yAxis[0].removePlotLine 'mic-hihi-limit-plotline'

	_calculateHiHiLimit = (normalValue) ->
		maxValue = 0
		normalValue + (maxValue - normalValue)/3
	
	@loadAllPanels: (moduleId) ->
		for mic in [1..4]
			panels[mic] = new pgweb.SonitusPanel()
			panels[mic].init mic
			panels[mic].loadFromAjax mic, moduleId

	@updateAllPanels: (moduleId) ->
		for mic in [1..4]
			panels[mic].loadFromAjax mic, moduleId

$(document).on 'pageshow', '.showModulePage', (event) ->
	moduleId = parseInt $($('.module-id')[0]).val()
	if moduleId in [5363, 5364, 5365, 5572, 5573] or $('[name=moduleTypeName]').val() == 'gw102'
		pgweb.SonitusPanel.loadAllPanels moduleId
class pgweb.SonitusCalculator
	
	# See computation of the parameters: https://docs.google.com/spreadsheets/d/1hh2SE5y1ywJgXXL-RVf6ibIJLZTHrlC-5mQbUnbfKbQ/edit#gid=0
	
	@yTickPositions: [-80, -75, -70, -60, -50, -40, -30, 0]

	_a = 2.313694449
	_b = 0.04450865606
	_c = -1.419

	# Compute linear to exponential for the Y axis.
	@linToExpY: (x) ->
		-(_a*Math.exp(-x*_b) + _c)
	
	# Compute exponential to linear for the Y axis.
	@expToLinY: (y) ->
		-Math.log((-y-_c)/_a)/_b
	
	@calcYTickPositions: ->
		arr = []
		for p in @yTickPositions
			arr.push @linToExpY p
		arr
class pgweb.SonitusSectionEdit

	instance = null
	
	constructor: ->
		$('body').off 'change', '#module1'
		$('body').on 'change', '#module1', (e) =>
			if globalSection?
				selectedMic = globalSection.mic_number1
			else
				selectedMic = 0
			moduleId = parseInt $(e.target).val()
			@populateMic 1, moduleId, selectedMic
		
		$('body').off 'change', '#module2'
		$('body').on 'change', '#module2', (e) =>
			if globalSection?
				selectedMic = globalSection.mic_number2
			else
				selectedMic = 0
			moduleId = parseInt $(e.target).val()
			@populateMic 2, moduleId, selectedMic
		
		$('body').off 'click', '.sonitus-section-save-button'
		$('body').on 'click', '.sonitus-section-save-button', =>
			@ajaxSave()

		$('body').off 'click', '.sonitus-section-remove-button'
		$('body').on 'click', '.sonitus-section-remove-button', =>
			if confirm t.SonitusSection_ConfirmRemove
				@ajaxRemove()

	@inst: ->
		if not instance?
			instance = new @
		instance

	# Populate mic selector #i with mics of the given module.
	populateMic: (i, moduleId, selectedMic) ->
		allModules = globalModulesInNetwork
		$('#mic-number'+i).html ''
		for module in allModules
			if module.id == moduleId
				for mic in [1..4]
					name = module['mic'+mic+'_name']
					selectedStr = if mic == selectedMic then 'selected' else ''
					option = '<option value="'+mic+'" '+selectedStr+'>Mic'+mic+' '+name+'</option>'
					$('#mic-number'+i).append option
		$('#mic-number'+i).selectmenu 'refresh'

	ajaxSave: ->
		module1Id = $('#module1').val()
		module2Id = $('#module2').val()
		errStr = ''
		if module1Id == module2Id then errStr += t.SonitusSection_ModulesMustNotBeSame+'<br/>'
		if !module1Id then errStr += t.SonitusSection_Module1Missing+"<br/>"
		if !module2Id then errStr += t.SonitusSection_Module2Missing+"<br/>"
		if errStr
			$('#sonitus-section-save-error-message').html errStr
			return
		waitStart()
		$.ajax
			url: "/pgweb/ajax/sonitus/saveSonitusSection.php"
			dataType: 'json'
			type: 'POST'
			data:
				sectionId: $('#section-id').val()
				name: $('#section-name').val()
				module1Id: $('#module1').val()
				module2Id: $('#module2').val()
				micNumber1: $('#mic-number1').val()
				micNumber2: $('#mic-number2').val()
				length: $('#section-length').val()
				note: $('#section-note').val()
			success: (data) ->
				switch data.result
					when "OK"
						$('#sonitus-new-section-popup').one 'popupafterclose', =>
							#$.mobile.changePage $.url().attr('source'), reloadPage: true
							location.href = $.url().attr 'source'
						$('#sonitus-new-section-popup').popup 'close'
					when 'NOT_LOGGED_IN'
						handleInactivity()
					when 'DUPLICATE_ENTRY'
						$('#sonitus-section-save-error-message').html t.SonitusSection_CombinationAlreadyUsed
					when 'LENGTH_MISSING'
						$('#sonitus-section-save-error-message').html t.SonitusSection_LengthMissing
					else
						$('#sonitus-section-save-error-message').html "Save failed: "+data.debug
			error: ajaxFailure
			complete: -> waitStop()

	ajaxRemove: ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/sonitus/removeSonitusSection.php"
			dataType: 'json'
			type: 'POST'
			data:
				sectionId: $('#section-id').val()
			success: (data) ->
				switch data.result
					when "OK"
						$('#sonitus-new-section-popup').one 'popupafterclose', =>
							location.href = '?action=listSonitusSections&networkId='+$.url().param().networkId
						$('#sonitus-new-section-popup').popup 'close'
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						$('#sonitus-section-save-error-message').html "Remove failed: "+data.debug
			error: ajaxFailure
			complete: -> waitStop()


# For "New" button.
$(document).on 'pageshow', '.listSonitusSectionsPage', (event) ->
	pgweb.SonitusSectionEdit.inst()

# For "Edit" button.
$(document).on 'pageshow', '.sonitusSectionShowPage', (event) ->
	pgweb.SonitusSectionEdit.inst()

class pgweb.SonitusSectionsListMap extends pgweb.Map
	
	instance = null
	intervalId = null
	
	@inst: ->
		# Run only on sonitus sections list page.
		if $.url().param().action != 'listSonitusSections'
			return
		if not instance?
			instance = new @
		instance
	
	initInterval: ->
		clearInterval intervalId
		intervalId = setInterval =>
			if pgweb.Main.inst().autoUpdateButtonIsOn()
				@update false
		, pgweb.Main.getUpdateInterval()
		if not pgweb.Main.inst().autoUpdateButtonIsOn()
			@initMarkers()
		
	initMarkers: ->
		# Get all modules in the sections, uniquely.
		moduleIds = []
		for section in sections
			if section.module1_id not in moduleIds
				moduleIds.push section.module1_id
			if section.module2_id not in moduleIds
				moduleIds.push section.module2_id
		@modules = []
		for moduleId in moduleIds
			for section in sections
				if section.module1_id == moduleId
					@modules.push section.module1
					break
				else if section.module2_id == moduleId
					@modules.push section.module2
					break
		
		# Get the points of the modules to be viewed (for map bounds calculation).
		pointsForBoundsCalc = (@correctCoords [module.gis_latitude, module.gis_longitude] for module in @modules)
	
		# If there are no modules to be viewed on the map, do nothing more.
		if pointsForBoundsCalc.length == 0
			@clearMarkers()
			return
	
		# Fit bounds perfectly to the points.
		bounds = new L.LatLngBounds pointsForBoundsCalc
		@fitBounds bounds
		
		@createMarkers()
		
		SonitusSectionCircles.clearAllCircles()
		for module in @modules
			SonitusSectionCircles.drawForOneModule @getMap(), module, '1h'
		
		for section in sections
			eps = 0.000004
			latDelta = eps*section.mic_number1 - eps*1.5
			lonDelta = eps*section.mic_number2 - eps*1.5
			latlngs = [
				[section.module1.gis_latitude+latDelta, section.module1.gis_longitude+lonDelta]
				[section.module2.gis_latitude+latDelta, section.module2.gis_longitude+lonDelta]
			]
			config =
				color: 'red'
				section: section
			L.polyline latlngs, config
				.on 'click', (e) =>
					latlng = e.latlng
					s = e.target.options.section
					networkId = $.url().param().networkId
					sectionId = s.id
					url = "?action=showSonitusSection&networkId=#{networkId}&sectionId=#{sectionId}"
					html  = "<a href=\"#{url}\" rel=\"external\">#{if s.name then s.name else '(no name)'}</a><br/><br/>"
					html += "#{s.system_name1}/Mic#{s.mic_number1} -- "
					html += "#{s.system_name2}/Mic#{s.mic_number2}<br/>"
					html += "#{s.length} m<br/>"
					@getMap().openPopup html, latlng
				.addTo @getMap()

	initEventHandlers: ->
		return

	# Display markers for all the modules visible in the table.
	update: (fitBounds) ->
		if $.url().param().action != 'listSonitusSections' then return
		if not pgweb.Main.inst().autoUpdateButtonIsOn() then return
	
	setQpgSymbol: (id, ch, html) ->
		qpgTags = $('#module-id-'+id+' .module-list-td-qpg > div')
		for qpgTag in qpgTags
			tagCh = lastNum($(qpgTag).attr('class').split(' ')[1])
			if tagCh == ch
				$(qpgTag).html html

$(document).on 'pageshow', '.listSonitusSectionsPage', (event) ->
	if $('#sonitus-sections-map').length > 0
		sonitusSectionsListMap = pgweb.SonitusSectionsListMap.inst()
		if sonitusSectionsListMap
			sonitusSectionsListMap.id = 'sonitus-sections-map'
			if !sonitusSectionsListMap.isInitialized()
				sonitusSectionsListMap.init()
			sonitusSectionsListMap.initMarkers()
			sonitusSectionsListMap.initInterval()
			sonitusSectionsListMap.initEventHandlers()
class pgweb.SonitusSectionShowMap extends pgweb.Map
	
	instance = null
	intervalId = null
	
	@inst: ->
		# Run only on sonitus section show page.
		if $.url().param().action != 'showSonitusSection'
			return
		if not instance?
			instance = new @
		instance
	
	initMarkers: ->
		s = globalSection
		
		@modules = [s.module1, s.module2]
		
		# Get the points of the modules to be viewed (for map bounds calculation).
		pointsForBoundsCalc = (@correctCoords [module.gis_latitude, module.gis_longitude] for module in @modules)
	
		# If there are no modules to be viewed on the map, do nothing more.
		if pointsForBoundsCalc.length == 0
			@clearMarkers()
			return
	
		# Fit bounds perfectly to the points, with a small margin.
		bounds = new L.LatLngBounds pointsForBoundsCalc
		bounds._northEast.lat += (bounds._northEast.lat - bounds._southWest.lat)*.05
		bounds._southWest.lat -= (bounds._northEast.lat - bounds._southWest.lat)*.05
		@fitBounds bounds
		
		@createMarkers()
		SonitusSectionCircles.clearAllCircles()
		for module in @modules
			SonitusSectionCircles.drawForOneModule @getMap(), module, '1h'
		
		# Red line between modules.
		latlngs = [
			[s.module1.gis_latitude, s.module1.gis_longitude]
			[s.module2.gis_latitude, s.module2.gis_longitude]
		]
		config =
			color: 'red'
		L.polyline latlngs, config
			.addTo @getMap()
		
	update: (fitBounds) ->
		if $.url().param().action != 'showSonitusSection' then return
		if not pgweb.Main.inst().autoUpdateButtonIsOn() then return

$(document).on 'pageshow', '.sonitusSectionShowPage', (event) ->
	if $('#sonitus-section-page-map').length > 0
		sonitusSectionShowMap = pgweb.SonitusSectionShowMap.inst()
		if sonitusSectionShowMap
			sonitusSectionShowMap.id = 'sonitus-section-page-map'
			if !sonitusSectionShowMap.isInitialized()
				sonitusSectionShowMap.init()
			sonitusSectionShowMap.initMarkers()
class pgweb.SonitusSectionShowCharts
	N_CURVES = 15
	MARGIN_LEFT = 80
	MARGIN_RIGHT = 100
	
	_themeType = null
	_timezone = { 'identifier': '', 'offset': 0}
	_currentData = []

	_lineCharts = []
	_heatmapCharts = []
	
	_colorAxisStops = [
		[0.00, '#0000aa']
		[0.08, '#0000ff']
		[0.14, '#0044ff']
		[0.23, '#0088ff']
		[0.30, '#00eeff']
		[0.37, '#00ffff']
		[0.44, '#00ff77']
		[0.50, '#00ff00']
		[0.57, '#77ff00']
		[0.64, '#ffff00']
		[0.74, '#ffee00']
		[0.81, '#ff8800']
		[0.88, '#ff6600']
		[0.93, '#ff2200']
		[1.00, '#ff0000']
	]

	_periods =
		free: 0
		sixMonths: 180
		threeMonths: 90
		oneMonth: 30
		oneWeek: 7

	_crosshairConfig =
		width: 1
		color: 'gray'
		dashStyle: 'dash'
		zIndex: 10

	_rememberPlotBand = null

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	constructor: ->
		
	init: ->
		_themeType = parseInt $('#theme-type').val()

		$('body').off 'change', '.charts-tool-range-buttons .range-free'
		$('body').on 'change', '.charts-tool-range-buttons .range-free', (event) ->
			$('#zoom-free-popup').popup 'open'
			$('#free-range-zoom-error-message').text ''
		
		$('body').off 'change', '.charts-tool-range-buttons .range-six-months'
		$('body').on 'change', '.charts-tool-range-buttons .range-six-months', (event) ->
			loadLineOrHeatmapCharts()
		
		$('body').off 'change', '.charts-tool-range-buttons .range-three-months'
		$('body').on 'change', '.charts-tool-range-buttons .range-three-months', (event) ->
			loadLineOrHeatmapCharts()
		
		$('body').off 'change', '.charts-tool-range-buttons .range-one-month'
		$('body').on 'change', '.charts-tool-range-buttons .range-one-month', (event) ->
			loadLineOrHeatmapCharts()
		
		$('body').off 'change', '.charts-tool-range-buttons .range-one-week'
		$('body').on 'change', '.charts-tool-range-buttons .range-one-week', (event) ->
			loadLineOrHeatmapCharts()
		
		$('body').off 'click', '.sonitusSectionShowPage #free-zoom-ok'
		$('body').on 'click', '.sonitusSectionShowPage #free-zoom-ok', (event) ->
			min = new Date $('[name=free-from]').val()
			max = new Date $('[name=free-to]').val()
			if min == "Invalid Date" or max == "Invalid Date"
				$('#free-range-zoom-error-message').text t.InvalidDate
			else
				loadLineOrHeatmapCharts()
				$('#zoom-free-popup').popup 'close'
		
		$('body').off 'change', '[name=chartType]'
		$('body').on 'change', '[name=chartType]', (event) ->
			chartType = $(@).val()
			showLineOrHeatmap chartType
		
		$('body').off 'click', '.sonitusSectionShowPage #free-zoom-cancel'
		$('body').on 'click', '.sonitusSectionShowPage #free-zoom-cancel', (event) ->
			$('#zoom-free-popup').popup 'close'
		
		$('body').off 'pageshow', '.sonitusSectionShowPage'
		$('body').on 'pageshow', '.sonitusSectionShowPage', (event) ->
			loadLineAndHeatmapCharts()
		
		pgweb.Event.on 'analysis_mode', ->
			for i in [1, 2]
				_lineCharts[i].update
					chart:
						zooming:
							type: undefined
				restorePlotBand _lineCharts[i]
			$('#drag-to-zoom-x-label').css 'visibility', 'hidden'
		
		pgweb.Event.on 'map_mode', ->
			for i in [1, 2]
				removePlotBand _lineCharts[i]
				_lineCharts[i].update
					chart:
						zooming:
							type: 'x'
			clearTable()
			$('.top-header-rest').removeClass 'selected-frequency'
			$('#drag-to-zoom-x-label').css 'visibility', 'visible'
			
		showLineOrHeatmap 'line'
		
		$('body').off 'click', '#x-zoom-reset-button'
		$('body').on 'click', '#x-zoom-reset-button', (event) ->
			period = $('[name=range]:checked').val()
			days = _periods[period]
			if days == 0
				minmax = pgweb.TrendsPage.getMinMax days
				min = minmax[0]
				max = minmax[1]
				from = dateTimeToJSTime min
				to = dateTimeToJSTime max
				for i in [1..2]
					_lineCharts[i].xAxis[0].setExtremes from, to
					_heatmapCharts[i].xAxis[0].setExtremes from, to
			else
				setXAxisInterval days
			pgweb.TrendsPage.showZoomXResetButton false

		pgweb.TrendsPage.showZoomXResetButton false
	
	setXAxisInterval = (days) ->
		minXLocal = getMinXFromDays days, _timezone.offset
		maxXLocal = getMaxXFromDays days, _timezone.offset
		minXLocal = dateTimeToJSTime minXLocal
		maxXLocal = dateTimeToJSTime maxXLocal
		for i in [1..2]
			_lineCharts[i].xAxis[0].setExtremes minXLocal, maxXLocal
			_heatmapCharts[i].xAxis[0].setExtremes minXLocal, maxXLocal

	lineOrHeatmapSelected = ->
		$('[name=chartType]:checked').val()
	
	# Switch between line chart och heatmap chart.
	# Possible values of chartType: 'line', 'heatmap'
	showLineOrHeatmap = (chartType) ->
		switch chartType
			when 'line'
				for i in  [1, 2]
					$(".linechart#{i}-container").show()
					$(".heatmapchart#{i}-container").hide()
				#if $(".ui-page-active .linechart#{i}-container").get()[0]
				#	loadLineCharts()
			when 'heatmap'
				for i in  [1, 2]
					$(".heatmapchart#{i}-container").show()
					$(".linechart#{i}-container").hide()
				##if $(".ui-page-active .heatmapchart#{i}-container").get()[0]
				##	loadHeatmapCharts()
			else
				console.log 'error'
				
	@setHeatmapChart: (chart, index) ->
		_heatmapCharts[index] = chart
		_heatmapCharts[index].index = index+1

	@getHeatmapChart: (index) ->
		_heatmapCharts[index]

	loadLineAndHeatmapCharts = ->
		loadLineCharts()
		loadHeatmapCharts()

	loadLineOrHeatmapCharts = ->
		if lineOrHeatmapSelected() == 'line'
			loadLineCharts()
		else
			loadLineCharts()
			loadHeatmapCharts()

	loadLineCharts = () ->
		s = globalSection
		
		showEveryPoint = $('#show-every-point').prop 'checked'

		period = $('[name=range]:checked').val()
		if (!period)
			period = 'oneWeek'
		days = _periods[period]

		min = null
		max = null
		if days == 0 # Free selection of start and end time.
			# Order of start date and end date does not matter.
			date1 = $('[name=free-from]').val()
			date2 = $('[name=free-to]').val()
			if date2 < date1
				dateTmp = date1
				date1 = date2
				date2 = dateTmp
			min = new Date date1+" 00:00:00.000"
			max = new Date date2+" 23:59:59.999"
			if min == 'Invalid Date'
				now = new Date()
				dateStr = now.toISOString().substr 0, 10
				min = new Date dateStr+" 00:00:00.000"
				$('[name=free-from]').val dateStr
			if max == 'Invalid Date'
				now = new Date()
				dateStr = now.toISOString().substr 0, 10
				max = new Date dateStr+" 23:59:59.999"
				$('[name=free-to]').val dateStr
			min = new Date(min.getTime() - min.getTimezoneOffset()*60000)
			max = new Date(max.getTime() - max.getTimezoneOffset()*60000)
		else
			min = getMinXFromDays days, _timezone.offset
			max = getMaxXFromDays days, _timezone.offset
		msg = ''
		if not showEveryPoint
			if days == 0
				timeDiff = (max.getTime() - min.getTime())/1000; # Convert ms into s.
				periodMinutes = Math.floor(timeDiff/1000)/60; # Period length in minutes.
				periodHours = 0
				if periodMinutes >= 60
					periodHours = Math.floor periodMinutes/60
					periodMinutes = Math.floor periodMinutes % 60
				msg = periodHours+" h "+periodMinutes.toFixed(1)+" min"
			else if days > 0 and days <= 7 # Up to 1 week
				msg = "10 min" # 10 minutes resolution = max 1008 values
			else if days > 7 and days <= 31 # Up to 1 month
				msg = "1 h" # 1 hour resolution = max 744 values
			else if days > 31 && days <= 93 # Up to 3 months
				msg = "3 h" # 3 hours resolution = max 744 values
			else if days > 93 && days <= 186 # Up to 6 months
				msg = "6 h" # 6 hours resolution = max 744 values
			else # More than 6 months
				msg = "24 h" # 24 hours resolution
			msg = t.TrendsPage_MaxOneValuePer + ' ' + msg
		$('#show-every-point-message').html msg

		pgweb.TrendsPage.showZoomXResetButton false

		howMuchData = days
		seriesColors = [
			'#941D2A', '#A8212C', '#B9242C', '#CD282D', '#E12A2E', '#FC3030', '#FE612E', '#FD872C', '#FCBC2A', '#FBDA29', '#FBFB28', '#FCFF5A', '#FDFF99', '#FEFFC6', '#FFFFEC'
		]

		yAxisStandardConfig = pgweb.CurveChart.inst().yAxisFloatConfig '#999', false, .001, 1
		yAxisExtraConfig =
			labels:
				formatter: SonitusSectionShowCharts.lineChartYLabelFormatter
			min: -80
			max: 0
			tickPositions: pgweb.SonitusCalculator.calcYTickPositions()
		yAxisConfig = Object.assign yAxisStandardConfig, yAxisExtraConfig

		zoom = undefined
		if $('.sonitusSectionShowPage .allow-zoom-button').is(':checked')
			zoom = 'xy'
		zoom = 'x'
		
		for i in [1, 2]
			renderTo = $(".ui-page-active .linechart#{i}-container").get()[0]
			if !$(renderTo).html()
				title = [null, 'A', 'B'][i]+": Module #{i}, mic #{s['mic_number'+i]}"
				events =
					click: onClick
					selection: (e) ->
						# When zooming, do the same in the other line chart and both heatmap charts.
						containerClass = $(e.target.renderTo).prop 'class'
						chartIndex = lastNum containerClass.split('-')[0]
						if not chartIndex in [1, 2] then throw 'Invalid chartIndex'
						chartIndexToZoom = [2, 1][chartIndex-1]
						_lineCharts[chartIndexToZoom].xAxis[0].setExtremes e.xAxis[0].min, e.xAxis[0].max
						for i in [1, 2]
							_heatmapCharts[i].xAxis[0].setExtremes e.xAxis[0].min, e.xAxis[0].max
						pgweb.TrendsPage.showZoomXResetButton true
				renderTo.onmousedown = onMouseDown
				renderTo.onmouseup = onMouseUp
				renderTo.onmousemove = onMouseMove
				_lineCharts[i] = pgweb.CurveChart.inst().create min, max, zoom, title, yAxisConfig, 0, seriesColors, renderTo, lineChartToolTipFormatter, true, events

				_lineCharts[i].index = i-1
		
				_lineCharts[i].update
					chart:
						marginLeft: MARGIN_LEFT
						marginRight: MARGIN_RIGHT
					legend:
						enabled: true
						layout: 'vertical'
						verticalAlign: 'top'
						align: 'right'
						reversed: true
					exporting:
						enabled: false
					plotOptions:
						series:
							events:
								legendItemClick: ->
									# When a legend item in one of the charts is hidden/shown,
									# the corresponding legend item in the other chart is also hidden/shown.
									otherIndex = 1 + (@chart.index ^ 1)
									# How to hide the legend item: hide the series.
									_lineCharts[otherIndex].series[@index].setVisible not @visible					
							point:
								events:
									mouseOut: onLineChartMouseOut
					xAxis:
						crosshair: _crosshairConfig
						minTickInterval: 3600*1000
					yAxis:
						crosshair: _crosshairConfig
					series: lineChartSeriesConfigs seriesColors
					, false
				

			moduleId = s["module#{i}_id"]
			which = 'mic' + s["mic_number#{i}"]
			if days == 0
				loadLineChartDataFromAjax i, which, 0, min, max, moduleId, showEveryPoint
			else
				loadLineChartDataFromAjax i, which, days, undefined, undefined, moduleId, showEveryPoint
	
	onClick = (e) ->
		console.log 'click!'
		#if preventOnClick then return
		#for i in [1, 2]
		#	chart = _lineCharts[i]
		#	removePlotBand chart
		#clearTable()
		#pgweb.Event.trigger 'chart_click'
	
	mouseIsDown = false
	mouseStartX = null
	mouseDragging = false
	
	onMouseDown = (e) ->
		mouseStartX = e.layerX
		mouseIsDown = true
	
	onMouseMove = (e) ->
		if mouseIsDown
			mouseDragging = true
			mouseX = e.chartX
			if analysisMode()
				for i in [1, 2]
					chart = _lineCharts[i]
					startTime = chart.xAxis[0].toValue mouseStartX
					stopTime = chart.xAxis[0].toValue mouseX
					addPlotBand chart, startTime, stopTime

	onMouseUp = (e) ->
		mouseX = e.layerX
		mouseIsDown = false
		if mouseDragging
			startTime = _lineCharts[1].xAxis[0].toValue mouseStartX
			stopTime = _lineCharts[1].xAxis[0].toValue mouseX
			if startTime > stopTime
				tmp = startTime
				startTime = stopTime
				stopTime = tmp
			onIntervalSelection startTime, stopTime
		mouseDragging = false
	
	# Selection of horizontal interval was finished.
	onIntervalSelection = (startTime, stopTime) ->
		startTimeIso = (pgweb.Main.unixMilliToIso startTime).replace 'T', ' '
		stopTimeIso = (pgweb.Main.unixMilliToIso stopTime).replace 'T', ' '
		if not analysisMode() then return false
		avg = []
		for i in [1, 2]
			avg[i] = []
			chart = _lineCharts[i]
			data = _currentData[i]
			for freqIndex in [1..15]
				sum = 0
				cnt = 0
				for point in data.dataSerieses[freqIndex-1]
					pointTimeUnix = pgweb.Main.isoToUnixMilliTz (point.t.replace ' ', 'T'), _timezone.offset
					startTimeUnix = pgweb.Main.isoToUnixMilliTz (startTimeIso.replace ' ','T'), 0
					stopTimeUnix = pgweb.Main.isoToUnixMilliTz (stopTimeIso.replace ' ', 'T'), 0
					if pointTimeUnix >= startTimeUnix and pointTimeUnix <= stopTimeUnix
						sum += point.v
						cnt++
				avg[i][freqIndex] = sum/cnt
		for i in [1, 2]
			for freqIndex in [1..15]
				setTableColor i, freqIndex, avg[i][freqIndex]
		for freqIndex in [1..15]
			if not isNaN avg[1][freqIndex] and not isNaN avg[2][freqIndex]
				setTableColor 'diff', freqIndex, avg[2][freqIndex] - avg[1][freqIndex]
			else
				setTableColor 'diff', freqIndex, NaN
		pgweb.Event.trigger 'interval_selected', {startTime: startTime, stopTime: stopTime}
		false
	
	# Add a horizontal plot band.
	addPlotBand = (chart, startTime, stopTime) ->
		plotBandObj =
			from: startTime
			to: stopTime
			color: 'rgba(150, 150, 255, .3)'
			id: 'selection-plotband'
		_rememberPlotBand = plotBandObj
		removePlotBand chart
		chart.xAxis[0].addPlotBand plotBandObj
	
	restorePlotBand = (chart) ->
		if _rememberPlotBand
			chart.xAxis[0].addPlotBand _rememberPlotBand
	
	removePlotBand = (chart) ->
		chart.xAxis[0].removePlotBand 'selection-plotband'

	clearTable = () ->
		for i in [1, 2, 'diff']
			for freqIndex in [1..15]
				setTableColor i, freqIndex, NaN

	lineChartSeriesConfigs = (seriesColors) ->
		arr = []
		moduleId = $('#module-id').val()
		for i in [0..14]
			arr[i] =
				name: "#{(i+1)*125} Hz"
				color: seriesColors[i]
				type: 'line'
				yAxis: 0
				animation: false
				data: []
				dashStyle: 'Solid'
				lineWidth: 2
				marker: { enabled: false }
				index: i
				step: ''
		arr

	loadHeatmapCharts = ->
		s = globalSection
		colorAxisMin = -80
		colorAxisMax = 0
		data = []
		for i in [1, 2]
			renderTo = $(".ui-page-active .heatmapchart#{i}-container").get()[0]
			title = "Module #{i}, mic #{s['mic_number'+i]}"
			pgweb.SonitusSectionShowCharts.createHeatmapChart i, renderTo, title, colorAxisMin, colorAxisMax
			fromTime = _lineCharts[i].xAxis[0].min
			toTime = _lineCharts[i].xAxis[0].max
			#fromTimeIso = fromTime.toISOString().substr 0, 19
			#toTimeIso = toTime.toISOString().substr 0, 19
			#fromTimeUnix = pgweb.Main.isoToUnixMilliTz fromTimeIso, _timezone.offset
			#toTimeUnix = pgweb.Main.isoToUnixMilliTz toTimeIso, _timezone.offset
			#_heatmapCharts[i].xAxis[0].setExtremes fromTimeUnix, toTimeUnix
			_heatmapCharts[i].xAxis[0].setExtremes fromTime, toTime

	onLineChartMouseOut = ->
		if not analysisMode()
			$('.value-column div').text ''
			$('.value-column').css 'background-color', 'transparent'
		for i in [1, 2]
			_lineCharts[i].xAxis[0].removePlotLine 'crosshair-plotline'
	
	onHeatmapChartMouseOut = ->
		$('.value-column div').text ''
		$('.value-column').css 'background-color', 'transparent'
		for i in [1, 2]
			_heatmapCharts[i].xAxis[0].removePlotLine 'crosshair-plotline'

	loadLineChartDataFromAjax = (chartIndex, which, days, from, to, moduleId, showEveryPoint) ->
		mic = lastNum which
		waitStart()
		if days == 0
			fromISO = from.toISOString()
			toISO = to.toISOString()
		$.ajax
			url: "/pgweb/ajax/sonitus/analysisGW102LineChart.php"
			dataType: 'json'
			data:
				mic: mic
				days: days
				from: fromISO
				to: toISO
				moduleId: moduleId
				showEveryPoint: showEveryPoint
			success: (data) ->
				if data.result == "OK"
					_currentData[chartIndex] = data
					for i in [0..(N_CURVES-1)]
						_lineCharts[chartIndex].series[i].setData []
					for curveIndex in [0..(N_CURVES-1)]
						dataSeriesObj = data.dataSerieses[curveIndex]
						if dataSeriesObj.length > 0
							for i in [0..(dataSeriesObj.length-1)]
								item = dataSeriesObj[i]
								dt = Globalize.parseDate item.t.replace ' ', 'T'
								dtJSTime = dateTimeToJSTime(dt) # Unix time * 1000
								_timezone = data.timezone
								dtJSTimeTzCorrected = dtJSTime + _timezone.offset*60000
								xy = [dtJSTimeTzCorrected, pgweb.SonitusCalculator.linToExpY item.v]
								_lineCharts[chartIndex].series[curveIndex].addPoint xy, false
								
								# Heatmap chart.
								xyz = SonitusSectionShowCharts.makeXYZ item, _timezone.offset, curveIndex+1
								SonitusSectionShowCharts.getHeatmapChart(chartIndex).series[0].addPoint xyz, false
					if days == 0
						from = dateTimeToJSTime from
						to = dateTimeToJSTime to
						_lineCharts[chartIndex].xAxis[0].setExtremes from, to, false
						_heatmapCharts[chartIndex].xAxis[0].setExtremes from, to, false
					else
						setLineChartXAxisInterval days, chartIndex

					_lineCharts[chartIndex].redraw()
					_heatmapCharts[chartIndex].redraw()

				else if data.result == 'NOT_LOGGED_IN'
					handleInactivity()
				else
					alert "Failed to load chart data: "+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()
	
	# Convert a 3D data item returned from ajax into an object acceptable for Highcharts heatmap.
	@makeXYZ: (item, timezoneOffset, i) ->
		time = item.t.replace ' ', 'T'
		dtJSTimeTzCorrected = pgweb.Main.isoToUnixMilliTz time, timezoneOffset
		[dtJSTimeTzCorrected, i, item.v]
	
	@lineChartYLabelFormatter: (obj) ->
		v = pgweb.SonitusCalculator.expToLinY obj.value
		for p in pgweb.SonitusCalculator.yTickPositions
			if v <= 0.98*p and v >= 1.02*p
				return p

	setLineChartXAxisInterval = (days, chartIndex) ->
		minXLocal = getMinXFromDays days, _timezone.offset
		maxXLocal = getMaxXFromDays days, _timezone.offset
		minXLocal = dateTimeToJSTime minXLocal
		maxXLocal = dateTimeToJSTime maxXLocal
		_lineCharts[chartIndex].xAxis[0].setExtremes minXLocal, maxXLocal, false
		_heatmapCharts[chartIndex].xAxis[0].setExtremes minXLocal, maxXLocal, false

	lineChartToolTipFormatter = (e) ->
		html = ''
		dBrowser = new Date @x
		dLocal = new Date dBrowser.getTime() + dBrowser.getTimezoneOffset() * 60000
		dStr = Globalize.format dLocal, 'F'
		html += dStr

		thisChartIndex = @.points[0].series.chart.index
		otherChartIndex = switch thisChartIndex
			when 0 then 2
			when 1 then 1
		otherChart = _lineCharts[otherChartIndex]

		if not analysisMode()
			time = @points[0].x

			$('.value-column').css 'background-color', 'transparent'
			for point in @points
				value = pgweb.SonitusCalculator.expToLinY point.y
				freqIndex = point.series.index+1
				setTableColor (thisChartIndex+1), freqIndex, value
			# Set table values for the other chart.
			for otherSer in otherChart.series
				lessPoints = []
				for otherPoint in otherSer.points
					# Check points inside a one hour interval around the selected point.
					if otherPoint.x > time - 1000*30*60 and otherPoint.x <= time + 1000*30*60
						lessPoints.push otherPoint
				if lessPoints.length > 0
					# Find the point that is closest to the selected point.
					foundPoint = null
					minAbsDiff = 9999999
					for p in lessPoints
						absDiff = Math.abs (p.x - time)
						if absDiff < minAbsDiff
							minAbsDiff = absDiff
							foundPoint = p
					freqIndex = foundPoint.series.index+1
					value = pgweb.SonitusCalculator.expToLinY foundPoint.y
					setTableColor otherChartIndex, freqIndex, value
					val1 = $("#val1index#{freqIndex}").text()
					val2 = $("#val2index#{freqIndex}").text()
					if val1.length > 0 and val2.length > 0
						setTableColor 'diff', freqIndex, val2 - val1
		
		addCrossHairPlotLine otherChart.xAxis[0], @x

		html

	analysisMode = ->
		$('#analysis-tab-link').hasClass 'ui-btn-active'
	
	heatmapChartToolTipFormatter = (a, b) ->
		dBrowser = new Date @point.x
		dLocal = new Date (dBrowser.getTime() + dBrowser.getTimezoneOffset()*60000)
		dStr = Globalize.format dLocal, 'F'
		html = '<div style="width: 10px">'+dStr+'<br>Frequency: '+@point.y*125+' Hz<br>Value: '+@point.value+' dB</div>'

		time = @point.x

		thisChartIndex = @.series.chart.index
		otherChartIndex = switch thisChartIndex
			when 2 then 2
			when 3 then 1
		otherChart = _heatmapCharts[otherChartIndex]
		
		# There is no ready-made array of values at the selected time like for the line chart, so we need
		# to put it together.
		items = (item for item in @.series.data when item.x == @.point.x)
		for item in items
			value = item.value
			freqIndex = item.y
			setTableColor thisChartIndex - 1, freqIndex, value
		
		# Set table values for the other chart.
		otherPoints = (point for point in otherChart.series[0].points when point.x > time - 1000*60*60 and point.x <= time + 1000*3*60)
		otherSeries = []
		for i in [0..N_CURVES]
			otherSeries[i] = {}
			otherSeries[i].points = []
		for otherPoint in otherPoints
			otherSeries[otherPoint.y].points.push otherPoint
		for otherSer in otherSeries
			foundPoint = null
			lessPoints = []
			for otherPoint in otherSer.points
				## Older than one hour not allowed. Also allow for 3 minutes of clock diff.
				if otherPoint.x > time - 1000*60*60 and otherPoint.x <= time + 1000*3*60
					lessPoints.push otherPoint
			if lessPoints.length > 0
				foundPoint = lessPoints.pop()
				freqIndex = foundPoint.y
				value = foundPoint.value
				setTableColor otherChartIndex, freqIndex, value
				val1 = $("#val1index#{freqIndex}").text()
				val2 = $("#val2index#{freqIndex}").text()
				if val1.length > 0 and val2.length > 0
					setTableColor 'diff', freqIndex, val2 - val1
		
		addCrossHairPlotLine otherChart.xAxis[0], @point.x

		html

	# tableNumber = 1 for module 1, 2 for module 2, 'diff' for diff line
	setTableColor = (tableNumber, freqIndex, value) ->
		if isNaN value
			$("#val#{tableNumber}index#{freqIndex}").text ''
			$("#val#{tableNumber}index#{freqIndex}").parent().css 'background-color', 'transparent'
		else
			$("#val#{tableNumber}index#{freqIndex}").text(value.toFixed 1)
			if tableNumber == 'diff'
				valueColorIndex = Math.floor(Math.min(Math.abs(value/2), 14))
			else
				valueColorIndex = 14 - Math.floor(-Math.max(Math.min(value, 0), -80)/5.334) # 80/(number of colors) = 5.334
			valueColor = _colorAxisStops[valueColorIndex][1]
			$("#val#{tableNumber}index#{freqIndex}").parent().css 'background-color', valueColor
	
	@createHeatmapChart: (chartIndex, renderTo, title, colorAxisMin, colorAxisMax) ->
		data = []
		chart = new Highcharts.Chart
			chart:
				type: 'heatmap'
				renderTo: renderTo
				animation: false
				marginLeft: MARGIN_LEFT
				marginRight: MARGIN_RIGHT
				events:
					resize: (e) =>
						chartIndex = e.target.index - 1
						colsize = calcColSize _heatmapCharts[chartIndex]
						_heatmapCharts[chartIndex].update {series: colsize: colsize}
					load: (e) =>
						intervalCount = 0
						intervalHandle = window.setInterval ->
							intervalCount += 1
							if intervalCount > 10 then clearInterval intervalHandle
							chartIndex = e.target.index - 1
							colsize = calcColSize _heatmapCharts[chartIndex]
							if not isNaN colsize
								clearInterval intervalHandle
								_heatmapCharts[chartIndex].update {series: colsize: colsize}
						, 1000
			exporting:
				enabled: false
			title:
				text: title
			xAxis:
				type: 'datetime',
				title:
					text: 'Time'
				startOnTick: false
				endOnTick: false
				dateTimeLabelFormats:
					second: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.T)
					minute: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.t)
					hour: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.t)
					day: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.M)
					week: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.M)
					month: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.Y)
					year: globalizeToHighchartsDatetimeFormat(Globalize.culture(Globalize.culture()).calendar.patterns.Y)
				crosshair: _crosshairConfig
				gridLineWidth: 0
				gridLineColor: 'rgba(255, 255, 255, .1)'
				lineColor: '#999'
				tickColor: '#999'
				#tickPixelInterval: 400
				tickInterval: undefined
				minTickInterval: 3600*1000
				labels:
					style:
						color: if _themeType == 1 then '#555' else '#999'
						font: 'bold 14px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif'
			yAxis:
				title:
					text: 'Hz'
				min: 1
				max: N_CURVES
				tickPositions: [1..N_CURVES]
				labels:
					formatter: SonitusSectionShowCharts.heatmapYLabelFormatter
					style:
						font: 'bold 10px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif'
				crosshair: _crosshairConfig
			colorAxis:
				stops: _colorAxisStops
				min: colorAxisMin
				max: colorAxisMax
				startOnTick: false
				endOnTick: false
				labels:
					format: '{value}dB'
					style:
						color: if _themeType == 1 then '#555' else '#999'
						font: 'bold 10px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif'
				reversed: false
				horizontal: true
				gridLineWidth: 0
			credits:
				enabled: false
			legend:
				layout: 'vertical'
				verticalAlign: 'top'
				align: 'right'
			tooltip:
				formatter: heatmapChartToolTipFormatter
				shared: true
			plotOptions:
				series:
					crisp: false
					point:
						events:
							mouseOut: onHeatmapChartMouseOut
			series: [
				nullColor: '#EFEFEF',
				colsize: 60*60*1000, # 60 minutes
				rowsize: 1
				data: data
			]
		@setHeatmapChart chart, chartIndex
		chart.redraw()
		chart

	# Calculate width of one square in the heatmap chart, equal to one pixel.
	calcColSize = (heatmapChart) ->
		width = heatmapChart.xAxis[0].toValue(1) - heatmapChart.xAxis[0].toValue(0)
		if width < 5*60*1000 then width = 5*60*1000
		width
	
	@heatmapYLabelFormatter: (obj) ->
		obj.value*125

	addCrossHairPlotLine = (axis, value) ->
		plotLineObj =
			color: 'gray'
			dashStyle: 'dash'
			width: 1
			value: value
			id: 'crosshair-plotline'
			zIndex: 10
		axis.removePlotLine 'crosshair-plotline'
		axis.addPlotLine plotLineObj

	# Min or max for the color axis changed.
	@onColorAxisMinMaxChanged: ->
		newMin = parseFloat $('#color-axis-min').val()
		newMax = parseFloat $('#color-axis-max').val()

$(document).on 'pagecreate', '.sonitusSectionShowPage', (event) ->
	pgweb.SonitusSectionShowCharts.inst().init()
class pgweb.SonitusSectionListPage

	instance = null

	constructor: ->
		$('body').on 'pageshow', '.listSonitusSectionsPage', =>
			pgweb.SonitusSectionListPage.inst()
		
		$('body').on 'click', '#section-new-button', ->
			$('#sonitus-new-section-popup').popup 'open'
			$('#section-popup-title').text t.SonitusSection_NewSection
			$('#section-id').val ''
			$('#section-name').val ''
			for i in [1, 2]
				$("#module#{i}").val ''
				$("#module#{i}").selectmenu 'refresh'
				$("#mic-number#{i}").val ''
			$("#section-length").val ''
			$("#section-note").val ''
			$('.sonitus-section-remove-button').remove()
		
		$('body').on 'click', '.sonitus-section-save-button', =>
			pgweb.SonitusSectionEdit.inst().ajaxSave()
		
		# Tooltip on mic bars is handled on the section show page.
		
	@inst: ->
		if not instance?
			instance = new @
		instance

$(document).on 'pageshow', '.listSonitusSectionsPage', (event) ->
	pgweb.SonitusSectionListPage.inst()
class pgweb.NotePopup
	POPUP_ID = 'note-edit-popup'
	LIST_ID = 'note-edit-popup-history-list'
	SAVE_BUTTON_ID = 'user-save-note-button'
	TEXTFIELD_ID = 'note-popup-note'
	COLLAPSIBLE_SET_ID = 'note-history-collapsible-set'
	COLLAPSIBLE_ID = 'note-history-collapsible'
	MORE_BUTTON_ID = 'notes-more-button'

	moduleId = null
	component = null
	channelNumber = 0

	nPerPage = 3
	pageOffset = 0

	htmlList = null
	textArea = null

	notes = []
	totalNumber = 0

	@init: (_moduleId, _component, _channelNumber) =>
		moduleId = _moduleId
		component = _component
		channelNumber = _channelNumber

		htmlList = $("##{LIST_ID}")
		textArea = $("##{TEXTFIELD_ID}")

		clearForm()

		$('body').off 'popupafteropen', '#'+POPUP_ID
		$('body').on 'popupafteropen', '#'+POPUP_ID, =>
			ajaxGetNotes nPerPage

		# Click on a version history list item.
		$('body').off 'click', "##{LIST_ID} li"
		$('body').on 'click', "##{LIST_ID} li", (e) =>
			onListItemClick $(e.currentTarget)
		
		$('body').off 'click', "##{SAVE_BUTTON_ID}"
		$('body').on 'click', "##{SAVE_BUTTON_ID}", (e) =>
			ajaxSave()

		$('body').off 'keyup', "##{TEXTFIELD_ID}"
		$('body').on 'keyup', "##{TEXTFIELD_ID}", (e) ->
			onKeyUp()

		$("##{COLLAPSIBLE_ID}").off 'collapsiblecollapse'
		$("##{COLLAPSIBLE_ID}").on 'collapsiblecollapse', (e) ->
			onCollapsibleCollapse()

		$("##{SAVE_BUTTON_ID}").button 'disable'
		$("##{COLLAPSIBLE_SET_ID}").hide()

		$("##{MORE_BUTTON_ID}").off 'click'
		$("##{MORE_BUTTON_ID}").on 'click', (e) ->
			ajaxGetNotes 99999
			$("##{MORE_BUTTON_ID}").hide()
			return false

	onCollapsibleCollapse = ->
		if notes.length > 0
			note = notes[0]
			fillForm note
			setSelectedListItem $("#note-item#{note.id}")
		else
			fillForm null

	clearForm = ->
		$("##{COLLAPSIBLE_ID}").collapsible 'collapse'
		fillForm null
		$('#note-created').text ''
		$('#note-author').html ''
		textArea.textinput 'refresh'
		htmlList.html ''
		htmlList.listview 'refresh'

	onListItemClick = (listItem) ->
		noteId = lastNum listItem.attr 'id'
		note = getNoteById noteId
		fillForm note
		setSelectedListItem listItem

	onKeyUp = ->
		newChangeData =
			buttonState: 'enable'
			created: t.ModulePage_NewVersion
			author: getCurrentUserFullName()
		changeData = if notes.length > 0
			if textArea.val().trim() == notes[0].note.trim()
				buttonState: 'disable'
				created: notes[0].created
				author: notes[0].author
			else newChangeData
		else newChangeData
		$("##{SAVE_BUTTON_ID}").button changeData.buttonState
		$('#note-created').text changeData.created
		$('#note-author').html getAuthorName changeData.author

	getCurrentUserFullName = ->
		$('#user-button .button-text').text()

	setSelectedListItem = (listItem) ->
		$("##{LIST_ID} li").attr 'data-theme', 'a'
		$("##{LIST_ID} li a").removeClass 'ui-btn-b'
		listItem.attr 'data-theme', 'b'
		listItem.find('a').addClass 'ui-btn-b'

	getNoteById = (id) ->
		notes.find (note) -> note.id == id

	ajaxGetNotes = (n) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/note/getNotes.php"
			dataType: 'json'
			type: 'POST'
			data:
				moduleId: moduleId
				component: component
				channelNumber: channelNumber
				n: n
				offset: pageOffset
			success: (data) =>
				switch data.result
					when "OK"
						notes = data.notes
						totalNumber = data.totalNumber
						htmlListItems = notes.map (note, i) -> getListItem note, i
						htmlListItems
						htmlList.html(htmlListItems).listview 'refresh'
						if notes.length > 0
							fillForm notes[0]
							$("##{COLLAPSIBLE_SET_ID}").show()
						else
							fillForm null
							$("##{COLLAPSIBLE_SET_ID}").hide()

						if $("##{LIST_ID} li").length < totalNumber
							$("##{MORE_BUTTON_ID}").show()
							$("##{MORE_BUTTON_ID}").text "+ #{totalNumber - nPerPage} #{t.ModulePage_More}"
						else
							$("##{MORE_BUTTON_ID}").hide()

						$("##{SAVE_BUTTON_ID}").button 'disable'
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get notes.', data.result+' '+data.debug);
			error: ajaxFailure
			complete: -> waitStop()

	ajaxSave = ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/note/saveNote.php"
			dataType: 'json'
			type: 'POST'
			data:
				moduleId: moduleId
				component: component
				channelNumber: channelNumber
				noteText: textArea.val()
			success: (data) =>
				switch data.result
					when "OK"
						ajaxGetNotes nPerPage
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to save the new version.', data.result+' '+data.debug);
			error: ajaxFailure
			complete: -> waitStop()

	fillForm = (note) ->
		if note
			text = note.note
			created = note.created
			author = note.author
			if note.index > 0
				$("##{SAVE_BUTTON_ID}").button 'disable'
		else
			text = ''
			created = t.ModulePage_NewVersion
			author = getCurrentUserFullName()
			$("##{SAVE_BUTTON_ID}").button 'enable'
		$('#channel-number-text').text if channelNumber > 0 then ", #{t.Channel} #{channelNumber}" else ''
		textArea.val text
		$('#note-created').text created
		$('#note-author').html getAuthorName author
		if note
			setTextAreaReadonly note.index != 0

		# Turn off keypress detection when other than the first element is selected.
		if note
			$('body').off 'keyup', "##{TEXTFIELD_ID}"
			if note.index == 0
				$('body').on 'keyup', "##{TEXTFIELD_ID}", (e) ->
					onKeyUp()

	getAuthorName = (author) ->
		author or "<i>#{t.ModulePage_UnknownUser}</i>"

	setTextAreaReadonly = (readonly) ->
		textArea.attr 'readonly', readonly
		if readonly
			textArea.addClass 'note-text-readonly'
		else
			textArea.removeClass 'note-text-readonly'

	getListItem = (note, i) ->
		theme = if i == 0 then 'b' else 'a'
		"""<li id="note-item#{note.id}" data-theme="#{theme}"><a href=""
			style="font-size: 14px; text-shadow: none"><span>#{note.created}</span><br/>""" +
			"""<span style="font-size: 13px">""" + (getAuthorName note.author) + '</span><br/>' +
			"""<span style="font-size: 12px; font-weight: normal">#{note.note}</span></a>
		</li>
		"""
class pgweb.NetworkListPage
	instance = null

	constructor: ->
		$('body').on 'pageshow', '.listNetworkPage', (event) =>
			@init()
		
	@inst: ->
		if not instance?
			instance = new @
		instance
	
	init: ->
		$('.network-collapsible .home-network-icon').on 'click', (event) ->
			onHomeClick event, $(this)
	
	onHomeClick = (event, icon) ->
		alreadySelected = icon.hasClass 'home-network-icon-selected'

		# Unselect all
		$('.home-network-icon').removeClass 'home-network-icon-selected'
		
		networkId = lastNum icon.attr 'id'

		if alreadySelected
			icon.removeClass 'home-network-icon-selected'
			ajaxSetSelected networkId, networkId != 0, false
		else
			icon.addClass 'home-network-icon-selected'
			ajaxSetSelected networkId, networkId == 0, true

		event.stopPropagation()
		event.preventDefault()
	
	ajaxSetSelected = (networkId, isFavorites, selected) ->
		if not selected
			networkId = null
		waitStart()
		$.ajax
			url: "/pgweb/ajax/network/saveHomeNetwork.php"
			dataType: 'json'
			type: 'POST'
			data:
				home_network_id: networkId,
				home_network_is_favorites: if isFavorites then 1 else 0
			success: (data) =>
				switch data.result
					when "OK"
						location.href = ""
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						alert "Saving home network failed. "+data.debug
			error: ajaxFailure,
			complete: -> waitStop()
		return true


$(-> pgweb.NetworkListPage.inst().init())
class pgweb.NetworkTasksDialog
	@init: ->
		pgweb.Main.onEvent 'click', '.network-settings-tasks-save-button', (event, ui) =>
			save()

		pgweb.Main.onEvent 'click', '.network-settings-tasks-cancel-button', (event, ui) =>
			$('#tasks-form').get(0).reset()

		pgweb.Main.onEvent 'click', '#tasks-edit-popup-button', (event, ui) =>
			$('#network-tasks-popup').popup 'open', {transition: 'pop'}

	@inst: ->
		if not instance?
			instance = new @
		instance
	
	save = ->
		$('#network-tasks-save-error-message').html ''
		id = $('input[name=network_id]').val()

		useTasks = $('#use-tasks').val()

		customColumnName1 = $('input[name=customColumnName1]').val()
		customColumnName2 = $('input[name=customColumnName2]').val()
		customColumnName3 = $('input[name=customColumnName3]').val()
		customColumnName4 = $('input[name=customColumnName4]').val()

		errStr = ''

		if errStr
			$('#network-tasks-save-error-message').html errStr
			return false

		waitStart()
		$.ajax
			url: "/pgweb/ajax/network/settings/saveNetworkTasks.php"
			dataType: 'json'
			type: 'POST'
			data:
				network:
					id: id
					useTasks: useTasks
					customColumnName1: customColumnName1
					customColumnName2: customColumnName2
					customColumnName3: customColumnName3
					customColumnName4: customColumnName4
			success: (data) =>
				switch data.result
					when "OK"
						location.reload true
					when 'NOT_LOGGED_IN'
						handleInactivity()
					when 'NAME_IS_NOT_UNIQUE_IN_NETWORK'
						$('#network-save-anav-error-message').html t.NetworkSettings_NameNotUnique
					else
						$('#network-save-anav-error-message').html "Saving tasks settings failed.<br/>"+data.debug
			error: ajaxFailure
			complete: -> waitStop()
		return true

pgweb.Main.onPageShow '.showNetworkSettingsPage', ->
	pgweb.NetworkTasksDialog.init()
class pgweb.NetworkAnAvCatDialog
	changed = null

	@init: ->
		pgweb.Main.onEvent 'click', '.network-settings-anav-categories-save-button', (event, ui) =>
			save()

		pgweb.Main.onEvent 'click', '.network-settings-anav-categories-cancel-button', (event, ui) =>
			$('#anav-categories-form').get(0).reset()
			if changed
				location.reload true

		pgweb.Main.onEvent 'click', '#anav-categories-edit-popup-button', (event, ui) =>
			$('#network-anav-categories-popup').popup 'open', {transition: 'pop'}

		pgweb.Main.onEvent 'click', '#anav-categories-add', (event, ui) ->
			pgweb.NetworkDialog.categoryAdd 'anav-categories'
			changed = true
			false

		pgweb.Main.onEvent 'click', '.anav-categories-delete', (event, ui) ->
			pgweb.NetworkDialog.categoryDelete $(@)
			changed = true
			false

		pgweb.Main.onEvent 'popupafteropen', '#network-anav-categories-popup', ->
			changed = false

	save = ->
		$('#network-anav-categories-save-error-message').html ''

		id = $('input[name=network_id]').val()

		anavCategoryInputs = $('.anav-categories-name')
		anavCategories = [{
			name: $(cat).val()
			id: if $(cat).prop 'id' then lastNum $(cat).prop 'id' else 0
			deleted: $(cat).closest('tr').hasClass 'deleted'
		} for cat in anavCategoryInputs][0]

		errStr = ''
		catNames = anavCategories.filter((cat) -> not cat.deleted).map (cat) -> cat.name.trim()
		if '' in catNames
			errStr = t.EmptyFieldsNotAllowed

		if errStr
			$('#network-anav-categories-save-error-message').html errStr
			return false

		waitStart()
		$.ajax
			url: "/pgweb/ajax/network/settings/saveNetworkAnAvCategories.php"
			dataType: 'json'
			type: 'POST'
			data:
				network:
					id: id
					anavCategories: anavCategories.filter (cat) -> not (cat.deleted and cat.id == 0)
			success: (data) =>
				switch data.result
					when "OK"
						location.reload true
					when "ANAV_CATEGORY_USED"
						anavs = JSON.parse data.anavsStr
						msg = t.NetworkSettings_ANAVCategoryCanNotBeDeleted + "\r\n"
						for anav in anavs
							msg += anav.domainName+' / '+anav.networkName + ' / ' + anav.moduleName + ' / ' +anav.number + "\r\n"
						alert msg
					when 'NOT_LOGGED_IN'
						handleInactivity()
					when 'NAME_IS_NOT_UNIQUE_IN_NETWORK'
						console.log 'uniq'
						$('#network-anav-categories-save-error-message').html t.NetworkSettings_NameNotUnique
					else
						$('#network-anav-categories-save-error-message').html "Saving AN/AV categories failed.<br/>"+data.debug
			error: ajaxFailure
			complete: -> waitStop()
		return true

pgweb.Main.onPageShow '.showNetworkSettingsPage', ->
	pgweb.NetworkAnAvCatDialog.init()
class pgweb.NetworkMiscDialog
	getCoordsMap = null

	@init: ->
		pgweb.Main.onEvent 'click', '.network-settings-misc-save-button', (event, ui) =>
			save()

		pgweb.Main.onEvent 'click', '.network-settings-misc-cancel-button', (event, ui) =>
			$('#misc-form').get(0).reset()

		pgweb.Main.onEvent 'click', '#misc-edit-popup-button', (event, ui) =>
			$('#network-misc-popup').popup 'open', {transition: 'pop'}

		getCoordsMap = new pgweb.GetCoordsMap 'network-coords-map'

	save = ->
		$('#network-misc-save-error-message').html ''
		id = $('input[name=network_id]').val()
		name = $('input[name=name]').val().trim()
		timezone = $('select[name=timezone]').val()

		latitudeStr = allowAltDecimal $('input[name=latitude]').val().trim()
		longitudeStr = allowAltDecimal $('input[name=longitude]').val().trim()
		latitude = null
		longitude = null

		errStr = ''

		if !name
			errStr += t.NetworkSettings_NameMissing
		
		if latitudeStr.length > 0
			if isNumeric latitudeStr
				latitude = Globalize.parseFloat latitudeStr
			else
				errStr += t.ModuleSettings_GisLatitudeWrongFormat+'<br/>'
		
		if longitudeStr.length > 0
			if isNumeric longitudeStr
				longitude = Globalize.parseFloat longitudeStr
			else
				errStr += t.ModuleSettings_GisLongitudeWrongFormat+'<br/>'
		
		if (latitudeStr.length > 0 and longitudeStr.length == 0) or (latitudeStr.length == 0 and longitudeStr.length > 0)
			errStr += t.ModuleSettings_GisCoordWrongFormat+'<br/>'

		if errStr
			$('#network-misc-save-error-message').html errStr
			return false

		waitStart()
		$.ajax
			url: "/pgweb/ajax/network/settings/saveNetworkMisc.php"
			dataType: 'json'
			type: 'POST'
			data:
				network:
					id: id
					name: name
					latitude: latitude
					longitude: longitude
					timezone: timezone
			success: (data) =>
				switch data.result
					when "OK"
						location.reload true
					when 'NOT_LOGGED_IN'
						handleInactivity()
					when 'NAME_IS_NOT_UNIQUE_IN_NETWORK'
						$('#network-save-misc-error-message').html t.NetworkSettings_NameNotUnique
					else
						$('#network-save-misc-error-message').html "Saving network miscellaneous changes failed.<br/>"+data.debug
			error: ajaxFailure
			complete: -> waitStop()
		return true

pgweb.Main.onPageShow '.showNetworkSettingsPage', ->
	pgweb.NetworkMiscDialog.init()
class pgweb.NetworkAreasDialog
	changed = null

	@init: ->
		pgweb.Main.onEvent 'click', '.network-settings-areas-save-button', (event, ui) =>
			save()

		pgweb.Main.onEvent 'click', '.network-settings-areas-cancel-button', (event, ui) =>
			$('#areas-form').get(0).reset()
			if changed
				location.reload true

		pgweb.Main.onEvent 'click', '#areas-edit-popup-button', (event, ui) =>
			$('#network-areas-popup').popup 'open', {transition: 'pop'}

		pgweb.Main.onEvent 'click', '#areas-add', (event, ui) ->
			pgweb.NetworkDialog.categoryAdd 'areas'
			changed = true
			false

		pgweb.Main.onEvent 'click', '.areas-delete', (event, ui) ->
			pgweb.NetworkDialog.categoryDelete $(@)
			changed = true
			false

		pgweb.Main.onEvent 'popupafteropen', '#network-areas-popup', ->
			changed = false

	save = ->
		$('#network-areas-save-error-message').html ''
		id = $('input[name=network_id]').val()

		areaInputs = $('.areas-name')
		areas = [{
			name: $(area).val()
			id: if $(area).prop 'id' then lastNum $(area).prop 'id' else 0
			deleted: $(area).closest('tr').hasClass 'deleted'
		} for area in areaInputs][0]

		errStr = ''
		areaNames = areas.filter((area) -> not area.deleted).map (area) -> area.name.trim()
		if '' in areaNames
			errStr = t.EmptyFieldsNotAllowed

		if errStr
			$('#network-areas-save-error-message').html errStr
			return false

		waitStart()
		$.ajax
			url: "/pgweb/ajax/network/settings/saveNetworkAreas.php"
			dataType: 'json'
			type: 'POST'
			data:
				network:
					id: id
					areas: areas.filter (cat) -> not (cat.deleted and cat.id == 0)
			success: (data) =>
				switch data.result
					when "OK"
						location.reload true
					when "AREA_USED"
						modulesStr = data.areasUsed.join ', '
						$('#network-save-error-message').html t.NetworkSettings_AreaUsed+' '+modulesStr
					when 'NOT_LOGGED_IN'
						handleInactivity()
					when 'NAME_IS_NOT_UNIQUE_IN_NETWORK'
						$('#network-areas-save-error-message').html t.NetworkSettings_NameNotUnique
					else
						$('#network-areas-save-error-message').html "Saving areas failed.<br/>"+data.debug
			error: ajaxFailure
			complete: -> waitStop()
		return true

pgweb.Main.onPageShow '.showNetworkSettingsPage', ->
	pgweb.NetworkAreasDialog.init()
class pgweb.NetworkDiCatDialog
	changed = null

	@init: ->
		pgweb.Main.onEvent 'click', '.network-settings-di-categories-save-button', (event, ui) =>
			save()

		pgweb.Main.onEvent 'click', '.network-settings-di-categories-cancel-button', (event, ui) =>
			$('#di-categories-form').get(0).reset()
			if changed
				location.reload true

		pgweb.Main.onEvent 'click', '#di-categories-edit-popup-button', (event, ui) =>
			$('#network-di-categories-popup').popup 'open', {transition: 'pop'}

		pgweb.Main.onEvent 'click', '#di-categories-add', (event, ui) ->
			pgweb.NetworkDialog.categoryAdd 'di-categories'
			changed = true
			false

		pgweb.Main.onEvent 'click', '.di-categories-delete', (event, ui) ->
			pgweb.NetworkDialog.categoryDelete $(@)
			changed = true
			false

		pgweb.Main.onEvent 'popupafteropen', '#network-di-categories-popup', ->
			changed = false

	save = ->
		$('#network-di-categories-save-error-message').html ''
		id = $('input[name=network_id]').val()

		diCategoryInputs = $('.di-categories-name')
		diCategories = [{
			name: $(cat).val()
			id: if $(cat).prop 'id' then lastNum $(cat).prop 'id' else 0
			deleted: $(cat).closest('tr').hasClass 'deleted'
		} for cat in diCategoryInputs][0]

		errStr = ''
		catNames = diCategories.filter((cat) -> not cat.deleted).map (cat) -> cat.name.trim()
		if '' in catNames
			errStr = t.EmptyFieldsNotAllowed

		if errStr
			$('#network-di-categories-save-error-message').html errStr
			return false

		waitStart()
		$.ajax
			url: "/pgweb/ajax/network/settings/saveNetworkDiCategories.php"
			dataType: 'json'
			type: 'POST'
			data:
				network:
					id: id
					diCategories: diCategories.filter (cat) -> not (cat.deleted and cat.id == 0)
			success: (data) =>
				switch data.result
					when "OK"
						location.reload true
					when "DI_CATEGORY_USED"
						dis = JSON.parse data.disStr
						msg = t.NetworkSettings_DICategoryCanNotBeDeleted + "\r\n"
						for di in dis
							msg += di.domainName+' / '+di.networkName + ' / ' + di.moduleName + ' / ' +di.number + "\r\n"
						alert msg
					when 'NOT_LOGGED_IN'
						handleInactivity()
					when 'NAME_IS_NOT_UNIQUE_IN_NETWORK'
						$('#network-di-categories-save-error-message').html t.NetworkSettings_NameNotUnique
					else
						$('#network-di-categories-save-error-message').html "Saving DI categories failed.<br/>"+data.debug
			error: ajaxFailure
			complete: -> waitStop()
		return true

pgweb.Main.onPageShow '.showNetworkSettingsPage', ->
	pgweb.NetworkDiCatDialog.init()
class pgweb.NetworkChannelCatDialog
	changed = null

	@init: ->
		pgweb.Main.onEvent 'click', '.network-settings-channel-categories-save-button', (event, ui) =>
			save()

		pgweb.Main.onEvent 'click', '.network-settings-channel-categories-cancel-button', (event, ui) =>
			$('#channel-categories-form').get(0).reset()
			if changed
				location.reload true

		pgweb.Main.onEvent 'click', '#channel-categories-edit-popup-button', (event, ui) =>
			$('#network-channel-categories-popup').popup 'open', {transition: 'pop'}

		pgweb.Main.onEvent 'click', '#channel-categories-add', (event, ui) ->
			pgweb.NetworkDialog.categoryAdd 'channel-categories'
			changed = true
			false

		pgweb.Main.onEvent 'click', '.channel-categories-delete', (event, ui) ->
			pgweb.NetworkDialog.categoryDelete $(@)
			changed = true
			false

		pgweb.Main.onEvent 'popupafteropen', '#network-channel-categories-popup', ->
			changed = false

	save = ->
		$('#network-channel-categories-save-error-message').html ''

		id = $('input[name=network_id]').val()

		channelCategoryInputs = $('.channel-categories-name')
		channelCategories = [{
			name: $(cat).val()
			id: if $(cat).prop 'id' then lastNum $(cat).prop 'id' else 0
			deleted: $(cat).closest('tr').hasClass 'deleted'
		} for cat in channelCategoryInputs][0]

		errStr = ''
		catNames = channelCategories.filter((cat) -> not cat.deleted).map (cat) -> cat.name.trim()
		if '' in catNames
			errStr = t.EmptyFieldsNotAllowed

		if errStr
			$('#network-channel-categories-save-error-message').html errStr
			return false

		waitStart()
		$.ajax
			url: "/pgweb/ajax/network/settings/saveNetworkChannelCategories.php"
			dataType: 'json'
			type: 'POST'
			data:
				network:
					id: id
					channelCategories: channelCategories.filter (cat) -> not (cat.deleted and cat.id == 0)
			success: (data) =>
				switch data.result
					when "OK"
						location.reload true
					when "CHANNEL_CATEGORY_USED"
						channels = JSON.parse data.channelsStr
						msg = t.NetworkSettings_ChannelCategoryCanNotBeDeleted + "\r\n"
						for ch in channels
							msg += ch.domainName+' / '+ch.networkName + ' / ' + ch.moduleName + ' / ' + t.Channel + ' ' + ch.channelNumber + "\r\n"
						alert msg
					when 'NOT_LOGGED_IN'
						handleInactivity()
					when 'NAME_IS_NOT_UNIQUE_IN_NETWORK'
						$('#network-channel-categories-save-error-message').html t.NetworkSettings_NameNotUnique
					else
						$('#network-channel-categories-save-error-message').html "Saving channel categories failed.<br/>"+data.debug
			error: ajaxFailure
			complete: -> waitStop()
		return true

pgweb.Main.onPageShow '.showNetworkSettingsPage', ->
	pgweb.NetworkChannelCatDialog.init()
class pgweb.NetworkPage
	@init: ->
		if $('#network-map-onoff').val() == 'on'
			pgweb.NetworkMap.inst().id = 'network-map'
			pgweb.NetworkMap.inst().init()
		
		pgweb.Main.onEvent 'change', '.needle-button', (e) =>
			runFilter()

		pgweb.Main.onEvent 'change', '#network-map-onoff', ->
			pgweb.NetworkMap.inst().id = 'network-map'
			checkMapOnOff()

		pgweb.Main.onEvent 'click', '#network-document-button', (event, ui) =>
			button = $(event.target).closest 'button'
			networkId = button.attr 'pgweb-data-assoc-id'
			$('#user-document-popup').find('[name=document-assoc]').val 'network'
			$('#user-document-popup').find('[name=document-assoc-id]').val networkId
			$('#user-document-popup-title').text $('[name=network_name]').val()
			$('#user-document-popup').popup 'open', {transition: 'pop'}

		pgweb.Event.on 'network_map_loaded', ->
			runFilter()
		
		checkMapOnOff()

		# Only run if there is a document popup on the page.
		if $('#user-document-popup').length > 0
			pgweb.UserDocumentPopup.inst()

	checkMapOnOff = ->
		if $('#network-map-onoff').val() == 'on'
			pgweb.NetworkMap.inst().show()
			$('#needle-color-buttons').show()
		else
			if pgweb.NetworkMap.inst().isInitialized()
				pgweb.NetworkMap.inst().hide()
			$('#needle-color-buttons').hide()

	runFilter = ->
		isGreen  = $('#needle-button-green').is  ':checked'
		isYellow = $('#needle-button-yellow').is ':checked'
		isRed    = $('#needle-button-red').is    ':checked'
		isGray   = $('#needle-button-gray').is   ':checked'
		networkMap = pgweb.NetworkMap.inst()
		networkMap.toggleLayers isGreen, isYellow, isRed, isGray

pgweb.Main.onPageShow '.showNetworkPage', ->
	pgweb.NetworkPage.init()

class pgweb.NetworkMap extends pgweb.Map
	
	instance = null
	intervalId = null
	
	@inst: ->
		# Run only on network page.
		if $.url().param().action != 'showNetwork'
			return
		if not instance?
			instance = new @
		instance

	initInterval: ->
		clearInterval intervalId
		intervalId = setInterval =>
			if pgweb.Main.inst().autoUpdateButtonIsOn()
				@update false
		, pgweb.Main.getUpdateInterval()
	
	# Find the modules in the network which have coordinates.
	update: (fitBounds) ->
		if $.url().param().action != 'showNetwork' then return
		
		@modules = []
		$.ajax
			url: "/pgweb/ajax/network/networkMap.php"
			dataType: 'json'
			type: 'GET'
			data:
				networkId: $.url().param().networkId
			success: (data) =>
				@modules = data.modules
				switch data.result
					when "OK"
						@internalUpdate fitBounds
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get module data.', data.result);
			error: ajaxFailure
	
	# Display markers for all the modules.
	internalUpdate: (fitBounds) ->
		@fitToBounds() if fitBounds
		
		# Display the map needles.
		@createMarkers()

		pgweb.Event.trigger 'network_map_loaded'
	
$(document).on 'pageshow', '.showNetworkPage', (event) ->
	if $('#network-map').length > 0
		networkMap = pgweb.NetworkMap.inst()
		if networkMap
			networkMap.id = 'network-map'
			networkMap.initInterval()
class pgweb.NetworkDialog

	@categoryAdd: (what) ->
		tr = $('<tr>')

		td1 = $('<td>')
		nameInput = $('<input type="text" class="'+what+'-name" data-inline="true"/>')
		td1.append nameInput
		tr.append td1

		td2 = $('<td>')
		myClasses = what+'-delete '+what+'-delete-new'
		internalClasses = 'ui-btn ui-btn-inline ui-shadow ui-corner-all'
		button = $('<button data-inline="true" class="'+myClasses+' '+internalClasses+'" style="position: relative; top: -3px;">')
		button.append $('<i class="fa fa-trash fa-lg">')
		td2.append button

		tr.append td2

		$('#'+what+'-list').append tr

		nameInput.textinput()
		
		# For some reason this does not work, instead I added the internal classes above.
		#button.button()

	# contactAdd = () ->
	# 	what = 'contact'
	# 	tr = $('<tr>')

	# 	td1 = $('<td>')
	# 	nameBox = '<div style="padding-left: 5px">'
	# 	nameBox += '<select class="user-id">'
	# 	for user in allUsersInOrg
	# 		nameBox += '<option value="'+user.id+'">'+user.name+'</option>'
	# 	nameBox += '</select>'
	# 	nameBox += '</div>'
	# 	td1.append nameBox
	# 	designationInput = $('<input type="text" class="'+what+'-designation" data-inline="true"/>')
	# 	td1.append designationInput
	# 	tr.append td1

	# 	td2 = $('<td style="vertical-align: bottom; position: relative; top: -3px">')
	# 	myClasses = what+'-delete '+what+'-delete-new'
	# 	internalClasses = 'ui-btn ui-btn-inline ui-shadow ui-corner-all'
	# 	button = $('<button id="contact-delete0" data-inline="true" class="'+myClasses+' '+internalClasses+'" style="position: relative; top: -3px;">')
	# 	button.append $('<i class="fa fa-trash fa-lg">')
	# 	td2.append button

	# 	tr.append td2

	# 	$('#'+what+'-list').append tr

	# 	designationInput.textinput()
		
	# 	# For some reason this does not work, instead I added the internal classes above.
	# 	#button.button()

	@categoryDelete: (delButton) ->
		if delButton.prop 'id'
			id = lastNum delButton.prop 'id'
			# Do not remove, id is needed for deletion.
			delButton.parent().parent().hide 'slow'
			delButton.parent().parent().addClass 'deleted', true
		else
			delButton.parent().parent().hide 'slow', -> delButton.remove()
class pgweb.GeniusMap
	instance = null
	marker = null
	map = null
	
	constructor: ->
		createMap()
		#map.invalidateSize()

	@inst: ->
		if not instance?
			instance = new @
		instance

	ensureNoMap = ->
		if map
			map.remove()
			map = undefined

	createMap = ->
		ensureNoMap()
		
		hasCoords = if $('#gisLatitude').val() then true else false
		lat = if $('#gisLatitude').val() then $('#gisLatitude').val().replace ',', '.' else 60
		lng = if $('#gisLongitude').val() then $('#gisLongitude').val().replace ',', '.' else 15
		
		if hasCoords then zoom = 13 else zoom = 3
		
		map = L.map('genius-map',
			zoomAnimationThreshold: 17
			attributionControl: false
		).setView [lat, lng], zoom
		attribution = ''
		config =
			attribution: attribution
			maxZoom: 21
			maxNativeZoom: 19

		marker = new L.marker([lat, lng])
		map.addLayer marker
		map.setView [lat ,lng]

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', config).addTo map

$(document).on 'pageshow', '.showGeniusPage', (event) ->
	pgweb.GeniusMap.inst()
class pgweb.ControlRoomOverviewMap
	map = null
	rect = null

	MARGIN_PIXELS = 2000

	ensureNoMap = ->
		if map
			map.remove()
			map = undefined

	createMap = (bounds) ->
		ensureNoMap()

		map = L.map('cr-overview-map',
			attributionControl: false
			zoomControl: false
			scrollWheelZoom: false
			dragging: false
			keyboard: false
			doubleClickZoom: false
		).on 'load', =>
			# setTimeout() should not be needed here, but it is...
			window.setTimeout ->
				$('.leaflet-layer').addClass 'cr-map-gray'
			, 10

		map.setView(bounds.getCenter(), 14).fitBounds bounds

		config =
			attribution: ''
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', config).addTo map

	@update: (bigmap) ->
		bounds = bigmap.getBounds()
		cpSouthWest = bigmap.latLngToContainerPoint bounds._southWest
		cpNorthEast = bigmap.latLngToContainerPoint bounds._northEast
		cpSouthWest.y -= MARGIN_PIXELS
		cpSouthWest.x -= MARGIN_PIXELS
		cpNorthEast.y += MARGIN_PIXELS
		cpNorthEast.x += MARGIN_PIXELS
		overviewBounds = bigmap.getBounds()
		overviewBounds._southWest = bigmap.containerPointToLatLng cpSouthWest
		overviewBounds._northEast = bigmap.containerPointToLatLng cpNorthEast
		if map
			map.fitBounds overviewBounds
		else
			createMap overviewBounds
		style =
			color: 'red'
			weight: 2
		if rect then rect.remove()
		rect = L.rectangle(bounds, style)
		rect.addTo map
class pgweb.ControlRoom
	constructor: (@data) ->

	fromJSON = ->
		JSON.stringify @data
class pgweb.ControlRoomFlowMap extends pgweb.Map
	instance = null
	intervalId = null
	fullscreen = false
	markerLayer = null
	networkIds = null
	leftIndex = 0
	rightIndex = 1
	coreNames = [
		'flow_forward', 'flow_return', 'flow_speed_forward', 'flow_speed_return', \
		'pressure_forward', 'pressure_return', 'temp_forward', 'temp_return', \
		'flow_deviation', 'flow_deviation_percent', 'pressure_deviation', 'temp_diff'
	]
	selectButtonTexts = [
		'-', \
		'Flöde Fram', 'Flöde Retur', \
		'Flöde hast. Fram', 'Flöde hast. Retur', \
		'Tryck Fram', 'Tryck Retur', \
		'Temp Fram', 'Temp Retur', \
		'Flöde Avvikelse', 'Flöde Avvik. %', \
		'Tryck Avvikelse', 'Temp Diff'
	]
	sortDirection = 'up'
	sortSelected = 'left'
	currentModule = null
	currentData = null
	leftAndRight = ['left', 'right']

	showAverage = false
	nAverage = 5

	zoomed = false

	@inst: ->
		# Run only on the right control room page and mode 'anValues' or when no mode.
		if $.url().param().action != "show#{controlRoom.className}ControlRoom"
			return
		pageNamesExceptMe = (Object.keys controlRoom.pages).filter (item) -> item != 'flow'
		if $.url().param().mode in pageNamesExceptMe
			return
		if not instance?
			instance = new @
		instance

	init: ->
		networkIds = $('#cr-network-ids').val()

		# Ensure there is no map.
		@ensureNoMap()

		# Create the map object.
		map = @createMap()

		map.on 'load', =>
			$('.leaflet-layer').addClass 'cr-map-gray'

		# Add the map fullscreen toggle button.
		map.addControl pgweb.ControlRoomCommon.createFullscreenButton @

		# Display markers for all the modules.
		@clearMarkers()
		@update true

		map.on 'resize', =>
			@fitToBounds()

		map.on 'zoomend', (obj) =>
			@onZoomEnd()
			@checkZoom()
			zoomed = true

		map.on 'moveend', ->
			pgweb.ControlRoomOverviewMap.update map

		maximized = @getMaximizedCookie()
		if ($.url().attr 'anchor') == 'fullscreen'
			$('.map-fullscreen-button').trigger 'click'
		else
			if maximized
				maximized = not maximized
				$('.map-maximize-button').trigger 'click'

		$(document).on 'keyup', (event) ->
			if event.key == 'F11'
				if fullscreen
					location.reload()

		pgweb.ControlRoomSmallChart.create @
		
		@updateAverageButton()
		$('#n-average-container').hide()

		$('body').on 'click', '#last-or-average-button', (e) =>
			showAverage = not showAverage
			$('#cr-flow-alarm-table').toggle not showAverage
			$('#n-average-container').toggle showAverage
			@updateAverageButton()
			@updateValueTable()
			@updateNeedles()
			module = @getSelectedModule()
			if module
				@updatePopupHtml module
				@showSmallChart module

		$('body').on 'change', '#n-average', (e) =>
			nAverage = $(e.currentTarget).val()
			@updateValueTable()
			module = @getSelectedModule()
			if module
				@updatePopupHtml module
				@showSmallChart module

		$('body').on 'click', '#cr-flow-value-table tbody tr', (e) =>
			@onValueTableBodyClick $(e.currentTarget)

		$('body').on 'click', '#cr-flow-alarm-table tbody tr', (e) =>
			@onAlarmTableBodyClick $(e.currentTarget)

		leftAndRight.forEach (leftRight) =>

			$('body').on 'click', "#cr-flow-#{leftRight}-selectbutton", (e) =>
				@onFlowNeedleSelect $(e.currentTarget)

			$('body').on 'click', '.cr-sort-'+leftRight, (e) =>
				[sortSelected, sortDirection] = pgweb.ControlRoomCommon.sortValues leftRight, sortDirection, 'cr-flow-value-table', leftIndex, rightIndex

		$('body').on 'click', '#cr-filter-button', (e) =>
			selectedClassName = 'cr-filter-button-selected'
			if $('#cr-filter-button').hasClass selectedClassName
				$('#cr-filter-button').removeClass selectedClassName
				$('#cr-filter-table').hide 200
			else
				$('#cr-filter-button').addClass selectedClassName
				$('#cr-filter-table').show 200

		$('body').on 'keyup', '.cr-filter', (e) =>
			box = $(e.currentTarget)
			pgweb.ControlRoomCommon.onFilterChange box, 'cr-flow-value-table', leftIndex, rightIndex

		pgweb.ControlRoomCommon.init @

		pgweb.HelpDialog.register 'cr-filter-help', 'cr-filter-help-button'

		pgweb.ControlRoomWeatherWidget.ajaxGetTemperature controlRoom.name

	showSmallChart: (module) ->
		pgweb.ControlRoomSmallChart.show @, module, (@menuState 'left'), (@menuState 'right'), \
			showAverage, selectButtonTexts, currentData, nAverage

	updateAverageButton: ->
		title = if showAverage then 'Medelvärden' else 'Senaste värden'
		$('#last-or-average-button').html title + ' &nbsp;<i class="fa fa-refresh"></i>'

	onFlowNeedleSelect: (button) ->
		id = $(button).attr 'id'
		[_, _, leftOrRight] = id.split '-'
		if leftOrRight == 'left'
			leftIndex += 1
			leftIndex %= (coreNames.length + 1)
			index = leftIndex
		else
			rightIndex += 1
			rightIndex %= (coreNames.length + 1)
			index = rightIndex
		$('#cr-flow-'+leftOrRight+'-text').text selectButtonTexts[index]
		@updateNeedles()
		@showHideValueTable()
		module = @getSelectedModule()
		if module
			@showSmallChart module

	updateNeedles: ->
		menuStateLeft  = @menuState 'left'
		menuStateRight = @menuState 'right'
		for module in @modules
			coords = @correctCoords [module.gis_latitude, module.gis_longitude]
			if coords[0] and coords[1]
				tooltipHtml = @getTooltipHtml menuStateLeft, menuStateRight, module
				tooltipConfig = @getTooltipConfig()
				module.marker.bindTooltip(tooltipHtml, tooltipConfig).openTooltip();
		@checkZoom()

	onValueTableBodyClick: (tr) ->
		moduleId = lastNum tr.attr 'id'
		module = @getModuleById moduleId
		if module
			selClass = 'cr-flow-value-list-selected'
			selected = tr.hasClass selClass
			if selected
				tr.removeClass selClass
				currentModule = module
			else
				$('#cr-flow-value-table tbody tr').removeClass selClass
				tr.addClass selClass
				currentModule = null
			$('#cr-value-table-error').text ''
	
			marker = @getMarkerByModuleId moduleId

			@openOrClosePopup marker, selected, 'value'

	onAlarmTableBodyClick: (tr) ->
		tagId = lastNum tr.attr 'id'
		tag = @getTagById tagId
		if tag
			selClass = 'cr-flow-alarm-list-selected'
			selected = tr.hasClass selClass
			if selected
				tr.removeClass selClass
				currentModule = @getModuleById tag.module_id
			else
				$('#cr-flow-alarm-table tbody tr').removeClass selClass
				tr.addClass selClass
				currentModule = null
			$('#cr-alarm-table-error').text ''

			marker = @getMarkerByModuleId tag.module_id

			@openOrClosePopup marker, selected, 'alarm'

	getSelectedModule: ->
		currentModule

	getSelectedTag: (leftOrRight) ->
		index = { left: leftIndex, right: rightIndex}[leftOrRight]
		if index > 0
			name = coreNames[index-1]
			tagName = name.snakeToPascal()
			currentModule.tags[tagName]
		else null

	openOrClosePopup: (marker, selected, valueOrAlarm) ->
		if marker
			if selected
				marker.closePopup()
			else
				marker.openPopup()
		else
			$('#cr-'+valueOrAlarm+'-table-error').text 'Modulen har inte koordinater.'
			@getMap().closePopup()

	getMarkerByModuleId: (moduleId) ->
		markers = markerLayer.getLayers()
		markers.find (marker) ->
			marker.moduleId == moduleId

	checkZoom: ->
		showOrHide = if @getMap().getZoom() < 10 then 'hidden' else 'visible'
		$('.cr-flow-tooltip-table').css 'visibility', showOrHide

	getLayerDataByAjax: (networkId) =>
		return

	update: (fitBounds) ->
		@ajaxUpdate fitBounds, networkIds

	ajaxUpdate: (fitBounds, networkIds) ->
		@modules = []
		$.ajax
			url: "/pgweb/ajax/controlroom/common/controlRoomFlowMap.php"
			dataType: 'json'
			type: 'GET'
			data:
				networkIds: networkIds
			success: (data) =>
				currentData = data
				@modules = data.modules
				switch data.result
					when "OK"
						@afterAjaxUpdate fitBounds
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get module data.', data.result);
			error: ajaxFailure

	# Display markers for all the modules.
	afterAjaxUpdate: (fitBounds) ->
		@fillValueTable()

		@fillAlarmTable()

		if fitBounds
			@fitToBounds 0.005, 0.01

		# Display the map needles.
		@createMarkers()

		for dir in leftAndRight
			@onFlowNeedleSelect $("#cr-flow-#{dir}-selectbutton")

		[sortSelected, sortDirection] = pgweb.ControlRoomCommon.sortValues sortSelected, sortDirection, 'cr-flow-value-table', leftIndex, rightIndex

		for module in @modules
			@getAreaGeoJSONByAjax module

	getValue: (module, indexOrName) ->
		if typeof indexOrName == 'number'
			index = indexOrName
			name = @indexToName index
		else
			name = indexOrName
			index = @nameToIndex name
		if showAverage
		 	# This is not the same smallChartData as the one got from ControlRoomFlowMapSmallChart.php.
			# Only needed for showing average values in the table!
			seriesData = module.smallChartData[index]
			a = seriesData[-nAverage..] # At most last nAverage elements
			if a.length > 0
				sum = a.reduce ((a, b) -> a + b.v), 0
				sum/a.length
			else
				''
		else
			module[name]

	fillValueTable: ->
		$('#cr-flow-value-table tbody').html ''

		for m in @modules

			html = """<tr class="cr-value-green" id="module-id-#{m.id}">"""
			for leftRight in leftAndRight
				for name, i in coreNames
					tag = m.tags[name.snakeToPascal()]
					format = pgweb.Main.removeFormatF tag.format
					value = @getValue m, i
					valueStr = pgweb.ControlRoomCommon.numFormat value, format
					color = if showAverage then 'white' else m[name+'_color']
					if value.toString().length > 0
						html += """<td class="cr-table-color-#{color} cr-col 
						cr-col-#{leftRight+i}"><span>#{valueStr}</span></td>"""
					else
						html += """<td class="cr-col cr-col-#{leftRight+i}"><span>-</span></td>"""
				if leftRight == 'left'
					html += """<td class="cr-col-name"></td>"""
			html += '</tr>'
			$('#cr-flow-value-table tbody').append html

		# Test of many rows:
		# for i in [1..80]
		# 	html = '<tr class="cr-tooltip-color-green cr-value-red" id="module-id-0">'
		# 	for leftRight in leftAndRight
		# 		html += '<td class="cr-table-color-gray cr-col cr-col-'+leftRight+'0"><span>0.1</span></td>'
		# 		if leftRight == 'left'
		# 			html += '<td class="cr-col-name">asdfasdf</td>'
		# 	html += '</tr>'
		# 	$('#cr-flow-value-table tbody').append html

		@showHideValueTable()

	updateValueTable: ->
		for m in @modules
			if showAverage
				for color in ['red', 'orange', 'green']
					$('#module-id-'+m.id).removeClass 'cr-value-'+color
				$('#module-id-'+m.id).addClass 'cr-value-white'
			else
				for color in ['red', 'orange', 'green', 'white']
					$('#module-id-'+m.id).removeClass 'cr-value-'+color
				$('#module-id-'+m.id).addClass 'cr-value-green'
			for leftRight in leftAndRight
				for name, i in coreNames
					tag = m.tags[name.snakeToPascal()]
					format = pgweb.Main.removeFormatF tag.format
					value = @getValue m, i
					valueStr = pgweb.ControlRoomCommon.numFormat value, format

					for color in ['red', 'orange', 'green', 'gray']
						$("#module-id-#{m.id} td.cr-col-#{leftRight+i}").removeClass 'cr-table-color-'+color
					color = if showAverage then 'white' else m[name+'_color']
					$("#module-id-#{m.id} td.cr-col-#{leftRight+i}").addClass 'cr-table-color-'+color
					if value.toString().length > 0
						$("#module-id-#{m.id} td.cr-col-#{leftRight+i} span").html valueStr
					else
						$("#module-id-#{m.id} td.cr-col-#{leftRight+i} span").html '-'

	showHideValueTable: ->
		$('#cr-flow-value-table tbody tr td').hide()
		$('#cr-flow-value-table tbody tr td.cr-col-name').show()

		showHideF = (dir) =>
			state = @menuState dir
			if state == -1
				@showValueTableDummy dir
			else
				@showValueTableColumn dir, state

		leftAndRight.forEach (dir) -> showHideF dir

	showValueTableDummy: (leftOrRight) ->
		sel = '#cr-flow-value-table tbody tr td.cr-col-'+leftOrRight+'0'
		$(sel).show()
		$(sel).addClass 'cr-col-hidden'

	showValueTableColumn: (leftOrRight, index) ->
		sel = '#cr-flow-value-table tbody tr td.cr-col-'+leftOrRight+index
		$(sel).show()
		$(sel).removeClass 'cr-col-hidden'

	fillAlarmTable: ->
		$('#cr-flow-alarm-table tbody').html ''
		rowHtml  = ""
		for module in @modules
			for name in coreNames
				rowHtml += @getAlarmRow module, name
		$('#cr-flow-alarm-table tbody').append rowHtml

	getAlarmRow: (module, name) ->
		color = module[name+'_color']
		if color in ['red', 'orange']
			tagName = name.snakeToPascal()
			tag = module.tags[tagName]
			value = module[name]
			valueStr = @formatTagValue module, value, tagName
			lowOrHigh = tag.passedAlarmLimits.split ','
			lowOrHighStr = if 'hi' in lowOrHigh or 'hihi' in lowOrHigh
				'arrow-up'
			else if 'lo' in lowOrHigh or 'lolo' in lowOrHigh
				'arrow-down'
			else '?'
			timerAlarmSymbol = if module.timer_color in ['red', 'yellow']
				'<i class="fa fa-warning" style="color:yellow"></i>'
			else ''
			index = @nameToIndex name
			title = selectButtonTexts[1+index]
			identity = module.technical_name or module.address or module.system_name
			"""<tr id="tag-id-#{tag.id}" class="cr-alarm-#{color}">
			<td><i class=\"fa fa-#{lowOrHighStr}\"></i></td>
			<td>#{valueStr} #{tag.unit}</td>
			<td>#{title}</td>
			<td>#{identity.toString().firstPart 12}</td>
			<td>#{timerAlarmSymbol}</td>
			</tr>"""
		else ''

	# Takes input 'left' or 'right'.
	# Returns the state of the left or right menu as an index 0-11:
	#  0 - Flow Forward
	#  1 - Flow Return
	# ...
	menuState: (leftOrRight) ->
		if leftOrRight == 'left'
			leftIndex - 1
		else
			rightIndex - 1

	createMarkers: ->
		map = @getMap()
		if markerLayer?
			markerLayer.clearLayers()
		markerLayer = L.layerGroup()
		markerLayer.addTo map

		for m in @modules
			coords = @correctCoords [m.gis_latitude, m.gis_longitude]
			if coords[0] and coords[1]
				marker = @getMarker coords, m
				m.marker = marker
				markerLayer.addLayer marker
		@checkZoom()

	getIcon: (module) ->
		color = 'green'
		L.divIcon
			html: """<img src="images/dial_white.png" 
			style="width: 14px; height: 16px; position: relative; top: 3px"/>"""
			className: 'map-needle map-needle-'+color
			iconSize: [24, 38]
			iconAnchor: [12, 38]
			popupAnchor: [0, -38]

	getMarker: (coords, module) ->
		icon = @getIcon module
		marker = L.marker coords,
			icon: icon
			title: module.module_name
		marker.bindPopup @getPopupHtml module
		marker.moduleId = module.id
		marker.on 'popupopen', (e) =>
			@onPopupOpen e
		marker.on 'popupclose', (e) =>
			@onPopupClose e
		menuStateLeft  = @menuState 'left'
		menuStateRight = @menuState 'right'
		tooltipHtml = @getTooltipHtml menuStateLeft, menuStateRight, module
		tooltipConfig = @getTooltipConfig()
		marker.bindTooltip(tooltipHtml, tooltipConfig).openTooltip()
		marker

	onPopupOpen: (e) ->
		moduleId = e.sourceTarget.moduleId
		module = @getModuleById moduleId
		currentModule = module

		@updatePopupHtml module
		@showSmallChart module

		zoomed = pgweb.ControlRoomCommon.showModulePanel @getMap(), true, zoomed, module
		@updateModulePanel module

		# Mark the row in the value table.
		$('#cr-flow-value-table tr').removeClass 'cr-flow-value-list-selected'
		if $('#module-id-'+moduleId).length > 0
			$('#module-id-'+moduleId).addClass 'cr-flow-value-list-selected'
			$('#module-id-'+moduleId).get(0).scrollIntoView
				behavior: "smooth"
				block: "center"

		# Mark the row(s) in the alarm table.
		for tag in Object.values module.tags
			if $('#tag-id-'+tag.id).length > 0
				$('#tag-id-'+tag.id).addClass 'cr-flow-alarm-list-selected'
				$('#tag-id-'+tag.id).get(0).scrollIntoView
					behavior: "smooth"
					block: "center"

	onPopupClose: (e) ->
		$('#cr-flow-value-table tbody tr').removeClass 'cr-flow-value-list-selected'
		$('#cr-flow-alarm-table tbody tr').removeClass 'cr-flow-alarm-list-selected'
		$('#cr-flow-chart').hide 'fast'
		currentModule = null
		pgweb.ControlRoomCommon.showModulePanel @getMap(), false, zoomed

	updateModulePanel: (module) ->
		$('#cr-module-data').html @getModulePanelHtml module

	nameToIndex: (name) ->
		# Make an object with the core names as keys and 0, 1, 2... as values.
		obj = Object.fromEntries (coreNames.map (name, i) -> [name, i])
		# Return the index of the selected name.
		obj[name]

	indexToName: (index) ->
		coreNames[index]

	# Return html for the values shown beside the map needles.
	getTooltipHtml: (leftButtonIndex, rightButtonIndex, module) ->
		getHtml = (buttonIndex, dir) =>
			if buttonIndex == -1
				valueStr = ''
				unit = ''
				invisibleClass = 'cr-tooltip-invisible'
			else
				name = @indexToName buttonIndex
				tagName = name.snakeToPascal()
				value = @getValue module, name
				unit = module.tags[tagName].unit
				color = module[name+'_color']
				format = pgweb.Main.removeFormatF module.tags[tagName].format
				valueStr = pgweb.ControlRoomCommon.numFormat value, format
				invisibleClass = ''
			[
				"""
				<td class="forward cr-tooltip-value cr-tooltip-color-#{color} 
					cr-tooltip-#{dir} #{invisibleClass}"><span>#{valueStr}</span></td>
				""",
				"""
				<td class="return cr-tooltip-unit cr-tooltip-color-#{color} 
					cr-tooltip-#{dir} #{invisibleClass}"><span>#{unit}</span></td>
				"""
			]
		
		[leftValueHtml, leftUnitHtml] = getHtml leftButtonIndex, 'left'
		[rightValueHtml, rightUnitHtml] = getHtml rightButtonIndex, 'right'

		"""
		<table class="cr-flow-tooltip-table">
			<tr>
				#{leftValueHtml}
				<td class="cr-tooltip-middle-spacing"></td>
				#{rightValueHtml}
			</tr>
			<tr>
				#{leftUnitHtml}
				<td class="cr-tooltip-middle-spacing"></td>
				#{rightUnitHtml}
			</tr>
		</table>
		"""
	
	getTooltipConfig: () ->
		offset: [0, -20]
		direction: 'center'
		permanent: true
		className: 'cr-flow-tooltip'
		content: ''
		backgroundColor: 'blue'

	# Return html för the popup that appears when clicking on the icon.
	getPopupHtml: (module) ->
		module.address or module.technical_name or module.system_name
	
	getModulePanelHtml: (module) ->
		[lat, lng] = [module.gis_latitude, module.gis_longitude]
		if module.projection not in ['', 'wgs84', undefined]
			[lat, lng] = ll2xy module.projection, module.gis_latitude, module.gis_longitude
		moduleTypeId = $.url().param().moduleTypeId
		url = "?action=showModule&networkId=#{module.network_id}&moduleTypeId="+moduleTypeId+"&moduleId=#{module.id}"

		flowForward      = @getValue module, 'flow_forward'           # m³/h
		flowSpeedForward = @getValue module, 'flow_speed_forward'     # m/s
		flowSpeedReturn  = @getValue module, 'flow_speed_return'      # m/s
		flowDeviation    = @getValue module, 'flow_deviation'         # m³/h
		leakage          = @getValue module, 'flow_deviation_percent' # %
		tempDiff         = @getValue module, 'temp_diff'              # °C

		deltaTemp = 83 # °C
		
		energy = 1.16*tempDiff*flowForward # kWh in one hour 
		energyMWhPerHour = energy/1000 # MWh in one hour

		energyDiff = 1.16*deltaTemp*flowDeviation # kWh in one hour 
		energyDiffPerHour = energyDiff/1000 # MWh in one hour

		costPerM3 = 35 # kr/m³
		costPerDay = costPerM3*flowDeviation*24 # kr/24h
		costPerYear = costPerDay*365 # kr/year

		name = module.address or module.technical_name or module.system_name

		ret = """
			<h3>#{name} <span class="cr-flow-popup-subtitle">[DN400]</span></h3>
			<button id="cr-module-panel-link-button" class="ui-btn ui-btn-b ui-mini ui-corner-all">#{module.system_name}</button>
			<h4>Senaste mätning</h4>
			<p class="cr-flow-popup-power-title">Tillförd energi:</p>
			<p class="cr-flow-popup-power">#{pgweb.ControlRoomCommon.numFormat energyMWhPerHour, '0.00'} MWh per timme</p>
			<p class="cr-flow-popup-flow-speed-forward">#{@formatTagValue module, flowSpeedForward, 'FlowSpeedForward'} m/s [tillopp]</p>
			<p class="cr-flow-popup-flow-speed-return">#{@formatTagValue module, flowSpeedReturn, 'FlowSpeedReturn'} m/s [retur]</p>
			<p class="cr-flow-popup-flow-deviation">#{@formatTagValue module, flowDeviation, 'FlowDeviation'} m³/h avvikelse</p>
			<p class="cr-flow-popup-leakage">#{@formatTagValue module, leakage, 'FlowDeviationPercent'} % läckage</p>
			<p class="cr-flow-popup-cost">Vattenkostnad:</p>
			<table class="cr-flow-popup-cost-table">
				<tbody>
					<tr><td class="cr-flow-popup-cost-table-value">#{pgweb.ControlRoomCommon.numFormat costPerDay, '0'}</td><td>kr/dygn</td></tr>
					<tr><td class="cr-flow-popup-cost-table-value">#{pgweb.ControlRoomCommon.numFormat costPerYear, '0'}</td><td>kr/år</td></tr>
				</tbody>
			</table>
			<p class="cr-flow-popup-power-diff">#{pgweb.ControlRoomCommon.numFormat energyDiffPerHour, '0.00'} MWh per timme</p>
			<tr><td>&nbsp;</td></tr>
			</table>
			<table class="cr-flow-popup-values-table">
			<tr><th colspan="2">Fram</th><th colspan="2">Retur</th></tr>
		"""
		for i in [0, 1, 4, 5, 6, 7]
			name = @indexToName i
			tagName = name.snakeToPascal()
			unit = module.tags[tagName].unit
			value = module[name]
			valueStr = @formatTagValue module, value, tagName
			if i % 2 == 0
				ret += '<tr>'
			ret += """
				<td class="cr-flow-popup-values-value">#{valueStr}</td>
				<td class="cr-flow-popup-values-unit">#{unit}</td>
			"""
			if i % 2 == 1
				ret += '</tr>'
		ret += "</table>"

	updatePopupHtml: (module) ->
		$('.leaflet-popup-content').html @getPopupHtml module

	formatTagValue: (module, value, tagName) ->
		pgweb.ControlRoomCommon.numFormat value, (pgweb.Main.removeFormatF module.tags[tagName].format)

	fitToBounds: ->
		# Get the points of the modules to be viewed (for map bounds calculation).
		pointsForBoundsCalc = controlRoom.pages['flow'].mapCorners

		# Fit bounds to the points.
		bounds = new L.LatLngBounds pointsForBoundsCalc
		@fitBounds bounds

	getAreaGeoJSONByAjax: (module) =>
		url = "coffee/controlroom/#{controlRoom.name}/area_#{module.module_name}.json"
		map = @getMap()
		leakage = module.flow_deviation_percent
		areaColor = @percentToAreaColor leakage
		$.getJSON url, (data, textStatus, jqXHR) =>
			geojsonFeature = data
			geojson = addAreaGeoJSONTolayer geojsonFeature, map, areaColor
			showAreaGeoJSON geojson, true
			@onZoomEnd()
	
	addAreaGeoJSONTolayer = (geojsonFeature, map, color) ->
		geojson = L.geoJson geojsonFeature,
			style:
				color: '#888888'
				weight: 1
				opacity: 1
				fillColor: color
				fillOpacity: 0.4
			onEachFeature: (feature, featureLayer) ->
				featureGroup = L.featureGroup([featureLayer])
				featureGroup.addTo map
		geojson
	
	showAreaGeoJSON = (geojson, show) ->
		geojson.setStyle
			opacity: if show then 1.0 else 0.0

	percentToAreaColor: (percent) ->
		switch
			when percent < 0.001 then '#66ff66'
			when percent < 1.0 then '#ffeeee'
			when percent < 2.0 then '#ffcccc'
			when percent < 3.0 then '#ffaaaa'
			when percent < 4.0 then '#ff8888'
			when percent < 5.0 then '#ff6666'
			when percent < 6.0 then '#ff4444'
			when percent < 7.0 then '#ff2222'
			when percent < 8.0 then '#ff0000'
			else '#ff0000'

	getTagById: (id) ->
		for module in @modules
			foundTag = (tag for tagName, tag of module.tags).find((tag) -> tag.id == id)
			if foundTag then return foundTag
class pgweb.ControlRoomCommon
	rememberCenter = null
	fullscreen = false

	@init: (mapObj) ->
		$('body').on 'click', '#cr-module-panel-link-button', (e) ->
			module = mapObj.getSelectedModule()
			url = "?action=showModule&networkId=#{module.network_id}&"
			url += "moduleTypeId=#{module.module_type_id}&"
			url += "moduleId=#{module.id}"
			pgweb.Main.inst().openInStrippedWindow url, module.module_name

	@onFilterChange: (box, valueTableId, leftIndex, rightIndex) ->
		leftOrRight = if box.hasClass 'cr-filter-right'
			other = 'left'
			'right'
		else
			other = 'right'
			'left'
		index = if leftOrRight == 'left' then leftIndex else rightIndex
		tdSelector = 'td.cr-col-'+leftOrRight+(index-1)+' span'
		regExp = new RegExp /^([<>])?([+-]?\d+([.,]\d*)?)$/
		input = box.find 'input'
		otherInput = $('.cr-filter-'+other+' input')
		otherInput.val('')
		regExpArr = input.val().match regExp
		if regExpArr
			[_, lessOrGreater, valueStr] = regExpArr
			value = parseFloat valueStr.replace ',', '.'
			$("##{valueTableId} tbody tr").get().forEach (tr) ->
				valStr = $(tr).find(tdSelector).text().replace ',', '.'
				val = parseFloat valStr
				if lessOrGreater == '<'
					$(tr).toggle val < value
				else if lessOrGreater == '>'
					$(tr).toggle val > value
				else $(tr).toggle val == value
		else
			$("##{valueTableId} tbody tr").show()

	@sortValues: (leftOrRight, sortDirection, valueTableId, leftIndex, rightIndex) ->
		sortDirection = if sortDirection == 'down' then 'up' else 'down'
		symbol = if sortDirection == 'down' then '▼' else '▲'
		$('.cr-sort-'+leftOrRight).html symbol
		$('.cr-sort').removeClass 'cr-sort-selected'
		$('.cr-sort-'+leftOrRight).addClass 'cr-sort-selected'
		sortSelected = leftOrRight
		index = if leftOrRight == 'left' then leftIndex else rightIndex
		tdSelector = 'td.cr-col-'+leftOrRight+(index-1)+' span'
		allTr = $("##{valueTableId} tbody tr").get().sort (a, b) ->
			tdSelector = 'td.cr-col-'+leftOrRight+(index-1)+' span'
			aVal = parseFloat $(a).find(tdSelector).text().replace ',', '.'
			bVal = parseFloat $(b).find(tdSelector).text().replace ',', '.'
			if sortDirection == 'down'
				if aVal < bVal then -1 else if aVal > bVal then 1 else 0
			else
				if aVal > bVal then -1 else if aVal < bVal then 1 else 0
		$("##{valueTableId} tbody").html ''
		allTr.forEach (tr) ->
			$("##{valueTableId} tbody").append tr
		[sortSelected, sortDirection]

	@showModulePanel: (map, show, zoomed, module) ->
		if show
			zoomed = false
			bounds = map.getBounds()
			# X coordinate of the right edge of the map.
			edgeX = (map.latLngToContainerPoint bounds._northEast).x
			markerCoords = [module.gis_latitude, module.gis_longitude]
			markerX = (map.latLngToContainerPoint markerCoords).x
			$('.cr-module-panel').show()
			if edgeX - markerX < 340
				rememberCenter = map.getCenter()
				map.panBy [340 - edgeX + markerX, 0]
			else
				rememberCenter = null
		else
			$('.cr-module-panel').hide()
			if rememberCenter and not zoomed
				map.panTo rememberCenter
		zoomed

	# Create the map fullscreen button.
	@createFullscreenButton: (mapObj) ->
		fullscreenButton = L.Control.extend(
			options:
				position: 'topright'
			onAdd: (map) =>
				button = L.DomUtil.create('button', 'map-fullscreen-button')
				$(button).html('<i class="fa fa-expand fa-lg"></i>')
				$('body').off 'click', '.map-fullscreen-button'
				$('body').on 'click', '.map-fullscreen-button', (event, ui) =>
					fullscreen = not fullscreen
					if fullscreen
						$('#'+mapObj.id).css
							position: 'fixed'
							width: '100%'
							height: $(window).height()
							top: 0
							left: 0
							'z-index': 1000
						$('.map-maximize-button').hide()
						$(button).html('<i class="fa fa-compress fa-lg"></i>')

						$.mobile.navigate $.url().attr('path')+'?'+$.url().attr('query')+'#fullscreen'
					else
						$('#'+mapObj.id).css
							position: 'relative'
							width: '100%'
							height: '100%'
							top: 0
							left: 0
							'z-index': 0
						$(button).html('<i class="fa fa-expand fa-lg"></i>')

						$.mobile.navigate $.url().attr('path')+'?'+$.url().attr('query')
					mapObj.refresh()

				return button
		)
		return new fullscreenButton()

	@numFormat: (v, formatStr) ->
		if not (v == undefined or v == null) then Globalize.format v, 'n'+formatStringToNDecimals formatStr
		else '-'
class pgweb.ControlRoomSmallChart
	smallChart = null
	smallChartData = null

	onPointMouseOver = (mapObj, point) ->
		dBrowser = new Date point.x
		dLocal = new Date(dBrowser.getTime() + dBrowser.getTimezoneOffset()*60000)
		dStr = (Globalize.format dLocal, 'F').replace 'den ', ''
		leftOrRight = if point.series.index == 0 then 'left' else 'right'
		tag  = mapObj.getSelectedTag leftOrRight
		html = ''
		if tag
			unit = tag.unit
			format = pgweb.Main.removeFormatF tag.format
			valueStr = pgweb.ControlRoomCommon.numFormat point.y, format
			html += """<h3>#{dStr}</h3>"""
			html += """<p><span style="color: #{point.series.color}">●</span> 
			#{point.series.name}: #{valueStr} #{unit}</p>"""
		$('#cr-flow-chart-info').html html

	update = (mapObj, module, leftState, rightState, showAverage, selectButtonTexts, currentData, nAverage) ->
		if smallChartData.length == 0
			$('#cr-flow-chart-info').html '<br>Ingen historikdata.'
			return
		leftData = smallChartData[0]
		rightData = smallChartData[1]
		
		if leftData.length == 0 and rightData.length == 0
			$('#cr-flow-chart').hide()
			$('#cr-flow-chart-info').html '<br>Ingen historikdata.'
			return

		$('#cr-flow-chart').show 'fast'
		$('#cr-flow-chart-info').html ''

		convdate = (t) ->
			dt = Globalize.parseDate t
			dtJSTime = dateTimeToJSTime dt # Unix time * 1000
			dtJSTime + currentData.timezone.offset*60000

		convertData = (data) ->
			dataConverted = []
			if data
				for item, i in data
					if showAverage
						if i >= nAverage - 1
							sum = data[(i-nAverage+1)..i].reduce ((a, b) -> a + b.v), 0
							avg = sum/nAverage
							dataConverted.push [(convdate item.t), avg]
					else
						dataConverted.push [(convdate item.t), item.v]
			dataConverted

		# Convert times.
		smallChart.series[0].setData (convertData leftData)
		smallChart.series[1].setData (convertData rightData)

		# Update legend labels according to select button texts.
		[leftState, rightState].map (state, seriesIndex) =>
			smallChart.series[seriesIndex].update
				name: selectButtonTexts[1 + state] or '(Dold)'

	@create: (mapObj) ->
		font = (fontSize) ->
			"bold #{fontSize}px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"

		smallChart = Highcharts.chart 'cr-flow-chart',
			chart:
				backgroundColor: '#393939'
			credits:
				text: 'Pipeguard'
				enabled: false
			accessibility:
				enabled: false
			exporting:
				enabled: false
			title:
				text: '7 dygn'
				align: 'center'
				style:
					color: '#fff'
					font: font 16
			yAxis:
				title:
					enabled: false
					text: 'm/s'
					style:
						color: '#fff'
						font: font 14
				labels:
					style:
						color: '#fff'
						font: font 14
				gridLineColor: '#779'
			xAxis:
				type: 'datetime'
				title:
					text: ''
					style:
						color: '#fff'
						font: font 14
				labels:
					style:
						color: '#fff'
						font: font 14
					enabled: false
				tickLength: 0
			legend:
				layout: 'horizontal'
				align: 'center',
				verticalAlign: 'top'
				itemStyle:
					color: '#fff'
					font: font 14
			series: [
				type: 'line'
				data: []
				lineColor: '#f00'
				color: '#f00'
			,
				type: 'line'
				data: []
				lineColor: '#55f'
				color: '#55f'
			]
			tooltip: false
			plotOptions:
					series:
						point:
							events:
								mouseOver: (e) =>
									onPointMouseOver mapObj, $(e.target)[0]
						events:
							mouseOut: ->
								$('#cr-flow-chart-info').html ''
		
		$('#cr-flow-chart').hide()

	@show: (mapObj, module, leftState, rightState, showAverage, selectButtonTexts, currentData, nAverage) ->
		$('#cr-flow-chart').hide 'fast'
		$('#cr-flow-chart-info').html '<br>Väntar på historik...<br><img src="css/jquery-mobile/images/ajax-loader.gif"/>'
		tag1 = mapObj.getSelectedTag 'left'
		tag2 = mapObj.getSelectedTag 'right'
		$.ajax
			url: "/pgweb/ajax/controlroom/common/controlRoomFlowMapSmallChart.php"
			dataType: 'json'
			type: 'GET'
			data:
				tag1Id: if tag1 then if tag1.id then tag1.id else tag1.tag_id else 0
				tag2Id: if tag2 then if tag2.id then tag2.id else tag2.tag_id else 0
			success: (data) =>
				smallChartData = data.smallChartData
				switch data.result
					when "OK"
						update mapObj, module, leftState, rightState, showAverage, selectButtonTexts, currentData, nAverage
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get chart data.', data.result);
			error: ajaxFailure
class pgweb.ControlRoomPage
	instance = null
	intervalId = null
	
	levelAlarmButton: null
	levelAlarmButton2: null

	constructor: ->
		@init()
	
	@inst: ->
		if not instance?
			instance = new @
		instance
	
	init: ->
		intervalId = null

		switch $.url().param().mode
			when 'anValues'
				$('#cr-anvalues-value-table').show()
				$('#cr-anvalues-alarm-table').show()
				map = pgweb.ControlRoomAnValuesMap.inst()
			when 'thermography'
				map = pgweb.ControlRoomThermographyMap.inst()
			when 'flow'
				$('#cr-flow-value-table').show()
				$('#cr-flow-alarm-table').show()
				map = pgweb.ControlRoomFlowMap.inst()
			else # 'diCategories' or default
				$('#cr-alarm-table').show()

				map = pgweb.ControlRoomCategoriesMap.inst()

		map.id = 'cr-map'
		if !map.isInitialized()
			map.init()
		
		$('[name="menu-select"]').on 'change', (e) =>
			$('#cr-menu-message').html 'Laddar om...'
			switch $(e.target).val()
				when 'di-categories' then @onDiCategoriesAlarmSelect()
				when 'an-values' then @onAnValuesSelect()
				when 'thermography' then @onThermographySelect()
				when 'flow' then @onFlowSelect()
				else alert 'Unknown mode!'
		
	onDiCategoriesAlarmSelect: ->
		document.location = "?action=show#{controlRoom.className}ControlRoom&mode=diCategories"

	onAnValuesSelect: ->
		document.location = "?action=show#{controlRoom.className}ControlRoom&mode=anValues"

	onThermographySelect: ->
		document.location = "?action=show#{controlRoom.className}ControlRoom&mode=thermography"

	onFlowSelect: ->
		document.location = "?action=show#{controlRoom.className}ControlRoom&mode=flow"

	cookieName: (name) ->
		idHash = pgwebGetCookie 'idHash'
		"#{controlRoom.name}_control_room_#{name}_#{idHash}"

	existsBoolCookie: (name) ->
		(pgwebGetCookie @cookieName name) != undefined

	getBoolCookie: (name) ->
		idHash = pgwebGetCookie 'idHash'
		Number(pgwebGetCookie @cookieName name) == 1
	
	setBoolCookie: (name, bool) ->
		idHash = pgwebGetCookie 'idHash'
		pgwebSetCookie @cookieName name, Number(bool)

$(document).on 'pageshow', ".controlRoomPage", (event) ->
	pgweb.ControlRoomPage.inst().init()
class pgweb.ControlRoomAnValuesMap extends pgweb.Map
	instance = null
	intervalId = null
	fullscreen = false
	markerLayer = null
	networkIds = null
	categoryNames = null
	leftIndex = 0
	rightIndex = 1
	selectButtonTexts = []
	sortDirection = 'up'
	sortSelected = 'left'
	currentModule = null
	currentData = null
	leftAndRight = ['left', 'right']

	showAverage = false
	nAverage = 5

	zoomed = false

	@inst: ->
		# Run only on the right control room page and mode 'anValues' or when no mode.
		if $.url().param().action != "show#{controlRoom.className}ControlRoom"
			return
		pageNamesExceptMe = (Object.keys controlRoom.pages).filter (item) -> item != 'anValues'
		if $.url().param().mode in pageNamesExceptMe
			return
		if not instance?
			instance = new @
		instance
	
	init: ->
		selectButtonTexts = ['-'].concat controlRoom.pages['anValues'].categoryNames

		networkIds = $('#cr-network-ids').val();
		categoryNames = $('#cr-category-names').val();

		# Ensure there is no map.
		@ensureNoMap()

		# Create the map object.
		map = @createMap()

		map.on 'load', =>
			$('.leaflet-layer').addClass 'cr-map-gray'

		# Add the map fullscreen toggle button.
		map.addControl pgweb.ControlRoomCommon.createFullscreenButton @

		# Display markers for all the modules.
		@clearMarkers()
		@update true

		map.on 'resize', =>
			@fitToBounds()

		map.on 'zoomend', (obj) =>
			@onZoomEnd()
			@checkZoom()
			zoomed = true

		map.on 'moveend', ->
			pgweb.ControlRoomOverviewMap.update map

		maximized = @getMaximizedCookie()
		if ($.url().attr 'anchor') == 'fullscreen'
			$('.map-fullscreen-button').trigger 'click'
		else
			if maximized
				maximized = not maximized
				$('.map-maximize-button').trigger 'click'

		$(document).on 'keyup', (event) ->
			if event.key == 'F11'
				if fullscreen
					location.reload()

		pgweb.ControlRoomSmallChart.create @

		$('#cr-alarm-settings-button').hide()

		$('body').on 'click', '#cr-anvalues-value-table tbody tr', (e) =>
			@onValueTableBodyClick $(e.currentTarget)

		$('body').on 'click', '#cr-anvalues-alarm-table tbody tr', (e) =>
			@onAlarmTableBodyClick $(e.currentTarget)

		leftAndRight.forEach (leftRight) =>

			$('body').on 'click', "#cr-anvalues-#{leftRight}-selectbutton", (e) =>
				@onAnValuesNeedleSelect $(e.currentTarget)

			$('body').on 'click', '.cr-sort-'+leftRight, (e) =>
				[sortSelected, sortDirection] = pgweb.ControlRoomCommon.sortValues leftRight, sortDirection, \
				'cr-anvalues-value-table', leftIndex, rightIndex

		$('body').on 'click', '#cr-filter-button', (e) =>
			selectedClassName = 'cr-filter-button-selected'
			if $('#cr-filter-button').hasClass selectedClassName
				$('#cr-filter-button').removeClass selectedClassName
				$('#cr-filter-table').hide 200
			else
				$('#cr-filter-button').addClass selectedClassName
				$('#cr-filter-table').show 200

		$('body').on 'keyup', '.cr-filter', (e) =>
			box = $(e.currentTarget)
			pgweb.ControlRoomCommon.onFilterChange box, 'cr-anvalues-value-table', leftIndex, rightIndex
		
		$('body').on 'click', '#cr-alarm-settings-button', =>
			@onAlarmSettingsButtonClick()
		
		$('body').on 'click', '#cr-alarm-settings-save-button', =>
			@onAlarmSettingsSaveButtonClick()

		$('body').on 'click', '#cr-alarm-settings-cancel-button', =>
			@onAlarmSettingsCancelButtonClick()

		pgweb.ControlRoomCommon.init @

		pgweb.HelpDialog.register 'cr-filter-help', 'cr-filter-help-button'

		pgweb.ControlRoomWeatherWidget.ajaxGetTemperature controlRoom.name

	showSmallChart: (module) ->
		pgweb.ControlRoomSmallChart.show @, module, (@menuState 'left'), (@menuState 'right'), \
			showAverage, selectButtonTexts, currentData, nAverage

	onAlarmSettingsButtonClick: ->
		visible = $('#cr-alarm-settings-panel').is ':visible'
		return if visible
		@disableSaveSettingsForm false
		@displayAlarmSettingsMessage ''
		@disableAlarmSettingsButton true
		$('#cr-alarm-settings-panel').show 'fast', =>
			$('#cr-alarm-settings-panel table tbody tr th').each (i, th) =>
				catName = $(th).html()
				tags = @tags.filter (tag, index, obj) -> tag.tag_category_name == catName
				for limit in ['lolo', 'lo', 'hi', 'hihi']
					input = $(th).parent().find 'td.'+limit+' input'
					input.removeClass 'cr-alarm-settings-different-limit'
					limitValues = (tag[limit+'_limit'] for tag in tags).filter (v) -> v isnt null
					if limitValues.length == 0
						limitValue = ''
					else
						mostCommonElementsObj = pgweb.Main.mostCommonElement limitValues
						limitValue = mostCommonElementsObj.mostCommon
						if mostCommonElementsObj.sortedPairs.length > 1
							input.addClass 'cr-alarm-settings-different-limit'
					input.val limitValue

	onAlarmSettingsSaveButtonClick: ->
		@disableSaveSettingsForm true
		limitsArrJQ = $('#cr-alarm-settings-panel table tbody tr').map (i, tr) =>
			title = $(tr).find('th').html()
			tds = $(tr).find 'td'
			limitsJQ = tds.map (j, td) =>
				name = $(td).attr 'class'
				value = $(td).find('input').val()
				{ name: name, value: value }
			# Convert JQ object to ordinary object.
			limits = ((Object.entries limitsJQ).filter ([key, value]) => 0 <= key <= 3).map (item) => item[1]
			{ title: title, limits: limits}
		# Convert JQ object to ordinary object.
		limitsArr = ((Object.entries limitsArrJQ).filter ([key, value]) => 0 <= key < categoryNames.length).map (item) => item[1]
		@displayAlarmSettingsMessage ''

		waitStart()
		$.ajax
			url: "/pgweb/ajax/controlroom/common/controlRoomAnValuesSaveLimits.php"
			dataType: 'json'
			type: 'POST'
			data:
				limitsArr: limitsArr
				networkIds: networkIds
			success: (data) =>
				switch data.result
					when "OK"
						@displayAlarmSettingsMessage 'Larmgränserna har sparats.', '#6f6'
						window.setTimeout =>
							$('#cr-alarm-settings-panel').hide 'fast', =>
								@disableAlarmSettingsButton false
						, 2000
						@update()
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						switch
							when data.result.includes 'TAG_CATEGORY_NOT_FOUND_IN_NETWORK'
								msg = "Kategorin finns inte i nätverket."
							when data.result.includes 'NO_TAG_WITH_CATEGORY_IN_NETWORK'
								regExp = new RegExp /.+?: "(.+?)" "(.+?)" (\d+)$/
								[_, catName, networkName, networkId] = data.result.match regExp
								msg  = "Kategorin \"#{catName}\" används inte i nätverket "
								msg += "\"#{networkName}\" (id #{networkId}) för någon av dessa taggar."
							else
								msg = 'Misslyckades med att spara larmgränserna: '+data.result
						@displayAlarmSettingsMessage msg
						@disableSaveSettingsForm false
			error: (jqXHR, str, ex) =>
				ajaxFailure jqXHR, str, ex
				@disableSaveSettingsForm false
			complete: ->
				waitStop()

	disableAlarmSettingsButton: (disable) ->
		if disable
			$('#cr-alarm-settings-button').addClass 'cr-alarm-settings-button-gray'
		else
			$('#cr-alarm-settings-button').removeClass 'cr-alarm-settings-button-gray'

	onAlarmSettingsCancelButtonClick: ->
		$('#cr-alarm-settings-panel').hide 'fast', =>
			@disableAlarmSettingsButton false

	disableSaveSettingsForm: (disable) ->
		$('#cr-alarm-settings-panel table td input').prop 'disabled', disable
		$('#cr-alarm-settings-save-button').prop 'disabled', disable
		$('#cr-alarm-settings-cancel-button').prop 'disabled', disable

	displayAlarmSettingsMessage: (msg, color = 'red') ->
		$('#cr-alarm-settings-error').text msg
		$('#cr-alarm-settings-error').css 'color', color

	onAnValuesNeedleSelect: (button) ->
		id = $(button).attr 'id'
		[_, _, leftOrRight] = id.split '-'
		if leftOrRight == 'left'
			leftIndex += 1
			leftIndex %= selectButtonTexts.length
			index = leftIndex
		else
			rightIndex += 1
			rightIndex %= selectButtonTexts.length
			index = rightIndex
		$('#cr-anvalues-'+leftOrRight+'-text').text selectButtonTexts[index]
		@updateNeedles()
		@showHideValueTable()
		module = @getSelectedModule()
		if module
			@showSmallChart module

	updateNeedles: ->
		menuStateLeft  = @menuState 'left'
		menuStateRight = @menuState 'right'
		for module in @modules
			coords = @correctCoords [module.gis_latitude, module.gis_longitude]
			if coords[0] and coords[1]
				tooltipHtml = @getTooltipHtml menuStateLeft, menuStateRight, module
				tooltipConfig = @getTooltipConfig()
				module.marker.bindTooltip(tooltipHtml, tooltipConfig).openTooltip();
		@checkZoom()

	onValueTableBodyClick: (tr) ->
		moduleId = lastNum tr.attr 'id'
		module = @getModuleById moduleId
		if module
			selected = tr.hasClass 'cr-value-list-selected'
			if selected
				tr.removeClass 'cr-value-list-selected'
			else
				$('#cr-anvalues-value-table tbody tr').removeClass 'cr-value-list-selected'
				tr.addClass 'cr-value-list-selected'
			$('#cr-value-table-error').text ''
	
			marker = @getMarkerByModuleId moduleId

			@openOrClosePopup marker, selected, 'value'

	onAlarmTableBodyClick: (tr) ->
		tagId = lastNum tr.attr 'id'
		tag = @getTagById tagId
		if tag
			selected = tr.hasClass 'cr-anvalues-alarm-list-selected'
			if selected
				tr.removeClass 'cr-anvalues-alarm-list-selected'
			else
				tr.addClass 'cr-anvalues-alarm-list-selected'
			$('#cr-alarm-table-error').text ''

			marker = @getMarkerByModuleId tag.module.id

			@openOrClosePopup marker, selected, 'alarm'

	openOrClosePopup: (marker, selected, valueOrAlarm) ->
		if marker
			if selected
				marker.closePopup()
			else
				marker.openPopup()
		else
			$('#cr-'+valueOrAlarm+'-table-error').text 'Modulen har inte koordinater.'
			@getMap().closePopup()

	getMarkerByModuleId: (moduleId) ->
		markers = markerLayer.getLayers()
		markers.find (marker) ->
			marker.moduleId == moduleId

	checkZoom: ->
		if @getMap().getZoom() < controlRoom.pages['anValues'].showNumbersZoomLimit
			$('.cr-anvalues-tooltip-table').css 'visibility', 'hidden'
		else
			$('.cr-anvalues-tooltip-table').css 'visibility', 'visible'

	getLayerDataByAjax: (networkId) =>
		return
	
	update: (fitBounds) ->
		@ajaxUpdate fitBounds, networkIds, categoryNames

	ajaxUpdate: (fitBounds, networkIds, categoryNames) ->
		@tags = []
		$.ajax
			url: "/pgweb/ajax/controlroom/common/controlRoomAnValuesMap.php"
			dataType: 'json'
			type: 'GET'
			data:
				networkIds: networkIds
				categoryNames: categoryNames
			success: (data) =>
				currentData = data

				@tags = data.tags

				# Get all module IDs uniquely from the tags.
				moduleIds = new Set()
				@tags.forEach (tag) -> moduleIds.add tag.module.id
				# All modules.
				@modules = Array.from(moduleIds).map (id) =>
					(@tags.find (tag) -> tag.module.id == id).module
				
				@modules.forEach (module) =>
					tags = (@tags.filter (tag) -> tag.module_id == module.id)

				# Remove duplicate references to module in tags
				for tag in @tags
					tag.module = @modules.find (module) -> module.id == tag.module.id

				switch data.result
					when "OK"
						@afterAjaxUpdate fitBounds
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get module data.', data.result);
			error: ajaxFailure

	# Display markers for all the modules.
	afterAjaxUpdate: (fitBounds) ->
		# To avoid conversion of the format string to a number, an 'f' was added. Here we remove it.
		for tag in @tags
			if tag.format.startsWith 'f'
				tag.format = tag.format[1..]

		@fillValueTable()

		@fillAlarmTable()

		if fitBounds
			@fitToBounds 0.005, 0.01
		
		# Display the map needles.
		@createMarkers()

		for dir in leftAndRight
			@onAnValuesNeedleSelect $("#cr-anvalues-#{dir}-selectbutton")

		[sortSelected, sortDirection] = pgweb.ControlRoomCommon.sortValues sortSelected, sortDirection, 'cr-anvalues-value-table', leftIndex, rightIndex

		$('#cr-alarm-settings-button').show()

	fillValueTable: ->
		$('#cr-anvalues-value-table tbody').html ''

		for m in @modules
			catTags = @catTags m
			tagMeanings = (catTag?.tag_meaning.toLowerCase() for catTag in catTags)
			m.dropletColor = @statusColor m, catTags, tagMeanings
			m.haloColor = ''
			if m.timer_color in ['red', 'yellow']
				# On timer expired, show a halo around the yellow needle.
				m.haloColor = m.dropletColor
				m.dropletColor = 'yellow'
			haloClass = if m.haloColor == '' then '' else 'map-needle-halo-'+m.haloColor
			valueColor = 'black'
			html = '<tr class="cr-value-'+(if m.dropletColor=='yellow' then 'yellow' else 'green')+'" id="module-id-'+m.id+'">'
			for leftRight in leftAndRight
				for tag, i in catTags
					if tag
						tag.valueColor = if tag then tag.module[tag.tag_meaning.toLowerCase()+'_color'] else ''
						valueStr = pgweb.ControlRoomCommon.numFormat(m[tagMeanings[i]], tag.format)
						html += '<td class="cr-table-color-'+tag.valueColor+' cr-col cr-col-'+leftRight+i+'"><span>'+valueStr+'</span></td>'
					else
						html += '<td class="cr-col cr-col-'+leftRight+i+'"><span>-</span></td>'
				if leftRight == 'left'
					html += '<td class="cr-col-name"></td>'
			html += '</tr>'
			$('#cr-anvalues-value-table tbody').append html

		# Test of many rows:
		if false
			for i in [1..80]
				html = '<tr class="cr-tooltip-color-green cr-value-red" id="module-id-0">'
				for leftRight in leftAndRight
					html += '<td class="cr-table-color-gray cr-col cr-col-'+leftRight+'0"><span>0.1</span></td>'
					if leftRight == 'left'
						html += '<td class="cr-col-name">asdfasdf</td>'
				html += '</tr>'
				$('#cr-anvalues-value-table tbody').append html

		@showHideValueTable()

	showHideValueTable: ->
		$('#cr-anvalues-value-table tbody tr td').hide()
		$('#cr-anvalues-value-table tbody tr td.cr-col-name').show()

		leftState = @menuState 'left'
		rightState = @menuState 'right'

		if leftState == -1
			@showValueTableDummy 'left'
		else
			@showValueTableColumn 'left', leftState

		if rightState == -1
			@showValueTableDummy 'right'
		else
			@showValueTableColumn 'right', rightState

	showValueTableDummy: (leftOrRight) ->
		sel = '#cr-anvalues-value-table tbody tr td.cr-col-'+leftOrRight+'0'
		$(sel).show()
		$(sel).addClass 'cr-col-hidden'

	showValueTableColumn: (leftOrRight, index) ->
		sel = '#cr-anvalues-value-table tbody tr td.cr-col-'+leftOrRight+index
		$(sel).show()
		$(sel).removeClass 'cr-col-hidden'

	fillAlarmTable: ->
		$('#cr-anvalues-alarm-table tbody').html ''

		rows = []
		
		for tag in @tags
			if tag.valueColor in ['red', 'orange']
				rowHtml = @getAlarmRow tag
				rows.push {color: tag.valueColor, html: rowHtml}
		
		rows.sort (a, b) -> if a.color < b.color then 1 else if a.color > b.color then -1 else  0

		for row in rows
			$('#cr-anvalues-alarm-table tbody').append row.html

		# Test of many rows:
		#for i in [1..80]
		#	rowHtml  = "<tr id=\"tag-id-0\" class=\"cr-alarm-red\">"
		#	rowHtml += "<td>0.1</td><td>m</td>"
		#	rowHtml += "<td>Låg</td>"
		#	rowHtml += "<td>Temp tjosan</td>"
		#	rowHtml += "</tr>"
		#	$('#cr-anvalues-alarm-table tbody').append rowHtml

	getAlarmRow: (tag) ->
		valueStr = pgweb.ControlRoomCommon.numFormat(tag.value_eu, tag.format)
		lowOrHigh = tag.passedAlarmLimits.split ','
		lowOrHighStr = '?'
		if 'hi' in lowOrHigh or 'hihi' in lowOrHigh
			lowOrHighStr = 'arrow-up'
		if 'lo' in lowOrHigh or 'lolo' in lowOrHigh
			lowOrHighStr = 'arrow-down'
		timerAlarmSymbol = if tag.module.timer_color in ['red', 'yellow']
			'<i class="fa fa-clock-o" style="color:yellow"></i>'
		else ''
		catName = tag.tagCategory.name
		words = catName.split ' '
		if words.length > 1
			name = if words[0] in ['Tryck', 'Temp'] then words[1] else catName
		else
			name = catName
		technicalName = tag.module.technical_name
		rowHtml  = "<tr id=\"tag-id-#{tag.tag_id}\" class=\"cr-alarm-#{tag.valueColor}\">"
		rowHtml += "<td><i class=\"fa fa-#{lowOrHighStr}\"></i></td>"
		rowHtml += "<td style=\"text-align: right; padding-left: 0\">#{valueStr} #{tag.unit}</td>"
		rowHtml += "<td>#{name}</td>"
		rowHtml += "<td>#{technicalName.toString().firstPart 12}</td>"
		rowHtml += "<td>#{timerAlarmSymbol}</td>"
		rowHtml += "</tr>"

	# Takes input 'left' or 'right'.
	# Returns the state of the left or right menu as an index 0-6 or -1 for none selected:
	# -1 - None selected
	#  0 - Pressure forward
	#  1 - Pressure return
	#  2 - Pressure diff
	#  3 - Temp forward
	#  4 - Temp return
	#  5 - Temp diff
	menuState: (leftOrRight) ->
		if leftOrRight == 'left'
			leftIndex - 1
		else
			rightIndex - 1

	getTagByTagCategoryName: (module, name) ->
		foundTagInModule = Object.values(module.tags).find (tag) -> tag.tagCategory?.name == name
		@tags.find (tag) -> tag.tag_id == foundTagInModule?.id

	createMarkers: ->
		map = @getMap()
		if markerLayer?
			markerLayer.clearLayers()
		markerLayer = L.layerGroup()
		markerLayer.addTo map

		for m in @modules
			coords = @correctCoords [m.gis_latitude, m.gis_longitude]
			if coords[0] and coords[1]
				marker = @getMarker coords, m
				m.marker = marker
				markerLayer.addLayer marker
		@checkZoom()

	getIcon: (catTags, module) ->
		tagMeanings = (catTag?.tag_meaning.toLowerCase() for catTag in catTags)
		#haloClass = if module.haloColor == '' then '' else 'map-needle-halo-'+module.haloColor
		#worstTag = @worstTag catTags, module, tagMeanings
		L.divIcon
			#html: '<i class="fa fa-'+worstTag?.tagCategory.awesome_name+' map-needle-symbol"></i>'
			html: '<img src="images/dial_white.png" style="width: 14px; height: 16px; position: relative; top: 3px"/>'
			className: 'map-needle map-needle-'+module.dropletColor #+' '+haloClass
			iconSize: [24, 38]
			iconAnchor: [12, 38]
			popupAnchor: [0, -38]

	getMarker: (coords, module) ->
		catTags = @catTags module
		icon = @getIcon catTags, module
		color = module.dropletColor
		zIndexOffset = if color == 'red' then 50000
		else if color == 'orange' then 40000
		else if color == 'yellow' then 30000
		else 20000
		marker = L.marker coords,
			icon: icon
			title: module.module_name
			zIndexOffset: zIndexOffset
		marker.bindPopup @getPopupHtml module
		marker.moduleId = module.id
		marker.on 'popupopen', (e) =>
			@onPopupOpen e
		marker.on 'popupclose', (e) =>
			@onPopupClose e
		menuStateLeft  = @menuState 'left'
		menuStateRight = @menuState 'right'
		tooltipHtml = @getTooltipHtml menuStateLeft, menuStateRight, module
		tooltipConfig = @getTooltipConfig()
		marker.bindTooltip(tooltipHtml, tooltipConfig).openTooltip()
		marker

	catTags: (module) ->
		(@getTagByTagCategoryName(module, catName) for catName in categoryNames.split '¤')

	worstTag: (catTags, module, names) ->
		worstTagName = @worstTagName module, names
		catTags.find (tag) -> tag?.tag_meaning.toLowerCase() == worstTagName

	worstTagName: (module, names) ->
		redName = names.find (name) -> module[name+'_color'] == 'red'
		orangeName = names.find (name) -> module[name+'_color'] == 'orange'
		otherName = names.find (name) -> module[name+'_color'] not in ['orange', 'red']
		redName ? orangeName ? otherName

	anyRed: (module, names) ->
		names.some (name) -> module[name+'_color'] == 'red'

	anyOrange: (module, names) ->
		names.some (name) -> module[name+'_color'] == 'orange'

	statusColor: (module, catTags, tagMeanings) ->
		if @anyRed module, tagMeanings
			'red'
		else
			if @anyOrange module, tagMeanings
				'orange'
			else
				'green'

	onPopupOpen: (e) ->
		moduleId = e.sourceTarget.moduleId
		module = @getModuleById moduleId
		currentModule = module

		@showSmallChart module

		zoomed = pgweb.ControlRoomCommon.showModulePanel @getMap(), true, zoomed, module
		@updateModulePanel module

		# Mark the row in the value table.
		$('#cr-anvalues-value-table tr').removeClass 'cr-anvalues-value-list-selected'
		if $('#module-id-'+moduleId).length > 0
			$('#module-id-'+moduleId).addClass 'cr-anvalues-value-list-selected'
			$('#module-id-'+moduleId).get(0).scrollIntoView
				behavior: "smooth"
				block: "center"

		# Mark the row(s) in the alarm table.
		module = @getModuleById moduleId
		tagIdsInModule = (tag?.tag_id for tag in @catTags module)
		for tag in @tags
			if tag.tag_id in tagIdsInModule
				tagId = tag.tag_id
				if $('#tag-id-'+tagId).length > 0
					$('#tag-id-'+tagId).addClass 'cr-anvalues-alarm-list-selected'
					$('#tag-id-'+tagId).get(0).scrollIntoView
						behavior: "smooth"
						block: "center"

	onPopupClose: (e) ->
		$('#cr-anvalues-value-table tbody tr').removeClass 'cr-anvalues-value-list-selected'
		$('#cr-anvalues-alarm-table tbody tr').removeClass 'cr-anvalues-alarm-list-selected'
		currentModule = null
		pgweb.ControlRoomCommon.showModulePanel @getMap(), false, zoomed

	updateModulePanel: (module) ->
		$('#cr-module-data').html @getModulePanelHtml module

	getSelectedModule: ->
		currentModule
	
	getSelectedTag: (leftOrRight) ->
		catTags = @catTags currentModule
		index = { left: leftIndex, right: rightIndex}[leftOrRight]
		catTags[index-1]

	# Return html for the values shown beside the map needles.
	getTooltipHtml: (leftButtonIndex, rightButtonIndex, module) ->
		catTags = @catTags module
		leftTag = catTags[leftButtonIndex]
		rightTag = catTags[rightButtonIndex]
		nullf = (v1, v2) ->
			if v1 == null then '-' else v2
		fmtf = (tag) ->
			if tag
				v = nullf tag.value_eu, tag.value_eu 
				Globalize.format v, 'n'+formatStringToNDecimals tag.format
			else
				'-'
		if leftButtonIndex == -1
			leftValueStr = ''
			leftUnit = ''
			leftInvisibleClass = 'cr-tooltip-invisible'
		else
			leftValueStr = fmtf leftTag
			leftUnit = if leftTag then leftTag.unit else '-'
			leftColor = if leftTag then leftTag.module[leftTag.tag_meaning.toLowerCase()+'_color'] else ''
			leftInvisibleClass = ''

		if rightButtonIndex == -1
			rightValueStr = ''
			rightUnit = ''
			rightInvisibleClass = 'cr-tooltip-invisible'
		else
			rightValueStr = fmtf rightTag
			rightUnit = if rightTag then rightTag.unit else '-'
			rightColor = if rightTag then rightTag.module[rightTag.tag_meaning.toLowerCase()+'_color'] else ''
			rightInvisibleClass = ''

		"""
		<table class="cr-anvalues-tooltip-table">
			<tr>
				<td class="forward cr-tooltip-value cr-tooltip-color-#{leftColor} 
					cr-tooltip-left #{leftInvisibleClass}"><span>#{leftValueStr}</span></td>
				<td class="cr-tooltip-middle-spacing"></td>
				<td class="forward cr-tooltip-value cr-tooltip-color-#{rightColor} 
					cr-tooltip-right #{rightInvisibleClass}"><span>#{rightValueStr}</span></td>
			</tr>
			<tr>
				<td class="return cr-tooltip-unit cr-tooltip-color-#{leftColor} 
					cr-tooltip-left" #{leftInvisibleClass}><span>#{leftUnit}</span></td>
				<td class="cr-tooltip-middle-spacing"></td>
				<td class="return cr-tooltip-unit cr-tooltip-color-#{rightColor} 
					cr-tooltip-right #{rightInvisibleClass}"><span>#{rightUnit}</span></td>
			</tr>
		</table>
		"""
	
	getTooltipConfig: () ->
		offset: [0, -20]
		direction: 'center'
		permanent: true
		className: 'cr-anvalues-tooltip'
		content: ''
		backgroundColor: 'blue'

	# Return html för the popup that appears when clicking on the icon.
	getPopupHtml: (module) ->
		module.address or module.technical_name or module.system_name

	getModulePanelHtml: (module) ->
		[lat, lng] = [module.gis_latitude, module.gis_longitude]
		if module.projection not in ['', 'wgs84', undefined]
			[lat, lng] = ll2xy module.projection, module.gis_latitude, module.gis_longitude
		moduleTypeId = $.url().param().moduleTypeId
		url = "?action=showModule&networkId=#{module.network_id}&moduleTypeId="+moduleTypeId+"&moduleId=#{module.id}"
		name = module.address or module.technical_name or module.system_name
		ret = """
			<h3>#{name}</h3>
			<button id="cr-module-panel-link-button" class="ui-btn ui-btn-b ui-mini ui-corner-all">#{module.system_name}</button>
		"""
		if module.dropletColor == 'yellow'
			ret += '<p style="font-weight: bold">OFFLINE</p>'
		ret += "<table>"
		catTags = @catTags module
		for cat, i in catTags
			name = '-'
			value = '-'
			unit = '-'
			if cat
				unit = cat.unit
				value = pgweb.ControlRoomCommon.numFormat cat.value_eu, cat.format
				if cat.tagCategory
					name = cat.tagCategory.name
				else
					name = ''
				ret += """
					<tr><td>#{name}:</td>
						<td class="cr-tooltip-color-#{cat.valueColor}">#{value} #{unit}</td>
					</tr>
				"""
			else
				ret += """
					<tr><td>-</td>
						<td class="cr-tooltip-color-">-</td>
					</tr>
				"""
				
		ret += """
			</table>
			<p class="cr-module-panel-label">#{t.ModuleList_ModuleName}:</p>
			<p>#{module.module_name}</p>
			<p class="cr-module-panel-label">#{t.ModuleList_TechnicalName}:</p>
			<p>#{escapeStringForHTML(module.technical_name)}</p>
			<p class="cr-module-panel-label">#{t.ModuleList_Address}:</p>
			<p>#{module.address}</p>
		"""
		ret

	getTagById: (id) ->
		@tags.find (tag) ->
			tag.tag_id == id

class pgweb.ControlRoomCategoriesMap extends pgweb.Map
	instance = null
	intervalId = null
	networkIds = null
	categoryNamesStr = null
	categoryNames = null
	markers = []
	layerGroups = []
	currentModule = null
	zoomed = false

	@inst: ->
		# Run only on the right control room page and mode 'diCategories' or when no mode.
		if $.url().param().action != "show#{controlRoom.className}ControlRoom"
			return
		pageNamesExceptMe = (Object.keys controlRoom.pages).filter (item) -> item != 'diCategories'
		if $.url().param().mode in pageNamesExceptMe
			return
		if not instance?
			instance = new @
		instance

	init: ->
		networkIds = $('#cr-network-ids').val();
		categoryNamesStr = $('#cr-category-names').val();
		categoryNames = categoryNamesStr.split('¤');

		# Ensure there is no map.
		@ensureNoMap()

		# Create the map object.
		map = @createMap()

		map.on 'load', =>
			$('.leaflet-layer').addClass 'cr-map-gray'

		# Add the map fullscreen toggle button.
		map.addControl pgweb.ControlRoomCommon.createFullscreenButton @

		# Display markers for all the modules.
		@clearMarkers()
		@update true

		map.on 'resize', =>
			@fitToBounds()

		map.on 'zoomend', (obj) =>
			@onZoomEnd()
			zoomed = true

		map.on 'moveend', ->
			pgweb.ControlRoomOverviewMap.update map
		
		maximized = @getMaximizedCookie()
		if ($.url().attr 'anchor') == 'fullscreen'
			$('.map-fullscreen-button').trigger 'click'
		else
			if maximized
				maximized = not maximized
				$('.map-maximize-button').trigger 'click'

		$(document).on 'keyup', (event) ->
			if event.key == 'F11'
				if fullscreen
					location.reload()

		$('body').on 'click', '#cr-alarm-table tbody tr', (e) =>
			tr = $(e.currentTarget)
			moduleId = lastNum tr.attr 'id'
			module = @getModuleById moduleId
			layerGroup = layerGroups[module.dropletColor]
			markers = layerGroup.getLayers()
			marker = markers.find (marker) ->
				marker.moduleId == moduleId
			$('#cr-alarm-table-error').text ''
			selected = tr.hasClass 'cr-alarm-list-selected'
			if selected
				tr.removeClass 'cr-alarm-list-selected'
			else
				$('#cr-alarm-table tbody tr').removeClass 'cr-alarm-list-selected'
			if selected
				if marker
					marker.closePopup()
			else
				$(e.currentTarget).addClass 'cr-alarm-list-selected'
				if marker
					marker.openPopup()
			if not marker
				html = 'Modulen har inte koordinater.<br/>'
				html += '<a href="/'+module.module_name+'" target="cr-anvalues-module">'+module.system_name+'</a>'
				$('#cr-alarm-table-error').html html
				@getMap().closePopup()

		$('body').on 'change', '.cr-needle-checkbox', (e) =>
			checkBoxId = $(e.target).attr 'id'
			color = checkBoxId.split('-').pop()
			bool = $(e.target).prop 'checked'

			# Toggle table rows.
			$('.cr-alarm-'+color).toggle bool

			for module in @modules
				if module.dropletColor == color
					layerGroup = layerGroups[color]
					if bool
						layerGroup.addTo map
					else
						layerGroup.removeFrom map

		pgweb.ControlRoomCommon.init @

		pgweb.ControlRoomWeatherWidget.ajaxGetTemperature controlRoom.name
	
	getMarkerByModuleId: (moduleId) =>
		markers.find (marker) ->
			marker.moduleId == moduleId

	getModuleById: (id) ->
		@modules.find (module) ->
			module.id == id

	getTagById: (id) ->
		@tags.find (tag) ->
			tag.tag_id == id

	onPopupOpen: (e) ->
		$('#cr-alarm-table-error').text ''
		moduleId = e.sourceTarget.moduleId
		module = @getModuleById moduleId
		currentModule = module
		tr = $('#module-id-'+moduleId)
		if tr.length > 0
			$('#cr-alarm-table tbody tr').removeClass 'cr-alarm-list-selected'
			tr.addClass 'cr-alarm-list-selected'
			tr.get(0).scrollIntoView
				behavior: "smooth"
				block: "center"
	
		zoomed = pgweb.ControlRoomCommon.showModulePanel @getMap(), true, zoomed, module
		@updateModulePanel (@getModuleById moduleId)

	onPopupClose: (e) ->
		moduleId = e.sourceTarget.moduleId
		$('#module-id-'+moduleId).removeClass 'cr-alarm-list-selected'
		currentModule = null
		pgweb.ControlRoomCommon.showModulePanel @getMap(), false, zoomed

	updateModulePanel: (module) ->
		$('#cr-module-data').html @getModulePanelHtml module

	getSelectedModule: ->
		currentModule
	
	# Display markers for all the tags.
	update: (fitBounds) ->
		@ajaxUpdate fitBounds, networkIds, categoryNamesStr

	ajaxUpdate: (fitBounds, networkIds, categoryNamesStr) ->
		@tags = []
		$.ajax
			url: "/pgweb/ajax/controlroom/common/tagCategoryMap.php"
			dataType: 'json'
			type: 'GET'
			data:
				networkIds: networkIds
				categoryNames: categoryNamesStr
			success: (data) =>
				@tags = data.tags
				switch data.result
					when "OK"
						@afterAjaxUpdate fitBounds
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						pgweb.ErrorDialog.inst().show('Failed', 'Failed to get tag category data.', data.result);
			error: ajaxFailure

	someDiIsCategoryAndHigh: (module, categoryName) ->
		for di in [1..module.nDIs]
			tag = module.tags['DI'+di]
			if tag.tagCategory?.name == categoryName
				if module['di'+di] == 1
					tag.module = module
					return tag
		null

	getFirstTag: (module) ->
		for di in [1..module.nDIs]
			tag = module.tags['DI'+di]
			if tag.tagCategory?.name == categoryNames[0]
				return tag
		for di in [1..module.nDIs]
			tag = module.tags['DI'+di]
			if tag.tagCategory?.name == categoryNames[1]
				return tag
		return null

	statusColor: (module) ->
		diRedTag = @someDiIsCategoryAndHigh module, categoryNames[1]
		diOrangeTag = null
		color = if diRedTag
			'red'
		else
			diOrangeTag = @someDiIsCategoryAndHigh module, categoryNames[0]
			if diOrangeTag
				'orange'
			else
				'green'
		firstTag = @getFirstTag module
		[color, diRedTag, diOrangeTag, firstTag]

	afterAjaxUpdate: ->
		$('#cr-alarm-table').show()
		$('#cr-alarm-table tbody').html ''

		# Get all module IDs  uniquely from the tags.
		moduleIds = new Set()
		@tags.forEach (tag) -> moduleIds.add tag.module.id

		# All modules.
		@modules = Array.from(moduleIds).map (id) =>
			(@tags.find (tag) -> tag.module.id == id).module

		# Remove duplicate references to module in tags
		for tag in @tags
			tag.module = @modules.find (module) -> module.id == tag.module.id

		# Get the points of the modules to be viewed (for map bounds calculation).
		pointsForBoundsCalc = (@correctCoords [module.gis_latitude, module.gis_longitude] for module in @modules when \
			typeof(module.gis_latitude) == 'number' and typeof(module.gis_longitude) == 'number')
		# If there are no modules to be viewed on the map, do nothing more.
		if pointsForBoundsCalc.length == 0
			@clearMarkers()
			return
		
		# Fit bounds perfectly to the points.
		bounds = new L.LatLngBounds pointsForBoundsCalc
		bounds._northEast.lat += (bounds._northEast.lat - bounds._southWest.lat)*0.17
		@fitBounds bounds
		layerGroups = []
		@modules.forEach (module) =>
			self = @
			[color, diRedTag, diOrangeTag, firstTag] = @statusColor module
			haloColor = ''
			haloClass = ''
			if module.timer_color in ['red', 'yellow']
				# On timer expired, show a halo around the yellow needle.
				haloColor = color
				haloClass = 'map-needle-halo-'+haloColor
				color = 'yellow'
			#console.log module.network_name, module.module_name, module.timer_color, color, diRedTag?.tagCategory.name, diOrangeTag?.tagCategory.name
		
			module.dropletColor = color
			module.haloColor = haloColor

			tag = diRedTag ? diOrangeTag ? firstTag

			# Show all modules in the alarm table except green.
			if color isnt 'green' and haloColor isnt 'green'
				$('#cr-alarm-table tbody').append @getAlarmRow tag, module

			module.tag = tag

			coords = @correctCoords [module.gis_latitude, module.gis_longitude]
			if coords[0] and coords[1]
				icon = @getIcon tag, color, haloClass
				marker = @getMarker color, coords, icon, module, tag
				if layerGroups[color] == undefined
					layerGroups[color] = L.layerGroup()
					layerGroups[color].addTo @getMap()
				layerGroups[color].addLayer marker

	getAlarmRow: (tag, module) ->
		html = '<tr class="cr-unacked cr-alarm-'+module.dropletColor+'" id="module-id-'+module.id+'">'
		if tag
			catName = tag.tagCategory.name
		else
			catName = 'OK'
		timerWarningSymbol = ''
		if module.dropletColor == 'yellow'
			origCatName = catName
			catName = ''
			if module.haloColor
				haloClass = 'cr-alarm-text-'+module.haloColor
				catName += '<span class="'+haloClass+'">'+origCatName+'</span>'
			timerWarningSymbol = '<i class="fa fa-clock-o" style="color:yellow"></i>'
		name = module.technical_name or module.address or module.system_name
		html += '<td><span style="color: white">'+pgweb.TagCategorySymbol.html(tag?.tagCategory.symbol, 8, 'white')+'</span></td>'
		html += '<td>'+catName+'</td>'
		html += "<td><span class=\""+haloClass+"\">#{name.toString().firstPart 12}</span></td>"
		html += '<td>'+timerWarningSymbol+'</td>'
		html += '</tr>'

	getIcon: (tag, color, haloClass) ->
		awesomeName = if tag
			if tag.tagCategory
				tag.tagCategory.awesome_name
			else ''
		else ''
		html = if awesomeName.endsWith '.png'
			pngcolor = 'black';
			fname = awesomeName.replace '.png', '-'+pngcolor+'.png'
			size = 10
			'<img src="images/'+fname+'" style="width: '+size+'px; position: relative; top: 3px"/>'
		else
			'<i class="fa fa-'+awesomeName+' map-needle-symbol"></i>'
		L.divIcon
			html: html
			className: 'map-needle map-needle-'+color #+' '+haloClass
			iconSize: [24, 38]
			iconAnchor: [12, 38]
			popupAnchor: [0, -38]
	
	getMarker: (color, coords, icon, module, tag) ->
		zIndexOffset = if color == 'red' then 50000
		else if color == 'orange' then 40000
		else if color == 'yellow' then 30000
		else 20000
		marker = L.marker coords,
			icon: icon
			title: module.module_name
			zIndexOffset: zIndexOffset
		marker.bindPopup @getPopupHtml module
		marker.moduleId = module.id
		marker.tag = tag
		marker.on 'popupopen', (e) =>
			@onPopupOpen e
		marker.on 'popupclose', (e) =>
			@onPopupClose e
		markers.push marker
		marker

	# Return html för the popup that appears when clicking on the icon.
	getPopupHtml: (module) ->
		module.address.toString() or module.technical_name.toString() or module.system_name

	getModulePanelHtml: (module) ->
		[lat, lng] = if module.projection in ['', 'wgs84', undefined]
			[module.gis_latitude, module.gis_longitude]
		else
			ll2xy module.projection, module.gis_latitude, module.gis_longitude
		moduleTypeId = $.url().param().moduleTypeId
		url = "?action=showModule&networkId=#{module.network_id}&moduleTypeId="+moduleTypeId+"&moduleId=#{module.id}"
		tag = module.tag
		color = module.dropletColor
		tagDesc = if tag
			if color == 'green' or module.haloColor == 'green'
				'OK'
			else if tag.tagCategory
				tag.tagCategory.name
			else 'OK'
		else 'OK'
		identity = module.address or module.technical_name or module.system_name
		if color == 'yellow'
			haloClass = 'cr-alarm-text-'+module.haloColor
			tagDesc = 'OFFLINE (<span class="'+haloClass+'">'+tagDesc+'</span>)'
		""" <!-- " -->
			<h3>#{identity}</h3>
			<button id="cr-module-panel-link-button" class="ui-btn ui-btn-b ui-mini ui-corner-all">#{module.system_name}</button>
			<p><b>#{tagDesc}</b></p>
			<p class="cr-module-panel-label">#{t.ModuleList_ModuleName}:</p>
			<p>#{module.module_name}</p>
			<p class="cr-module-panel-label">#{t.ModuleList_TechnicalName}:</p>
			<p>#{escapeStringForHTML(module.technical_name) or '-'}</p>
			<p class="cr-module-panel-label">#{t.ModuleList_Address}:</p>
			<p>#{module.address or '-'}</p>
		""" # "

	showLayerGroupByName: (bool, name) ->
		layer = layerGroups[name]
		if bool
			layer.addTo @getMap()
		else
			layer.remove()
		@showTableRowsByFilter()

	showTableRowsByFilter: ->
		showRed =    $('#needle-button-red').prop 'checked'
		showOrange = $('#needle-button-orange').prop 'checked'
		showYellow = $('#needle-button-yellow').prop 'checked'
		showGreen =  $('#needle-button-green').prop 'checked'

		$('#cr-alarm-table tbody tr').each (i, tr) =>
			moduleId = lastNum $(tr).attr 'id'
			module = @getModuleById moduleId
			if module.dropletColor == 'red'
				$(tr).toggle showRed
			if module.dropletColor == 'orange'
				$(tr).toggle showOrange
			if module.dropletColor == 'yellow'
				$(tr).toggle showYellow
			if module.dropletColor == 'green'
				$(tr).toggle showGreen
class pgweb.ControlRoomWeatherWidget
	@ajaxGetTemperature: (name) ->
		#@windDegreesToSymbolTest()
		waitStart()
		$.ajax
			url: $.url().attr('base')+'/pgweb/ajax/controlroom/common/controlRoomWeather.php'
			dataType: 'json'
			type: 'GET'
			data:
				name: name
			success: (data) =>
				now = new Date()
				nowStr = (Globalize.format now, 'D').replace('den ', '') + ' ' + (Globalize.format now, 'HH:mm')
				$('#cr-weather-container h4').text nowStr
				$('#cr-weather-temp').text Math.round(data.main.temp)+'°'
				$('#cr-weather-tempmin').text Math.round(data.main.temp_min)+'° min'
				$('#cr-weather-description').text data.weather[0].description
				$('#cr-weather-icon').html '<img src="https://openweathermap.org/img/wn/'+data.weather[0].icon+'.png"/>'
				$('#cr-weather-humidity').text data.main.humidity+' %RH'
				$('#cr-weather-pressure').text data.main.pressure+' hPa'
				$('#cr-weather-wind').html Math.round(data.wind.speed)+' m/s ' + @windDegreesToSymbol data.wind.deg
				sunrise = new Date data.sys.sunrise*1000
				$('#cr-weather-sunrise').text '↥'+Globalize.format sunrise, 'HH:mm'
				sunset = new Date data.sys.sunset*1000
				$('#cr-weather-sunset').text '↧'+Globalize.format sunset, 'HH:mm'
			error: (jqXHR, str, ex) =>
				ajaxFailure jqXHR, str, ex
				$('#cr-anvalues-weather-temperature').html ''
			complete: -> waitStop()

	@windDegreesToSymbol: (deg) ->
		arrows = "⇓⇙⇐⇖⇑⇗⇒⇘".split('')
		deg = deg + 22.5
		if deg < 0 then deg += 360
		index = (Math.floor deg / 45) % 8
		arrows[index]

	@windDegreesToSymbolTest: ->
		console.assert @windDegreesToSymbol(0) == '⇓'
		console.assert @windDegreesToSymbol(22) == '⇓'
		console.assert @windDegreesToSymbol(-22) == '⇓'
		console.assert @windDegreesToSymbol(359) == '⇓'
		console.assert @windDegreesToSymbol(360-22) == '⇓'
		console.assert @windDegreesToSymbol(23) == '⇙'
		console.assert @windDegreesToSymbol(45) == '⇙'
		console.assert @windDegreesToSymbol(45+22) == '⇙'
		console.assert @windDegreesToSymbol(360-23) == '⇘'
		console.assert @windDegreesToSymbol(360-23-45) == '⇒'
		console.assert @windDegreesToSymbol(360-23-45*2) == '⇗'
		console.assert @windDegreesToSymbol(270) == '⇒'
		console.assert @windDegreesToSymbol(270+45) == '⇘'

class pgweb.ControlRoomThermographyMap extends pgweb.Map
	instance = null
	intervalId = null
	fullscreen = false
	networkIds = null
	markerLayer = null
	labelLayer = null
	
	maxLat = 60
	minLat = 59
	maxLon = 17
	minLon = 16

	drawingCnt = 0
	drawings = []

	@inst: ->
		# Run only on the right control room page and mode 'anValues' or when no mode.
		if $.url().param().action != "show#{controlRoom.className}ControlRoom"
			return
		pageNamesExceptMe = (Object.keys controlRoom.pages).filter (item) -> item != 'thermography'
		if $.url().param().mode in pageNamesExceptMe
			return
		if not instance?
			instance = new @
		instance
	
	init: ->
		networkIds = $('#cr-network-ids').val().split(',');

		# Ensure there is no map.
		@ensureNoMap()

		# Create the map object.
		map = @createMap()

		map.on 'load', =>
			$('.leaflet-layer').addClass 'cr-map-gray'

		# Add the map fullscreen toggle button.
		map.addControl pgweb.ControlRoomCommon.createFullscreenButton @

		# Display markers for all the modules.
		@clearMarkers()
		@update true

		map.on 'resize', =>
			@fitToBounds()

		map.on 'zoomend', (obj) =>
			@onZoomEnd()
			#if @getMap().getZoom() < 12
			#	$('.cr-anvalues-tooltip-table').css 'visibility', 'hidden'
			#else
			#	$('.cr-anvalues-tooltip-table').css 'visibility', 'visible'

		map.on 'moveend', ->
			pgweb.ControlRoomOverviewMap.update map

		maxLat = -90
		minLat = 90
		maxLon = -90
		minLon = 90
		drawingCnt = 0

		drawings = ['compare-city', 'compare-lidingo']
		for drawing in drawings
			@getGeoJSONByAjaxByName drawing

		pgweb.ControlRoomWeatherWidget.ajaxGetTemperature controlRoom.name

	update: (fitBounds) ->
		@fitToBounds()

	fitToBounds: ->
		# Get the points of the modules to be viewed (for map bounds calculation).
		pointsForBoundsCalc = [@correctCoords([minLat, minLon]), @correctCoords([maxLat, maxLon])]

		# Fit bounds to the points.
		bounds = new L.LatLngBounds(pointsForBoundsCalc)
		@fitBounds bounds

	getGeoJSONByAjaxByName: (name) =>
		url = 'shapefiles/'+name+'.json'
		$.getJSON url, (data, textStatus, jqXHR) =>
			for feature in data.features
				polygon = []
				for lnglat in feature.geometry.coordinates[0]
					polygon.push [lnglat[1], lnglat[0]]
					maxLat = Math.max lnglat[1], maxLat
					minLat = Math.min lnglat[1], minLat
					maxLon = Math.max lnglat[0], maxLon
					minLon = Math.min lnglat[0], minLon
				values = feature.properties
				for k, v of values
					lastValue = v
				if lastValue > 0
					config =
						color: '#444'
						opacity: 0.2
						weight: 1
						fill: true
						fillColor: @valToColor lastValue
						fillOpacity: @valToTransparency lastValue
					polygon = L.polygon(polygon, config).addTo @getMap()
			drawingCnt += 1
			if drawingCnt == drawings.length
				@getMap().fitBounds([[minLat, minLon], [maxLat, maxLon]])

	valToColor: (val) ->
		'#' + switch
			# when val > 5000 then 'ff1100'
			# when val > 3000 then 'ee2200'
			# when val > 2000 then 'dd3300'
			# when val > 1000 then 'cc4400'
			# when val > 800 then  'bb5500'
			# when val > 600 then  'aa6600'
			# when val > 400 then  '997700'
			# when val > 200 then  '888800'
			# when val > 100 then  '779900'
			# when val > 80 then   '66aa00'
			# when val > 60 then   '55bb00'
			# when val > 40 then   '44cc00'
			# when val > 20 then   '33dd00'
			# when val > 0 then    '22ee00'
			# else                 '11ff00'
			when val > 5000 then 'ff0000'
			when val > 3000 then 'ff1111'
			when val > 2000 then 'ff2222'
			when val > 1000 then 'ff3333'
			when val > 800 then  'ff4444'
			when val > 600 then  'ff5555'
			when val > 400 then  'ff6666'
			when val > 200 then  'ff7777'
			when val > 100 then  'ff8888'
			when val > 80 then   'ff9999'
			when val > 60 then   'ffaaaa'
			when val > 40 then   'ffbbbb'
			when val > 20 then   'ffcccc'
			when val > 0 then    'ffdddd'
			else                 'ffeeee'

	valToTransparency: (val) ->
		d = .5/15
		0.05 + switch
			when val > 5000 then d*15
			when val > 3000 then d*14
			when val > 2000 then d*13
			when val > 1000 then d*12
			when val > 800 then  d*11
			when val > 600 then  d*10
			when val > 400 then  d*9
			when val > 200 then  d*8
			when val > 100 then  d*7
			when val > 80 then   d*6
			when val > 60 then   d*5
			when val > 40 then   d*4
			when val > 20 then   d*3
			when val > 0 then    d*2
			else                 d*1
class pgweb.Task
	constructor: (@id, @module_id, @module_type_id, @channel_id, @selectedChannelNumber, @tag_id, @selectedTag, @assigned_to_user_id, @closed_by_user_id, @system_name, @identity, @name, @category, @type, @progress, @remark, @custom1, @custom2, @custom3, @custom4) ->
		
	getIdentityStr: ->
		switch @category
			when 1
				'M'+@identity
			when 2
				'C'+@identity
			when 3
				'T'+@identity
			else '?'+@identity
class pgweb.TaskPopup
	isNew = false
	searchbox = null
	query = null
	nowtime = null
	delay = 400
	ongoing = false
	errStr = ''
	rememberArt = ''
	droppedDown = false
	
	id = null 
	moduleTypeInfo = null

	savedType = false

	constructor: ->
		$('body').on 'popupafteropen', '.task-edit-popup', (e) =>
			onOpen()
			
		$('body').on 'click', '#task-edit-save-button', =>
			save()

		$('body').on 'click', '#task-edit-cancel-button', =>
			if savedType
				$.mobile.changePage $.url().attr('source'), reloadPage: true

		$('body').on 'click', '#task-edit-remove-button', =>
			remove()
			
		$('body').on 'change', '[name="category"]', (e) =>
			category = $(e.currentTarget).val()
			selectorToShow = {1: null, 2: 'channel', 3: 'tag'}[category]
			allSelectors = ['channel', 'tag']
			selectorsToHide = allSelectors.filter (item) -> item != selectorToShow
			
			selectorsToHide.forEach (selector) -> getSelector(selector).hide 250
			(getSelector selectorToShow).show 250

			channelSelector = $('[name=category-select-channel]')
			if not channelSelector.val()
				channelSelector.val(channelSelector.find('option:first').val())
				channelSelector.selectmenu 'refresh'

			tagSelector = $('[name=category-select-tag]')
			if not tagSelector.val()
				tagSelector.val(tagSelector.find('option:first').val())
				tagSelector.selectmenu 'refresh'

		$('body').on 'click', '#task-edit-type-update-button', =>
			visible = $('#task-edit-type-editadd').is ':visible'
			setTypeEditMode not visible
			
		$('body').on 'click', '#task-edit-type-add-button', =>
			visible = $('#task-edit-type-editadd').is ':visible'
			setTypeAddMode not visible

		$('body').on 'change', '#task-edit-type', =>
			value = $('#task-edit-type').val()
			if value
				$('#task-edit-type-text').val value
				$('#task-edit-type-update-button').prop 'disabled', false
			else
				setTypeEditMode false
				$('#task-edit-type-update-button').prop 'disabled', true

		$('body').on 'click', '#task-edit-type-save-button', =>
			ajaxSaveType()

	instance = null

	@inst: ->
		if not instance?
			instance = new @
		instance

	getSelector = (name) -> $("[name=category-select-#{name}]").closest('.ui-btn')

	setTypeEditMode = (isOn) ->
		if isOn
			value = $('#task-edit-type').val()
			$('#task-edit-type-text').val value
			$('#task-edit-type-editadd').show 500
			$('#task-edit-type-add-button').prop 'disabled', true
		else
			$('#task-edit-type-editadd').hide 500, ->
				$('#task-edit-type-text').val ''
				$('#task-edit-type-add-button').prop 'disabled', false
		$('#task-save-error-message').html ''

	setTypeAddMode = (isOn) ->
		$('#task-edit-type-text').val ''
		if isOn
			$('#task-edit-type-editadd').show 500
			$('#task-edit-type-update-button').prop 'disabled', true
		else
			$('#task-edit-type-editadd').hide 500, ->
				$('#task-edit-type-update-button').prop 'disabled', false
		$('#task-save-error-message').html ''

	onOpen = () ->
		savedType = false
		clearError()
		$('#task-edit-type-editadd').hide()
		networkId = $.url().param().networkId
		if id
			moduleTypeId = pgweb.tasks[id].module_type_id
		else
			moduleTypeId = $('#module-type-id').val()
		ajaxGetModuleTypeInfo networkId, moduleTypeId, ->
			if isNew
				id = null
				t = new pgweb.Task 0, 0, 0, 0, 0, 0, 0, '', 0, '', 1, '', 0, '', '', '', '', ''
			else
				t = pgweb.tasks[id]
			fill t, moduleTypeInfo.channelNumbers, moduleTypeInfo.tags

	fill = (task, channelNumbers, tags) ->
		# Bug workaround; removes extra labels.
		$('.ui-block-a > [for=task-edit-category-module]').hide()
		$('.ui-block-b > [for=task-edit-category-channel]').hide()
		$('.ui-block-c > [for=task-edit-category-tag]').hide()

		if task.id
			$('#task-edit-identity').html task.system_name
		else
			$('#task-edit-identity').html $('#system-name').val()
		$('#task-edit-name').val task.name
		
		$('input[name=category]').val [task.category]
		$('input[name=category]').checkboxradio 'refresh'

		['channel', 'tag'].forEach (selector) -> getSelector(selector).hide()
		switch task.category
			when 2 then getSelector('channel').show()
			when 3 then getSelector('tag').show()

		# When the module has no channels, hide the channel radio button and the channel dropdown.
		if channelNumbers.length == 0
			$('#task-edit-category-container .ui-block-b').hide()
			$('#task-edit-category-select-container .ui-block-b').hide()
		else
			$('#task-edit-category-container .ui-block-b').show()
			$('#task-edit-category-select-container .ui-block-b').show()
		
		# When target=channel, show the channel number select menu.
		channelSelector = $('[name=category-select-channel]')
		channelSelector.html ''
		for ch, i in channelNumbers
			selectedStr = if ch == task.selectedChannelNumber then 'selected' else if i == 0 then 'selected'
			html = "<option value=\"#{ch}\" #{selectedStr}>#{ch}</option>"
			channelSelector.append $(html)
		channelSelector.val task.selectedChannelNumber
		channelSelector.selectmenu 'refresh'

		# When target=tag, show the tag name select menu.
		tagSelector = $('[name=category-select-tag]')
		tagSelector.html ''
		for tag, i in tags
			if tag.match /^((AN|AV|DI|DV|DO|DOut|RTD|Temp)\d+|Humidity|AirTemp|Temp1W|WaterLevel|Mic\dFilter)$/
				selectedStr = if tag == task.selectedTag then 'selected' else if i == 0 then 'selected'
				html = "<option value=\"#{tag}\" #{selectedStr}>#{t['Tag'+tag] or tag}</option>"
				tagSelector.append $(html)
		tagSelector.val task.selectedTag
		tagSelector.selectmenu 'refresh'

		ajaxPopulateTypes task.type

		$('#task-edit-remark').val task.remark
		if task.assigned_to_user_id
			$('#task-edit-assigned-to').val task.assigned_to_user_id
		else
			$('#task-edit-assigned-to').val $('#task-edit-assigned-to option:first').val()
		$('#task-edit-assigned-to').selectmenu 'refresh'
		$('#task-edit-progress').prop('checked', task.progress == 100).checkboxradio('refresh')
		$('#task-edit-custom1').val task.custom1
		$('#task-edit-custom2').val task.custom2
		$('#task-edit-custom3').val task.custom3
		$('#task-edit-custom4').val task.custom4

	setTitle = (title) ->
		$('#task-edit-popup h1').html title

	clearError = () ->
		errStr = ''
		showError()
	
	addError = (msg) ->
		errStr += msg+'<br/>'
	
	showError = () ->
		$('#task-save-error-message').html errStr

	remove = () ->
		if confirm t.TaskPopup_ConfirmDelete
			ajaxRemove()

	ajaxSaveType = ->
		isNewType = not $('#task-edit-type-add-button').prop 'disabled'
		if isNewType
			existingType = null
		else
			existingType = $('#task-edit-type').val()
		newType = $('#task-edit-type-text').val().trim()
		if !newType
			$('#task-save-error-message').html 'Please enter the type.'
			return
		waitStart()
		$.ajax
			url: '/pgweb/ajax/task/saveTaskType.php'
			dataType: 'json'
			type: 'POST'
			data:
				existingType: existingType
				newType: newType
				taskId: id
				networkId: $.url().param().networkId
			success: (data) -> 
				switch data.result
					when "OK"
						setTypeAddMode false
						setTypeEditMode false
						ajaxPopulateTypes newType
						savedType = true
					when 'TYPE_EXISTS'
						$('#task-save-error-message').html 'The type already exists in this network.'
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else $('#task-save-error-message').html "Saving task type failed: "+data.debug
			error: ajaxFailure
			complete: -> waitStop()

	ajaxRemove = () ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/task/removeTask.php"
			dataType: 'json'
			type: 'POST'
			data:
				taskId: id
			success: (data) -> 
				switch data.result
					when "OK"
						$('#task-edit-popup').popup 'close'
						$('#task-edit-popup').one 'popupafterclose', =>
							$.mobile.changePage $.url().attr('source'), reloadPage: true
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else $('#task-save-error-message').html "Remove failed: "+data.debug
			error: ajaxFailure
			complete: -> waitStop()
	
	save = () ->
		clearError()
		category = $('[name=category]:checked').val()
		if !category
			addError t.TaskPopup_CategoryMissing
		name = $('#task-edit-name').val()
		if !name
			addError t.TaskPopup_NameMissing
		type = $('#task-edit-type').val()
		if !type
			addError t.TaskPopup_TypeMissing
		if errStr
			showError()
		else
			ajaxSave()
	
	ajaxSave = () ->
		if isNew
			moduleId = $.url().param().moduleId
			moduleTypeId = $.url().param().moduleTypeId
			task = new pgweb.Task(
				null
				moduleId
				moduleTypeId
				null # channel_id
				parseInt $('[name=category-select-channel]').val()
				null # tag_id
				$('[name=category-select-tag]').val()
				parseInt $('#task-edit-assigned-to').val()
				0 # closed_by_user_id
				'' # system_name
				0 # identity
				$('#task-edit-name').val()
				parseInt $('[name=category]:checked').val()
				$('#task-edit-type').val()
				0
				$('#task-edit-remark').val()
				$('#task-edit-custom1').val()
				$('#task-edit-custom2').val()
				$('#task-edit-custom3').val()
				$('#task-edit-custom4').val()
			)
		else
			moduleId = pgweb.tasks[id].module_id
			moduleTypeId = pgweb.tasks[id].module_type_id
			task = new pgweb.Task(
				id
				moduleId
				moduleTypeId
				null # channel_id
				parseInt $('[name=category-select-channel]').val() # selectedChannel
				null # tag_id
				$('[name=category-select-tag]').val() # selectedTag
				parseInt $('#task-edit-assigned-to').val()
				0 # closed_by_user_id
				'' # system_name
				0 # identity
				$('#task-edit-name').val()
				parseInt $('[name=category]:checked').val()
				$('#task-edit-type').val()
				if $('#task-edit-progress:checked').val() == 'on' then 100 else 0
				$('#task-edit-remark').val()
				$('#task-edit-custom1').val()
				$('#task-edit-custom2').val()
				$('#task-edit-custom3').val()
				$('#task-edit-custom4').val()
			)
		waitStart()
		$.ajax
			url: "/pgweb/ajax/task/saveTask.php"
			dataType: 'json'
			type: 'POST'
			data:
				task: task
			success: (data) -> 
				switch data.result
					when "OK"
						$('#task-edit-popup').one 'popupafterclose', =>
							$.mobile.changePage $.url().attr('source'), reloadPage: true
						$('#task-edit-popup').popup 'close'
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						$('#task-save-error-message').html "Save failed: "+data.debug
			error: ajaxFailure
			complete: -> waitStop()

	openForNew: ->
		isNew = true
		setTitle t.TaskPopup_NewTask
		$('#task-edit-progress-container').hide()
		$('#task-edit-remove-button').hide()
		$('#task-edit-popup').popup 'open'

	openForEdit: (taskId) ->
		isNew = false
		id = taskId
		setTitle t.TaskPopup_EditTask
		$('#task-edit-progress-container').show()
		$('#task-edit-remove-button').show()
		$('#task-edit-popup').popup 'open'

	getCurrentTime = ->
		mynowdate = new Date()
		mynowdate.getTime()

	ajaxGetModuleTypeInfo = (networkId, moduleTypeId, callBack) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/module/getModuleTypeInfo.php"
			dataType: 'json'
			type: 'GET'
			data:
				networkId: networkId
				moduleTypeId: moduleTypeId
			success: (data) =>
				switch data.result
					when "OK"
						moduleTypeInfo = data
						callBack()
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						alert("Getting module info failed: " + data.debug);
			error: ajaxFailure
			complete: ->
				waitStop();

	ajaxPopulateTypes = (selectedType) ->
		ongoing=true
		waitStart()
		networkId = $.url().param().networkId
		$.ajax
			url: "/pgweb/ajax/task/searchTaskTypes.php"
			dataType: 'json'
			type: 'POST'
			data:
				networkId: networkId
			success: (data) =>
				switch data.result
					when "OK"
						$('#task-edit-type').html ''
						option = $('<option value=""></option>').append '-- '+t.DropDownSelect+' --'
						$('#task-edit-type').append option
						$.each data.types, (i, typeData) ->
							option = $('<option value="'+typeData.type+'"></option>').append typeData.type
							$('#task-edit-type').append option
						
						$('#task-edit-type').val selectedType

						# For the case when creating a new task type when creating a new task.
						# Add the new type at the bottom of the dropdown and select it.
						if !$('#task-edit-type').val() and selectedType
							option = $('<option value="'+selectedType+'"></option>').append selectedType
							$('#task-edit-type').append option
							$('#task-edit-type').val selectedType # Try again.
						
						$('#task-edit-type').selectmenu 'refresh'
					when 'NOT_LOGGED_IN'
						handleInactivity()
					else
						alert("Searching modules failed: "+data.debug);
			error: ajaxFailure
			complete: ->
				waitStop();
				ongoing = false;

$(-> pgweb.TaskPopup.inst())
class pgweb.TaskListPage

	@init: ->
		$('body').off 'click', '#task-new-button'
		$('body').on 'click', '#task-new-button', (event, ui) =>
			pgweb.TaskPopup.inst().openForNew()
		
		$('body').off 'click', '.task-edit-button'
		$('body').on 'click', '.task-edit-button', (event, ui) =>
			id = lastNum $(event.target).closest('a').attr 'id'
			pgweb.TaskPopup.inst().openForEdit id
		
		pgweb.ExportToClipboard.init 'task-table'

$(document).on 'pageshow', '.showTasksPage', (event) ->
	pgweb.TaskListPage.init()
	
$(document).on 'pageshow', '.showTasksInNetworkPage', (event) ->
	pgweb.TaskListPage.init()
